import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Time: string;
};

export enum AccessSetting {
  AllowedEmailsOnly = 'allowed_emails_only',
  Anyone = 'anyone',
  AnyoneLeavingDetails = 'anyone_leaving_details',
}

/** An AlicloudAccountConfig stores the details of an AliCloud account */
export type AlicloudAccountConfig = {
  __typename?: 'AlicloudAccountConfig';
  /** Unique ID */
  id: Scalars['ID'];
  /** List of managed policies that should be applied to the account. See https://console.aws.amazon.com/iam/home?region=eu-west-1#/policies */
  managed_policies: Array<Scalars['String']>;
  /** Name of the project */
  name: Scalars['String'];
  /** RAM policy that should be applied to the account, can be empty */
  ram_policy: Maybe<Scalars['String']>;
};

/** An AlicloudAccountInput stores the details of an Alicloud account */
export type AlicloudAccountConfigInput = {
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']>;
  /** List of managed policies that should be applied to the account */
  managed_policies?: InputMaybe<Array<Scalars['String']>>;
  /** Name of the project */
  name?: InputMaybe<Scalars['String']>;
  /** RAM policy that should be applied to the account, can be empty */
  ram_policy?: InputMaybe<Scalars['String']>;
  /** ID of the track this config belongs to */
  track?: InputMaybe<Scalars['String']>;
};

/** An arcade machine */
export type Arcade = {
  __typename?: 'Arcade';
  /** If the arcade machine is active */
  active: Scalars['Boolean'];
  /** The alternative URL for the arcade machine */
  alternative_url: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Organization Slug */
  organization: Scalars['String'];
  /** Serial Number */
  serial_number: Scalars['String'];
};

export type ArcadeInput = {
  alternative_url?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type ArcadeLogin = {
  __typename?: 'ArcadeLogin';
  alternative_url: Maybe<Scalars['String']>;
  organization: Organization;
  token: Scalars['String'];
};

/** An AwsAccountConfig stores the details of an AWS account */
export type AwsAccountConfig = {
  __typename?: 'AwsAccountConfig';
  /** IAM policy that should be applied to the account, can be empty */
  iam_policy: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** List of managed policies that should be applied to the account. See https://console.aws.amazon.com/iam/home?region=eu-west-1#/policies */
  managed_policies: Array<Scalars['String']>;
  /** Name of the project */
  name: Scalars['String'];
  /** Service Control policy that will be applied to the account, can be empty */
  scp_policy: Maybe<Scalars['String']>;
};

/** An AwsAccountConfigInput stores the details of an AWS account */
export type AwsAccountConfigInput = {
  /** IAM policy that should be applied to the account, can be empty */
  iam_policy?: InputMaybe<Scalars['String']>;
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']>;
  /** List of managed policies that should be applied to the account. See https://console.aws.amazon.com/iam/home?region=eu-west-1#/policies */
  managed_policies?: InputMaybe<Array<Scalars['String']>>;
  /** Name of the project */
  name?: InputMaybe<Scalars['String']>;
  /** Service Control policy that will be applied to the account, can be empty */
  scp_policy?: InputMaybe<Scalars['String']>;
  /** ID of the track this config belongs to */
  track?: InputMaybe<Scalars['String']>;
};

/** An AzureSubscriptionConfig stores the details of an Azure Subscription */
export type AzureSubscriptionConfig = {
  __typename?: 'AzureSubscriptionConfig';
  /** Unique ID */
  id: Scalars['ID'];
  /** Name of the project */
  name: Scalars['String'];
  /** Roles to assign to the user */
  roles: Array<Scalars['String']>;
  /** Only create an AAD user */
  user_only: Scalars['Boolean'];
};

/** An AzureSubscriptionInput stores the details of an Azure Subscription */
export type AzureSubscriptionConfigInput = {
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']>;
  /** Name of the project */
  name?: InputMaybe<Scalars['String']>;
  /** Roles to assign to the user */
  roles?: InputMaybe<Array<Scalars['String']>>;
  /** ID of the track this config belongs to */
  track?: InputMaybe<Scalars['String']>;
  /** Only create an AAD user */
  user_only?: InputMaybe<Scalars['Boolean']>;
};

/** A challenge is a bite-sized problem that needs to be solved. Each challenge consists of the explanation followed by a hands-on assignment or quiz. */
export type Challenge = {
  __typename?: 'Challenge';
  /** List of possible answers in case of a quiz type challenge */
  answers: Array<Scalars['String']>;
  /** The assignment a user has to complete. In case of a quiz, this is the question. */
  assignment: Scalars['String'];
  /** List of attempts the user has done to solve the challenge */
  attempts: Array<ChallengeAttempt>;
  /** Whether checking is available or not, this is dependent on the presence of a check script */
  can_check: Maybe<Scalars['Boolean']>;
  /** Timestamp when the challenge was completed. Will be 0 when not yet completed */
  completed: Scalars['Int'];
  /** Difficulty of the challenge. This field is currently not used */
  difficulty: Scalars['String'];
  /** Error message for when the challenge was failed. Will be null if there was no error */
  failMessage: Maybe<Scalars['String']>;
  /** Timestamp when the challenge was failed. Will be 0 when there was no error */
  failed: Scalars['Int'];
  /** Unique ID */
  id: Scalars['ID'];
  /** Index of the challenge, used for ordering the challenges in a track. Starts at 0. */
  index: Scalars['Int'];
  /** List of notes for this challenge */
  notes: Array<ChallengeNote>;
  /** Permalink for this challenge. Will be generated automatically, based on the slugs of the team, track and challenge. */
  permalink: Maybe<Scalars['String']>;
  /** List of scripts for this challenge */
  scripts: Array<ChallengeScript>;
  /** Slug of the challenge. This will be visible in the address bar of the browser */
  slug: Scalars['String'];
  /** List of valid answers for a quiz */
  solution: Array<Scalars['Int']>;
  /** Timestamp when the challenge was started. Will be 0 when not yet started */
  started: Scalars['Int'];
  /** Status of the challenge */
  status: ChallengeStatus;
  /** List of tabs for this challenge */
  tabs: Array<ChallengeTab>;
  /** Teaser of the challenge. This will be visible for the user when the challenge is not yet unlocked. */
  teaser: Scalars['String'];
  /** Maximum time the challenge is available. The sum of timelimits of all challenges determine the total TTL for a track. */
  timelimit: Maybe<Scalars['Int']>;
  /** Title of the challenge */
  title: Scalars['String'];
  /** Type of the challenge */
  type: ChallengeType;
  /** Which challenge will be unlocked after this challenge has been successfully completed. This field is currently not used (the next challenge in the list will automatically be unlocked) */
  unlocks: Maybe<Challenge>;
};

/** ChallengeAttempt stores an attempt to solve a challenge */
export type ChallengeAttempt = {
  __typename?: 'ChallengeAttempt';
  /** Result message of the attempt */
  message: Scalars['String'];
  /** Timestamp of the attempt */
  timestamp: Scalars['Time'];
};

/** A challenge is a bite-sized problem that needs to be solved. Each challenge consists of the explanation followed by a hands-on assignment or quiz. */
export type ChallengeInput = {
  /** List of possible answers in case of a quiz type challenge */
  answers?: InputMaybe<Array<Scalars['String']>>;
  /** The assignment a user has to complete. In case of a quiz, this is the question. */
  assignment?: InputMaybe<Scalars['String']>;
  /** Difficulty of the challenge. This field is currently not used */
  difficulty?: InputMaybe<Scalars['String']>;
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']>;
  /** Index of the challenge, used for ordering the challenges in a track. Starts at 0. */
  index?: InputMaybe<Scalars['Int']>;
  /** List of notes for this challenge */
  notes?: InputMaybe<Array<ChallengeNoteInput>>;
  /** List of scripts for this challenge */
  scripts?: InputMaybe<Array<ChallengeScriptInput>>;
  /** Slug of the challenge. This will be visible in the address bar of the browser */
  slug?: InputMaybe<Scalars['String']>;
  /** List of valid answers for a quiz */
  solution?: InputMaybe<Array<Scalars['Int']>>;
  /** List of tabs for this challenge */
  tabs?: InputMaybe<Array<ChallengeTabInput>>;
  /** Teaser of the challenge. This will be visible for the user when the challenge is not yet unlocked. */
  teaser?: InputMaybe<Scalars['String']>;
  /** Maximum time the challenge is available. The sum of timelimits of all challenges determine the total TTL for a track. */
  timelimit?: InputMaybe<Scalars['Int']>;
  /** Title of the challenge */
  title?: InputMaybe<Scalars['String']>;
  /** ID of the track this challenge belongs to */
  track?: InputMaybe<Scalars['String']>;
  /** Type of the challenge */
  type?: InputMaybe<Scalars['String']>;
};

/** A ChallengeNote is displayed when the infrastructure of your challenge is being created. You can display markdown text but also show an image or video. */
export type ChallengeNote = {
  __typename?: 'ChallengeNote';
  /** Text contents */
  contents: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Index of the note, used for ordering the notes of a challenge. Starts at 0. */
  index: Scalars['Int'];
  /** Type of the note */
  type: ChallengeNoteType;
  /** URL for image and video notes */
  url: Maybe<Scalars['String']>;
};

/** A ChallengeNote is displayed when the infrastructure of your challenge is being created. You can display markdown text but also show an image or video. */
export type ChallengeNoteInput = {
  /** ID of the challenge this note belongs to */
  challenge?: InputMaybe<Scalars['String']>;
  /** Text contents */
  contents?: InputMaybe<Scalars['String']>;
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']>;
  /** Index of the note, used for ordering the notes of a challenge. Starts at 0. */
  index?: InputMaybe<Scalars['Int']>;
  /** ID of the track this note belongs to */
  track?: InputMaybe<Scalars['String']>;
  /** Type of the note */
  type?: InputMaybe<ChallengeNoteType>;
  /** URL for image and video notes */
  url?: InputMaybe<Scalars['String']>;
};

/** ChallengeNoteType enumerated the possible note types */
export enum ChallengeNoteType {
  Image = 'image',
  Text = 'text',
  Video = 'video',
}

/**
 * Challenge scripts provide the automation hooks for interacting with the infrastructure of the track.
 * There are 4 actions: setup, check, cleanup and solve
 */
export type ChallengeScript = {
  __typename?: 'ChallengeScript';
  /** One of: setup, check, cleanup and solve */
  action: Scalars['String'];
  /** The script contents */
  contents: Scalars['String'];
  /** On which host the script is executed. Must reference a host in the track config */
  host: Scalars['String'];
  /** Unique ID */
  id: Scalars['ID'];
};

/**
 * Challenge scripts provide the automation hooks for interacting with the infrastructure of the track.
 * There are 4 actions: setup, check, cleanup and solve
 */
export type ChallengeScriptInput = {
  /** One of: setup, check, cleanup and solve */
  action?: InputMaybe<Scalars['String']>;
  /** ID of the track this challenge belongs to */
  challenge?: InputMaybe<Scalars['String']>;
  /** The script contents */
  contents?: InputMaybe<Scalars['String']>;
  /** On which host the script is executed. Must reference a host in the track config */
  host?: InputMaybe<Scalars['String']>;
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']>;
  /** ID of the track this script belongs to */
  track?: InputMaybe<Scalars['String']>;
};

export type ChallengeSeries = {
  __typename?: 'ChallengeSeries';
  completed: Scalars['Int'];
  date: Scalars['String'];
  started: Scalars['Int'];
  unlocked: Scalars['Int'];
};

export type ChallengeStatistics = {
  __typename?: 'ChallengeStatistics';
  attempts_avg: Maybe<Scalars['Int']>;
  attempts_max: Maybe<Scalars['Int']>;
  attempts_min: Maybe<Scalars['Int']>;
  attempts_stddev: Maybe<Scalars['Int']>;
  attempts_total: Maybe<Scalars['Int']>;
  completed_total: Maybe<Scalars['Int']>;
  duration_avg: Maybe<Scalars['Int']>;
  duration_max: Maybe<Scalars['Int']>;
  duration_min: Maybe<Scalars['Int']>;
  duration_stddev: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  series: Array<ChallengeSeries>;
  started_total: Maybe<Scalars['Int']>;
  title: Maybe<Scalars['String']>;
  unlocked_total: Maybe<Scalars['Int']>;
};

/** ChallengeStatus enumerates the possible states for challenges */
export enum ChallengeStatus {
  /** The check script is being run */
  Checking = 'checking',
  /** The user has completed the challenge successfully */
  Completed = 'completed',
  /** The challenge is ready for the user to start playing */
  Created = 'created',
  /** The setup script is being run */
  Creating = 'creating',
  /** The setup script has failed to run */
  Failed = 'failed',
  /** The challenge is locked, another challenge has to be completed first */
  Locked = 'locked',
  /** The user has started the challenge */
  Started = 'started',
  /** The challenge is available to play, but has not yet been started by the user */
  Unlocked = 'unlocked',
}

/** A tab shows a service, terminal or (external) website for a challenge */
export type ChallengeTab = {
  __typename?: 'ChallengeTab';
  /** initial command to run, only valid for terminal tabs */
  cmd: Maybe<Scalars['String']>;
  /** Refers to a host in the track config. Must be set for types service and terminal. */
  hostname: Maybe<Scalars['String']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Index of the tab, used for ordering the tabs of a challenge. Starts at 0. */
  index: Scalars['Int'];
  /** Whether to open this tab in an external window */
  new_window: Scalars['Boolean'];
  /** Path of a service. Only valid for type service, defaults to / */
  path: Maybe<Scalars['String']>;
  /** Port of a service. Only valid for type service */
  port: Maybe<Scalars['Int']>;
  /** Currently not used */
  target: Maybe<Scalars['String']>;
  /** Title of the tab */
  title: Scalars['String'];
  /** Type of the tab */
  type: ChallengeTabType;
  /** URL of an (external) website. Only valid for type website and external */
  url: Maybe<Scalars['String']>;
  /** Initial work directory, only valid for terminal tabs */
  workdir: Maybe<Scalars['String']>;
};

/** A tab shows a service, terminal or (external) website for a challenge */
export type ChallengeTabInput = {
  /** ID of the challenge this tab belongs to */
  challenge?: InputMaybe<Scalars['String']>;
  /** initial command to run, only valid for terminal tabs */
  cmd?: InputMaybe<Scalars['String']>;
  /** Refers to a host in the track config. Must be set for types service and terminal. */
  hostname?: InputMaybe<Scalars['String']>;
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']>;
  /** Index of the tab, used for ordering the tabs of a challenge. Starts at 0. */
  index?: InputMaybe<Scalars['Int']>;
  /** Whether to open this tab in an external window */
  new_window?: InputMaybe<Scalars['Boolean']>;
  /** Path of a service. Only valid for type service, defaults to / */
  path?: InputMaybe<Scalars['String']>;
  /** Port of a service. Only valid for type service */
  port?: InputMaybe<Scalars['Int']>;
  /** Title of the tab */
  title?: InputMaybe<Scalars['String']>;
  /** ID of the track this tab belongs to */
  track?: InputMaybe<Scalars['String']>;
  /** Type of the tab */
  type?: InputMaybe<ChallengeTabType>;
  /** URL of an (external) website. Only valid for type website and external */
  url?: InputMaybe<Scalars['String']>;
  /** Initial work directory, only valid for terminal tabs */
  workdir?: InputMaybe<Scalars['String']>;
};

/** ChallengeTabType enumerates the possible tab types */
export enum ChallengeTabType {
  /** Virtual browser provided as a service */
  Browser = 'browser',
  /** Simple code editor */
  Code = 'code',
  /** URL to an external website. Useful for sites that are not frameable */
  External = 'external',
  /** Internal service of your track, should reference a host in the track config */
  Service = 'service',
  /** Terminal to a host in the track config */
  Terminal = 'terminal',
  /** URL to a website. The website should be frameable in an iframe */
  Website = 'website',
}

/** ChallengeType enumerates the possible challenge types */
export enum ChallengeType {
  /** A challenge has setup and scripts */
  Challenge = 'challenge',
  /** A quiz has a question and one or more answers */
  Quiz = 'quiz',
}

/** A ContainerConfig stores the details of a container */
export type ContainerConfig = {
  __typename?: 'ContainerConfig';
  /** Override the CMD from the docker image */
  cmd: Maybe<Scalars['String']>;
  /** Override the ENTRYPOINT from the docker image */
  entrypoint: Maybe<Scalars['String']>;
  /** List of key-value pairs that are injected as environment variables */
  environment: Maybe<Array<EnvironmentVariable>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Container image to use */
  image: Scalars['String'];
  /** Amount of memory to use, in megabytes. Defaults to 32 */
  memory: Scalars['Int'];
  /** Name of the container, will be used as hostname */
  name: Scalars['String'];
  /** Ports to expose */
  ports: Maybe<Array<Scalars['Int']>>;
  /** Deprecated */
  resources: ContainerResources;
  /** Which shell to expose in the terminal. Defaults to /bin/sh */
  shell: Scalars['String'];
};

/** A ContainerConfig stores the details of a container */
export type ContainerConfigInput = {
  /** Override the CMD from the docker image */
  cmd?: InputMaybe<Scalars['String']>;
  /** Override the ENTRYPOINT from the docker image */
  entrypoint?: InputMaybe<Scalars['String']>;
  /** List of key-value pairs that are injected as environment variables */
  environment?: InputMaybe<Array<EnvironmentInput>>;
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']>;
  /** Container image to use */
  image?: InputMaybe<Scalars['String']>;
  /** Amount of memory to use, in megabytes. Defaults to 32 */
  memory?: InputMaybe<Scalars['Int']>;
  /** Name of the container, will be used as hostname */
  name?: InputMaybe<Scalars['String']>;
  /** Ports to expose */
  ports?: InputMaybe<Array<Scalars['Int']>>;
  /** Deprecated */
  resources?: InputMaybe<ContainerResourcesInput>;
  /** Which shell to expose in the terminal. Defaults to /bin/sh */
  shell?: InputMaybe<Scalars['String']>;
  /** ID of the track this config belongs to */
  track?: InputMaybe<Scalars['String']>;
};

/**
 * A ContainerConfigPreset stores the config for
 * a container preset.
 */
export type ContainerConfigPreset = {
  __typename?: 'ContainerConfigPreset';
  /** Container image to use */
  image: Scalars['String'];
  /** The label of the preset */
  label: Scalars['String'];
  /** Amount of memory to use */
  memory: Scalars['Int'];
};

/** Deprecated */
export type ContainerResources = {
  __typename?: 'ContainerResources';
  memory: Scalars['Int'];
};

/** Deprecated */
export type ContainerResourcesInput = {
  memory?: InputMaybe<Scalars['Int']>;
};

/** CustomHeader represents a Instruqt CustomHeader */
export type CustomHeader = {
  __typename?: 'CustomHeader';
  /** The key of the header */
  key: Scalars['String'];
  /** The value of the header */
  value: Scalars['String'];
};

/** Parameters used to create or update a webhooks headers */
export type CustomHeaderInput = {
  /** The key of the header */
  key: Scalars['String'];
  /** The value of the header */
  value: Scalars['String'];
};

/** Key value pair of a custom parameter associated with a Play */
export type CustomParameter = {
  __typename?: 'CustomParameter';
  /** Key of custom parameter */
  key: Scalars['String'];
  /** Value associated with the key of custom parameter */
  value: Scalars['String'];
};

/** Filter for key value pair */
export type CustomParameterFilter = {
  /** Key of filter */
  key: Scalars['String'];
  /** Value of filter */
  value: Scalars['String'];
};

/**
 * A custom parameter can be used to add metadata to a track play.
 * You can use this metadata to integrate with external systems, like an LMS or
 * a marketing automation tool.
 */
export type CustomParametersInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Filter for date range */
export type DateRangeFilter = {
  /** Begining of range */
  from?: InputMaybe<Scalars['Time']>;
  /** End of range */
  to?: InputMaybe<Scalars['Time']>;
};

/** Sort direction, can be either Asc or Desc. */
export enum Direction {
  Asc = 'Asc',
  Desc = 'Desc',
}

/** Specifies a Environment Variable */
export type EnvironmentInput = {
  /** Name of the env var */
  key?: InputMaybe<Scalars['String']>;
  /** Value of the env var */
  value?: InputMaybe<Scalars['String']>;
};

export type EnvironmentVariable = {
  __typename?: 'EnvironmentVariable';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type Form = {
  __typename?: 'Form';
  consentNotice: Maybe<Scalars['String']>;
  fields: Array<FormField>;
  formTitle: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type FormField = {
  __typename?: 'FormField';
  /** Name of the field */
  fieldName: FormFieldName;
  id: Scalars['ID'];
  /** Is this field required to be filled in by the user */
  isRequired: Scalars['Boolean'];
};

export type FormFieldInput = {
  fieldName: FormFieldName;
  isRequired: Scalars['Boolean'];
};

export enum FormFieldName {
  CompanyName = 'company_name',
  Consent = 'consent',
  CountryCode = 'country_code',
  Email = 'email',
  FirstName = 'first_name',
  JobLevel = 'job_level',
  JobTitle = 'job_title',
  LastName = 'last_name',
  PhoneNumber = 'phone_number',
  UsState = 'us_state',
}

export type FormInput = {
  consentNotice?: InputMaybe<Scalars['String']>;
  fields: Array<FormFieldInput>;
  formTitle?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

/** A GcpProjectConfig stores the details of a GCP Project */
export type GcpProjectConfig = {
  __typename?: 'GcpProjectConfig';
  /** Unique ID */
  id: Scalars['ID'];
  /** Name of the project */
  name: Scalars['String'];
  /** List of roles that should be applied to the project Service Account and User, e.g. roles/compute.admin. See predefined list https://cloud.google.com/iam/docs/understanding-roles#predefined */
  roles: Array<Scalars['String']>;
  /** List of services that should be enabled. See https://cloud.google.com/service-usage/docs/list-services */
  services: Array<Scalars['String']>;
};

/** A GcpProjectConfig stores the details of a GCP Project */
export type GcpProjectConfigInput = {
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']>;
  /** Name of the project */
  name?: InputMaybe<Scalars['String']>;
  /** List of roles that should be applied to the project Service Account and User, e.g. roles/compute.admin. See predefined list https://cloud.google.com/iam/docs/understanding-roles#predefined */
  roles?: InputMaybe<Array<Scalars['String']>>;
  /** List of services that should be enabled. See https://cloud.google.com/service-usage/docs/list-services */
  services?: InputMaybe<Array<Scalars['String']>>;
  /** ID of the track this config belongs to */
  track?: InputMaybe<Scalars['String']>;
};

/**
 * A GoogleCloudMachineTypePreset defines a Google
 * Cloud machine type.
 */
export type GoogleCloudMachineTypePreset = {
  __typename?: 'GoogleCloudMachineTypePreset';
  /** The label of the Google Cloud machine type preset */
  label: Scalars['String'];
  /** The name of the Google Cloud machine type */
  machine_type: Scalars['String'];
};

export type HappinessCount = {
  __typename?: 'HappinessCount';
  count: Scalars['Int'];
  score: Scalars['Int'];
};

export type HotStartConfigTrackEdge = {
  __typename?: 'HotStartConfigTrackEdge';
  /** The amount of available sandboxes. */
  available: Scalars['Int'];
  /** The amount of claimed sandboxes. */
  claimed: Scalars['Int'];
  /** The amount of created sandboxes. */
  created: Scalars['Int'];
  /** The amount of sandboxes currently being created. */
  creating: Scalars['Int'];
  /** The amount of sandboxes that failed to create. */
  failed: Scalars['Int'];
  /** The config version node */
  node: SandboxConfig;
  /** The total amount of sandboxes. */
  total: Scalars['Int'];
};

/** A hot start pool manages the hot sandboxes available per track */
export type HotStartPool = {
  __typename?: 'HotStartPool';
  /** Flag that signals if the sandboxes should be auto refillable */
  auto_refill: Scalars['Boolean'];
  /** Tracks in the hot start pool */
  configs: Array<HotStartConfigTrackEdge>;
  /** Creation time of the hot start pool */
  created: Maybe<Scalars['Time']>;
  /** The user that created the pool */
  created_by: Maybe<User>;
  /** Schedule time for the hot start pool to stop creating sandboxes */
  ends_at: Maybe<Scalars['Time']>;
  /** ID of the hot start pool */
  id: Scalars['ID'];
  /** Name given to the hot start pool */
  name: Scalars['String'];
  /**
   * Organization Slug
   * @deprecated Replace with team
   */
  organization: Scalars['String'];
  /** Region of a hotstart pool */
  region: Maybe<Scalars['String']>;
  /** Number of sandboxes available per track */
  size: Scalars['Int'];
  /** Schedule time for the hot start pool to start creating sandboxes */
  starts_at: Maybe<Scalars['Time']>;
  /** Status of the hot start pool */
  status: HotStartStatus;
  /** Team Slug */
  team: Scalars['String'];
  /** Tracks in the hot start pool */
  tracks: Array<HotStartPoolTrackEdge>;
  /** The type of hot start pool */
  type: HotStartPoolType;
};

export type HotStartPoolConnection = {
  __typename?: 'HotStartPoolConnection';
  /** A list of edges containing cursors to each node. */
  edges: Array<HotStartPoolEdge>;
  /** A list of nodes. */
  nodes: Array<HotStartPool>;
  /** Pagination information. */
  pageInfo: PageInfo;
  /** Total items in the current result set. */
  totalCount: Scalars['Int'];
};

export type HotStartPoolEdge = {
  __typename?: 'HotStartPoolEdge';
  /** Cursor to the current node. */
  cursor: Scalars['String'];
  /** The current node. */
  node: Maybe<HotStartPool>;
};

/** A hot start pool is a pool of sandboxes available before the tracks start */
export type HotStartPoolInput = {
  /** List of config IDs */
  configs?: InputMaybe<Array<Scalars['String']>>;
  /** Scheduled time for the pool to start stopping sandboxes */
  ends_at?: InputMaybe<Scalars['Time']>;
  /** Name of the hot start pool */
  name?: InputMaybe<Scalars['String']>;
  /** Organization Slug of the organization creating the pool */
  organization_slug?: InputMaybe<Scalars['String']>;
  /** Region of the hotstart pool */
  region?: InputMaybe<Scalars['String']>;
  /** The amount of sandboxes per track */
  size?: InputMaybe<Scalars['Int']>;
  /** Scheduled time for the pool to start creating sandboxes */
  starts_at?: InputMaybe<Scalars['Time']>;
  /** Team Slug of the organization creating the pool */
  team_slug?: InputMaybe<Scalars['String']>;
  /** List of track IDs */
  tracks?: InputMaybe<Array<Scalars['String']>>;
  /** The type of hotstart pool */
  type?: InputMaybe<HotStartPoolType>;
};

export type HotStartPoolTrackEdge = {
  __typename?: 'HotStartPoolTrackEdge';
  /** The amount of available sandboxes. */
  available: Scalars['Int'];
  /** The amount of claimed sandboxes. */
  claimed: Scalars['Int'];
  /** The amount of created sandboxes. */
  created: Scalars['Int'];
  /** The amount of sandboxes currently being created. */
  creating: Scalars['Int'];
  /** The amount of sandboxes that failed to create. */
  failed: Scalars['Int'];
  /** The track node */
  node: Track;
  /** The total amount of sandboxes. */
  total: Scalars['Int'];
};

export enum HotStartPoolType {
  Dedicated = 'dedicated',
  Shared = 'shared',
}

export enum HotStartStatus {
  AutoRefill = 'AutoRefill',
  Expired = 'Expired',
  Inactive = 'Inactive',
  Provisioning = 'Provisioning',
  Running = 'Running',
}

/** Represents a criterium to match against */
export type HtmlElement = {
  __typename?: 'HtmlElement';
  /** The CSS selector of the element */
  selector: Scalars['String'];
  /** The expected value of the element */
  value: Scalars['String'];
};

export type HtmlElementInput = {
  selector: Scalars['String'];
  value: Scalars['String'];
};

/** A claim is a used that has accepted an invite */
export type InviteClaim = {
  __typename?: 'InviteClaim';
  /** When the user claimed the invite */
  claimedAt: Maybe<Scalars['Time']>;
  /** Custom parameters associated with this claim */
  customParameters: Array<CustomParameter>;
  /** A list of events for this track */
  events: Array<InviteEvent>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The number of plays the end user has done */
  playCount: Scalars['Int'];
  /** The number of plays the end user is allowed to do */
  playLimit: Maybe<Scalars['Int']>;
  /** The TTL until when the end user can play the track */
  playTTL: Maybe<Scalars['Time']>;
  /** The invite associated with this claim */
  trackInvite: Maybe<TrackInvite>;
  /** The list of library entries for the claim */
  trackLibrary: Array<TrackLibraryEntry>;
  /** The user that has accepted the invite */
  user: User;
  /**
   * Username of the user that has accepted the invite
   * @deprecated Replaced by user object
   */
  username: Scalars['String'];
};

/** An event stores the timestamp and status of an invite */
export type InviteEvent = {
  __typename?: 'InviteEvent';
  /** Challenge of the event */
  challenge: Maybe<Challenge>;
  /** Message of the event */
  message: Scalars['String'];
  /** participantID of the event */
  participantID: Maybe<Scalars['String']>;
  /** Status of the event */
  status: InviteStatus;
  /** Time of the event */
  time: Scalars['Time'];
  /** Track of the event */
  track: Maybe<Track>;
};

/** InviteFilterStatus options */
export enum InviteFilterStatus {
  /** Active invites */
  Active = 'active',
  /** All invites */
  All = 'all',
  /** Expired invites */
  Expired = 'expired',
  /** Upcoming invites */
  Upcoming = 'upcoming',
}

/** InviteFilters applies filters to the invite */
export type InviteFilters = {
  /**
   * Status filters the invite status.
   * Deprecated: Use `statuses`.
   */
  status?: InputMaybe<InviteFilterStatus>;
  /** Status filters the invite status */
  statuses?: InputMaybe<Array<TrackInviteStatus>>;
};

/** InvitePlay the metadata of a user's track play. */
export type InvitePlay = {
  __typename?: 'InvitePlay';
  /** Number of completed challenges. */
  completed_challenges: Scalars['Int'];
  /** The number of failed challenge attempts. */
  failed_challenge_attempts: Scalars['Int'];
  /** The last instant the user was active on this track. */
  last_activity: Scalars['Time'];
  /** The play. */
  participant: Play;
  /** The time spent on this play in seconds. */
  time_spent: Scalars['Int'];
  /** The amount of challenges associated with the track. */
  total_challenges: Scalars['Int'];
  /** The track that the user played. */
  track: Track;
  /** The instant the track was completed. */
  track_completed_at: Maybe<Scalars['Time']>;
  /** The instant the track was started. */
  track_started_at: Scalars['Time'];
  /** The user. */
  user: User;
};

/** InviteStatus enumerated the status of the invite */
export enum InviteStatus {
  /** User has accessed the invite */
  Accessed = 'accessed',
  /** User has attempted to solve the challange */
  Attempted = 'attempted',
  /** User has completed the track */
  Completed = 'completed',
  /** User has created the track */
  Created = 'created',
  /**
   * User has accepted the invite
   * @deprecated invited was ambiguous, use 'accessed' instead.
   */
  Invited = 'invited',
  /** User has skipped the challenge */
  Skipped = 'skipped',
  /** User has started the track */
  Started = 'started',
  /** User has stopped the track */
  Stopped = 'stopped',
}

export type LtiCredentials = {
  __typename?: 'LTICredentials';
  /** The consumer key of LTI credentials. */
  consumer_key: Scalars['String'];
  /** The consumer name of LTI credentials. */
  consumer_name: Scalars['String'];
  /** The id of the LTI credentials. */
  id: Scalars['ID'];
};

export type LabConfig = {
  __typename?: 'LabConfig';
  /** The seconds lab can be extended for */
  extendTTL: Maybe<Scalars['Int']>;
  /** Defines if the assignment side bar for the track's lab will overlay on top of the content */
  overlay: Scalars['Boolean'];
  /** Where in the screen will the assignment side bar show */
  position: Scalars['String'];
  /** The amount of space the asignment side bar will take for the track's lab */
  width: Scalars['Int'];
};

export type LabConfigInput = {
  /** The amount of time the sandbox will be extended */
  extendTTL?: InputMaybe<Scalars['Int']>;
  /** The lab's assignement side pannel overlays on top of the content */
  overlay?: InputMaybe<Scalars['Boolean']>;
  /** The position the side pannel starts on */
  position?: InputMaybe<Scalars['String']>;
  /** The width the assignment side pannel starts with */
  width?: InputMaybe<Scalars['Int']>;
};

/** A Learning path is a set of courses */
export type LearningPath = {
  __typename?: 'LearningPath';
  /**
   * The reason this user has access to this learning path.
   * Empty if the user has no access.
   */
  access_type: Maybe<LearningPathAccessType>;
  /** Accessible defines whether the learning path is accessible for the user, and thus is ready to play */
  accessible: Scalars['Boolean'];
  /** List of authors for this learning path */
  authors: Array<User>;
  /** List of courses that are part of this learning path */
  courses: Array<Track>;
  /** Description of the learning path */
  description: Scalars['String'];
  /** Unique ID */
  id: Scalars['ID'];
  /** Hero image, must be a URL to an image */
  image: Scalars['String'];
  /** Level defines the for what skill level the learning path is designed */
  level: Level;
  /** Slug of the team that owns the learning path */
  owner: Scalars['String'];
  /** Permalink will be generated automatically, based on the slug of the learning path */
  permalink: Scalars['String'];
  /** Preview defines whether the learning path is in preview or not */
  preview: Scalars['Boolean'];
  /** Published defines whether the learning path is published */
  published: Scalars['Boolean'];
  /** Slug. This will be visible in the address bar of the browser */
  slug: Scalars['String'];
  /** Short Teaser for the learning path */
  teaser: Scalars['String'];
  /** Learning Path Title */
  title: Scalars['String'];
};

/** The reason a user has access to a learning path. */
export enum LearningPathAccessType {
  /** One of the user's teams is the owner of this learning path. */
  Owner = 'owner',
  /** One of the user's teams purchased this content. */
  Purchased = 'purchased',
}

/** A Learning path is a set of courses */
export type LearningPathInput = {
  /** List of authors (by email) for this learning path */
  authors?: InputMaybe<Array<Scalars['String']>>;
  /** List of course slugs that are part of this learning path */
  courses?: InputMaybe<Array<Scalars['String']>>;
  /** Description of the learning path */
  description?: InputMaybe<Scalars['String']>;
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']>;
  /** Hero image, must be a URL to an image */
  image?: InputMaybe<Scalars['String']>;
  /** Level defines the for what skill level the learning path is designed */
  level?: InputMaybe<Level>;
  /** Slug of the organization that owns the learning path */
  owner?: InputMaybe<Scalars['String']>;
  /** Preview defines whether the learning path is in preview or not */
  preview?: InputMaybe<Scalars['Boolean']>;
  /** Published defines whether the learning path is published */
  published?: InputMaybe<Scalars['Boolean']>;
  /** Slug. This will be visible in the address bar of the browser */
  slug?: InputMaybe<Scalars['String']>;
  /** Short Teaser for the learning path */
  teaser?: InputMaybe<Scalars['String']>;
  /** Learning Path Title */
  title?: InputMaybe<Scalars['String']>;
};

export type LearningPathProgress = Progress & {
  __typename?: 'LearningPathProgress';
  /** Whether the user has completed all the tracks belonging to this learning path. */
  completed: Scalars['Boolean'];
  /** The number of tracks the user has completed. */
  completed_tracks: Scalars['Int'];
  /** The last time this learning path was played. */
  last_played_at: Maybe<Scalars['Time']>;
  /** The learning path. */
  learning_path: LearningPath;
};

/** Level defines the skill level, that is used in Learning Paths and Courses/Tracks */
export enum Level {
  Beginner = 'beginner',
  Expert = 'expert',
  Intermediate = 'intermediate',
}

/**
 * A MachineTypePreset defines an instruqt
 * machine type.
 */
export type MachineTypePreset = {
  __typename?: 'MachineTypePreset';
  /** The amount of cpus for the machine */
  cpus: Scalars['Int'];
  /** The label of the machine type preset */
  label: Scalars['String'];
  /** The amount of memory for the machine in MB */
  memory: Scalars['Int'];
};

/** The mode in which a play was started. */
export enum Mode {
  /** Embedded play */
  Embed = 'embed',
  /** Platform play */
  Platform = 'platform',
  /** CI test play */
  Test = 'test',
}

export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Add a track to an arcade
   *
   * Note: you need to be a member of the organization that owns the track
   */
  addTrackToArcade: Scalars['Boolean'];
  /**
   * Add a track to a topic
   *
   * Note: you need to be a member of the organization that owns the track and topic
   */
  addTrackToTopic: Maybe<Topic>;
  /**
   * Build a track
   *
   * This converts the track config into a participant environment definition. After a build, the (updated) track is available for new participant.
   *
   * Note: you need to be a developer for this track
   */
  buildTrack: Scalars['Boolean'];
  /** Promote or demote a user within a team. */
  changeTeamUserRole: Maybe<Team>;
  /**
   * Promote or demote a user within an organization.
   * @deprecated No longer supported
   */
  changeUserRole: Maybe<Organization>;
  /** Check an arcade challenge */
  checkArcadeChallenge: Maybe<Challenge>;
  /** Runs the check script of the challenge */
  checkChallenge: Maybe<Challenge>;
  /** Check if a quiz type challenge is correct */
  checkQuiz: Maybe<Challenge>;
  /**
   * Claim an organizatation invite
   * @deprecated No longer supported
   */
  claimOrganizationInvite: Maybe<OrganizationInvite>;
  /** Claim a track invite. */
  claimTrackInvite: Maybe<InviteClaim>;
  /**
   * Set whether or not the user gives consent to receive marketing updates from the given organization.
   * @deprecated No longer supported
   */
  consentToOrganizationPrivacyPolicy: Scalars['Boolean'];
  /** Set whether or not the user gives consent to receive marketing updates from the given team. */
  consentToTeamPrivacyPolicy: Scalars['Boolean'];
  /**
   * Create an Alicloud account config
   *
   * Note: you need to be a developer for this track
   */
  createAlicloudAccountConfig: Maybe<TrackConfig>;
  /**
   * Create an AWS account config
   *
   * Note: you need to be a developer for this track
   */
  createAwsAccountConfig: Maybe<TrackConfig>;
  /**
   * Create an Azure Subscription config
   *
   * Note: you need to be a developer for this track
   */
  createAzureSubscriptionConfig: Maybe<TrackConfig>;
  /**
   * Create a new challenge for a track
   *
   * Note: you need to be a developer for this track
   */
  createChallenge: Maybe<Challenge>;
  /**
   * Create a challenge note
   *
   * Note: you need to be a developer for this track
   */
  createChallengeNote: Maybe<ChallengeNote>;
  /**
   * Create a challenge tab
   *
   * Note: you need to be a developer for this track
   */
  createChallengeTab: Maybe<ChallengeTab>;
  /**
   * Create a container config
   *
   * Note: you need to be a developer for this track
   */
  createContainerConfig: Maybe<TrackConfig>;
  /**
   * Create a GCP project config
   *
   * Note: you need to be a developer for this track
   */
  createGcpProjectConfig: Maybe<TrackConfig>;
  /** Create a new hot start pool */
  createHotStartPool: Maybe<HotStartPool>;
  /**
   * Create a new learning path
   *
   * Note: you need to be a member of the organization that will own the learning path
   */
  createLearningPath: Maybe<LearningPath>;
  /**
   * Create an organization
   *
   * Note: you need to be an instruqt admin to call this mutation
   * @deprecated No longer supported
   */
  createOrganization: Maybe<Organization>;
  /** Create a new Arcade player */
  createPlayer: Maybe<Player>;
  /**
   * Creates a sandbox config with
   * the given details and resources
   *
   */
  createSandboxConfig: Maybe<SandboxConfigVersion>;
  /**
   * Create a team
   *
   * Note: you need to be an instruqt admin to call this mutation
   */
  createTeam: Maybe<Team>;
  /**
   * Create a new topic
   *
   * Note: you need to be a member of the organization that will own the topic
   */
  createTopic: Maybe<Topic>;
  /**
   * Create a track
   *
   * Note: you need to be a member of the organization that owns the track
   */
  createTrack: Maybe<Track>;
  /**
   * Create a track developer
   *
   * Note: you need to be a developer for this track
   */
  createTrackDeveloper: Maybe<Track>;
  /**
   * Create a new track invite
   *
   * Note: you need to be a member of the organization of the track the invite is for
   */
  createTrackInvite: Maybe<TrackInvite>;
  /**
   * Create track review.
   *
   * Note: this stores track review as the currently authenticated user.
   */
  createTrackReview: Maybe<TrackReview>;
  /**
   * Create a virtualbrowser config
   *
   * Note: you need to be a developer for this track
   */
  createVirtualBrowserConfig: Maybe<TrackConfig>;
  /**
   * Create a virtualmachine config
   *
   * Note: you need to be a developer for this track
   */
  createVirtualMachineConfig: Maybe<TrackConfig>;
  /** Create a webhook */
  createWebhook: Webhook;
  /**
   * Delete an Alicloud account config
   *
   * Note: you need to be a developer for this track
   */
  deleteAlicloudAccountConfig: Maybe<TrackConfig>;
  /**
   * Delete an AWS account config
   *
   * Note: you need to be a developer for this track
   */
  deleteAwsAccountConfig: Maybe<TrackConfig>;
  /**
   * Delete an Azure Subscription config
   *
   * Note: you need to be a developer for this track
   */
  deleteAzureSubscriptionConfig: Maybe<TrackConfig>;
  /**
   * Delete a challenge from a track
   *
   * Note: you need to be a developer for this track
   */
  deleteChallenge: Scalars['Boolean'];
  /**
   * Delete a challenge note
   *
   * Note: you need to be a developer for this track
   */
  deleteChallengeNote: Scalars['Boolean'];
  /**
   * Delete a challenge script
   *
   * Note: you need to be a developer for this track
   */
  deleteChallengeScript: Scalars['Boolean'];
  /**
   * Delete a challenge tab
   *
   * Note: you need to be a developer for this track
   */
  deleteChallengeTab: Scalars['Boolean'];
  /**
   * Delete a container config
   *
   * Note: you need to be a developer for this track
   */
  deleteContainerConfig: Maybe<TrackConfig>;
  /**
   * Delete a GCP project config
   *
   * Note: you need to be a developer for this track
   */
  deleteGcpProjectConfig: Maybe<TrackConfig>;
  /** Delete hot start pool */
  deleteHotStartPool: Scalars['Boolean'];
  /**
   * Delete a learning path
   *
   * Note: you need to be a member of the organization that owns the learning path
   */
  deleteLearningPath: Scalars['Boolean'];
  /**
   * Delete an organization invite
   *
   * Note: you need to be a member of the organization to invite a user
   * @deprecated No longer supported
   */
  deleteOrganizationInvite: Maybe<Organization>;
  /**
   * Deletes the given config version
   * drafts are deleted published are archived
   *
   */
  deleteSandboxConfig: Scalars['Boolean'];
  deleteSandboxConfigHost: Maybe<SandboxConfigVersion>;
  /**
   * Delete a team invite
   *
   * Note: you need to be a member of the team to invite a user
   */
  deleteTeamInvite: Maybe<Team>;
  deleteTeamSecret: Scalars['Boolean'];
  /**
   * Delete a topic
   *
   * Note: you need to be a member of the organization that owns the topic
   */
  deleteTopic: Scalars['Boolean'];
  /**
   * Delete a track
   *
   * Note: you need to be a developer for this track
   */
  deleteTrack: Scalars['Boolean'];
  /**
   * Delete a track invite
   *
   * Deleting an invite does not delete the access to the track for users that have already accepted the invite.
   *
   * Note: you need to be a member of the organization of the track the invite is for
   */
  deleteTrackInvite: Scalars['Boolean'];
  /** Delete a track invite claim. */
  deleteTrackInviteClaim: Scalars['Boolean'];
  /** Deletes a user */
  deleteUser: Scalars['Boolean'];
  /** Delete a virtual browser check */
  deleteVirtualBrowserCheck: Scalars['Boolean'];
  /**
   * Delete a virtualbrowser config
   *
   * Note: you need to be a developer for this track
   */
  deleteVirtualBrowserConfig: Maybe<TrackConfig>;
  /**
   * Delete a virtualmachine config
   *
   * Note: you need to be a developer for this track
   */
  deleteVirtualMachineConfig: Maybe<TrackConfig>;
  /** Delete a webhook */
  deleteWebhook: Scalars['Boolean'];
  /**
   * Generate a new one time play token for a track
   *
   * Note: you need to be a developer for this track
   */
  generateOneTimePlayToken: Scalars['String'];
  /**
   * Generate an API key for an organization
   *
   * Either organizationSlug or organizationID must be specified
   *
   * Note: you need to be a member of the organization to generate an API key
   * @deprecated No longer supported
   */
  generateOrganizationAPIKey: Maybe<Scalars['String']>;
  /**
   * Generate an API key for a team
   *
   * Either teamSlug or teamID must be specified
   *
   * Note: you need to be a member of the team to generate an API key
   */
  generateTeamAPIKey: Maybe<Scalars['String']>;
  /**
   * Generate LTI credentials for a team
   *
   * Either teamSlug or teamID must be specified
   *
   * Note: you need to be a member of the team to generate an API key
   */
  generateTeamLTICredentials: Maybe<LtiCredentials>;
  /**
   * Generate a new embed token for a track
   *
   * Note: you need to be a developer for this track
   */
  generateTrackEmbedToken: Maybe<Track>;
  /**
   * Invite a user to an organization
   *
   * Note: you need to be a member of the organization to invite a user
   * @deprecated No longer supported
   */
  inviteOrganizationUser: Maybe<Organization>;
  /**
   * Invite a user to a team
   *
   * Note: you need to be a member of the team to invite a user
   */
  inviteTeamUser: Maybe<Team>;
  /** Notify the track idle service that a participant is still active */
  keepAlive: Scalars['Boolean'];
  /** Login the user identified by the token in the Authorization Header */
  login: Maybe<User>;
  /**
   * Merge a anonymous account into a registered account
   *
   * Note: should be called by a logged in user
   */
  mergeAnonymousUser: Scalars['Boolean'];
  /**
   * Publish publishes the draft version
   * for the given configID
   *
   */
  publishSandboxConfig: Maybe<SandboxConfigVersion>;
  /** Refresh an ID token using the given refeshtoken */
  refreshToken: Maybe<SecureToken>;
  /** Register an arcade machine */
  registerArcade: Maybe<Arcade>;
  /** Register a new score for the the current arcade player */
  registerScore: Maybe<Ranking>;
  /**
   * Remove a user from an organization
   *
   * Note: you need to be a member of the organization to remove a user
   * @deprecated No longer supported
   */
  removeOrganizationUser: Maybe<Organization>;
  /**
   * Remove a user from a team
   *
   * Note: you need to be a member of the team to remove a user
   */
  removeTeamUser: Maybe<Team>;
  /**
   * Remove a track developer
   *
   * Note: you need to be a developer for this track
   */
  removeTrackDeveloper: Scalars['Boolean'];
  /**
   * Remove a track from an arcade
   *
   * Note: you need to be a member of the organization that owns the track
   */
  removeTrackFromArcade: Scalars['Boolean'];
  /**
   * Remove a track from a topic
   *
   * Note: you need to be a member of the organization that owns the track and topic
   */
  removeTrackFromTopic: Maybe<Topic>;
  /**
   * Renames a sandbox config with
   * the given id
   *
   */
  renameSandboxConfig: Maybe<SandboxConfig>;
  renameSandboxConfigHost: Maybe<SandboxConfigVersion>;
  /**
   * Save a challenge script
   *
   * Note: you need to be a developer for this track
   */
  saveChallengeScript: Maybe<ChallengeScript>;
  /**
   * Set a track play limit
   *
   * This sets a limit how many times a public track can be played. You can use this to prevent excessive charges to your account.
   *
   * Note: you have to be a developer for this track
   */
  saveTrackPlayLimit: Maybe<Track>;
  /**
   * Set th track play limits for the given track and team
   *
   * Note: if the track ID is not specified the limits will
   * apply globally for all tracks
   */
  saveTrackPlayLimits: Array<TrackPlayLimit>;
  /**
   * Save a track script
   *
   * Note: you need to be a developer for this track
   */
  saveTrackScript: Maybe<TrackScript>;
  /** Set runtime variable value to sandbox host */
  setSandboxVariable: Maybe<SandboxVariable>;
  /**
   * Set maintenance flag for a track
   *
   * Note: you need to be a developer for this track
   */
  setTrackMaintenance: Maybe<Track>;
  setTrackSandboxConfigVersion: Scalars['Boolean'];
  /** Runs the setup script for a challenge */
  setupChallenge: Maybe<Challenge>;
  /** Sign in anonymously, returns an ID token */
  signInAnonymously: Maybe<SecureToken>;
  /** Skip a specific challenge of a track */
  skipChallenge: Scalars['Boolean'];
  /** Skip to a specific challenge of a track */
  skipToChallenge: Maybe<Track>;
  /** Solve callenge solves the challenge */
  solveChallenge: Maybe<Challenge>;
  /**
   * Starts a challenge
   *
   * Should be called after the setup has completed successfully
   */
  startChallenge: Maybe<Challenge>;
  /**
   * Starts a track
   *
   * Will start a new play for the logged in user. If the user already has a running instance of this track, that one will be returned rather than starting a new one.
   */
  startTrack: Maybe<Track>;
  /** Stop all active tracks */
  stopAllTracks: Scalars['Boolean'];
  /** Stop a sandbox instance */
  stopSandbox: Maybe<Sandbox>;
  /** Stops a track */
  stopTrack: Maybe<Track>;
  /**
   * Update an Alicloud account config
   *
   * Note: you need to be a developer for this track
   */
  updateAlicloudAccountConfig: Maybe<TrackConfig>;
  /**
   * Update an existing arcade
   *
   * Note: you need to be a member of the organization that owns the arcade
   */
  updateArcade: Maybe<Arcade>;
  /**
   * Update an AWS account config
   *
   * Note: you need to be a developer for this track
   */
  updateAwsAccountConfig: Maybe<TrackConfig>;
  /**
   * Update an Azure Subscription config
   *
   * Note: you need to be a developer for this track
   */
  updateAzureSubscriptionConfig: Maybe<TrackConfig>;
  /**
   * Update a challenge of a track
   *
   * Note: you need to be a developer for this track
   */
  updateChallenge: Maybe<Challenge>;
  /**
   * Update the challenge order of a track
   *
   * Note: you need to be a developer for this track
   */
  updateChallengeIndexes: Maybe<Array<Challenge>>;
  /**
   * Update a challenge note
   *
   * Note: you need to be a developer for this track
   */
  updateChallengeNote: Maybe<ChallengeNote>;
  /**
   * Update challenge note order
   *
   * Note: you need to be a developer for this track
   */
  updateChallengeNoteIndexes: Maybe<Array<ChallengeNote>>;
  /**
   * Update a challenge tab
   *
   * Note: you need to be a developer for this track
   */
  updateChallengeTab: Maybe<ChallengeTab>;
  /**
   * Update challenge tab order
   *
   * Note: you need to be a developer for this track
   */
  updateChallengeTabIndexes: Maybe<Array<ChallengeTab>>;
  /**
   * Update a complete track
   *
   * This is similar to updateTrack, but will also update the developers, challenge scripts and track config. It expects that all these fields are set on the input. If they are not set, it will remove any existing values from the database. The main use-case for this is facilitating the CLI.
   *
   * Note: you need to be a developer for this track
   */
  updateCompleteTrack: Maybe<Track>;
  /**
   * Update a container config
   *
   * Note: you need to be a developer for this track
   */
  updateContainerConfig: Maybe<TrackConfig>;
  /** Updates the user details form for a team */
  updateForm: Maybe<Form>;
  /**
   * Update a GCP project config
   *
   * Note: you need to be a developer for this track
   */
  updateGcpProjectConfig: Maybe<TrackConfig>;
  /** Update hot start pool */
  updateHotStartPool: Maybe<HotStartPool>;
  /**
   * Update a learning path
   *
   * Note: you need to be a member of the organization that owns the learning path
   */
  updateLearningPath: Maybe<LearningPath>;
  updateLocalOrganization: Maybe<Organization>;
  /**
   * Update an organization
   * @deprecated No longer supported
   */
  updateOrganization: Maybe<Organization>;
  /**
   * Update organization features
   * @deprecated No longer supported
   */
  updateOrganizationFeatures: Maybe<OrganizationFeatures>;
  /**
   * Updates the given config
   *
   */
  updateSandboxConfig: Maybe<SandboxConfigVersion>;
  /** Update the sandbox ttl time */
  updateSandboxTTL: Maybe<Sandbox>;
  /**
   * Updates the secret configs for a track
   *
   * Note: you need to be a developer for this track
   */
  updateSecretConfig: Maybe<TrackConfig>;
  /** Update a team */
  updateTeam: Maybe<Team>;
  /** Update team features */
  updateTeamFeatures: Maybe<TeamFeatures>;
  /**
   * Update a topic
   *
   * Note: you need to be a member of the organization that owns the topic
   */
  updateTopic: Maybe<Topic>;
  /**
   * Update the indexes of tracks in a topic
   *
   * Note: you need to be a member of the organization that owns the topic
   */
  updateTopicTrackIndexes: Maybe<Topic>;
  /**
   * Update a track
   *
   * Note: you need to be a developer for this track
   */
  updateTrack: Maybe<Track>;
  /**
   * Update a track invite
   *
   * Note: you need to be a member of the organization of the track the invite is for
   */
  updateTrackInvite: Maybe<TrackInvite>;
  /**
   * Update track review with content.
   *
   * Note: this updates track review as the currently authenticated user.
   */
  updateTrackReview: Maybe<TrackReview>;
  /** Update a user with displayName and/or slug (username) */
  updateUser: Maybe<User>;
  /**
   * Update a virtualbrowser config
   *
   * Note: you need to be a developer for this track
   */
  updateVirtualBrowserConfig: Maybe<TrackConfig>;
  /**
   * Update a virtualmachine config
   *
   * Note: you need to be a developer for this track
   */
  updateVirtualMachineConfig: Maybe<TrackConfig>;
  /** Update a webhook */
  updateWebhook: Webhook;
  upsertTeamSecret: Maybe<Secret>;
  /** Create a new virtual browser check */
  upsertVirtualBrowserCheck: VirtualBrowserCheck;
};

export type MutationAddTrackToArcadeArgs = {
  trackID: Scalars['String'];
};

export type MutationAddTrackToTopicArgs = {
  topicID: Scalars['String'];
  trackID: Scalars['String'];
};

export type MutationBuildTrackArgs = {
  trackID: Scalars['String'];
};

export type MutationChangeTeamUserRoleArgs = {
  role: RoleName;
  teamID: Scalars['String'];
  userID: Scalars['String'];
};

export type MutationChangeUserRoleArgs = {
  organizationID: Scalars['String'];
  role: RoleName;
  userID: Scalars['String'];
};

export type MutationCheckArcadeChallengeArgs = {
  challengeID: Scalars['String'];
  playerID: Scalars['String'];
};

export type MutationCheckChallengeArgs = {
  challengeID: Scalars['String'];
  inviteID: InputMaybe<Scalars['String']>;
  userID: InputMaybe<Scalars['String']>;
  waitForCleanup: InputMaybe<Scalars['Boolean']>;
};

export type MutationCheckQuizArgs = {
  challengeID: Scalars['String'];
  inviteID: InputMaybe<Scalars['String']>;
  solution: Array<Scalars['Int']>;
  userID: InputMaybe<Scalars['String']>;
};

export type MutationClaimOrganizationInviteArgs = {
  token: Scalars['String'];
};

export type MutationClaimTrackInviteArgs = {
  customParameters: InputMaybe<Array<CustomParametersInput>>;
  inviteID: Scalars['String'];
  userDetails: InputMaybe<UserDetailsInput>;
};

export type MutationConsentToOrganizationPrivacyPolicyArgs = {
  consent: Scalars['Boolean'];
  organizationID: Scalars['String'];
};

export type MutationConsentToTeamPrivacyPolicyArgs = {
  consent: Scalars['Boolean'];
  teamID: Scalars['String'];
};

export type MutationCreateAlicloudAccountConfigArgs = {
  config: AlicloudAccountConfigInput;
};

export type MutationCreateAwsAccountConfigArgs = {
  config: AwsAccountConfigInput;
};

export type MutationCreateAzureSubscriptionConfigArgs = {
  config: AzureSubscriptionConfigInput;
};

export type MutationCreateChallengeArgs = {
  challenge: ChallengeInput;
};

export type MutationCreateChallengeNoteArgs = {
  note: ChallengeNoteInput;
};

export type MutationCreateChallengeTabArgs = {
  tab: ChallengeTabInput;
};

export type MutationCreateContainerConfigArgs = {
  config: ContainerConfigInput;
};

export type MutationCreateGcpProjectConfigArgs = {
  config: GcpProjectConfigInput;
};

export type MutationCreateHotStartPoolArgs = {
  pool: HotStartPoolInput;
};

export type MutationCreateLearningPathArgs = {
  learningPath: LearningPathInput;
};

export type MutationCreateOrganizationArgs = {
  name: Scalars['String'];
  ownerEmails: Array<Scalars['String']>;
  slug: Scalars['String'];
};

export type MutationCreatePlayerArgs = {
  difficulty: InputMaybe<Scalars['String']>;
  trackID: InputMaybe<Scalars['String']>;
};

export type MutationCreateSandboxConfigArgs = {
  config: SandboxConfigInput;
  name: InputMaybe<Scalars['String']>;
  slug: InputMaybe<Scalars['String']>;
  teamID: InputMaybe<Scalars['String']>;
  teamSlug: InputMaybe<Scalars['String']>;
};

export type MutationCreateTeamArgs = {
  name: Scalars['String'];
  ownerEmails: Array<Scalars['String']>;
  slug: Scalars['String'];
};

export type MutationCreateTopicArgs = {
  topic: TopicInput;
};

export type MutationCreateTrackArgs = {
  track: TrackInput;
};

export type MutationCreateTrackDeveloperArgs = {
  trackID: Scalars['String'];
  userID: Scalars['String'];
};

export type MutationCreateTrackInviteArgs = {
  invite: TrackInviteInput;
};

export type MutationCreateTrackReviewArgs = {
  participantID: Scalars['String'];
  score: Scalars['Int'];
  trackID: Scalars['String'];
};

export type MutationCreateVirtualBrowserConfigArgs = {
  config: VirtualBrowserConfigInput;
};

export type MutationCreateVirtualMachineConfigArgs = {
  config: VirtualMachineConfigInput;
};

export type MutationCreateWebhookArgs = {
  teamID: InputMaybe<Scalars['String']>;
  teamSlug: InputMaybe<Scalars['String']>;
  webhook: WebhookInput;
};

export type MutationDeleteAlicloudAccountConfigArgs = {
  alicloudAccountID: Scalars['String'];
};

export type MutationDeleteAwsAccountConfigArgs = {
  awsAccountID: Scalars['String'];
};

export type MutationDeleteAzureSubscriptionConfigArgs = {
  azureSubscriptionID: Scalars['String'];
};

export type MutationDeleteChallengeArgs = {
  challengeID: Scalars['String'];
};

export type MutationDeleteChallengeNoteArgs = {
  noteID: Scalars['String'];
};

export type MutationDeleteChallengeScriptArgs = {
  challengeScriptID: Scalars['String'];
};

export type MutationDeleteChallengeTabArgs = {
  tabID: Scalars['String'];
};

export type MutationDeleteContainerConfigArgs = {
  containerID: Scalars['String'];
};

export type MutationDeleteGcpProjectConfigArgs = {
  gcpProjectID: Scalars['String'];
};

export type MutationDeleteHotStartPoolArgs = {
  poolID: Scalars['ID'];
};

export type MutationDeleteLearningPathArgs = {
  learningPathID: Scalars['String'];
};

export type MutationDeleteOrganizationInviteArgs = {
  email: Scalars['String'];
  organizationID: Scalars['String'];
};

export type MutationDeleteSandboxConfigArgs = {
  configVersionID: Scalars['String'];
};

export type MutationDeleteSandboxConfigHostArgs = {
  configID: Scalars['String'];
  hostName: Scalars['String'];
};

export type MutationDeleteTeamInviteArgs = {
  email: Scalars['String'];
  teamID: Scalars['String'];
};

export type MutationDeleteTeamSecretArgs = {
  name: Scalars['String'];
  teamID: InputMaybe<Scalars['String']>;
  teamSlug: InputMaybe<Scalars['String']>;
};

export type MutationDeleteTopicArgs = {
  topicID: Scalars['String'];
};

export type MutationDeleteTrackArgs = {
  trackID: Scalars['String'];
};

export type MutationDeleteTrackInviteArgs = {
  inviteID: Scalars['String'];
};

export type MutationDeleteTrackInviteClaimArgs = {
  claimID: Scalars['String'];
};

export type MutationDeleteVirtualBrowserCheckArgs = {
  id: Scalars['String'];
};

export type MutationDeleteVirtualBrowserConfigArgs = {
  virtualbrowserID: Scalars['String'];
};

export type MutationDeleteVirtualMachineConfigArgs = {
  virtualmachineID: Scalars['String'];
};

export type MutationDeleteWebhookArgs = {
  id: Scalars['String'];
  teamID: InputMaybe<Scalars['String']>;
  teamSlug: InputMaybe<Scalars['String']>;
};

export type MutationGenerateOneTimePlayTokenArgs = {
  trackID: Scalars['String'];
};

export type MutationGenerateOrganizationApiKeyArgs = {
  organizationID: InputMaybe<Scalars['String']>;
  organizationSlug: InputMaybe<Scalars['String']>;
};

export type MutationGenerateTeamApiKeyArgs = {
  teamID: InputMaybe<Scalars['String']>;
  teamSlug: InputMaybe<Scalars['String']>;
};

export type MutationGenerateTeamLtiCredentialsArgs = {
  teamID: InputMaybe<Scalars['String']>;
  teamSlug: InputMaybe<Scalars['String']>;
};

export type MutationGenerateTrackEmbedTokenArgs = {
  trackID: Scalars['String'];
};

export type MutationInviteOrganizationUserArgs = {
  email: InputMaybe<Scalars['String']>;
  organizationID: Scalars['String'];
  role: InputMaybe<RoleName>;
  userID: InputMaybe<Scalars['String']>;
};

export type MutationInviteTeamUserArgs = {
  email: InputMaybe<Scalars['String']>;
  role: InputMaybe<RoleName>;
  teamID: Scalars['String'];
  userID: InputMaybe<Scalars['String']>;
};

export type MutationKeepAliveArgs = {
  trackID: Scalars['ID'];
};

export type MutationLoginArgs = {
  inviteToken: InputMaybe<Scalars['String']>;
};

export type MutationMergeAnonymousUserArgs = {
  token: Scalars['String'];
};

export type MutationPublishSandboxConfigArgs = {
  changeLogEntry: InputMaybe<Scalars['String']>;
  configID: Scalars['String'];
};

export type MutationRefreshTokenArgs = {
  refreshToken: Scalars['String'];
};

export type MutationRegisterArcadeArgs = {
  organizationSlug: Scalars['String'];
  serialNumber: Scalars['String'];
  token: Scalars['String'];
};

export type MutationRegisterScoreArgs = {
  difficulty: Scalars['String'];
  handle: Scalars['String'];
  organizationID: InputMaybe<Scalars['String']>;
  organizationSlug: InputMaybe<Scalars['String']>;
  playerID: Scalars['String'];
  trackID: Scalars['String'];
};

export type MutationRemoveOrganizationUserArgs = {
  organizationID: Scalars['String'];
  userID: Scalars['String'];
};

export type MutationRemoveTeamUserArgs = {
  teamID: Scalars['String'];
  userID: Scalars['String'];
};

export type MutationRemoveTrackDeveloperArgs = {
  trackID: Scalars['String'];
  userID: Scalars['String'];
};

export type MutationRemoveTrackFromArcadeArgs = {
  trackID: Scalars['String'];
};

export type MutationRemoveTrackFromTopicArgs = {
  topicID: Scalars['String'];
  trackID: Scalars['String'];
};

export type MutationRenameSandboxConfigArgs = {
  configID: Scalars['String'];
  name: Scalars['String'];
};

export type MutationRenameSandboxConfigHostArgs = {
  configID: Scalars['String'];
  hostName: Scalars['String'];
  newName: Scalars['String'];
};

export type MutationSaveChallengeScriptArgs = {
  base64Encoded: InputMaybe<Scalars['Boolean']>;
  script: ChallengeScriptInput;
};

export type MutationSaveTrackPlayLimitArgs = {
  limit: Scalars['Int'];
  organizationID: Scalars['String'];
  trackID: Scalars['String'];
};

export type MutationSaveTrackPlayLimitsArgs = {
  teamID: InputMaybe<Scalars['String']>;
  teamSlug: InputMaybe<Scalars['String']>;
  trackID: InputMaybe<Scalars['String']>;
  trackPlayLimits: TrackPlayLimitInput;
};

export type MutationSaveTrackScriptArgs = {
  base64Encoded: InputMaybe<Scalars['Boolean']>;
  script: TrackScriptInput;
};

export type MutationSetSandboxVariableArgs = {
  hostname: Scalars['String'];
  key: Scalars['String'];
  sandboxID: Scalars['String'];
  value: Scalars['String'];
};

export type MutationSetTrackMaintenanceArgs = {
  maintenance: Scalars['Boolean'];
  trackID: Scalars['String'];
};

export type MutationSetTrackSandboxConfigVersionArgs = {
  configVersionID: InputMaybe<Scalars['String']>;
  trackID: Scalars['String'];
};

export type MutationSetupChallengeArgs = {
  challengeID: Scalars['String'];
};

export type MutationSkipChallengeArgs = {
  challengeID: Scalars['String'];
  inviteID: InputMaybe<Scalars['String']>;
  trackID: Scalars['String'];
  userID: InputMaybe<Scalars['String']>;
};

export type MutationSkipToChallengeArgs = {
  challengeID: Scalars['String'];
  force: InputMaybe<Scalars['Boolean']>;
  inviteID: InputMaybe<Scalars['String']>;
  trackID: Scalars['String'];
  userID: InputMaybe<Scalars['String']>;
};

export type MutationSolveChallengeArgs = {
  challengeID: Scalars['String'];
};

export type MutationStartChallengeArgs = {
  challengeID: Scalars['String'];
};

export type MutationStartTrackArgs = {
  customParameters: InputMaybe<Array<CustomParametersInput>>;
  force: InputMaybe<Scalars['Boolean']>;
  inviteID: InputMaybe<Scalars['String']>;
  mode: InputMaybe<Mode>;
  prestart: InputMaybe<Scalars['Boolean']>;
  recaptchaToken: InputMaybe<Scalars['String']>;
  region: InputMaybe<Scalars['String']>;
  trackID: Scalars['String'];
};

export type MutationStopSandboxArgs = {
  sandboxID: Scalars['String'];
};

export type MutationStopTrackArgs = {
  trackID: Scalars['String'];
};

export type MutationUpdateAlicloudAccountConfigArgs = {
  config: AlicloudAccountConfigInput;
};

export type MutationUpdateArcadeArgs = {
  arcade: ArcadeInput;
};

export type MutationUpdateAwsAccountConfigArgs = {
  config: AwsAccountConfigInput;
};

export type MutationUpdateAzureSubscriptionConfigArgs = {
  config: AzureSubscriptionConfigInput;
};

export type MutationUpdateChallengeArgs = {
  challenge: ChallengeInput;
};

export type MutationUpdateChallengeIndexesArgs = {
  challenges: Array<Scalars['String']>;
  trackID: Scalars['String'];
};

export type MutationUpdateChallengeNoteArgs = {
  note: ChallengeNoteInput;
};

export type MutationUpdateChallengeNoteIndexesArgs = {
  challengeID: Scalars['String'];
  notes: Array<Scalars['String']>;
};

export type MutationUpdateChallengeTabArgs = {
  tab: ChallengeTabInput;
};

export type MutationUpdateChallengeTabIndexesArgs = {
  challengeID: Scalars['String'];
  tabs: Array<Scalars['String']>;
};

export type MutationUpdateCompleteTrackArgs = {
  track: TrackInput;
};

export type MutationUpdateContainerConfigArgs = {
  config: ContainerConfigInput;
};

export type MutationUpdateFormArgs = {
  form: FormInput;
};

export type MutationUpdateGcpProjectConfigArgs = {
  config: GcpProjectConfigInput;
};

export type MutationUpdateHotStartPoolArgs = {
  id: Scalars['ID'];
  pool: HotStartPoolInput;
};

export type MutationUpdateLearningPathArgs = {
  learningPath: LearningPathInput;
};

export type MutationUpdateLocalOrganizationArgs = {
  id: Scalars['String'];
  organization: OrganizationInput;
};

export type MutationUpdateOrganizationArgs = {
  organization: OrganizationInput;
};

export type MutationUpdateOrganizationFeaturesArgs = {
  features: OrganizationFeaturesInput;
  orgID: Scalars['String'];
};

export type MutationUpdateSandboxConfigArgs = {
  config: SandboxConfigInput;
  configID: Scalars['String'];
};

export type MutationUpdateSandboxTtlArgs = {
  sandboxID: Scalars['String'];
  until: Scalars['Time'];
};

export type MutationUpdateSecretConfigArgs = {
  configs: Array<SecretConfigInput>;
  trackID: Scalars['String'];
};

export type MutationUpdateTeamArgs = {
  team: TeamInput;
};

export type MutationUpdateTeamFeaturesArgs = {
  features: TeamFeaturesInput;
  teamID: Scalars['String'];
};

export type MutationUpdateTopicArgs = {
  topic: TopicInput;
};

export type MutationUpdateTopicTrackIndexesArgs = {
  topicID: Scalars['String'];
  tracks: Array<Scalars['String']>;
};

export type MutationUpdateTrackArgs = {
  track: TrackInput;
};

export type MutationUpdateTrackInviteArgs = {
  invite: TrackInviteInput;
};

export type MutationUpdateTrackReviewArgs = {
  content: Scalars['String'];
  id: Scalars['String'];
};

export type MutationUpdateUserArgs = {
  displayName: InputMaybe<Scalars['String']>;
  slug: InputMaybe<Scalars['String']>;
  userID: Scalars['String'];
};

export type MutationUpdateVirtualBrowserConfigArgs = {
  config: VirtualBrowserConfigInput;
};

export type MutationUpdateVirtualMachineConfigArgs = {
  config: VirtualMachineConfigInput;
};

export type MutationUpdateWebhookArgs = {
  id: Scalars['String'];
  teamID: InputMaybe<Scalars['String']>;
  teamSlug: InputMaybe<Scalars['String']>;
  webhook: WebhookInput;
};

export type MutationUpsertTeamSecretArgs = {
  description: Scalars['String'];
  name: Scalars['String'];
  secret: Scalars['String'];
  teamID: InputMaybe<Scalars['String']>;
  teamSlug: InputMaybe<Scalars['String']>;
};

export type MutationUpsertVirtualBrowserCheckArgs = {
  virtualBrowserCheck: VirtualBrowserCheckInput;
};

/** Parameters to sort a result set. */
export type Ordering = {
  /** The sort direction to use, either Asc or Desc. */
  direction?: InputMaybe<Direction>;
  /** The column to sort by. */
  orderBy: Scalars['String'];
};

/** An organization has members, and owns topics and tracks */
export type Organization = {
  __typename?: 'Organization';
  /** API Key for the organization */
  api_key: Maybe<Scalars['String']>;
  /** The time the organization was created at. */
  created_at: Maybe<Scalars['Time']>;
  /** The time the organization has become a customer at. */
  customer_since: Maybe<Scalars['Time']>;
  /** The list of features that an organization can access or use */
  features: Maybe<OrganizationFeatures>;
  /** Unique ID */
  id: Scalars['ID'];
  /**
   * Invited shows a list of email addresses that are invites
   * TODO: IN-378 Remove deprecated field.
   * @deprecated use field `invites`
   */
  invited: Array<Scalars['String']>;
  /** A list of active invites for this organization */
  invites: Maybe<Array<OrganizationInvite>>;
  /** Logo of the organization */
  logo: Maybe<Scalars['String']>;
  /**
   * List of members
   * TODO: IN-364 Remove deprecated members field from organization.
   * @deprecated use `users` field
   */
  members: Array<OrganizationMember>;
  /** Name of the organization */
  name: Scalars['String'];
  /** Whether the organization is personal or not */
  personal: Maybe<Scalars['Boolean']>;
  /** Text of the primary link of the organization */
  primary_link_text: Maybe<Scalars['String']>;
  /** URL of the primary link of the organization */
  primary_link_url: Maybe<Scalars['String']>;
  /** The URL of the organization's privacy policy, if any. */
  privacy_policy: Maybe<Scalars['String']>;
  /** Text of the secondary link of the organization */
  secondary_link_text: Maybe<Scalars['String']>;
  /** URL of the secondary link of the organization */
  secondary_link_url: Maybe<Scalars['String']>;
  /** Slug of the organization */
  slug: Scalars['String'];
  /** Subtitle of the organization */
  subtitle: Maybe<Scalars['String']>;
  /** The theme that is used to style the organization page */
  theme: Maybe<OrganizationTheme>;
  /** Title of the organization */
  title: Maybe<Scalars['String']>;
  /** The time the organization's trial terminates. */
  trial_end_at: Maybe<Scalars['Time']>;
  /** List of users */
  users: Maybe<Array<OrganizationUserEdge>>;
  /** The one time use URL for the Svix dashboard to configure webhook endpoints. */
  webhook_dashboard_url: Scalars['String'];
};

/** OrganizationFeatures define what features are enabled for an organization */
export type OrganizationFeatures = {
  __typename?: 'OrganizationFeatures';
  /** Whether the user has a custom invite with the terms of service */
  accept_terms_checkbox: Scalars['Boolean'];
  /** Whether Alicloud accounts can be used */
  alicloud_accounts: Scalars['Boolean'];
  /** Whether arcades can be used */
  arcades: Scalars['Boolean'];
  /** Whether AWS accounts can be used */
  aws_accounts: Scalars['Boolean'];
  /** Whether Azure subscriptions can be used */
  azure_subscriptions: Scalars['Boolean'];
  /** Whether containers can be used */
  containers: Scalars['Boolean'];
  /** Whether tracks can be embedded in other pages */
  embedded: Scalars['Boolean'];
  /** Whether GCP projects can be used */
  gcp_projects: Scalars['Boolean'];
  /** Whether hot start is enabled for this organization */
  hot_start: Scalars['Boolean'];
  /** Whether invites can be created */
  invites: Scalars['Boolean'];
  /**
   * The maximum size of a hot start pool
   * @deprecated Use `max_hot_start_pool_size_scheduled`.
   */
  max_hot_start_pool_size: Scalars['Int'];
  /** The maximum size of an always on hot start pool */
  max_hot_start_pool_size_always_on: Scalars['Int'];
  /** The maximum size of a scheduled hot start pool */
  max_hot_start_pool_size_scheduled: Scalars['Int'];
  /** The maximum number of members in this organization */
  max_members: Scalars['Int'];
  /** The maximum timelimit for a single track */
  max_timelimit: Scalars['Int'];
  /** The maximum number of tracks that can be created */
  max_tracks: Scalars['Int'];
  /** Whether organization members can skip to a challenge */
  members_skip_to_challenge: Scalars['Boolean'];
  /** Whether private content is allowed */
  private_content: Scalars['Boolean'];
  /** Whether an overlay if shown on the service tab when playing a challenge. */
  service_tab_focus_overlay: Scalars['Boolean'];
  /** Whether statistics are accessible */
  statistics: Scalars['Boolean'];
  /** Whether the new study room is enabled for this organization */
  study_room_v2: Scalars['Boolean'];
  /** Whether the new team page is enabled for this organization */
  team_page_v2: Scalars['Boolean'];
  /** Whether students can leave a track review after finishing a track. */
  track_reviews: Scalars['Boolean'];
  /** Whether virtual machines can be used */
  virtual_machines: Scalars['Boolean'];
  /** Whether vm pooling can be used */
  vm_pooling: Scalars['Boolean'];
  /** Whether webhooks are enabled for this organization */
  webhooks: Scalars['Boolean'];
};

/** OrganizationFeaturesInput defines the input for mutating features of an organization. */
export type OrganizationFeaturesInput = {
  /** Whether the user has a custom invite with the terms of service */
  accept_terms_checkbox?: InputMaybe<Scalars['Boolean']>;
  /** Whether Alicloud accounts can be used */
  alicloud_accounts?: InputMaybe<Scalars['Boolean']>;
  /** Whether arcades can be used */
  arcades?: InputMaybe<Scalars['Boolean']>;
  /** Whether AWS accounts can be used */
  aws_accounts?: InputMaybe<Scalars['Boolean']>;
  /** Whether Azure subscriptions can be used */
  azure_subscriptions?: InputMaybe<Scalars['Boolean']>;
  /** Whether containers can be used */
  containers?: InputMaybe<Scalars['Boolean']>;
  /** Whether tracks can be embedded in other pages */
  embedded?: InputMaybe<Scalars['Boolean']>;
  /** Whether GCP projects can be used */
  gcp_projects?: InputMaybe<Scalars['Boolean']>;
  /** Whether hot start is enabled for this organization */
  hot_start?: InputMaybe<Scalars['Boolean']>;
  /** Whether invites can be created */
  invites?: InputMaybe<Scalars['Boolean']>;
  /**
   * The maximum size of a hot start pool.
   * Deprecated: Use `max_hot_start_pool_size_scheduled`.
   */
  max_hot_start_pool_size?: InputMaybe<Scalars['Int']>;
  /** The maximum size of an always on hot start pool */
  max_hot_start_pool_size_always_on?: InputMaybe<Scalars['Int']>;
  /** The maximum size of a scheduled hot start pool */
  max_hot_start_pool_size_scheduled?: InputMaybe<Scalars['Int']>;
  /** The maximum number of members in this organization */
  max_members?: InputMaybe<Scalars['Int']>;
  /** The maximum timelimit for a single track */
  max_timelimit?: InputMaybe<Scalars['Int']>;
  /** The maximum number of tracks that can be created */
  max_tracks?: InputMaybe<Scalars['Int']>;
  /** Whether organization members can skip to a challenge */
  members_skip_to_challenge?: InputMaybe<Scalars['Boolean']>;
  /** Whether private content is allowed */
  private_content?: InputMaybe<Scalars['Boolean']>;
  /** Whether an overlay if shown on the service tab when playing a challenge. */
  service_tab_focus_overlay?: InputMaybe<Scalars['Boolean']>;
  /** Whether statistics are accessible */
  statistics?: InputMaybe<Scalars['Boolean']>;
  /** Whether the new study room is enabled for this organization */
  study_room_v2?: InputMaybe<Scalars['Boolean']>;
  /** Whether the new team page is enabled for this organization */
  team_page_v2?: InputMaybe<Scalars['Boolean']>;
  /** Whether students can leave a track review after finishing a track. */
  track_reviews?: InputMaybe<Scalars['Boolean']>;
  /** Whether virtual machines can be used */
  virtual_machines?: InputMaybe<Scalars['Boolean']>;
  /** Whether vm pooling can be used */
  vm_pooling?: InputMaybe<Scalars['Boolean']>;
  /** Whether webhooks are enabled for this organization */
  webhooks?: InputMaybe<Scalars['Boolean']>;
};

/** An organization has members, and owns topics and tracks */
export type OrganizationInput = {
  /** time when the organization became a customer */
  customer_since?: InputMaybe<Scalars['Time']>;
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']>;
  /** Logo of the organization */
  logo?: InputMaybe<Scalars['String']>;
  /** Name of the organization */
  name?: InputMaybe<Scalars['String']>;
  /** Text of the primary link of the organization */
  primary_link_text?: InputMaybe<Scalars['String']>;
  /** URL of the primary link of the organization */
  primary_link_url?: InputMaybe<Scalars['String']>;
  /** Text of the secondary link of the organization */
  secondary_link_text?: InputMaybe<Scalars['String']>;
  /** URL of the secondary link of the organization */
  secondary_link_url?: InputMaybe<Scalars['String']>;
  /** Slug of the organization */
  slug?: InputMaybe<Scalars['String']>;
  /** Subtitle of the organization */
  subtitle?: InputMaybe<Scalars['String']>;
  /** The theme that is used to style the organization page */
  theme?: InputMaybe<OrganizationThemeInput>;
  /** Title of the organization */
  title?: InputMaybe<Scalars['String']>;
  /** instant at which the organization's ends / ended */
  trial_end_at?: InputMaybe<Scalars['Time']>;
};

/** OrganizationInvite represents an outstanding invite for an email address to join the organization */
export type OrganizationInvite = {
  __typename?: 'OrganizationInvite';
  /** The time the invite was accepted */
  accepted_at: Maybe<Scalars['Time']>;
  /** The user the invite was created by */
  created_by: Maybe<User>;
  /** The email of the invite */
  email: Scalars['String'];
  /** The organization this invite belongs to */
  organization: Maybe<Organization>;
  /** The role that the user will get when accepting the invite */
  role: RoleName;
  /** Whether the token in the email invite has expired */
  token_expired: Scalars['Boolean'];
};

/**
 * Member of an organization
 * TODO: IN-364 Remove deprecated type.
 */
export type OrganizationMember = {
  __typename?: 'OrganizationMember';
  /**
   * The user's ID
   * @deprecated use field `user`
   */
  id: Scalars['ID'];
  /**
   * The user's profile
   * @deprecated use field `user`
   */
  profile: Maybe<UserProfile>;
  /** The user's role in the organization */
  role: RoleName;
  /** The user */
  user: User;
};

export type OrganizationSeries = {
  __typename?: 'OrganizationSeries';
  completed: Scalars['Int'];
  date: Scalars['String'];
  started: Scalars['Int'];
};

export type OrganizationStatistics = {
  __typename?: 'OrganizationStatistics';
  completed_total: Maybe<Scalars['Int']>;
  organization_series: Array<OrganizationSeries>;
  restarted_total: Maybe<Scalars['Int']>;
  started_total: Maybe<Scalars['Int']>;
  track_statistics: Array<TrackStatistics>;
};

/** An OrganizationTeme defines the look and feel for an organization */
export type OrganizationTheme = {
  __typename?: 'OrganizationTheme';
  /** The color used for the background of the header */
  background_color: Maybe<Scalars['String']>;
  /** The image used for the background of the header */
  background_image: Maybe<Scalars['String']>;
  /** The color used for the text in the header */
  foreground_color: Maybe<Scalars['String']>;
  /** The image that is shown in the header */
  foreground_image: Maybe<Scalars['String']>;
  /** The color used for the background of the primary button */
  primary_background_color: Maybe<Scalars['String']>;
  /** The color used for the text of the primary button */
  primary_foreground_color: Maybe<Scalars['String']>;
  /** The color used for the background of the secondary button */
  secondary_background_color: Maybe<Scalars['String']>;
  /** The color used for the text of the secondary button */
  secondary_foreground_color: Maybe<Scalars['String']>;
};

export type OrganizationThemeInput = {
  /** The color used for the background of the header */
  background_color?: InputMaybe<Scalars['String']>;
  /** The image used for the background of the header */
  background_image?: InputMaybe<Scalars['String']>;
  /** The color used for the text in the header */
  foreground_color?: InputMaybe<Scalars['String']>;
  /** The image that is shown in the header */
  foreground_image?: InputMaybe<Scalars['String']>;
  /** The color used for the background of the primary button */
  primary_background_color?: InputMaybe<Scalars['String']>;
  /** The color used for the text of the primary button */
  primary_foreground_color?: InputMaybe<Scalars['String']>;
  /** The color used for the background of the secondary button */
  secondary_background_color?: InputMaybe<Scalars['String']>;
  /** The color used for the text of the secondary button */
  secondary_foreground_color?: InputMaybe<Scalars['String']>;
};

/** Represents the user's which are member of an organization. */
export type OrganizationUserEdge = {
  __typename?: 'OrganizationUserEdge';
  /** ID of this edge; the compound of the org ID and the user ID. */
  id: Scalars['ID'];
  /** The target user. */
  node: User;
  /** The user's role within this organization. */
  role: RoleName;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** Parameters to paginate a result set. */
export type Pagination = {
  After?: InputMaybe<Scalars['String']>;
  First?: InputMaybe<Scalars['Int']>;
};

/** Play is the domain model of a user's journey through a track. */
export type Play = {
  __typename?: 'Play';
  /** Custom parameters associated with this play. */
  customParameters: Array<CustomParameter>;
  /** The hot start pool used for the play, if the track was hot started. */
  hotStartPool: Maybe<HotStartPool>;
  /** The ID of this user's play. */
  id: Scalars['ID'];
  /** The track invitation of a play. */
  track_invite: Maybe<TrackInvite>;
  /** TTL has been extended by the user */
  ttlExtendedByUser: Scalars['Boolean'];
};

/** Events for play user's activity log */
export type PlayActivity = {
  __typename?: 'PlayActivity';
  /** Challange from play, where event was triggered */
  challenge: Maybe<Challenge>;
  /** Description message of activity */
  message: Scalars['String'];
  /** Time of event trigger */
  time: Scalars['Time'];
};

/** PlayInput defines input for plays for team tracks */
export type PlayReportInput = {
  /** Filter for custom parameters */
  customParameterFilters?: InputMaybe<Array<CustomParameterFilter>>;
  /** Date range filter for plays */
  dateRangeFilter?: InputMaybe<DateRangeFilter>;
  /** Sorting parameters */
  ordering?: InputMaybe<Ordering>;
  /** Pagination parameters */
  pagination?: InputMaybe<SkipTakePagination>;
  /** Slug of a team for which we want to get plays */
  teamSlug: Scalars['String'];
  /** IDs of tracks for which we want to get plays */
  trackIds?: InputMaybe<Array<Scalars['String']>>;
};

/** Play is the domain model of a user's journey through a track. */
export type PlayReportItem = {
  __typename?: 'PlayReportItem';
  /** Log of activities in play */
  activity: Array<PlayActivity>;
  /** Percentage of play chellenges completed in track */
  completionPercent: Scalars['Float'];
  /** Custom parameters associated with this play. */
  customParameters: Array<CustomParameter>;
  /** The hot start pool used for the play, if the track was hot started. */
  hotStartPool: Maybe<HotStartPool>;
  /** The ID of this user's play. */
  id: Scalars['ID'];
  /** The way this track was played */
  mode: Maybe<Mode>;
  /** The review of the user for the play */
  playReview: Maybe<TrackReview>;
  /** The time of track start */
  startedAt: Scalars['Time'];
  /** Time spent on play */
  timeSpent: Scalars['Int'];
  /** Track associated with this play */
  track: Track;
  /** The track invitation of a play. */
  trackInvite: Maybe<TrackInvite>;
  /** User associated with this play */
  user: User;
};

export type PlayReportPage = {
  __typename?: 'PlayReportPage';
  items: Array<PlayReportItem>;
  totalItems: Scalars['Int'];
};

/** A player is an arcade user */
export type Player = {
  __typename?: 'Player';
  /** Unique ID */
  id: Scalars['ID'];
  /** Number of lives left */
  lives: Scalars['Int'];
};

export type Progress = {
  /** The last time this content was played by the user. */
  last_played_at: Maybe<Scalars['Time']>;
};

export type Query = {
  __typename?: 'Query';
  /**
   * Get an Alicloud Account config for a track
   *
   * Note: you need to be developer of that track to access this
   */
  alicloudAccountConfig: Maybe<AlicloudAccountConfig>;
  /** Get a specific arcade machine */
  arcade: Maybe<Arcade>;
  /** Get jwt login token for an arcade */
  arcadeLogin: Maybe<ArcadeLogin>;
  /** Get a list of arcade machines */
  arcades: Maybe<Array<Arcade>>;
  /** Get a list of arcade tracks for the given organization */
  arcadetracks: Maybe<Array<Track>>;
  /**
   * Get an AWS Account config for a track
   *
   * Note: you need to be developer of that track to access this
   */
  awsAccountConfig: Maybe<AwsAccountConfig>;
  /**
   * Get an Azure Subscription config for a track
   *
   * Note: you need to be developer of that track to access this
   */
  azureSubscriptionConfig: Maybe<AzureSubscriptionConfig>;
  /**
   * Get a specific challenge
   *
   * Either challengeID must be specified, or challengeSlug, trackSlug and organizationSlug
   */
  challenge: Maybe<Challenge>;
  /**
   * Get a specific challenge script
   *
   * Note: you need to be developer of that track to access this
   */
  challengeScript: Maybe<ChallengeScript>;
  /**
   * Get the scripts for a challenge
   *
   * Note: you need to be developer of that track to access this
   */
  challengeScripts: Maybe<Array<ChallengeScript>>;
  /**
   * Get a all challenges of a track
   *
   * Either trackID must be specified, or both trackSlug and organizationSlug
   */
  challenges: Maybe<Array<Challenge>>;
  /**
   * Get a container config for a track
   *
   * Note: you need to be developer of that track to access this
   */
  containerConfig: Maybe<ContainerConfig>;
  /**
   * Get all tracks for an specific usr
   *
   * This will return all the tracks that a user is developer of.
   */
  developerTracks: Maybe<Array<Track>>;
  findTeamUsers: Maybe<Array<User>>;
  /** @deprecated No longer supported */
  findUsers: Maybe<Array<User>>;
  /**
   * Get a GCP Project config for a track
   *
   * Note: you need to be developer of that track to access this
   */
  gcpProjectConfig: Maybe<GcpProjectConfig>;
  /** Get runtime variable value from sandbox host */
  getSandboxVariable: Maybe<SandboxVariable>;
  /** Get hot start pool */
  hotStartPool: HotStartPool;
  /** Get hot start pools in organization */
  hotStartPools: Maybe<HotStartPoolConnection>;
  /** Checks if the image is valid before it being created */
  isContainerImageValid: Scalars['Boolean'];
  /** Checks whether a URL is embeddable via a frame. */
  isURLEmbeddable: Maybe<Scalars['Boolean']>;
  /**
   * Get a specific learningPath
   *
   * Either learningPathID or learningPathSlug must be specified
   */
  learningPath: Maybe<LearningPath>;
  /** Get a list of learning paths */
  learningPaths: Array<LearningPath>;
  /** Gets the currently logged in user */
  me: Maybe<User>;
  /** Get user's progress for tracks and learning paths. */
  myProgress: Array<Progress>;
  /**
   * Get progress on tracks for the current user.
   * @deprecated Use myProgress query
   */
  myTrackProgress: Maybe<Array<TrackProgress>>;
  /**
   * Get a list tracks of the current user
   *
   * This will return all tracks that are in a user's library. Currently this only includes tracks for which the user has been invited.
   * @deprecated Replaced by trackLibary()
   */
  myTracks: Maybe<Array<Track>>;
  /** Get a challenge note */
  note: Maybe<ChallengeNote>;
  /**
   * Get a specific organization
   * @deprecated No longer supported
   */
  organization: Maybe<Organization>;
  /**
   * Check if an organization exists
   * @deprecated No longer supported
   */
  organizationExists: Scalars['Boolean'];
  /**
   * Get an organization invite
   * @deprecated No longer supported
   */
  organizationInvite: Maybe<OrganizationInvite>;
  /** @deprecated No longer supported */
  organizationStatistics: Maybe<OrganizationStatistics>;
  /**
   * Get the list of all organizations you have access to.
   * @deprecated No longer supported
   */
  organizations: Maybe<Array<Organization>>;
  /** Returns a page of plays for a team */
  playReports: PlayReportPage;
  /** Get a specific player */
  player: Maybe<Player>;
  /** Get the rankings for a track */
  rankings: Maybe<Array<Ranking>>;
  sandboxConfig: SandboxConfig;
  sandboxConfigVersion: Maybe<SandboxConfigVersion>;
  sandboxConfigVersions: Maybe<Array<SandboxConfigVersion>>;
  sandboxConfigs: Maybe<Array<SandboxConfig>>;
  /** Returns an array of filtered sandboxes */
  sandboxes: Maybe<SandboxConnection>;
  /**
   * Get statistics for a track
   *
   * Either trackID must be specified, or both trackSlug and teamSlug
   */
  statistics: Maybe<Statistics>;
  /** Get the student for a given invite id and user id. */
  student: Maybe<Student>;
  /** Get the statistics related to the students. */
  studentStatistics: Maybe<StudentStatistics>;
  /** Get the students for a given invite id. */
  students: Maybe<Array<Student>>;
  /** Get a challenge tab */
  tab: Maybe<ChallengeTab>;
  /** Get a specific team */
  team: Maybe<Team>;
  /** Check if a team exists */
  teamExists: Scalars['Boolean'];
  /** Get a team invite */
  teamInvite: Maybe<TeamInvite>;
  teamSecrets: Maybe<Array<Secret>>;
  teamStatistics: Maybe<TeamStatistics>;
  /** Get the list of all teams you have access to. */
  teams: Maybe<Array<Team>>;
  /**
   * Get a specific topic
   *
   * Either topicID must be specified, or both topicSlug and organizationSlug
   */
  topic: Maybe<Topic>;
  /** Check if a topic exists */
  topicExists: Scalars['Boolean'];
  /** Get a list of topics for a given organization */
  topics: Maybe<Array<Topic>>;
  /**
   * Get a specific track
   *
   * Either trackID must be specified, or both trackSlug and teamlug
   */
  track: Maybe<Track>;
  /**
   * Get the config for a track
   *
   * Note: you need to be developer of that track to access this
   */
  trackConfig: Maybe<TrackConfig>;
  /**
   * Get presets for track config
   *
   */
  trackConfigPresets: Maybe<TrackConfigPresets>;
  /** Check if a track exists */
  trackExists: Scalars['Boolean'];
  /** Get a specific invite for a track */
  trackInvite: Maybe<TrackInvite>;
  /**
   * Get an InviteClaim for a specific invite and user
   *
   * Either claimID or a combination of inviteID and userID must be specified
   */
  trackInviteClaim: Maybe<InviteClaim>;
  /**
   * Get all invites for a team
   *
   * Either teamSlug or teamID must be specified
   */
  trackInvites: Maybe<Array<TrackInvite>>;
  /**
   * Get a list tracks of the current user
   *
   * This will return all tracks that are in a user's library. Currently this only includes tracks for which the user has been invited.
   * @deprecated Query userTrackInvites instead
   */
  trackLibrary: Maybe<TrackLibraryEntryConnection>;
  /**
   * Get all the limits configured for the given team
   *
   */
  trackPlayLimits: Array<TrackPlayLimit>;
  /**
   * Get reviews for a specific track
   *
   * A trackID must be specified
   */
  trackReviews: Maybe<TrackReviewConnection>;
  /**
   * Get a specific challenge script
   *
   * Note: you need to be developer of that track to access this
   */
  trackScript: Maybe<TrackScript>;
  /**
   * Get the scripts for a track
   *
   * Note: you need to be developer of that track to access this
   */
  trackScripts: Maybe<Array<TrackScript>>;
  /**
   * Get a list of tracks
   *
   * If either teamSlug or teamID is set, it will return only tracks for that team. Otherwise it will return tracks from all teams
   */
  tracks: Maybe<Array<Track>>;
  /**
   * Gets a user
   *
   * One of userID, email or slug must be specified
   */
  user: Maybe<User>;
  /** Check if the user consented to the team's privacy policy */
  userConsentedToPrivacyPolicy: Maybe<Scalars['Boolean']>;
  /** Check whether the user exists */
  userExists: Scalars['Boolean'];
  /**
   * Check if the currently logged in user is member of the given organiztion
   * @deprecated No longer supported
   */
  userInOrganization: Scalars['Boolean'];
  /** Check if the currently logged in user is member of the given team */
  userInTeam: Scalars['Boolean'];
  /**
   * Checks if the currently logged in user is a developer for the given track
   *
   * Either trackID must be specified, or both trackSlug and teamSlug
   */
  userIsTrackDeveloper: Scalars['Boolean'];
  /**
   * Get all the accepted invites or a user
   * @deprecated User User.claims instead
   */
  userTrackInvites: Maybe<Array<TrackInvite>>;
  /** Check whether the user exists */
  userWithSlugExists: Scalars['Boolean'];
  /**
   * Get a specific invite for a track
   *
   * This query is similar to trackInvite(inviteID), but will throw an error when the invite has expired
   */
  viewInvite: Maybe<TrackInvite>;
  /** Returns a single Virtual Browser Check corresponding to the given challenge and host. */
  virtualBrowserCheck: VirtualBrowserCheck;
  /** Returns all Virtual Browser Checks corresponding to the given track. */
  virtualBrowserChecks: Array<VirtualBrowserCheck>;
  /**
   * Get a virtual machine config for a track
   *
   * Note: you need to be developer of that track to access this
   */
  virtualMachineConfig: Maybe<VirtualMachineConfig>;
  /** Returns all a teams webhooks */
  webhooks: Array<Webhook>;
};

export type QueryAlicloudAccountConfigArgs = {
  alicloudAccountID: Scalars['String'];
};

export type QueryArcadeArgs = {
  arcadeID: Scalars['String'];
};

export type QueryArcadeLoginArgs = {
  token: Scalars['String'];
};

export type QueryArcadesArgs = {
  organizationSlug: Scalars['String'];
};

export type QueryArcadetracksArgs = {
  organizationSlug: InputMaybe<Scalars['String']>;
};

export type QueryAwsAccountConfigArgs = {
  awsAccountID: Scalars['String'];
};

export type QueryAzureSubscriptionConfigArgs = {
  azureSubscriptionID: Scalars['String'];
};

export type QueryChallengeArgs = {
  challengeID: InputMaybe<Scalars['String']>;
  challengeSlug: InputMaybe<Scalars['String']>;
  inviteID: InputMaybe<Scalars['String']>;
  organizationSlug: InputMaybe<Scalars['String']>;
  parseAssignmentVariables: InputMaybe<Scalars['Boolean']>;
  teamSlug: InputMaybe<Scalars['String']>;
  trackSlug: InputMaybe<Scalars['String']>;
  userID: InputMaybe<Scalars['String']>;
};

export type QueryChallengeScriptArgs = {
  scriptID: Scalars['String'];
};

export type QueryChallengeScriptsArgs = {
  challengeID: Scalars['String'];
};

export type QueryChallengesArgs = {
  organizationSlug: InputMaybe<Scalars['String']>;
  parseAssignmentVariables: InputMaybe<Scalars['Boolean']>;
  teamSlug: InputMaybe<Scalars['String']>;
  trackID: InputMaybe<Scalars['String']>;
  trackSlug: InputMaybe<Scalars['String']>;
};

export type QueryContainerConfigArgs = {
  containerID: Scalars['String'];
};

export type QueryDeveloperTracksArgs = {
  slug: InputMaybe<Scalars['String']>;
  userID: InputMaybe<Scalars['String']>;
};

export type QueryFindTeamUsersArgs = {
  searchTerm: InputMaybe<Scalars['String']>;
  teamSlug: Scalars['String'];
};

export type QueryFindUsersArgs = {
  organizationSlug: Scalars['String'];
  searchTerm: InputMaybe<Scalars['String']>;
};

export type QueryGcpProjectConfigArgs = {
  gcpProjectID: Scalars['String'];
};

export type QueryGetSandboxVariableArgs = {
  hostname: Scalars['String'];
  key: Scalars['String'];
  sandboxID: Scalars['String'];
};

export type QueryHotStartPoolArgs = {
  id: Scalars['String'];
  organizationSlug: Scalars['String'];
  teamSlug: InputMaybe<Scalars['String']>;
};

export type QueryHotStartPoolsArgs = {
  ordering: InputMaybe<Ordering>;
  organizationSlug: Scalars['String'];
  paging: InputMaybe<Pagination>;
  teamSlug: InputMaybe<Scalars['String']>;
};

export type QueryIsContainerImageValidArgs = {
  image: Scalars['String'];
  trackID: Scalars['String'];
};

export type QueryIsUrlEmbeddableArgs = {
  url: InputMaybe<Scalars['String']>;
};

export type QueryLearningPathArgs = {
  learningPathID: InputMaybe<Scalars['String']>;
  learningPathSlug: InputMaybe<Scalars['String']>;
};

export type QueryNoteArgs = {
  noteID: Scalars['String'];
};

export type QueryOrganizationArgs = {
  organizationID: InputMaybe<Scalars['String']>;
  organizationSlug: InputMaybe<Scalars['String']>;
};

export type QueryOrganizationExistsArgs = {
  organizationSlug: Scalars['String'];
};

export type QueryOrganizationInviteArgs = {
  token: Scalars['String'];
};

export type QueryOrganizationStatisticsArgs = {
  end: InputMaybe<Scalars['Time']>;
  filterDevelopers: InputMaybe<Scalars['Boolean']>;
  organizationID: InputMaybe<Scalars['String']>;
  organizationSlug: InputMaybe<Scalars['String']>;
  start: InputMaybe<Scalars['Time']>;
  trackIDs: InputMaybe<Array<Scalars['String']>>;
};

export type QueryPlayReportsArgs = {
  input: PlayReportInput;
};

export type QueryPlayerArgs = {
  playerID: Scalars['String'];
};

export type QueryRankingsArgs = {
  trackID: InputMaybe<Scalars['String']>;
};

export type QuerySandboxConfigArgs = {
  configID: InputMaybe<Scalars['String']>;
  configSlug: InputMaybe<Scalars['String']>;
  teamID: InputMaybe<Scalars['String']>;
  teamSlug: InputMaybe<Scalars['String']>;
};

export type QuerySandboxConfigVersionArgs = {
  configVersionID: Scalars['String'];
};

export type QuerySandboxConfigVersionsArgs = {
  filter: InputMaybe<SandboxConfigVersionsFilterInput>;
  teamID: InputMaybe<Scalars['String']>;
  teamSlug: InputMaybe<Scalars['String']>;
};

export type QuerySandboxConfigsArgs = {
  teamID: InputMaybe<Scalars['String']>;
  teamSlug: InputMaybe<Scalars['String']>;
};

export type QuerySandboxesArgs = {
  filter: InputMaybe<SandboxFilterInput>;
  ordering: InputMaybe<Ordering>;
  paging: InputMaybe<Pagination>;
  teamID: InputMaybe<Scalars['String']>;
  teamSlug: InputMaybe<Scalars['String']>;
};

export type QueryStatisticsArgs = {
  end: InputMaybe<Scalars['Time']>;
  filterDevelopers: InputMaybe<Scalars['Boolean']>;
  organizationSlug: InputMaybe<Scalars['String']>;
  start: InputMaybe<Scalars['Time']>;
  teamSlug: InputMaybe<Scalars['String']>;
  trackID: InputMaybe<Scalars['String']>;
  trackSlug: InputMaybe<Scalars['String']>;
};

export type QueryStudentArgs = {
  inviteID: Scalars['ID'];
  userID: Scalars['ID'];
};

export type QueryStudentStatisticsArgs = {
  inviteID: Scalars['ID'];
};

export type QueryStudentsArgs = {
  inviteID: Scalars['ID'];
};

export type QueryTabArgs = {
  tabID: Scalars['String'];
};

export type QueryTeamArgs = {
  teamID: InputMaybe<Scalars['String']>;
  teamSlug: InputMaybe<Scalars['String']>;
};

export type QueryTeamExistsArgs = {
  teamSlug: Scalars['String'];
};

export type QueryTeamInviteArgs = {
  token: Scalars['String'];
};

export type QueryTeamSecretsArgs = {
  teamID: InputMaybe<Scalars['String']>;
  teamSlug: InputMaybe<Scalars['String']>;
};

export type QueryTeamStatisticsArgs = {
  end: InputMaybe<Scalars['Time']>;
  filterDevelopers: InputMaybe<Scalars['Boolean']>;
  start: InputMaybe<Scalars['Time']>;
  teamID: InputMaybe<Scalars['String']>;
  teamSlug: InputMaybe<Scalars['String']>;
  trackIDs: InputMaybe<Array<Scalars['String']>>;
};

export type QueryTopicArgs = {
  organizationSlug: InputMaybe<Scalars['String']>;
  topicID: InputMaybe<Scalars['String']>;
  topicSlug: InputMaybe<Scalars['String']>;
};

export type QueryTopicExistsArgs = {
  organizationSlug: Scalars['String'];
  topicSlug: Scalars['String'];
};

export type QueryTopicsArgs = {
  organizationSlug: InputMaybe<Scalars['String']>;
};

export type QueryTrackArgs = {
  inviteID: InputMaybe<Scalars['String']>;
  organizationSlug: InputMaybe<Scalars['String']>;
  teamSlug: InputMaybe<Scalars['String']>;
  trackID: InputMaybe<Scalars['String']>;
  trackSlug: InputMaybe<Scalars['String']>;
  userID: InputMaybe<Scalars['String']>;
};

export type QueryTrackConfigArgs = {
  trackID: Scalars['String'];
};

export type QueryTrackExistsArgs = {
  organizationSlug: Scalars['String'];
  teamSlug: InputMaybe<Scalars['String']>;
  trackSlug: Scalars['String'];
};

export type QueryTrackInviteArgs = {
  inviteID: Scalars['String'];
};

export type QueryTrackInviteClaimArgs = {
  claimID: InputMaybe<Scalars['String']>;
  inviteID: InputMaybe<Scalars['String']>;
  userID: InputMaybe<Scalars['String']>;
};

export type QueryTrackInvitesArgs = {
  filters: InputMaybe<InviteFilters>;
  organizationID: InputMaybe<Scalars['String']>;
  organizationSlug: InputMaybe<Scalars['String']>;
  teamID: InputMaybe<Scalars['String']>;
  teamSlug: InputMaybe<Scalars['String']>;
};

export type QueryTrackLibraryArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};

export type QueryTrackPlayLimitsArgs = {
  teamID: InputMaybe<Scalars['String']>;
  teamSlug: InputMaybe<Scalars['String']>;
};

export type QueryTrackReviewsArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  trackID: Scalars['String'];
};

export type QueryTrackScriptArgs = {
  scriptID: Scalars['String'];
};

export type QueryTrackScriptsArgs = {
  trackID: Scalars['String'];
};

export type QueryTracksArgs = {
  orderBy: InputMaybe<TrackOrder>;
  organizationID: InputMaybe<Scalars['String']>;
  organizationSlug: InputMaybe<Scalars['String']>;
  teamID: InputMaybe<Scalars['String']>;
  teamSlug: InputMaybe<Scalars['String']>;
};

export type QueryUserArgs = {
  email: InputMaybe<Scalars['String']>;
  slug: InputMaybe<Scalars['String']>;
  userID: InputMaybe<Scalars['String']>;
};

export type QueryUserConsentedToPrivacyPolicyArgs = {
  userID: Scalars['String'];
};

export type QueryUserExistsArgs = {
  userID: Scalars['String'];
};

export type QueryUserInOrganizationArgs = {
  organizationSlug: Scalars['String'];
};

export type QueryUserInTeamArgs = {
  teamSlug: Scalars['String'];
};

export type QueryUserIsTrackDeveloperArgs = {
  organizationSlug: InputMaybe<Scalars['String']>;
  teamSlug: InputMaybe<Scalars['String']>;
  trackID: InputMaybe<Scalars['String']>;
  trackSlug: InputMaybe<Scalars['String']>;
};

export type QueryUserTrackInvitesArgs = {
  userID: Scalars['String'];
};

export type QueryUserWithSlugExistsArgs = {
  slug: Scalars['String'];
};

export type QueryViewInviteArgs = {
  inviteID: Scalars['String'];
};

export type QueryVirtualBrowserCheckArgs = {
  challenge: Scalars['String'];
  host: Scalars['String'];
};

export type QueryVirtualBrowserChecksArgs = {
  track: Scalars['String'];
};

export type QueryVirtualMachineConfigArgs = {
  virtualmachineID: Scalars['String'];
};

export type QueryWebhooksArgs = {
  teamID: InputMaybe<Scalars['String']>;
  teamSlug: InputMaybe<Scalars['String']>;
};

/** Ranking is an entry for an arcade leaderboard */
export type Ranking = {
  __typename?: 'Ranking';
  /** Difficulty level */
  difficulty: Scalars['String'];
  /** Name of the highscore */
  handle: Scalars['String'];
  /** Unique ID */
  id: Scalars['ID'];
  /** Player */
  player: Player;
  /** Score for this track */
  score: Scalars['Int'];
  /** Track for which the ranking is for */
  track: Track;
};

export enum RoleName {
  ContentCreator = 'content_creator',
  Member = 'member',
  Owner = 'owner',
}

export type Sandbox = {
  __typename?: 'Sandbox';
  /** The created time of the sandbox */
  created: Maybe<Scalars['Time']>;
  /** The hot start pool of the sandbox */
  hot_start_pool: Maybe<HotStartPool>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The invite for the sandbox */
  invite: Maybe<TrackInvite>;
  /** The last time there was recorded activity in the sandbox */
  last_activity_at: Maybe<Scalars['Time']>;
  /** State of the sandbox */
  state: SandboxState;
  /** Track for which the sandbox is for */
  track: Maybe<Track>;
  /** The TTL of the current active environment */
  ttl: Maybe<Scalars['Time']>;
  /** The user of the sandbox */
  user: Maybe<User>;
};

export type SandboxConfig = {
  __typename?: 'SandboxConfig';
  /** Deleted time of the config */
  deleted: Maybe<Scalars['Time']>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The name of the config */
  name: Scalars['String'];
  /** The slug of the config */
  slug: Scalars['String'];
  /** Version of the config */
  version: Scalars['Int'];
};

export type SandboxConfigInput = {
  /** Description of the config */
  description?: InputMaybe<Scalars['String']>;
  /** Resources for the config */
  resources?: InputMaybe<SandboxResourcesInput>;
  /** Scripts for the config */
  scripts?: InputMaybe<Array<SandboxScriptInput>>;
};

export type SandboxConfigVersion = {
  __typename?: 'SandboxConfigVersion';
  /** The change log entry of the config */
  change_log_entry: Scalars['String'];
  /** The config */
  config: Maybe<SandboxConfig>;
  /** Description of the config */
  description: Scalars['String'];
  /** The hot-start pools using the config version */
  hot_start_pools: Array<Maybe<HotStartPool>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** The time the config was published */
  published_at: Maybe<Scalars['Time']>;
  /** The user who published the config */
  published_by: Maybe<User>;
  /** The resources for the config */
  resources: Maybe<SandboxResources>;
  /** The scripts for the config version */
  scripts: Maybe<Array<SandboxScript>>;
  /** Status of the version */
  status: SandboxConfigVersionStatus;
  /** The tracks using the config version */
  tracks: Array<Maybe<Track>>;
  /** Version of the config */
  version: Scalars['Int'];
};

/** Sandbox config statuses */
export enum SandboxConfigVersionStatus {
  Archived = 'archived',
  Draft = 'draft',
  Isolated = 'isolated',
  Published = 'published',
}

export type SandboxConfigVersionsFilterInput = {
  /** Config ID to filter on */
  config_id?: InputMaybe<Scalars['String']>;
  /** Config version statuses to filter on */
  statuses?: InputMaybe<Array<SandboxConfigVersionStatus>>;
};

export type SandboxConnection = {
  __typename?: 'SandboxConnection';
  /** A list of edges containing cursors to each node. */
  edges: Array<SandboxEdge>;
  /** A list of nodes. */
  nodes: Array<Sandbox>;
  /** Total number of pages */
  pageCount: Scalars['Int'];
  /** Pagination information. */
  pageInfo: PageInfo;
  /** Total items in the current result set. */
  totalCount: Scalars['Int'];
};

export type SandboxEdge = {
  __typename?: 'SandboxEdge';
  /** Cursor to the current node. */
  cursor: Scalars['String'];
  /** The current node. */
  node: Maybe<Sandbox>;
};

/** Filter fields for querying sandboxes */
export type SandboxFilterInput = {
  /** From time to filter on */
  from?: InputMaybe<Scalars['Time']>;
  /** ID an invite to filter on */
  invite_ids?: InputMaybe<Array<Scalars['String']>>;
  /** ID a hot start pool to filter on */
  pool_ids?: InputMaybe<Array<Scalars['String']>>;
  /** Status to filter on */
  state?: InputMaybe<Array<SandboxState>>;
  /** To time to filter on */
  to?: InputMaybe<Scalars['Time']>;
  /** ID a track to filter on */
  track_ids?: InputMaybe<Array<Scalars['String']>>;
  /** The users name or id */
  user_name_or_id?: InputMaybe<Scalars['String']>;
};

/**
 * Sort options for the
 * sandboxes orderBy.
 */
export enum SandboxOrderBy {
  HotstartPoolName = 'hotstart_pool_name',
  InviteTitle = 'invite_title',
  SandboxCreated = 'sandbox_created',
  SandboxState = 'sandbox_state',
  TrackSlug = 'track_slug',
}

export type SandboxResources = {
  __typename?: 'SandboxResources';
  /** List of AWS accounts */
  aws_accounts: Array<AwsAccountConfig>;
  /** List of Azure subscriptions */
  azure_subscriptions: Array<AzureSubscriptionConfig>;
  /** List of containers */
  containers: Array<ContainerConfig>;
  /** List of GCP projects */
  gcp_projects: Array<GcpProjectConfig>;
  /** List of secrets */
  secrets: Array<SecretConfig>;
  /** List of virtual browsers */
  virtualbrowsers: Array<VirtualBrowserConfig>;
  /** List of virtual machines */
  virtualmachines: Array<VirtualMachineConfig>;
};

export type SandboxResourcesInput = {
  /** List of AWS accounts */
  aws_accounts?: InputMaybe<Array<AwsAccountConfigInput>>;
  /** List of Azure subscriptions */
  azure_subscriptions?: InputMaybe<Array<AzureSubscriptionConfigInput>>;
  /** List of containers */
  containers?: InputMaybe<Array<ContainerConfigInput>>;
  /** List of GCP projects */
  gcp_projects?: InputMaybe<Array<GcpProjectConfigInput>>;
  /** List of secrets */
  secrets?: InputMaybe<Array<SecretConfigInput>>;
  /** List of virtual browsers */
  virtualbrowsers?: InputMaybe<Array<VirtualBrowserConfigInput>>;
  /** List of virtual machines */
  virtualmachines?: InputMaybe<Array<VirtualMachineConfigInput>>;
};

export type SandboxScript = {
  __typename?: 'SandboxScript';
  /** One of: setup, cleanup */
  action: Scalars['String'];
  /** The script contents */
  contents: Scalars['String'];
  /**
   * On which host the script is executed.
   * Must reference a host in the config resources.
   */
  host: Scalars['String'];
};

export type SandboxScriptInput = {
  /** One of: setup, cleanup */
  action?: InputMaybe<Scalars['String']>;
  /** The script contents */
  contents?: InputMaybe<Scalars['String']>;
  /** On which host the script is executed. Must reference a host in the config */
  host?: InputMaybe<Scalars['String']>;
};

/** Sandbox states */
export enum SandboxState {
  Active = 'active',
  Cleaned = 'cleaned',
  Cleaning = 'cleaning',
  Created = 'created',
  Creating = 'creating',
  Failed = 'failed',
  Pooled = 'pooled',
  Stopped = 'stopped',
}

export type SandboxVariable = {
  __typename?: 'SandboxVariable';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type Secret = {
  __typename?: 'Secret';
  /** The time the secret was created */
  created_at: Scalars['Time'];
  /** The user who created the secret */
  created_by: User;
  /** A description of the secret. */
  description: Scalars['String'];
  /** The name of the secret. */
  name: Scalars['String'];
  /** ID of the team */
  teamID: Scalars['String'];
  /** The time the secret was last updated */
  updated_at: Maybe<Scalars['Time']>;
  /** The user who last updated the secret */
  updated_by: Maybe<User>;
};

/** A SecretConfig stores the details of an track secret */
export type SecretConfig = {
  __typename?: 'SecretConfig';
  /** Unique ID */
  id: Scalars['ID'];
  /** Name of the secret */
  name: Scalars['String'];
};

/** A SecretConfigInput stores details about a secret */
export type SecretConfigInput = {
  /** Name of the secret */
  name?: InputMaybe<Scalars['String']>;
};

/** SecureToken for a user */
export type SecureToken = {
  __typename?: 'SecureToken';
  /** IDToken for user */
  idToken: Scalars['String'];
  /** RefreshToken for user */
  refreshToken: Scalars['String'];
  /** User ID */
  userID: Scalars['String'];
};

export type SkipTakePagination = {
  skip: Scalars['Int'];
  take: Scalars['Int'];
};

export type Statistics = {
  __typename?: 'Statistics';
  track: Maybe<TrackStatistics>;
};

export type Student = {
  __typename?: 'Student';
  /** The time when the user has accessed the invite. */
  accessed_at: Maybe<Scalars['Time']>;
  /** The amount of active sandboxes for the user */
  activeSandboxesTotal: Maybe<Scalars['Int']>;
  /** Challenge the student currently is within the track. */
  challenge: Maybe<Challenge>;
  /** The claim associated to the student */
  claim: Maybe<InviteClaim>;
  /** Last time that the user has completed a track. */
  completed_at: Maybe<Scalars['Time']>;
  /** Whether the student machine is available to inspect or not */
  inspectable: Maybe<Scalars['Boolean']>;
  /** Last activity the user had in track's challenge. */
  last_activity_at: Maybe<Scalars['Time']>;
  /** Name of the track the student is currently on. */
  track: Maybe<Track>;
  /** Student user. */
  user: Maybe<User>;
};

export type StudentStatistics = {
  __typename?: 'StudentStatistics';
  /** Total number of students that have completed all tracks within a live event. */
  completedTotal: Maybe<Scalars['Int']>;
  /** Total number of students that have tracks in progress within a live event. */
  inProgressTotal: Maybe<Scalars['Int']>;
};

/** Track statistics for a specific classroom. */
export type StudentTrackStatistics = {
  __typename?: 'StudentTrackStatistics';
  /** Number of students that have completed the track. */
  completedTotal: Maybe<Scalars['Int']>;
  /** Number of students that have started the track but not completed it. */
  inProgressTotal: Maybe<Scalars['Int']>;
};

/** A team has members, and owns topics and tracks */
export type Team = {
  __typename?: 'Team';
  /** API Key for the team */
  api_key: Maybe<Scalars['String']>;
  /** The time the team was created at. */
  created_at: Maybe<Scalars['Time']>;
  /** The time the team has become a customer at. */
  customer_since: Maybe<Scalars['Time']>;
  /** The list of features that a team can access or use */
  features: Maybe<TeamFeatures>;
  /** The user details form for a team. */
  form: Maybe<Form>;
  /** Unique ID */
  id: Scalars['ID'];
  /**
   * Invited shows a list of email addresses that are invites
   * TODO: IN-378 Remove deprecated field.
   * @deprecated use field `invites`
   */
  invited: Array<Scalars['String']>;
  /** A list of active invites for this team */
  invites: Maybe<Array<TeamInvite>>;
  /** Logo of the team */
  logo: Maybe<Scalars['String']>;
  /** The LTI credentials for a team. */
  lti_credentials: Maybe<LtiCredentials>;
  /**
   * List of members
   * TODO: IN-364 Remove deprecated members field from team.
   * @deprecated use `users` field
   */
  members: Array<TeamMember>;
  /** Name of the team */
  name: Scalars['String'];
  /** Whether the team is personal or not */
  personal: Maybe<Scalars['Boolean']>;
  /** Text of the primary link of the team */
  primary_link_text: Maybe<Scalars['String']>;
  /** URL of the primary link of the team */
  primary_link_url: Maybe<Scalars['String']>;
  /** The URL of the team's privacy policy, if any. */
  privacy_policy: Maybe<Scalars['String']>;
  /** Text of the secondary link of the team */
  secondary_link_text: Maybe<Scalars['String']>;
  /** URL of the secondary link of the team */
  secondary_link_url: Maybe<Scalars['String']>;
  /** Slug of the team */
  slug: Scalars['String'];
  /** Subtitle of the team */
  subtitle: Maybe<Scalars['String']>;
  /** The theme that is used to style the team page */
  theme: Maybe<TeamTheme>;
  /** Title of the team */
  title: Maybe<Scalars['String']>;
  /** The time the team's trial terminates. */
  trial_end_at: Maybe<Scalars['Time']>;
  /** List of users */
  users: Maybe<Array<TeamUserEdge>>;
  /** The one time use URL for the Svix dashboard to configure webhook endpoints. */
  webhook_dashboard_url: Scalars['String'];
};

/** TeamFeatures define what features are enabled for a team */
export type TeamFeatures = {
  __typename?: 'TeamFeatures';
  /** Whether the user has a custom invite with the terms of service */
  accept_terms_checkbox: Scalars['Boolean'];
  /** Whether Alicloud accounts can be used */
  alicloud_accounts: Scalars['Boolean'];
  /** Whether arcades can be used */
  arcades: Scalars['Boolean'];
  /** Whether AWS accounts can be used */
  aws_accounts: Scalars['Boolean'];
  /** Whether Azure subscriptions can be used */
  azure_subscriptions: Scalars['Boolean'];
  /** Whether containers can be used */
  containers: Scalars['Boolean'];
  /** Where resource based virtual machines is enabled for this team */
  custom_machine_type: Scalars['Boolean'];
  /** Whether tracks can be embedded in other pages */
  embedded: Scalars['Boolean'];
  /** Whether GCP projects can be used */
  gcp_projects: Scalars['Boolean'];
  /** Whether multi-region setup is enabled for this team */
  global_sandboxes: Scalars['Boolean'];
  /** Whether hot start is enabled for this team */
  hot_start: Scalars['Boolean'];
  /** Whether invites can be created */
  invites: Scalars['Boolean'];
  /** Whether the LTI integration is enabled for this team */
  lti_enabled: Scalars['Boolean'];
  /**
   * The maximum size of a hot start pool
   * @deprecated Use `max_hot_start_pool_size_scheduled`.
   */
  max_hot_start_pool_size: Scalars['Int'];
  /** The maximum size of an always on hot start pool */
  max_hot_start_pool_size_always_on: Scalars['Int'];
  /** The maximum size of a scheduled hot start pool */
  max_hot_start_pool_size_scheduled: Scalars['Int'];
  /** The maximum number of members in this team */
  max_members: Scalars['Int'];
  /** The maximum timelimit for a single track */
  max_timelimit: Scalars['Int'];
  /** The maximum number of tracks that can be created */
  max_tracks: Scalars['Int'];
  /** Whether team members can skip to a challenge */
  members_skip_to_challenge: Scalars['Boolean'];
  /** Whether private content is allowed */
  private_content: Scalars['Boolean'];
  /** Whether SAAS tracks are enabled for this team */
  saas: Scalars['Boolean'];
  /** Whether the new scripts over http is enabled for this team */
  scripts_over_http: Scalars['Boolean'];
  /** Whether an overlay if shown on the service tab when playing a challenge. */
  service_tab_focus_overlay: Scalars['Boolean'];
  /** Whether the new shared hotstart pools invite flow is enabled for this team */
  shared_hotstart_pools: Scalars['Boolean'];
  /** Whether statistics are accessible */
  statistics: Scalars['Boolean'];
  /** Whether the new study room is enabled for this team */
  study_room_v2: Scalars['Boolean'];
  /** Whether the new team page is enabled for this team */
  team_page_v2: Scalars['Boolean'];
  /** Whether students can leave a track review after finishing a track. */
  track_reviews: Scalars['Boolean'];
  /** Whether we should replace the terminal iframe with xterm directly on the frontend */
  use_new_terminal: Scalars['Boolean'];
  /** Whether virtual machines can be used */
  virtual_machines: Scalars['Boolean'];
  /** Whether vm pooling can be used */
  vm_pooling: Scalars['Boolean'];
  /** Whether webhooks are enabled for this team */
  webhooks: Scalars['Boolean'];
};

/** TeamFeaturesInput defines the input for mutating features of a team. */
export type TeamFeaturesInput = {
  /** Whether the user has a custom invite with the terms of service */
  accept_terms_checkbox?: InputMaybe<Scalars['Boolean']>;
  /** Whether Alicloud accounts can be used */
  alicloud_accounts?: InputMaybe<Scalars['Boolean']>;
  /** Whether arcades can be used */
  arcades?: InputMaybe<Scalars['Boolean']>;
  /** Whether AWS accounts can be used */
  aws_accounts?: InputMaybe<Scalars['Boolean']>;
  /** Whether Azure subscriptions can be used */
  azure_subscriptions?: InputMaybe<Scalars['Boolean']>;
  /** Whether containers can be used */
  containers?: InputMaybe<Scalars['Boolean']>;
  /** Where resource based virtual machines is enabled for this team */
  custom_machine_type?: InputMaybe<Scalars['Boolean']>;
  /** Whether tracks can be embedded in other pages */
  embedded?: InputMaybe<Scalars['Boolean']>;
  /** Whether GCP projects can be used */
  gcp_projects?: InputMaybe<Scalars['Boolean']>;
  /** Whether multi-region setup is enabled for this team */
  global_sandboxes?: InputMaybe<Scalars['Boolean']>;
  /** Whether hot start is enabled for this team */
  hot_start?: InputMaybe<Scalars['Boolean']>;
  /** Whether invites can be created */
  invites?: InputMaybe<Scalars['Boolean']>;
  /** Whether the LTI integration is enabled for this team */
  lti_enabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * The maximum size of a hot start pool.
   * Deprecated: Use `max_hot_start_pool_size_scheduled`.
   */
  max_hot_start_pool_size?: InputMaybe<Scalars['Int']>;
  /** The maximum size of an always on hot start pool */
  max_hot_start_pool_size_always_on?: InputMaybe<Scalars['Int']>;
  /** The maximum size of a scheduled hot start pool */
  max_hot_start_pool_size_scheduled?: InputMaybe<Scalars['Int']>;
  /** The maximum number of members in this team */
  max_members?: InputMaybe<Scalars['Int']>;
  /** The maximum timelimit for a single track */
  max_timelimit?: InputMaybe<Scalars['Int']>;
  /** The maximum number of tracks that can be created */
  max_tracks?: InputMaybe<Scalars['Int']>;
  /** Whether team members can skip to a challenge */
  members_skip_to_challenge?: InputMaybe<Scalars['Boolean']>;
  /** Whether private content is allowed */
  private_content?: InputMaybe<Scalars['Boolean']>;
  /** Whether SAAS tracks are enabled for this team */
  saas?: InputMaybe<Scalars['Boolean']>;
  /** Whether the new scripts over http is enabled for this team */
  scripts_over_http?: InputMaybe<Scalars['Boolean']>;
  /** Whether an overlay if shown on the service tab when playing a challenge. */
  service_tab_focus_overlay?: InputMaybe<Scalars['Boolean']>;
  /** Whether the new shared hotstart pools invite flow is enabled for this team */
  shared_hotstart_pools?: InputMaybe<Scalars['Boolean']>;
  /** Whether statistics are accessible */
  statistics?: InputMaybe<Scalars['Boolean']>;
  /** Whether the new study room is enabled for this team */
  study_room_v2?: InputMaybe<Scalars['Boolean']>;
  /** Whether the new team page is enabled for this team */
  team_page_v2?: InputMaybe<Scalars['Boolean']>;
  /** Whether students can leave a track review after finishing a track. */
  track_reviews?: InputMaybe<Scalars['Boolean']>;
  /** Whether we should replace the terminal iframe with xterm directly on the frontend */
  use_new_terminal?: InputMaybe<Scalars['Boolean']>;
  /** Whether virtual machines can be used */
  virtual_machines?: InputMaybe<Scalars['Boolean']>;
  /** Whether vm pooling can be used */
  vm_pooling?: InputMaybe<Scalars['Boolean']>;
  /** Whether webhooks are enabled for this team */
  webhooks?: InputMaybe<Scalars['Boolean']>;
};

/** A team has members, and owns topics and tracks */
export type TeamInput = {
  /** time when the team became a customer */
  customer_since?: InputMaybe<Scalars['Time']>;
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']>;
  /** Logo of the team */
  logo?: InputMaybe<Scalars['String']>;
  /** Name of the team */
  name?: InputMaybe<Scalars['String']>;
  /** Text of the primary link of the team */
  primary_link_text?: InputMaybe<Scalars['String']>;
  /** URL of the primary link of the team */
  primary_link_url?: InputMaybe<Scalars['String']>;
  /** Text of the secondary link of the team */
  secondary_link_text?: InputMaybe<Scalars['String']>;
  /** URL of the secondary link of the team */
  secondary_link_url?: InputMaybe<Scalars['String']>;
  /** Slug of the team */
  slug?: InputMaybe<Scalars['String']>;
  /** Subtitle of the team */
  subtitle?: InputMaybe<Scalars['String']>;
  /** The theme that is used to style the team page */
  theme?: InputMaybe<TeamThemeInput>;
  /** Title of the team */
  title?: InputMaybe<Scalars['String']>;
  /** instant at which the team's ends / ended */
  trial_end_at?: InputMaybe<Scalars['Time']>;
};

/** TeamInvite represents an outstanding invite for an email address to join the team */
export type TeamInvite = {
  __typename?: 'TeamInvite';
  /** The time the invite was accepted */
  accepted_at: Maybe<Scalars['Time']>;
  /** The user the invite was created by */
  created_by: Maybe<User>;
  /** The email of the invite */
  email: Scalars['String'];
  /** The role that the user will get when accepting the invite */
  role: RoleName;
  /** The team this invite belongs to */
  team: Maybe<Team>;
  /** Whether the token in the email invite has expired */
  token_expired: Scalars['Boolean'];
};

/** Member of a team */
export type TeamMember = {
  __typename?: 'TeamMember';
  /**
   * The user's ID
   * @deprecated use field `user`
   */
  id: Scalars['ID'];
  /**
   * The user's profile
   * @deprecated use field `user`
   */
  profile: Maybe<UserProfile>;
  /** The user's role in the organization */
  role: RoleName;
  /** The user */
  user: User;
};

export type TeamSeries = {
  __typename?: 'TeamSeries';
  completed: Scalars['Int'];
  date: Scalars['String'];
  started: Scalars['Int'];
};

export type TeamStatistics = {
  __typename?: 'TeamStatistics';
  completed_total: Maybe<Scalars['Int']>;
  restarted_total: Maybe<Scalars['Int']>;
  started_total: Maybe<Scalars['Int']>;
  team_series: Array<TeamSeries>;
  track_statistics: Array<TrackStatistics>;
};

/** A TeamTeme defines the look and feel for a team */
export type TeamTheme = {
  __typename?: 'TeamTheme';
  /** The color used for the background of the header */
  background_color: Maybe<Scalars['String']>;
  /** The image used for the background of the header */
  background_image: Maybe<Scalars['String']>;
  /** The color used for the text in the header */
  foreground_color: Maybe<Scalars['String']>;
  /** The image that is shown in the header */
  foreground_image: Maybe<Scalars['String']>;
  /** The color used for the background of the primary button */
  primary_background_color: Maybe<Scalars['String']>;
  /** The color used for the text of the primary button */
  primary_foreground_color: Maybe<Scalars['String']>;
  /** The color used for the background of the secondary button */
  secondary_background_color: Maybe<Scalars['String']>;
  /** The color used for the text of the secondary button */
  secondary_foreground_color: Maybe<Scalars['String']>;
};

export type TeamThemeInput = {
  /** The color used for the background of the header */
  background_color?: InputMaybe<Scalars['String']>;
  /** The image used for the background of the header */
  background_image?: InputMaybe<Scalars['String']>;
  /** The color used for the text in the header */
  foreground_color?: InputMaybe<Scalars['String']>;
  /** The image that is shown in the header */
  foreground_image?: InputMaybe<Scalars['String']>;
  /** The color used for the background of the primary button */
  primary_background_color?: InputMaybe<Scalars['String']>;
  /** The color used for the text of the primary button */
  primary_foreground_color?: InputMaybe<Scalars['String']>;
  /** The color used for the background of the secondary button */
  secondary_background_color?: InputMaybe<Scalars['String']>;
  /** The color used for the text of the secondary button */
  secondary_foreground_color?: InputMaybe<Scalars['String']>;
};

/** Represents the user's which are member of a team. */
export type TeamUserEdge = {
  __typename?: 'TeamUserEdge';
  /** ID of this edge; the compound of the team ID and the user ID. */
  id: Scalars['ID'];
  /** The target user. */
  node: User;
  /** The user's role within this team. */
  role: RoleName;
};

/** A topic is a group of tracks, all centered around a certain topic */
export type Topic = {
  __typename?: 'Topic';
  /** Description of the topic */
  description: Scalars['String'];
  /** Icon for the topic, must be a URL to an image */
  icon: Scalars['String'];
  /** Unique ID */
  id: Scalars['ID'];
  /** Slug of the organization that owns the track */
  owner: Maybe<Scalars['String']>;
  /** Permalink for this topic. Will be generated automatically, based on the slugs of the organization and topic */
  permalink: Maybe<Scalars['String']>;
  /** If a topic is private, it is only visible for organization members */
  private: Scalars['Boolean'];
  /** Slug for the topic. This will be visible in the address bar of the browser */
  slug: Scalars['String'];
  /** List of tags of the topic */
  tags: Array<Scalars['String']>;
  /** Teaser of the topic */
  teaser: Scalars['String'];
  /** Title of the topic */
  title: Scalars['String'];
  /** List of tracks that are part of this topic */
  tracks: Array<Track>;
};

/** A topic is a group of tracks, all centered around a certain topic */
export type TopicInput = {
  /** Description of the topic */
  description?: InputMaybe<Scalars['String']>;
  /** Icon for the topic, must be a URL to an image */
  icon?: InputMaybe<Scalars['String']>;
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']>;
  /** Slug of the organization that owns the track */
  owner?: InputMaybe<Scalars['String']>;
  /** If a topic is private, it is only visible for organization members */
  private?: InputMaybe<Scalars['Boolean']>;
  /** Slug for the topic. This will be visible in the address bar of the browser */
  slug?: InputMaybe<Scalars['String']>;
  /** Teaser of the topic */
  teaser?: InputMaybe<Scalars['String']>;
  /** Title of the topic */
  title?: InputMaybe<Scalars['String']>;
};

/** A track consists of a list of challenges */
export type Track = {
  __typename?: 'Track';
  /** Whether the current user can play this track. */
  accessible: Scalars['Boolean'];
  /** Actual pool size repesents the amount of actual enviroments in the stand-by pool */
  actual_pool_size: Scalars['Int'];
  /** Whether skipping is available or not, this is dependent on the presence of check & solve scripts */
  can_skip: Scalars['Boolean'];
  /** List of challenges for this track */
  challenges: Array<Challenge>;
  /** Time when track was cleaned */
  cleaned: Scalars['Time'];
  /** Time when track was completed */
  completed: Scalars['Time'];
  /** The config for this track */
  config: TrackConfig;
  /** Time when track was created successfully */
  created: Scalars['Time'];
  /** Timestamp of when track was created */
  createdAt: Scalars['Time'];
  /** Time when track creation has started */
  creating: Scalars['Time'];
  /** Description of the track */
  description: Scalars['String'];
  /** List of developers for this track */
  developers: Array<User>;
  /** Embed token */
  embed_token: Scalars['String'];
  /**
   * How many plays are left on this track. Only set when track is made available through an invite
   * @deprecated Should be resolved from the relevant track_library entry
   */
  expiry_count: Maybe<Scalars['Int']>;
  /**
   * When the access to this track expires. Only set when track is made available through an invite
   * @deprecated Should be resolved from the relevant track_invite
   */
  expiry_date: Maybe<Scalars['Time']>;
  /** Time when track failed to create */
  failed: Scalars['Time'];
  /** Icon of the track */
  icon: Scalars['String'];
  /** Unique ID */
  id: Scalars['ID'];
  /** The timeout value in seconds before the underlying sandbox will be detroyed. */
  idle_timeout: Maybe<Scalars['Int']>;
  /** The lab configuration for the track. */
  lab_config: Maybe<LabConfig>;
  /** Timestamp of when track has been last updated */
  last_update: Scalars['Time'];
  /** List of learning paths this track is part of */
  learning_paths: Array<LearningPath>;
  /** Level defines the skill level the track is designed for */
  level: Maybe<Level>;
  /** Whether the track is in maintenance mode. If it is, a maintenance banner will be shown and the track will not be playable. */
  maintenance: Scalars['Boolean'];
  /** Median starting time of the track and the first challenge */
  median_starttime: Maybe<Scalars['Int']>;
  /** Slug of the team that owns the track */
  owner: Maybe<Scalars['String']>;
  /** The latest play of the current user on this track if available */
  participant: Maybe<Play>;
  /** Permalink for this topic. Will be generated automatically, based on the slugs of the team and track */
  permalink: Maybe<Scalars['String']>;
  /** Amount of public plays done */
  play_count: Maybe<Scalars['Int']>;
  /** Amount of public plays allowed for this track */
  play_limit: Maybe<Scalars['Int']>;
  /** Whether the track has pre start capabilities. */
  prestart: Scalars['Boolean'];
  /** If a track is private, it is only visible for team members */
  private: Scalars['Boolean'];
  /** If a track is not published, it is only visible to track developers */
  published: Scalars['Boolean'];
  /** Revision of the track. Currently not used */
  revision: Scalars['Time'];
  /** The sandbox config for the track */
  sandboxConfig: Maybe<SandboxConfigVersion>;
  /** Scripts that belong to the track */
  scripts: Array<TrackScript>;
  /** Show timer represents the track setting whether to show a timer or not. */
  show_timer: Scalars['Boolean'];
  /** Whether skipping is enabled for the challenges in this track */
  skipping_enabled: Scalars['Boolean'];
  /** Which challenge the track is currently skipping to. */
  skipping_to: Maybe<Challenge>;
  /** Slug of the track */
  slug: Scalars['String'];
  /** Start time of this track */
  started: Scalars['Time'];
  /** Track statistics */
  statistics: Maybe<TrackStatistics>;
  /** Status of the track */
  status: Maybe<TrackStatus>;
  /** Time when track was stopped */
  stopped: Scalars['Time'];
  /** Track statistics for a specific live event. */
  studentStatistics: Maybe<StudentTrackStatistics>;
  /** List of tags for this track */
  tags: Array<Scalars['String']>;
  /** Teaser of the track */
  teaser: Scalars['String'];
  /** the time limit value in seconds that the sandbox will be available for the track as a whole. */
  timelimit: Maybe<Scalars['Int']>;
  /** Title of the track */
  title: Scalars['String'];
  /** The TTL of the current active environment */
  ttl: Maybe<Scalars['Time']>;
  /**
   * Type of the track. One of: track, sandbox. Defaults to track. When choosing sandbox, the 'check' button changes to 'next'.
   * @deprecated no longer used
   */
  type: Scalars['String'];
  /** User that last updated the track */
  updated_by: Maybe<User>;
  /** Version of the track. Currently not used */
  version: Scalars['String'];
  /**
   * Visibility status of the track
   * @deprecated Replaced by `private`, `published` and `maintenance`
   */
  visibility: VisibilityStatus;
};

/** A track consists of a list of challenges */
export type TrackStatisticsArgs = {
  end: InputMaybe<Scalars['Time']>;
  filterDevelopers: InputMaybe<Scalars['Boolean']>;
  start: InputMaybe<Scalars['Time']>;
};

/** A track consists of a list of challenges */
export type TrackStudentStatisticsArgs = {
  inviteID: Scalars['ID'];
};

/** A track config contains the infrastructure needed for the challenges */
export type TrackConfig = {
  __typename?: 'TrackConfig';
  /** List of Alicloud accounts */
  alicloud_accounts: Array<AlicloudAccountConfig>;
  /** List of AWS accounts */
  aws_accounts: Array<AwsAccountConfig>;
  /** List of Azure subscriptions */
  azure_subscriptions: Array<AzureSubscriptionConfig>;
  /** List of containers */
  containers: Array<ContainerConfig>;
  /** List of GCP projects */
  gcp_projects: Array<GcpProjectConfig>;
  /** Unique ID */
  id: Scalars['ID'];
  /** List of secrets */
  secrets: Array<SecretConfig>;
  /** Version of the config, latest version is "2" */
  version: Maybe<Scalars['String']>;
  /** List of virtual browsers */
  virtualbrowsers: Array<VirtualBrowserConfig>;
  /** List of virtual machines */
  virtualmachines: Array<VirtualMachineConfig>;
};

/** A track config contains the infrastructure needed for the challenges */
export type TrackConfigInput = {
  /** List of Alicloud accounts */
  alicloud_accounts?: InputMaybe<Array<AlicloudAccountConfigInput>>;
  /** List of AWS accounts */
  aws_accounts?: InputMaybe<Array<AwsAccountConfigInput>>;
  /** List of Azure Subscriptions */
  azure_subscriptions?: InputMaybe<Array<AzureSubscriptionConfigInput>>;
  /** List of containers */
  containers?: InputMaybe<Array<ContainerConfigInput>>;
  /** List of GCP projects */
  gcp_projects?: InputMaybe<Array<GcpProjectConfigInput>>;
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']>;
  /** List of secret configs */
  secrets?: InputMaybe<Array<SecretConfigInput>>;
  /** Version of the config, latest version is "2" */
  version?: InputMaybe<Scalars['String']>;
  /** List of virtual browsers */
  virtualbrowsers?: InputMaybe<Array<VirtualBrowserConfigInput>>;
  /** List of virtual machines */
  virtualmachines?: InputMaybe<Array<VirtualMachineConfigInput>>;
};

/** A track config presets contains presets for track configs */
export type TrackConfigPresets = {
  __typename?: 'TrackConfigPresets';
  /** List of container presets */
  containers: Array<ContainerConfigPreset>;
  /** List of all Google Cloud machine types */
  googlecloudmachinetypes: Array<GoogleCloudMachineTypePreset>;
  /** List of all Instruqt machine types */
  machinetypes: Array<MachineTypePreset>;
  /** List of virtual machine presets */
  virtualmachines: Array<VirtualMachineConfigPreset>;
};

/** A track consists of a list of challenges */
export type TrackInput = {
  /** List of challenges for this track */
  challenges?: InputMaybe<Array<ChallengeInput>>;
  /** The config for this track */
  config?: InputMaybe<TrackConfigInput>;
  /** Description of the track */
  description?: InputMaybe<Scalars['String']>;
  /** List of developers for this track */
  developers?: InputMaybe<Array<UserInput>>;
  /** Icon of the track */
  icon?: InputMaybe<Scalars['String']>;
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']>;
  /** The timeout value in seconds before the underlying sandbox will be detroyed. */
  idle_timeout?: InputMaybe<Scalars['Int']>;
  /** lab configuration for the track */
  lab_config?: InputMaybe<LabConfigInput>;
  /** Level defines the skill level the track is designed for */
  level?: InputMaybe<Level>;
  /** If a track is in maintenance, it can only be played by developers, but is visible to others */
  maintenance?: InputMaybe<Scalars['Boolean']>;
  /** Slug of the team that owns the track */
  owner?: InputMaybe<Scalars['String']>;
  /** If a track is private, it is only visible for team members */
  private?: InputMaybe<Scalars['Boolean']>;
  /** If a track is not published, it is only visible to track developers */
  published?: InputMaybe<Scalars['Boolean']>;
  /** Revision of the track. Currently not used */
  revision?: InputMaybe<Scalars['Time']>;
  /** The slug of the sandbox config to use for the track */
  sandboxConfig?: InputMaybe<Scalars['String']>;
  /** The scripts for this track */
  scripts?: InputMaybe<Array<TrackScriptInput>>;
  /** If the track should show a timer while playing the track */
  show_timer?: InputMaybe<Scalars['Boolean']>;
  /** If the end user is able to skip to a specific challenge */
  skipping_enabled?: InputMaybe<Scalars['Boolean']>;
  /** Slug of the track */
  slug?: InputMaybe<Scalars['String']>;
  /** List of tags for this track */
  tags?: InputMaybe<Array<Scalars['String']>>;
  /** Teaser of the track */
  teaser?: InputMaybe<Scalars['String']>;
  /** the time limit value in seconds that the sandbox will be available for the track as a whole. */
  timelimit?: InputMaybe<Scalars['Int']>;
  /** Title of the track */
  title?: InputMaybe<Scalars['String']>;
  /** Version of the track. Currently not used */
  version?: InputMaybe<Scalars['String']>;
};

/** An invite can be used to invite users outside of an organization to access private tracks */
export type TrackInvite = {
  __typename?: 'TrackInvite';
  /** The access setting of the invite */
  accessSetting: Maybe<AccessSetting>;
  /** List the currently active users */
  activeUsers: Array<UserActivity>;
  /** Whether anyone with the link is able to access the invite anonymously (`true`), or is asked to leave their details (`false`, default). */
  allowAnonymous: Scalars['Boolean'];
  /** List of email addresses that are allowed to accept invite */
  allowedEmailAddresses: Array<Scalars['String']>;
  /** Whether a specific email addresses must be used to accept invite */
  allowedEmailAddressesOnly: Scalars['Boolean'];
  /** Can the current user claim the invite */
  canClaim: Scalars['Boolean'];
  /** The number of times this invite has been claimed */
  claimCount: Maybe<Scalars['Int']>;
  /** A list of claims for this invite */
  claims: Array<InviteClaim>;
  /** When this invite was created */
  created: Maybe<Scalars['Time']>;
  /** Whether the currently logged in user is allowed to accept invite */
  currentUserAllowed: Scalars['Boolean'];
  /** The invite claim for the current user, if this invite was claimed */
  currentUserClaim: Maybe<InviteClaim>;
  /** Whether the currently logged in user has claimed this invite */
  currentUserClaimed: Scalars['Boolean'];
  /**
   * The number of days until the live event's start.
   * @deprecated This can be resolved from the startsAt field in the frontend
   */
  daysUntil: Maybe<Scalars['Int']>;
  /** Whether learner sharing is enabled */
  enableLearnerSharing: Scalars['Boolean'];
  /** The expiry date for this invite */
  expiresAt: Maybe<Scalars['Time']>;
  /** Unique ID */
  id: Scalars['ID'];
  /**
   * The number of times this invite has been used
   * @deprecated name is ambiguous, use 'claimCount' instead.
   */
  inviteCount: Maybe<Scalars['Int']>;
  /** The number of times this invite can be used */
  inviteLimit: Maybe<Scalars['Int']>;
  /**
   * The TTL until when this invite can be used
   * @deprecated name is ambiguous, use 'expiresAt' instead.
   */
  inviteTTL: Maybe<Scalars['Time']>;
  /**
   * When the invite got claimed
   * @deprecated Can be obtained through TrackInvite.currentUserClaim or User.claims
   */
  last_updated: Maybe<Scalars['Time']>;
  /**
   * The organization this invite belongs to
   * @deprecated No longer supported
   */
  organization: Organization;
  /** The number of plays the end user is allowed to do */
  playLimit: Maybe<Scalars['Int']>;
  /** The amount of time the track is available to the end user */
  playTTL: Maybe<Scalars['Int']>;
  /** List all the plays using this invite */
  plays: Array<InvitePlay>;
  /** The public description of the invite. This description will be shown to end users */
  publicDescription: Maybe<Scalars['String']>;
  /** The public title of the invite. This title will be shown to end users */
  publicTitle: Maybe<Scalars['String']>;
  /** The start time for a `type:live_event` invite. Invites will get `status:active` 24 hours before. */
  startsAt: Maybe<Scalars['Time']>;
  /** The status of the invite. */
  status: Maybe<TrackInviteStatus>;
  /** The team this invite belongs to */
  team: Team;
  /** The title of the invite. Will not be shown to end users, but is only for administration purposes */
  title: Scalars['String'];
  /**
   * The track library of the invite for the current user
   * @deprecated No longer supported
   */
  trackLibrary: Maybe<TrackLibraryEntryConnection>;
  /** The tracks this invite applies to */
  tracks: Array<Track>;
  /** Type of invite */
  type: Maybe<TrackInviteType>;
};

/** An invite can be used to invite users outside of an organization to access private tracks */
export type TrackInviteTrackLibraryArgs = {
  paging: InputMaybe<Pagination>;
};

/** An invite can be used to invite users outside of an organization to access private tracks */
export type TrackInviteInput = {
  /** Whether anyone with the link should be able to access the invite anonymously. Set to `false` (default) to gate your content with a form asking for details. */
  allowAnonymous?: InputMaybe<Scalars['Boolean']>;
  /** List of email addresses that are allowed to accept invite */
  allowedEmailAddresses?: InputMaybe<Array<Scalars['String']>>;
  /** Whether learner sharing is enabled */
  enableLearnerSharing?: InputMaybe<Scalars['Boolean']>;
  /** The expiry date for this invite */
  expiresAt?: InputMaybe<Scalars['Time']>;
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']>;
  /** The number of times this invite can be used */
  inviteLimit?: InputMaybe<Scalars['Int']>;
  /** The TTL until when this invite can be used */
  inviteTTL?: InputMaybe<Scalars['Time']>;
  /** The number of plays the end user is allowed to do */
  playLimit?: InputMaybe<Scalars['Int']>;
  /** The amount of time the track is available to the end user */
  playTTL?: InputMaybe<Scalars['Int']>;
  /** The public description of the invite. This description will be shown to end users */
  publicDescription?: InputMaybe<Scalars['String']>;
  /** The public title of the invite. This title will be shown to end users */
  publicTitle?: InputMaybe<Scalars['String']>;
  /** The start time for a `type:live_event` invite. Invites will be accessible (`status:active`) for new users 24 hours before start. */
  startsAt?: InputMaybe<Scalars['Time']>;
  /** The title of the invite. Will not be shown to end users, but is only for administration purposes */
  title?: InputMaybe<Scalars['String']>;
  /** The IDs of the tracks this invite applies to */
  trackIDs?: InputMaybe<Array<Scalars['String']>>;
  /** Type of invite */
  type?: InputMaybe<TrackInviteType>;
};

export enum TrackInviteStatus {
  /** Default status. Allows new users to acces the invite link. */
  Active = 'active',
  /** After `invite.expiresAt` has passed. No longer allows new users to access the invite link. */
  Expired = 'expired',
  /** If `invite.startsAt` > 24 hours from now (applies to `invite.type: live_event` only.) New users are not yet allowed to access the invite link. */
  Upcoming = 'upcoming',
}

export enum TrackInviteType {
  /** Used to deliver content for instructor-led workshops. */
  LiveEvent = 'live_event',
  /** Used to deliver content to users to complete in their own time. */
  SelfPaced = 'self_paced',
}

/** TrackLibraryEntry a track owned by a user by accepting a track invite. */
export type TrackLibraryEntry = {
  __typename?: 'TrackLibraryEntry';
  /** The number of times this track was played by the user */
  playCount: Maybe<Scalars['Int']>;
  /** The track. */
  track: Track;
  /**
   * Instant this track was last viewed by the user, nil if not viewed.
   * @deprecated No longer supported
   */
  viewed_at: Maybe<Scalars['Time']>;
};

export type TrackLibraryEntryConnection = {
  __typename?: 'TrackLibraryEntryConnection';
  /** A list of edges. */
  edges: Array<TrackLibraryEntryEdge>;
  /** A list of nodes. */
  nodes: Array<TrackLibraryEntry>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

/** An edge to a TackLibraryEntry with its cursor. */
export type TrackLibraryEntryEdge = {
  __typename?: 'TrackLibraryEntryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The entry at the end of this edge. */
  node: Maybe<TrackLibraryEntry>;
};

/** TrackOrder defines the order in which to return tracks */
export enum TrackOrder {
  LastUpdateAsc = 'last_update_ASC',
  LastUpdateDesc = 'last_update_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
}

export type TrackPlayLimit = {
  __typename?: 'TrackPlayLimit';
  /** The amount of times a track can be played for a calendar month */
  calendarMonth: Scalars['Int'];
  /** The amount of times a track can be started per IP Address for a rolling hour period */
  rollingIPAddressPerHour: Scalars['Int'];
  /** The amount of times a track can be started for a rolling month period */
  rollingMonth: Scalars['Int'];
  /** The track the limits apply to, if configured for a track */
  track: Maybe<Track>;
};

/** Input values for track play limits */
export type TrackPlayLimitInput = {
  /** The amount of times a track can be played for a calendar month */
  calendarMonth?: InputMaybe<Scalars['Int']>;
  /** The amount of times a track can be started per IP Address for a rolling hour period */
  rollingIPAddressPerHour?: InputMaybe<Scalars['Int']>;
  /** The amount of times a track can be started for a rolling month period */
  rollingMonth?: InputMaybe<Scalars['Int']>;
};

export type TrackProgress = Progress & {
  __typename?: 'TrackProgress';
  /** The time when the track was completed. */
  completed_at: Maybe<Scalars['Time']>;
  /** The amount of challenges completed. */
  completed_challenges: Scalars['Int'];
  /** The last time this track was played. */
  last_played_at: Maybe<Scalars['Time']>;
  /** The track. */
  track: Track;
};

/** A student's review of a track. */
export type TrackReview = {
  __typename?: 'TrackReview';
  /** Written feedback. */
  content: Scalars['String'];
  /** The time the review was created. */
  created_at: Scalars['Time'];
  /** The ID of this track review. */
  id: Scalars['ID'];
  /** The score the user gave to this track; should be between 1-5. */
  score: Scalars['Int'];
  /** The track this review applies to. */
  track: Track;
  /** The time the review was last updated. */
  updated_at: Scalars['Time'];
  /** The user which supplied this review. */
  user: User;
};

export type TrackReviewConnection = {
  __typename?: 'TrackReviewConnection';
  /** A list of edges. */
  edges: Array<TrackReviewEdge>;
  /** A list of nodes. */
  nodes: Array<TrackReview>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

/** An edge to a TrackReview with its cursor. */
export type TrackReviewEdge = {
  __typename?: 'TrackReviewEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The entry at the end of this edge. */
  node: Maybe<TrackReview>;
};

/**
 * Track scripts provide the automation hooks for interacting with the infrastructure of the track.
 * There are 2 actions: setup,cleanup
 */
export type TrackScript = {
  __typename?: 'TrackScript';
  /** One of: setup, cleanup */
  action: Scalars['String'];
  /** The script contents */
  contents: Scalars['String'];
  /** On which host the script is executed. Must reference a host in the track config */
  host: Scalars['String'];
  /** Unique ID */
  id: Scalars['ID'];
};

/**
 * Track scripts provide the automation hooks for interacting with the infrastructure of the track.
 * There are 2 actions: setup, cleanup
 */
export type TrackScriptInput = {
  /** One of: setup, cleanup */
  action?: InputMaybe<Scalars['String']>;
  /** The script contents */
  contents?: InputMaybe<Scalars['String']>;
  /** On which host the script is executed. Must reference a host in the track config */
  host?: InputMaybe<Scalars['String']>;
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']>;
  /** ID of the track this script belongs to */
  track?: InputMaybe<Scalars['String']>;
};

export type TrackSeries = {
  __typename?: 'TrackSeries';
  completed: Scalars['Int'];
  date: Scalars['String'];
  started: Scalars['Int'];
};

export type TrackStatistics = {
  __typename?: 'TrackStatistics';
  average_review_score: Maybe<Scalars['Float']>;
  challenge_series: Array<ChallengeSeries>;
  challenges: Array<ChallengeStatistics>;
  completed_total: Maybe<Scalars['Int']>;
  happiness: Array<HappinessCount>;
  /** @deprecated Replaced by `track` */
  id: Scalars['ID'];
  restarted_total: Maybe<Scalars['Int']>;
  /** @deprecated Replaced by `track` */
  slug: Maybe<Scalars['String']>;
  started_total: Maybe<Scalars['Int']>;
  /** @deprecated Replaced by `track` */
  title: Maybe<Scalars['String']>;
  track: Maybe<Track>;
  track_series: Array<TrackSeries>;
};

/** TrackStatus enumerate all track statuses */
export enum TrackStatus {
  /** Track has been cleaned up */
  Cleaned = 'cleaned',
  /** Track is being cleaned up */
  Cleaning = 'cleaning',
  /** The infrastructure has been completed */
  Created = 'created',
  /** The infrastructure for the track is being created */
  Creating = 'creating',
  /** The track setup has failed */
  Failed = 'failed',
  /** The user has started the track */
  Started = 'started',
  /** Track was stopped by the user */
  Stopped = 'stopped',
}

/** User */
export type User = {
  __typename?: 'User';
  /** The user's invite claims. */
  claims: Array<InviteClaim>;
  /** The details last used to claim an invite */
  details: Maybe<UserDetails>;
  /** Unique ID */
  id: Scalars['ID'];
  /** Whether the user's account is anonymous */
  is_anonymous: Scalars['Boolean'];
  /** Whether the user has admin rights */
  is_global_admin: Maybe<Scalars['Boolean']>;
  /**
   * The organizations this user is a member of
   * @deprecated Replace with teams
   */
  organizations: Array<UserOrganizationEdge>;
  /** The user's profile */
  profile: Maybe<UserProfile>;
  /** The user's segments. */
  segments: Array<UserSegment>;
  /** The teams this user is a member of */
  teams: Array<UserTeamEdge>;
};

/** User */
export type UserDetailsArgs = {
  teamID: InputMaybe<Scalars['String']>;
  teamSlug: InputMaybe<Scalars['String']>;
};

/** UserActivity the current track and challenge a user is playing. */
export type UserActivity = {
  __typename?: 'UserActivity';
  /** The challenge this user is currently playing. */
  challenge: Maybe<Challenge>;
  /** The last instant the user was active on this track. */
  last_activity: Maybe<Scalars['Time']>;
  /** The current play of this user. */
  participant: Maybe<Play>;
  /** The track this user is currently playing. */
  track: Maybe<Track>;
  /** The user. */
  user: Maybe<User>;
};

export type UserDetails = {
  __typename?: 'UserDetails';
  companyName: Maybe<Scalars['String']>;
  consent: Maybe<Scalars['Boolean']>;
  countryCode: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
  firstName: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  jobLevel: Maybe<Scalars['String']>;
  jobTitle: Maybe<Scalars['String']>;
  lastName: Maybe<Scalars['String']>;
  phoneNumber: Maybe<Scalars['String']>;
  team: Maybe<Team>;
  usState: Maybe<Scalars['String']>;
  user: Maybe<User>;
};

export type UserDetailsInput = {
  /** Company name field value of submitted user details */
  companyName?: InputMaybe<Scalars['String']>;
  /** Whether the user has accepted the Consent Notice. */
  consent?: InputMaybe<Scalars['Boolean']>;
  /** Country code field value of submitted user details */
  countryCode?: InputMaybe<Scalars['String']>;
  /** email field value of submitted user details */
  email?: InputMaybe<Scalars['String']>;
  /** First name field value of submitted user details */
  firstName?: InputMaybe<Scalars['String']>;
  /** Job level name field value of submitted user details */
  jobLevel?: InputMaybe<Scalars['String']>;
  /** Job title field value of submitted user details */
  jobTitle?: InputMaybe<Scalars['String']>;
  /** Last name field value of submitted user details */
  lastName?: InputMaybe<Scalars['String']>;
  /** Phone number field value of submitted user details */
  phoneNumber?: InputMaybe<Scalars['String']>;
  /** US state field value of submitted user details */
  usState?: InputMaybe<Scalars['String']>;
};

/** User */
export type UserInput = {
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']>;
  /** The user's profile */
  profile?: InputMaybe<UserProfileInput>;
};

/** Represents a user's relationship to an organization */
export type UserOrganizationEdge = {
  __typename?: 'UserOrganizationEdge';
  /** ID of this edge; a compound of the user ID and org ID. */
  id: Scalars['ID'];
  /** The organization */
  node: Maybe<Organization>;
  /** The user's role in this organization */
  role: Maybe<RoleName>;
};

/** User Profile */
export type UserProfile = {
  __typename?: 'UserProfile';
  /** Avatar for the user, will typically be fetched from a social login */
  avatar: Maybe<Scalars['String']>;
  /** Display name of the user */
  display_name: Maybe<Scalars['String']>;
  /** Email address of the user */
  email: Maybe<Scalars['String']>;
  /** Slug or username of the user */
  slug: Maybe<Scalars['String']>;
};

/** User Profile */
export type UserProfileInput = {
  /** Email address of the user */
  email?: InputMaybe<Scalars['String']>;
};

/** A user can be in one or more of these user segments. */
export enum UserSegment {
  /** Users in this segment are allowed to create content. */
  ContentCreator = 'content_creator',
  /** Users in this segment have admin rights */
  InstruqtEmployee = 'instruqt_employee',
  /** Users in this segment are not part of any organization. */
  Learner = 'learner',
  /** Users in this segment are part of an organization but cannot create content. */
  Member = 'member',
}

/** Represents a user's relationship to a team */
export type UserTeamEdge = {
  __typename?: 'UserTeamEdge';
  /** ID of this edge; a compound of the user ID and org ID. */
  id: Scalars['ID'];
  /** The team */
  node: Maybe<Team>;
  /** The user's role in this team */
  role: Maybe<RoleName>;
};

/** Virtual browser specififc check */
export type VirtualBrowserCheck = {
  __typename?: 'VirtualBrowserCheck';
  /** The challenge ID this check belongs to */
  challenge: Challenge;
  /** The DOM element to check */
  element: Array<HtmlElement>;
  /** On which host (name) the script is executed. Must reference a host in the track config. */
  host: Scalars['String'];
  /** Unique ID */
  id: Scalars['ID'];
  /** The InnerText of an element to check */
  innerText: Array<HtmlElement>;
  /**
   * The url inside the virtual browser must be on in order to pass the check
   * more than one url can be provided, in which case the check will pass if any of the urls are matching
   */
  location: Array<Scalars['String']>;
};

export type VirtualBrowserCheckInput = {
  challenge: Scalars['String'];
  element?: InputMaybe<Array<HtmlElementInput>>;
  host: Scalars['String'];
  innerText?: InputMaybe<Array<HtmlElementInput>>;
  location?: InputMaybe<Array<Scalars['String']>>;
  track: Scalars['String'];
};

export type VirtualBrowserConfig = {
  __typename?: 'VirtualBrowserConfig';
  /** Unique ID */
  id: Scalars['ID'];
  /** Name of the virtual browser host */
  name: Scalars['String'];
  /** URL of the virtual browser host */
  url: Scalars['String'];
};

export type VirtualBrowserConfigInput = {
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']>;
  /** Name of the container, will be used as hostname */
  name?: InputMaybe<Scalars['String']>;
  /** ID of the track this config belongs to */
  track?: InputMaybe<Scalars['String']>;
  /** URL which the virtual browser will point to */
  url?: InputMaybe<Scalars['String']>;
};

/** A VirtualMachineConfig stores the details of a VM */
export type VirtualMachineConfig = {
  __typename?: 'VirtualMachineConfig';
  /** What port (ranges) to expose for external ingress */
  allow_external_ingress: Array<Scalars['String']>;
  /** The number of CPUs the machine should have */
  cpus: Maybe<Scalars['Int']>;
  /** List of key-value pairs that are injected as environment variables */
  environment: Maybe<Array<EnvironmentVariable>>;
  /** Unique ID */
  id: Scalars['ID'];
  /** GCP Compute image to use */
  image: Scalars['String'];
  /** Machine type to use. Must be a valid machine type according to https://cloud.google.com/compute/docs/machine-types */
  machine_type: Scalars['String'];
  /** The amount of memory the machine should have */
  memory: Maybe<Scalars['Int']>;
  /** Name of the vm, will be used as hostname */
  name: Scalars['String'];
  /** Whether nested virtualization is enabled */
  nested_virtualization: Scalars['Boolean'];
  /** The pool size of VMs that will be kept as warm standby. If this is 0, pooling is disabled */
  pool_size: Scalars['Int'];
  /** Whether to use preemptible vms. Defaults to false */
  preemptible: Scalars['Boolean'];
  /** Which shell to expose in the terminal. Defaults to /bin/sh */
  shell: Scalars['String'];
};

/** A VirtualMachineConfig stores the details of a VM */
export type VirtualMachineConfigInput = {
  /** What port (ranges) to expose for external ingress */
  allow_external_ingress?: InputMaybe<Array<Scalars['String']>>;
  /** The number of CPUs the machine should have */
  cpus?: InputMaybe<Scalars['Int']>;
  /** List of key-value pairs that are injected as environment variables */
  environment?: InputMaybe<Array<EnvironmentInput>>;
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']>;
  /** GCP Compute image to use */
  image?: InputMaybe<Scalars['String']>;
  /** Machine type to use. Must be a valid machine type according to https://cloud.google.com/compute/docs/machine-types */
  machine_type?: InputMaybe<Scalars['String']>;
  /** The amount of memory the machine should have */
  memory?: InputMaybe<Scalars['Int']>;
  /** Name of the vm, will be used as hostname */
  name?: InputMaybe<Scalars['String']>;
  /** Whether nested virtualization is enabled */
  nested_virtualization?: InputMaybe<Scalars['Boolean']>;
  /** The pool size of VMs that will be kept as warm standby. If this is 0, pooling is disabled */
  pool_size?: InputMaybe<Scalars['Int']>;
  /** Whether to use preemptible vms. Defaults to false */
  preemptible?: InputMaybe<Scalars['Boolean']>;
  /** Which shell to expose in the terminal. Defaults to /bin/sh */
  shell?: InputMaybe<Scalars['String']>;
  /** ID of the track this config belongs to */
  track?: InputMaybe<Scalars['String']>;
};

/**
 * A VirtualMachineConfigPreset stores the config
 * for a virtual machine preset.
 */
export type VirtualMachineConfigPreset = {
  __typename?: 'VirtualMachineConfigPreset';
  /** The amount of cpus for the machine */
  cpus: Scalars['Int'];
  /** Unique ID */
  image: Scalars['String'];
  /** The label of the preset */
  label: Scalars['String'];
  /** Machine type to use. */
  machine_type: Scalars['String'];
  /** The amount of memory for the machine in MB */
  memory: Scalars['Int'];
};

export enum VisibilityStatus {
  /** Track is in maintenance */
  Maintenance = 'maintenance',
  /** Track is private */
  Private = 'private',
  /** Track is public */
  Public = 'public',
  /** Track has not been published */
  Unpublished = 'unpublished',
}

/** Webhook represents an Instruqt Webhook */
export type Webhook = {
  __typename?: 'Webhook';
  /** The time the webhook was created */
  created_at: Scalars['Time'];
  /** Custom header for the webhook */
  custom_headers: Array<CustomHeader>;
  /** The events which trigger the webhook */
  events: Array<Scalars['String']>;
  /** The ID of the Webhook */
  id: Scalars['ID'];
  /** Name of the webhook */
  name: Scalars['String'];
  /** The time the webhook was updated */
  updated_at: Scalars['Time'];
  /** URL of the webhook */
  url: Scalars['String'];
};

/** Parameter used to create or update a webhook */
export type WebhookInput = {
  /** Custom header for the webhook */
  custom_headers?: InputMaybe<Array<CustomHeaderInput>>;
  /** The events which trigger the webhook */
  events?: InputMaybe<Array<Scalars['String']>>;
  /** Name of the webhook */
  name?: InputMaybe<Scalars['String']>;
  /** URL of the webhook */
  url: Scalars['String'];
};

/**
 * This type is required for schema validation to pass.
 * https://www.apollographql.com/docs/federation/v1/federation-spec/#type-_service
 */
export type _Service = {
  __typename?: '_Service';
  sdl: Scalars['String'];
};

export type BrandedOrganizationFragment = {
  __typename?: 'Organization';
  name: string;
  logo: string | null;
  title: string | null;
  subtitle: string | null;
  slug: string;
  primary_link_text: string | null;
  primary_link_url: string | null;
  secondary_link_text: string | null;
  secondary_link_url: string | null;
  theme: {
    __typename?: 'OrganizationTheme';
    foreground_color: string | null;
    foreground_image: string | null;
    background_color: string | null;
    background_image: string | null;
    primary_foreground_color: string | null;
    primary_background_color: string | null;
    secondary_foreground_color: string | null;
    secondary_background_color: string | null;
  } | null;
};

export type ArcadeIdleTimerStopTrackMutationVariables = Exact<{
  trackID: Scalars['String'];
}>;

export type ArcadeIdleTimerStopTrackMutation = {
  __typename?: 'Mutation';
  stopTrack: {
    __typename?: 'Track';
    id: string;
    started: string;
    creating: string;
    created: string;
    failed: string;
    stopped: string;
    completed: string;
    cleaned: string;
    published: boolean;
  } | null;
};

export type ArcadeAssignmentQueryVariables = Exact<{
  trackID: Scalars['String'];
  challengeID: Scalars['String'];
  teamSlug: Scalars['String'];
}>;

export type ArcadeAssignmentQuery = {
  __typename?: 'Query';
  team: {
    __typename?: 'Team';
    id: string;
    features: { __typename?: 'TeamFeatures'; use_new_terminal: boolean } | null;
  } | null;
  track: { __typename?: 'Track'; id: string; status: TrackStatus | null } | null;
  challenge: {
    __typename?: 'Challenge';
    id: string;
    status: ChallengeStatus;
    timelimit: number | null;
    started: number;
    assignment: string;
    tabs: Array<{
      __typename?: 'ChallengeTab';
      type: ChallengeTabType;
      title: string;
      target: string | null;
      path: string | null;
      url: string | null;
      index: number;
    }>;
    attempts: Array<{ __typename?: 'ChallengeAttempt'; timestamp: string; message: string }>;
    notes: Array<{ __typename?: 'ChallengeNote'; type: ChallengeNoteType; contents: string | null }>;
  } | null;
};

export type ArcadeChallengeCheckMutationVariables = Exact<{
  playerID: Scalars['String'];
  challengeID: Scalars['String'];
}>;

export type ArcadeChallengeCheckMutation = {
  __typename?: 'Mutation';
  checkArcadeChallenge: {
    __typename?: 'Challenge';
    id: string;
    status: ChallengeStatus;
    started: number;
    completed: number;
    attempts: Array<{ __typename?: 'ChallengeAttempt'; timestamp: string; message: string }>;
    unlocks: { __typename?: 'Challenge'; id: string } | null;
  } | null;
};

export type ArcadeChallengeQueryVariables = Exact<{
  trackID: Scalars['String'];
  challengeID: Scalars['String'];
}>;

export type ArcadeChallengeQuery = {
  __typename?: 'Query';
  track: { __typename?: 'Track'; id: string; challenges: Array<{ __typename?: 'Challenge'; id: string }> } | null;
  challenge: {
    __typename?: 'Challenge';
    id: string;
    index: number;
    title: string;
    started: number;
    timelimit: number | null;
    assignment: string;
    tabs: Array<{ __typename?: 'ChallengeTab'; type: ChallengeTabType; title: string; target: string | null }>;
    notes: Array<{
      __typename?: 'ChallengeNote';
      type: ChallengeNoteType;
      contents: string | null;
      url: string | null;
    }>;
  } | null;
};

export type ArcadeStartStatusQueryVariables = Exact<{
  trackID: Scalars['String'];
  challengeID: Scalars['String'];
}>;

export type ArcadeStartStatusQuery = {
  __typename?: 'Query';
  track: { __typename?: 'Track'; id: string; status: TrackStatus | null } | null;
  challenge: { __typename?: 'Challenge'; id: string; status: ChallengeStatus } | null;
};

export type ArcadeChallengeStartMutationVariables = Exact<{
  challengeID: Scalars['String'];
}>;

export type ArcadeChallengeStartMutation = {
  __typename?: 'Mutation';
  startChallenge: {
    __typename?: 'Challenge';
    id: string;
    status: ChallengeStatus;
    started: number;
    timelimit: number | null;
  } | null;
};

export type ArcadeChallengeSetupMutationVariables = Exact<{
  challengeID: Scalars['String'];
}>;

export type ArcadeChallengeSetupMutation = {
  __typename?: 'Mutation';
  setupChallenge: { __typename?: 'Challenge'; id: string; status: ChallengeStatus } | null;
};

export type ArcadeInputContainerQueryVariables = Exact<{
  trackID: Scalars['String'];
}>;

export type ArcadeInputContainerQuery = {
  __typename?: 'Query';
  track: { __typename?: 'Track'; id: string; status: TrackStatus | null } | null;
};

export type InputContainerRegisterScoreMutationVariables = Exact<{
  playerID: Scalars['String'];
  trackID: Scalars['String'];
  handle: Scalars['String'];
  difficulty: Scalars['String'];
  teamSlug: InputMaybe<Scalars['String']>;
}>;

export type InputContainerRegisterScoreMutation = {
  __typename?: 'Mutation';
  registerScore: {
    __typename?: 'Ranking';
    id: string;
    handle: string;
    score: number;
    player: { __typename?: 'Player'; id: string; lives: number };
    track: { __typename?: 'Track'; id: string; title: string };
  } | null;
};

export type InputContainerStopTrackMutationVariables = Exact<{
  trackID: Scalars['String'];
}>;

export type InputContainerStopTrackMutation = {
  __typename?: 'Mutation';
  stopTrack: {
    __typename?: 'Track';
    id: string;
    started: string;
    creating: string;
    created: string;
    failed: string;
    stopped: string;
    completed: string;
    cleaned: string;
    published: boolean;
  } | null;
};

export type ArcadeLeaderboardQueryVariables = Exact<{
  trackID: Scalars['String'];
}>;

export type ArcadeLeaderboardQuery = {
  __typename?: 'Query';
  track: { __typename?: 'Track'; id: string; title: string; teaser: string } | null;
  rankings: Array<{ __typename?: 'Ranking'; id: string; difficulty: string; handle: string; score: number }> | null;
};

export type ArcadeLeaderboardsQueryVariables = Exact<{
  teamSlug: Scalars['String'];
}>;

export type ArcadeLeaderboardsQuery = {
  __typename?: 'Query';
  arcadetracks: Array<{ __typename?: 'Track'; id: string; title: string; teaser: string }> | null;
};

export type ArcadeLeaderboardsRankingsQueryVariables = Exact<{
  trackID: Scalars['String'];
}>;

export type ArcadeLeaderboardsRankingsQuery = {
  __typename?: 'Query';
  rankings: Array<{ __typename?: 'Ranking'; id: string; difficulty: string; handle: string; score: number }> | null;
};

export type ArcadeLoginQueryVariables = Exact<{
  token: Scalars['String'];
}>;

export type ArcadeLoginQuery = {
  __typename?: 'Query';
  arcadeLogin: {
    __typename?: 'ArcadeLogin';
    token: string;
    alternative_url: string | null;
    organization: { __typename?: 'Organization'; id: string; slug: string };
  } | null;
};

export type ArcadeDifficultyCreatePlayerMutationVariables = Exact<{
  trackID: Scalars['String'];
  difficulty: Scalars['String'];
}>;

export type ArcadeDifficultyCreatePlayerMutation = {
  __typename?: 'Mutation';
  createPlayer: { __typename?: 'Player'; id: string; lives: number } | null;
};

export type ArcadeTracksQueryVariables = Exact<{
  teamSlug: InputMaybe<Scalars['String']>;
}>;

export type ArcadeTracksQuery = {
  __typename?: 'Query';
  arcadetracks: Array<{
    __typename?: 'Track';
    id: string;
    slug: string;
    title: string;
    teaser: string;
    icon: string;
  }> | null;
};

export type ArcadeTracksStartTrackMutationVariables = Exact<{
  trackID: Scalars['String'];
  region: InputMaybe<Scalars['String']>;
}>;

export type ArcadeTracksStartTrackMutation = {
  __typename?: 'Mutation';
  startTrack: {
    __typename?: 'Track';
    id: string;
    started: string;
    creating: string;
    created: string;
    failed: string;
    stopped: string;
    completed: string;
    cleaned: string;
    published: boolean;
    challenges: Array<{ __typename?: 'Challenge'; id: string; title: string; teaser: string; status: ChallengeStatus }>;
  } | null;
};

export type ArcadeTvLeaderboardsQueryVariables = Exact<{
  teamSlug: Scalars['String'];
}>;

export type ArcadeTvLeaderboardsQuery = {
  __typename?: 'Query';
  arcadetracks: Array<{ __typename?: 'Track'; id: string; title: string; teaser: string }> | null;
  team: { __typename?: 'Team'; id: string; name: string } | null;
};

export type ArcadeTvLeaderboardsRankingsQueryVariables = Exact<{
  trackID: Scalars['String'];
}>;

export type ArcadeTvLeaderboardsRankingsQuery = {
  __typename?: 'Query';
  rankings: Array<{ __typename?: 'Ranking'; id: string; difficulty: string; handle: string; score: number }> | null;
};

export type GetActivityPageQueryVariables = Exact<{
  inviteID: Scalars['ID'];
  inviteIDLegacy: Scalars['String'];
  userID: Scalars['ID'];
  teamSlug: Scalars['String'];
}>;

export type GetActivityPageQuery = {
  __typename?: 'Query';
  student: {
    __typename?: 'Student';
    activeSandboxesTotal: number | null;
    inspectable: boolean | null;
    user: {
      __typename?: 'User';
      id: string;
      profile: { __typename?: 'UserProfile'; display_name: string | null } | null;
      details: { __typename?: 'UserDetails'; id: string; firstName: string | null; lastName: string | null } | null;
    } | null;
  } | null;
  trackInvite: {
    __typename?: 'TrackInvite';
    expiresAt: string | null;
    publicDescription: string | null;
    publicTitle: string | null;
    startsAt: string | null;
    status: TrackInviteStatus | null;
    type: TrackInviteType | null;
  } | null;
  students: Array<{
    __typename?: 'Student';
    user: {
      __typename?: 'User';
      id: string;
      profile: { __typename?: 'UserProfile'; display_name: string | null } | null;
      details: { __typename?: 'UserDetails'; id: string; firstName: string | null; lastName: string | null } | null;
    } | null;
  }> | null;
};

export type GetActivityLogAndSandboxesQueryVariables = Exact<{
  teamSlug: Scalars['String'];
  inviteID: Scalars['String'];
  userID: Scalars['String'];
  filter: SandboxFilterInput;
}>;

export type GetActivityLogAndSandboxesQuery = {
  __typename?: 'Query';
  trackInviteClaim: {
    __typename?: 'InviteClaim';
    events: Array<{
      __typename?: 'InviteEvent';
      message: string;
      participantID: string | null;
      time: string;
      challenge: { __typename?: 'Challenge'; slug: string } | null;
      track: { __typename?: 'Track'; slug: string } | null;
    }>;
    user: { __typename?: 'User'; profile: { __typename?: 'UserProfile'; display_name: string | null } | null };
  } | null;
  sandboxes: {
    __typename?: 'SandboxConnection';
    totalCount: number;
    edges: Array<{
      __typename?: 'SandboxEdge';
      node: {
        __typename?: 'Sandbox';
        created: string | null;
        last_activity_at: string | null;
        ttl: string | null;
        state: SandboxState;
        id: string;
        track: { __typename?: 'Track'; title: string } | null;
      } | null;
    }>;
  } | null;
};

export type SandboxFragment = {
  __typename?: 'Sandbox';
  created: string | null;
  last_activity_at: string | null;
  ttl: string | null;
  state: SandboxState;
  id: string;
  track: { __typename?: 'Track'; title: string } | null;
};

export type GetClassroomPageQueryVariables = Exact<{
  inviteID: Scalars['ID'];
  inviteIDLegacy: Scalars['String'];
  teamSlug: Scalars['String'];
}>;

export type GetClassroomPageQuery = {
  __typename?: 'Query';
  team: {
    __typename?: 'Team';
    id: string;
    features: { __typename?: 'TeamFeatures'; hot_start: boolean } | null;
  } | null;
  studentStatistics: {
    __typename?: 'StudentStatistics';
    inProgressTotal: number | null;
    completedTotal: number | null;
  } | null;
  trackInvite: {
    __typename?: 'TrackInvite';
    id: string;
    inviteLimit: number | null;
    expiresAt: string | null;
    publicDescription: string | null;
    publicTitle: string | null;
    startsAt: string | null;
    type: TrackInviteType | null;
    status: TrackInviteStatus | null;
    tracks: Array<{
      __typename?: 'Track';
      icon: string;
      id: string;
      title: string;
      studentStatistics: {
        __typename?: 'StudentTrackStatistics';
        inProgressTotal: number | null;
        completedTotal: number | null;
      } | null;
    }>;
  } | null;
};

export type GetStudentsQueryVariables = Exact<{
  inviteID: Scalars['ID'];
  teamSlug: Scalars['String'];
}>;

export type GetStudentsQuery = {
  __typename?: 'Query';
  students: Array<{
    __typename?: 'Student';
    completed_at: string | null;
    activeSandboxesTotal: number | null;
    inspectable: boolean | null;
    last_activity_at: string | null;
    accessed_at: string | null;
    challenge: { __typename?: 'Challenge'; index: number; started: number; title: string } | null;
    claim: { __typename?: 'InviteClaim'; id: string } | null;
    track: {
      __typename?: 'Track';
      id: string;
      title: string;
      challenges: Array<{ __typename?: 'Challenge'; id: string }>;
    } | null;
    user: {
      __typename?: 'User';
      id: string;
      profile: { __typename?: 'UserProfile'; display_name: string | null } | null;
      details: { __typename?: 'UserDetails'; id: string; firstName: string | null; lastName: string | null } | null;
    } | null;
  }> | null;
};

export type DeleteTrackInviteClaimMutationVariables = Exact<{
  claimID: Scalars['String'];
}>;

export type DeleteTrackInviteClaimMutation = { __typename?: 'Mutation'; deleteTrackInviteClaim: boolean };

export type GetInspectStudentPageQueryVariables = Exact<{
  inviteID: Scalars['ID'];
  userID: Scalars['ID'];
  teamSlug: Scalars['String'];
}>;

export type GetInspectStudentPageQuery = {
  __typename?: 'Query';
  student: {
    __typename?: 'Student';
    inspectable: boolean | null;
    last_activity_at: string | null;
    challenge: { __typename?: 'Challenge'; index: number; permalink: string | null } | null;
    user: {
      __typename?: 'User';
      id: string;
      profile: { __typename?: 'UserProfile'; display_name: string | null } | null;
      details: { __typename?: 'UserDetails'; id: string; firstName: string | null; lastName: string | null } | null;
    } | null;
  } | null;
  students: Array<{
    __typename?: 'Student';
    user: {
      __typename?: 'User';
      id: string;
      profile: { __typename?: 'UserProfile'; display_name: string | null } | null;
      details: { __typename?: 'UserDetails'; id: string; firstName: string | null; lastName: string | null } | null;
    } | null;
  }> | null;
};

export type StudentNameFragment = {
  __typename?: 'User';
  id: string;
  profile: { __typename?: 'UserProfile'; display_name: string | null } | null;
  details: { __typename?: 'UserDetails'; id: string; firstName: string | null; lastName: string | null } | null;
};

export type CreateInstruqtUserMutationVariables = Exact<{
  inviteToken: InputMaybe<Scalars['String']>;
}>;

export type CreateInstruqtUserMutation = {
  __typename?: 'Mutation';
  login: {
    __typename?: 'User';
    id: string;
    segments: Array<UserSegment>;
    is_global_admin: boolean | null;
    profile: {
      __typename?: 'UserProfile';
      email: string | null;
      display_name: string | null;
      avatar: string | null;
      slug: string | null;
    } | null;
    teams: Array<{
      __typename?: 'UserTeamEdge';
      role: RoleName | null;
      node: {
        __typename?: 'Team';
        id: string;
        slug: string;
        name: string;
        features: {
          __typename?: 'TeamFeatures';
          hot_start: boolean;
          invites: boolean;
          statistics: boolean;
          arcades: boolean;
          webhooks: boolean;
          track_reviews: boolean;
          shared_hotstart_pools: boolean;
        } | null;
      } | null;
    }>;
  } | null;
};

export type GetInstruqtUserQueryVariables = Exact<{ [key: string]: never }>;

export type GetInstruqtUserQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    id: string;
    segments: Array<UserSegment>;
    is_global_admin: boolean | null;
    profile: {
      __typename?: 'UserProfile';
      email: string | null;
      display_name: string | null;
      avatar: string | null;
      slug: string | null;
    } | null;
    teams: Array<{
      __typename?: 'UserTeamEdge';
      role: RoleName | null;
      node: {
        __typename?: 'Team';
        id: string;
        slug: string;
        name: string;
        features: {
          __typename?: 'TeamFeatures';
          hot_start: boolean;
          invites: boolean;
          statistics: boolean;
          arcades: boolean;
          webhooks: boolean;
          track_reviews: boolean;
          shared_hotstart_pools: boolean;
        } | null;
      } | null;
    }>;
  } | null;
};

export type AuthenticationUserFragment = {
  __typename?: 'User';
  id: string;
  segments: Array<UserSegment>;
  is_global_admin: boolean | null;
  profile: {
    __typename?: 'UserProfile';
    email: string | null;
    display_name: string | null;
    avatar: string | null;
    slug: string | null;
  } | null;
  teams: Array<{
    __typename?: 'UserTeamEdge';
    role: RoleName | null;
    node: {
      __typename?: 'Team';
      id: string;
      slug: string;
      name: string;
      features: {
        __typename?: 'TeamFeatures';
        hot_start: boolean;
        invites: boolean;
        statistics: boolean;
        arcades: boolean;
        webhooks: boolean;
        track_reviews: boolean;
        shared_hotstart_pools: boolean;
      } | null;
    } | null;
  }>;
};

export type DeleteTeamInviteMutationVariables = Exact<{
  teamID: Scalars['String'];
  email: Scalars['String'];
}>;

export type DeleteTeamInviteMutation = {
  __typename?: 'Mutation';
  deleteTeamInvite: {
    __typename?: 'Team';
    id: string;
    invites: Array<{ __typename?: 'TeamInvite'; email: string; role: RoleName }> | null;
  } | null;
};

export type InvitesTeamFragment = {
  __typename?: 'Team';
  id: string;
  invites: Array<{ __typename?: 'TeamInvite'; email: string; role: RoleName }> | null;
};

export type RemoveTeamUserMutationVariables = Exact<{
  teamID: Scalars['String'];
  userID: Scalars['String'];
}>;

export type RemoveTeamUserMutation = {
  __typename?: 'Mutation';
  removeTeamUser: {
    __typename?: 'Team';
    id: string;
    members: Array<{
      __typename?: 'TeamMember';
      role: RoleName;
      user: {
        __typename?: 'User';
        id: string;
        profile: {
          __typename?: 'UserProfile';
          display_name: string | null;
          avatar: string | null;
          slug: string | null;
        } | null;
      };
    }>;
  } | null;
};

export type MembersTeamFragment = {
  __typename?: 'Team';
  id: string;
  members: Array<{
    __typename?: 'TeamMember';
    role: RoleName;
    user: {
      __typename?: 'User';
      id: string;
      profile: {
        __typename?: 'UserProfile';
        display_name: string | null;
        avatar: string | null;
        slug: string | null;
      } | null;
    };
  }>;
};

export type ChangeTeamUserRoleMutationVariables = Exact<{
  teamID: Scalars['String'];
  userID: Scalars['String'];
  role: RoleName;
}>;

export type ChangeTeamUserRoleMutation = {
  __typename?: 'Mutation';
  changeTeamUserRole: {
    __typename?: 'Team';
    id: string;
    members: Array<{ __typename?: 'TeamMember'; role: RoleName; user: { __typename?: 'User'; id: string } }>;
  } | null;
};

export type RoleSelectTeamFragment = {
  __typename?: 'Team';
  id: string;
  members: Array<{ __typename?: 'TeamMember'; role: RoleName; user: { __typename?: 'User'; id: string } }>;
};

export type TrackTagsGetTrackQueryVariables = Exact<{
  trackID: Scalars['String'];
}>;

export type TrackTagsGetTrackQuery = {
  __typename?: 'Query';
  track: {
    __typename?: 'Track';
    id: string;
    permalink: string | null;
    slug: string;
    owner: string | null;
    icon: string;
    title: string;
    teaser: string;
    timelimit: number | null;
    description: string;
    level: Level | null;
    tags: Array<string>;
    idle_timeout: number | null;
    status: TrackStatus | null;
    completed: string;
    maintenance: boolean;
    show_timer: boolean;
    skipping_enabled: boolean;
    can_skip: boolean;
    lab_config: {
      __typename?: 'LabConfig';
      width: number;
      position: string;
      overlay: boolean;
      extendTTL: number | null;
    } | null;
    challenges: Array<{
      __typename?: 'Challenge';
      id: string;
      permalink: string | null;
      slug: string;
      title: string;
      teaser: string;
      status: ChallengeStatus;
      index: number;
      type: ChallengeType;
      timelimit: number | null;
      started: number;
      completed: number;
      failed: number;
      failMessage: string | null;
    }>;
    developers: Array<{
      __typename?: 'User';
      id: string;
      profile: {
        __typename?: 'UserProfile';
        slug: string | null;
        avatar: string | null;
        display_name: string | null;
        email: string | null;
      } | null;
    }>;
  } | null;
};

export type UpdateTrackTagsMutationVariables = Exact<{
  track: TrackInput;
}>;

export type UpdateTrackTagsMutation = {
  __typename?: 'Mutation';
  updateTrack: {
    __typename?: 'Track';
    id: string;
    permalink: string | null;
    slug: string;
    owner: string | null;
    icon: string;
    title: string;
    teaser: string;
    timelimit: number | null;
    description: string;
    level: Level | null;
    tags: Array<string>;
    idle_timeout: number | null;
    status: TrackStatus | null;
    completed: string;
    maintenance: boolean;
    show_timer: boolean;
    skipping_enabled: boolean;
    can_skip: boolean;
    lab_config: {
      __typename?: 'LabConfig';
      width: number;
      position: string;
      overlay: boolean;
      extendTTL: number | null;
    } | null;
    challenges: Array<{
      __typename?: 'Challenge';
      id: string;
      permalink: string | null;
      slug: string;
      title: string;
      teaser: string;
      status: ChallengeStatus;
      index: number;
      type: ChallengeType;
      timelimit: number | null;
      started: number;
      completed: number;
      failed: number;
      failMessage: string | null;
    }>;
    developers: Array<{
      __typename?: 'User';
      id: string;
      profile: {
        __typename?: 'UserProfile';
        slug: string | null;
        avatar: string | null;
        display_name: string | null;
        email: string | null;
      } | null;
    }>;
  } | null;
};

export type TrackInviteListTrackFragment = {
  __typename?: 'Track';
  id: string;
  status: TrackStatus | null;
  title: string;
  teaser: string;
  icon: string;
  completed: string;
  maintenance: boolean;
};

export type TrackInviteListItemTrackFragment = {
  __typename?: 'Track';
  id: string;
  title: string;
  teaser: string;
  icon: string;
  status: TrackStatus | null;
  completed: string;
  maintenance: boolean;
};

export type TrackInviteListItemInviteFragment = {
  __typename?: 'TrackInvite';
  playLimit: number | null;
  currentUserClaim: {
    __typename?: 'InviteClaim';
    trackLibrary: Array<{
      __typename?: 'TrackLibraryEntry';
      playCount: number | null;
      track: { __typename?: 'Track'; id: string };
    }>;
  } | null;
};

export type AddTeamMemberSlugCheckQueryVariables = Exact<{
  slug: InputMaybe<Scalars['String']>;
  email: InputMaybe<Scalars['String']>;
}>;

export type AddTeamMemberSlugCheckQuery = {
  __typename?: 'Query';
  user: { __typename?: 'User'; id: string; profile: { __typename?: 'UserProfile'; slug: string | null } | null } | null;
};

export type AddTeamMemberMutationVariables = Exact<{
  teamID: Scalars['String'];
  userID: InputMaybe<Scalars['String']>;
  email: InputMaybe<Scalars['String']>;
  role: InputMaybe<RoleName>;
}>;

export type AddTeamMemberMutation = {
  __typename?: 'Mutation';
  inviteTeamUser: {
    __typename?: 'Team';
    id: string;
    name: string;
    slug: string;
    members: Array<{
      __typename?: 'TeamMember';
      role: RoleName;
      user: {
        __typename?: 'User';
        id: string;
        profile: {
          __typename?: 'UserProfile';
          display_name: string | null;
          avatar: string | null;
          slug: string | null;
        } | null;
      };
    }>;
    invites: Array<{ __typename?: 'TeamInvite'; email: string; role: RoleName }> | null;
  } | null;
};

export type StartMutationVariables = Exact<{
  trackID: Scalars['String'];
  inviteID: InputMaybe<Scalars['String']>;
}>;

export type StartMutation = {
  __typename?: 'Mutation';
  startTrack: {
    __typename?: 'Track';
    id: string;
    status: TrackStatus | null;
    permalink: string | null;
    challenges: Array<{
      __typename?: 'Challenge';
      id: string;
      index: number;
      slug: string;
      title: string;
      teaser: string;
      status: ChallengeStatus;
      started: number;
      completed: number;
      timelimit: number | null;
      failed: number;
      failMessage: string | null;
    }>;
  } | null;
};

export type GetChallengeToDuplicateQueryVariables = Exact<{
  challengeID: Scalars['String'];
}>;

export type GetChallengeToDuplicateQuery = {
  __typename?: 'Query';
  challenge: {
    __typename?: 'Challenge';
    slug: string;
    title: string;
    teaser: string;
    started: number;
    timelimit: number | null;
    assignment: string;
    type: ChallengeType;
    difficulty: string;
    answers: Array<string>;
    solution: Array<number>;
    tabs: Array<{
      __typename?: 'ChallengeTab';
      cmd: string | null;
      index: number;
      new_window: boolean;
      type: ChallengeTabType;
      title: string;
      target: string | null;
      hostname: string | null;
      path: string | null;
      port: number | null;
      url: string | null;
      workdir: string | null;
    }>;
    notes: Array<{
      __typename?: 'ChallengeNote';
      type: ChallengeNoteType;
      contents: string | null;
      url: string | null;
      index: number;
    }>;
    scripts: Array<{ __typename?: 'ChallengeScript'; action: string; contents: string; host: string }>;
  } | null;
};

export type DuplicateChallengeMutationVariables = Exact<{
  challenge: ChallengeInput;
}>;

export type DuplicateChallengeMutation = {
  __typename?: 'Mutation';
  createChallenge: { __typename?: 'Challenge'; id: string } | null;
};

export type SkippingToQueryVariables = Exact<{
  trackSlug: Scalars['String'];
  teamSlug: Scalars['String'];
}>;

export type SkippingToQuery = {
  __typename?: 'Query';
  track: {
    __typename?: 'Track';
    id: string;
    status: TrackStatus | null;
    skipping_to: { __typename?: 'Challenge'; id: string } | null;
    challenges: Array<{
      __typename?: 'Challenge';
      id: string;
      title: string;
      slug: string;
      index: number;
      status: ChallengeStatus;
      started: number;
      completed: number;
      failed: number;
      failMessage: string | null;
    }>;
  } | null;
};

export type SkipAChallengeQueryVariables = Exact<{
  trackSlug: Scalars['String'];
  teamSlug: Scalars['String'];
}>;

export type SkipAChallengeQuery = {
  __typename?: 'Query';
  userIsTrackDeveloper: boolean;
  userInTeam: boolean;
  team: {
    __typename?: 'Team';
    id: string;
    features: { __typename?: 'TeamFeatures'; members_skip_to_challenge: boolean } | null;
  } | null;
  track: {
    __typename?: 'Track';
    id: string;
    status: TrackStatus | null;
    skipping_enabled: boolean;
    can_skip: boolean;
    skipping_to: { __typename?: 'Challenge'; id: string } | null;
    challenges: Array<{
      __typename?: 'Challenge';
      id: string;
      type: ChallengeType;
      title: string;
      index: number;
      status: ChallengeStatus;
      started: number;
      completed: number;
    }>;
  } | null;
};

export type Skip_StartTrackMutationVariables = Exact<{
  trackID: Scalars['String'];
  inviteID: InputMaybe<Scalars['String']>;
}>;

export type Skip_StartTrackMutation = {
  __typename?: 'Mutation';
  startTrack: { __typename?: 'Track'; id: string; status: TrackStatus | null } | null;
};

export type StartingTrackModalQueryVariables = Exact<{
  trackSlug: Scalars['String'];
  teamSlug: Scalars['String'];
}>;

export type StartingTrackModalQuery = {
  __typename?: 'Query';
  track: {
    __typename?: 'Track';
    id: string;
    status: TrackStatus | null;
    median_starttime: number | null;
    challenges: Array<{ __typename?: 'Challenge'; id: string; index: number; status: ChallengeStatus }>;
  } | null;
};

export type SkipChallengeMutationVariables = Exact<{
  trackID: Scalars['String'];
  challengeID: Scalars['String'];
  userID: InputMaybe<Scalars['String']>;
  inviteID: InputMaybe<Scalars['String']>;
}>;

export type SkipChallengeMutation = { __typename?: 'Mutation'; skipChallenge: boolean };

export type SkipToChallengeMutationVariables = Exact<{
  trackID: Scalars['String'];
  challengeID: Scalars['String'];
  userID: InputMaybe<Scalars['String']>;
  inviteID: InputMaybe<Scalars['String']>;
  force: InputMaybe<Scalars['Boolean']>;
}>;

export type SkipToChallengeMutation = {
  __typename?: 'Mutation';
  skipToChallenge: { __typename?: 'Track'; id: string; status: TrackStatus | null } | null;
};

export type UpdateChallengeIndexesMutationVariables = Exact<{
  trackID: Scalars['String'];
  challenges: Array<Scalars['String']> | Scalars['String'];
}>;

export type UpdateChallengeIndexesMutation = {
  __typename?: 'Mutation';
  updateChallengeIndexes: Array<{ __typename?: 'Challenge'; id: string; title: string; index: number }> | null;
};

export type SortableChallengesChallengeFragment = {
  __typename?: 'Challenge';
  id: string;
  title: string;
  teaser: string;
};

export type StartLearningStopTrackMutationVariables = Exact<{
  trackID: Scalars['String'];
}>;

export type StartLearningStopTrackMutation = {
  __typename?: 'Mutation';
  stopTrack: {
    __typename?: 'Track';
    id: string;
    status: TrackStatus | null;
    challenges: Array<{
      __typename?: 'Challenge';
      id: string;
      slug: string;
      title: string;
      teaser: string;
      status: ChallengeStatus;
    }>;
  } | null;
};

export type StudyRoomClaimFragment = {
  __typename?: 'InviteClaim';
  id: string;
  claimedAt: string | null;
  trackInvite: {
    __typename?: 'TrackInvite';
    id: string;
    publicTitle: string | null;
    publicDescription: string | null;
    tracks: Array<{ __typename?: 'Track'; id: string; status: TrackStatus | null; completed: string }>;
    team: {
      __typename?: 'Team';
      id: string;
      slug: string;
      name: string;
      logo: string | null;
      theme: { __typename?: 'TeamTheme'; background_image: string | null; background_color: string | null } | null;
    };
  } | null;
};

export type FindUsersQueryVariables = Exact<{
  searchTerm: Scalars['String'];
  teamSlug: Scalars['String'];
}>;

export type FindUsersQuery = {
  __typename?: 'Query';
  findUsers: Array<{
    __typename?: 'User';
    id: string;
    profile: {
      __typename?: 'UserProfile';
      avatar: string | null;
      display_name: string | null;
      slug: string | null;
    } | null;
  }> | null;
};

export type CreateTrackDeveloperMutationVariables = Exact<{
  trackID: Scalars['String'];
  userID: Scalars['String'];
}>;

export type CreateTrackDeveloperMutation = {
  __typename?: 'Mutation';
  createTrackDeveloper: {
    __typename?: 'Track';
    id: string;
    developers: Array<{
      __typename?: 'User';
      id: string;
      profile: {
        __typename?: 'UserProfile';
        slug: string | null;
        avatar: string | null;
        display_name: string | null;
      } | null;
    }>;
  } | null;
};

export type RemoveTrackDeveloperMutationVariables = Exact<{
  trackID: Scalars['String'];
  userID: Scalars['String'];
}>;

export type RemoveTrackDeveloperMutation = { __typename?: 'Mutation'; removeTrackDeveloper: boolean };

export type GetDevelopersQueryVariables = Exact<{
  trackID: Scalars['String'];
}>;

export type GetDevelopersQuery = {
  __typename?: 'Query';
  track: {
    __typename?: 'Track';
    id: string;
    developers: Array<{
      __typename?: 'User';
      id: string;
      profile: {
        __typename?: 'UserProfile';
        slug: string | null;
        avatar: string | null;
        display_name: string | null;
      } | null;
    }>;
  } | null;
};

export type TrackDetailsQueryVariables = Exact<{
  inviteID: InputMaybe<Scalars['String']>;
  trackSlug: Scalars['String'];
  teamSlug: Scalars['String'];
}>;

export type TrackDetailsQuery = {
  __typename?: 'Query';
  userIsTrackDeveloper: boolean;
  userInTeam: boolean;
  team: {
    __typename?: 'Team';
    id: string;
    name: string;
    logo: string | null;
    theme: {
      __typename?: 'TeamTheme';
      foreground_color: string | null;
      foreground_image: string | null;
      background_color: string | null;
      background_image: string | null;
      primary_foreground_color: string | null;
      primary_background_color: string | null;
    } | null;
    features: {
      __typename?: 'TeamFeatures';
      statistics: boolean;
      embedded: boolean;
      members_skip_to_challenge: boolean;
    } | null;
  } | null;
  track: {
    __typename?: 'Track';
    id: string;
    permalink: string | null;
    slug: string;
    owner: string | null;
    icon: string;
    title: string;
    teaser: string;
    timelimit: number | null;
    description: string;
    level: Level | null;
    tags: Array<string>;
    idle_timeout: number | null;
    status: TrackStatus | null;
    completed: string;
    maintenance: boolean;
    show_timer: boolean;
    skipping_enabled: boolean;
    can_skip: boolean;
    lab_config: {
      __typename?: 'LabConfig';
      width: number;
      position: string;
      overlay: boolean;
      extendTTL: number | null;
    } | null;
    challenges: Array<{
      __typename?: 'Challenge';
      id: string;
      permalink: string | null;
      slug: string;
      title: string;
      teaser: string;
      status: ChallengeStatus;
      index: number;
      type: ChallengeType;
      timelimit: number | null;
      started: number;
      completed: number;
      failed: number;
      failMessage: string | null;
    }>;
    developers: Array<{
      __typename?: 'User';
      id: string;
      profile: {
        __typename?: 'UserProfile';
        slug: string | null;
        avatar: string | null;
        display_name: string | null;
        email: string | null;
      } | null;
    }>;
  } | null;
};

export type TrackDetailsTeamDataFragment = {
  __typename?: 'Team';
  id: string;
  name: string;
  logo: string | null;
  theme: {
    __typename?: 'TeamTheme';
    foreground_color: string | null;
    foreground_image: string | null;
    background_color: string | null;
    background_image: string | null;
    primary_foreground_color: string | null;
    primary_background_color: string | null;
  } | null;
  features: {
    __typename?: 'TeamFeatures';
    statistics: boolean;
    embedded: boolean;
    members_skip_to_challenge: boolean;
  } | null;
};

export type TrackDetailsTrackDataFragment = {
  __typename?: 'Track';
  id: string;
  permalink: string | null;
  slug: string;
  owner: string | null;
  icon: string;
  title: string;
  teaser: string;
  timelimit: number | null;
  description: string;
  level: Level | null;
  tags: Array<string>;
  idle_timeout: number | null;
  status: TrackStatus | null;
  completed: string;
  maintenance: boolean;
  show_timer: boolean;
  skipping_enabled: boolean;
  can_skip: boolean;
  lab_config: {
    __typename?: 'LabConfig';
    width: number;
    position: string;
    overlay: boolean;
    extendTTL: number | null;
  } | null;
  challenges: Array<{
    __typename?: 'Challenge';
    id: string;
    permalink: string | null;
    slug: string;
    title: string;
    teaser: string;
    status: ChallengeStatus;
    index: number;
    type: ChallengeType;
    timelimit: number | null;
    started: number;
    completed: number;
    failed: number;
    failMessage: string | null;
  }>;
  developers: Array<{
    __typename?: 'User';
    id: string;
    profile: {
      __typename?: 'UserProfile';
      slug: string | null;
      avatar: string | null;
      display_name: string | null;
      email: string | null;
    } | null;
  }>;
};

export type UpdateTrackOptionsMutationVariables = Exact<{
  track: TrackInput;
}>;

export type UpdateTrackOptionsMutation = {
  __typename?: 'Mutation';
  updateTrack: {
    __typename?: 'Track';
    id: string;
    maintenance: boolean;
    show_timer: boolean;
    skipping_enabled: boolean;
  } | null;
};

export type TrackStatisticsTableTrackStatisticsFragment = {
  __typename?: 'TrackStatistics';
  average_review_score: number | null;
  started_total: number | null;
  completed_total: number | null;
  track: {
    __typename?: 'Track';
    title: string;
    slug: string;
    developers: Array<{
      __typename?: 'User';
      profile: { __typename?: 'UserProfile'; display_name: string | null; avatar: string | null } | null;
    }>;
  } | null;
};

export type UpdateUserMutationVariables = Exact<{
  userID: Scalars['String'];
  displayName: Scalars['String'];
}>;

export type UpdateUserMutation = {
  __typename?: 'Mutation';
  updateUser: {
    __typename?: 'User';
    id: string;
    profile: { __typename?: 'UserProfile'; display_name: string | null } | null;
  } | null;
};

export type SignupPageQueryVariables = Exact<{
  teamID: Scalars['String'];
  skipTeam: Scalars['Boolean'];
  token: Scalars['String'];
  skipInvite: Scalars['Boolean'];
}>;

export type SignupPageQuery = {
  __typename?: 'Query';
  team?: { __typename?: 'Team'; id: string; name: string; privacy_policy: string | null } | null;
  teamInvite?: {
    __typename?: 'TeamInvite';
    email: string;
    token_expired: boolean;
    accepted_at: string | null;
    team: { __typename?: 'Team'; id: string; name: string } | null;
    created_by: {
      __typename?: 'User';
      id: string;
      profile: { __typename?: 'UserProfile'; email: string | null; display_name: string | null } | null;
    } | null;
  } | null;
};

export type ConsentToTeamPrivacyPolicyMutationVariables = Exact<{
  teamID: Scalars['String'];
  consent: Scalars['Boolean'];
}>;

export type ConsentToTeamPrivacyPolicyMutation = { __typename?: 'Mutation'; consentToTeamPrivacyPolicy: boolean };

export type MergeAnonymousUserMutationVariables = Exact<{
  token: Scalars['String'];
}>;

export type MergeAnonymousUserMutation = { __typename?: 'Mutation'; mergeAnonymousUser: boolean };

export type UpdateDisplayNameMutationVariables = Exact<{
  userID: Scalars['String'];
  displayName: Scalars['String'];
}>;

export type UpdateDisplayNameMutation = {
  __typename?: 'Mutation';
  updateUser: {
    __typename?: 'User';
    id: string;
    profile: { __typename?: 'UserProfile'; display_name: string | null } | null;
  } | null;
};

export type DeleteUserMutationVariables = Exact<{ [key: string]: never }>;

export type DeleteUserMutation = { __typename?: 'Mutation'; deleteUser: boolean };

export type GetTemplateQueryVariables = Exact<{
  trackSlug: Scalars['String'];
  teamSlug: Scalars['String'];
}>;

export type GetTemplateQuery = {
  __typename?: 'Query';
  track: {
    __typename?: 'Track';
    id: string;
    permalink: string | null;
    slug: string;
    icon: string;
    title: string;
    teaser: string;
    description: string;
    tags: Array<string>;
  } | null;
};

export type UpdateCompleteTrackMutationVariables = Exact<{
  track: TrackInput;
}>;

export type UpdateCompleteTrackMutation = {
  __typename?: 'Mutation';
  updateCompleteTrack: {
    __typename?: 'Track';
    id: string;
    slug: string;
    owner: string | null;
    title: string;
    permalink: string | null;
  } | null;
};

export type InspirationLibraryQueryVariables = Exact<{ [key: string]: never }>;

export type InspirationLibraryQuery = {
  __typename?: 'Query';
  templates: Array<{
    __typename?: 'Track';
    icon: string;
    id: string;
    maintenance: boolean;
    slug: string;
    teaser: string;
    title: string;
    challenges: Array<{ __typename?: 'Challenge'; permalink: string | null }>;
  }> | null;
  examples: Array<{
    __typename?: 'Track';
    icon: string;
    id: string;
    maintenance: boolean;
    slug: string;
    teaser: string;
    title: string;
    challenges: Array<{ __typename?: 'Challenge'; permalink: string | null }>;
  }> | null;
  tutorials: Array<{
    __typename?: 'Track';
    icon: string;
    id: string;
    maintenance: boolean;
    slug: string;
    teaser: string;
    title: string;
    challenges: Array<{ __typename?: 'Challenge'; permalink: string | null }>;
  }> | null;
};

export type InviteEntryPageQueryVariables = Exact<{
  inviteID: Scalars['String'];
}>;

export type InviteEntryPageQuery = {
  __typename?: 'Query';
  invitePublic: {
    __typename?: 'TrackInvite';
    id: string;
    accessSetting: AccessSetting | null;
    currentUserAllowed: boolean;
    currentUserClaimed: boolean;
    startsAt: string | null;
    tracks: Array<{ __typename?: 'Track'; id: string }>;
    team: {
      __typename?: 'Team';
      id: string;
      slug: string;
      name: string;
      logo: string | null;
      features: { __typename?: 'TeamFeatures'; accept_terms_checkbox: boolean } | null;
      theme: { __typename?: 'TeamTheme'; background_image: string | null; background_color: string | null } | null;
    };
  } | null;
  invitePrivate: { __typename?: 'TrackInvite'; id: string } | null;
};

export type GainAccessContainerQueryVariables = Exact<{
  inviteID: Scalars['String'];
}>;

export type GainAccessContainerQuery = {
  __typename?: 'Query';
  invitePublic: {
    __typename?: 'TrackInvite';
    id: string;
    currentUserClaimed: boolean;
    team: {
      __typename?: 'Team';
      id: string;
      name: string;
      slug: string;
      logo: string | null;
      features: { __typename?: 'TeamFeatures'; accept_terms_checkbox: boolean } | null;
      theme: { __typename?: 'TeamTheme'; background_image: string | null; background_color: string | null } | null;
    };
  } | null;
  invitePrivate: {
    __typename?: 'TrackInvite';
    id: string;
    allowAnonymous: boolean;
    allowedEmailAddressesOnly: boolean;
    currentUserAllowed: boolean;
    startsAt: string | null;
  } | null;
};

export type ClaimTrackInviteMutationVariables = Exact<{
  inviteID: Scalars['String'];
}>;

export type ClaimTrackInviteMutation = {
  __typename?: 'Mutation';
  claimTrackInvite: {
    __typename?: 'InviteClaim';
    id: string;
    trackInvite: { __typename?: 'TrackInvite'; id: string; currentUserClaimed: boolean } | null;
  } | null;
};

export type TrackInvitePageQueryVariables = Exact<{
  inviteID: Scalars['String'];
  teamSlug: Scalars['String'];
}>;

export type TrackInvitePageQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    id: string;
    details: {
      __typename?: 'UserDetails';
      id: string;
      firstName: string | null;
      lastName: string | null;
      email: string | null;
      companyName: string | null;
      phoneNumber: string | null;
      jobTitle: string | null;
      jobLevel: string | null;
      countryCode: string | null;
      usState: string | null;
      consent: boolean | null;
    } | null;
  } | null;
  trackInvite: {
    __typename?: 'TrackInvite';
    id: string;
    title: string;
    publicTitle: string | null;
    publicDescription: string | null;
    enableLearnerSharing: boolean;
    accessSetting: AccessSetting | null;
    canClaim: boolean;
    currentUserClaimed: boolean;
    playLimit: number | null;
    tracks: Array<{
      __typename?: 'Track';
      id: string;
      owner: string | null;
      permalink: string | null;
      slug: string;
      title: string;
      status: TrackStatus | null;
      teaser: string;
      icon: string;
      completed: string;
      maintenance: boolean;
      challenges: Array<{
        __typename?: 'Challenge';
        completed: number;
        index: number;
        slug: string;
        started: number;
        status: ChallengeStatus;
      }>;
    }>;
    team: {
      __typename?: 'Team';
      id: string;
      name: string;
      logo: string | null;
      privacy_policy: string | null;
      form: {
        __typename?: 'Form';
        formTitle: string | null;
        consentNotice: string | null;
        fields: Array<{ __typename?: 'FormField'; id: string; fieldName: FormFieldName; isRequired: boolean }>;
      } | null;
      theme: {
        __typename?: 'TeamTheme';
        foreground_color: string | null;
        background_color: string | null;
        background_image: string | null;
      } | null;
      features: { __typename?: 'TeamFeatures'; accept_terms_checkbox: boolean } | null;
    };
    currentUserClaim: {
      __typename?: 'InviteClaim';
      trackLibrary: Array<{
        __typename?: 'TrackLibraryEntry';
        playCount: number | null;
        track: { __typename?: 'Track'; id: string };
      }>;
    } | null;
  } | null;
};

export type TrackInviteOverviewClaimTrackInviteMutationVariables = Exact<{
  inviteID: Scalars['String'];
  userDetails: InputMaybe<UserDetailsInput>;
  customParameters: InputMaybe<Array<CustomParametersInput> | CustomParametersInput>;
}>;

export type TrackInviteOverviewClaimTrackInviteMutation = {
  __typename?: 'Mutation';
  claimTrackInvite: {
    __typename?: 'InviteClaim';
    id: string;
    trackInvite: { __typename?: 'TrackInvite'; id: string; currentUserClaimed: boolean } | null;
  } | null;
};

export type TrackInviteOverviewConsentToTeamPrivacyPolicyMutationVariables = Exact<{
  teamID: Scalars['String'];
  consent: Scalars['Boolean'];
}>;

export type TrackInviteOverviewConsentToTeamPrivacyPolicyMutation = {
  __typename?: 'Mutation';
  consentToTeamPrivacyPolicy: boolean;
};

export type TrackInviteOverviewStopTrackMutationVariables = Exact<{
  trackID: Scalars['String'];
}>;

export type TrackInviteOverviewStopTrackMutation = {
  __typename?: 'Mutation';
  stopTrack: { __typename?: 'Track'; id: string; status: TrackStatus | null } | null;
};

export type MembersPageQueryVariables = Exact<{
  teamSlug: Scalars['String'];
}>;

export type MembersPageQuery = {
  __typename?: 'Query';
  userInTeam: boolean;
  team: {
    __typename?: 'Team';
    id: string;
    members: Array<{
      __typename?: 'TeamMember';
      role: RoleName;
      user: {
        __typename?: 'User';
        id: string;
        profile: {
          __typename?: 'UserProfile';
          display_name: string | null;
          avatar: string | null;
          slug: string | null;
        } | null;
      };
    }>;
    invites: Array<{ __typename?: 'TeamInvite'; email: string; role: RoleName }> | null;
  } | null;
};

export type InsightsStatisticsQueryVariables = Exact<{
  teamSlug: Scalars['String'];
  trackIDs: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  start: InputMaybe<Scalars['Time']>;
  end: InputMaybe<Scalars['Time']>;
  filterDevelopers: InputMaybe<Scalars['Boolean']>;
}>;

export type InsightsStatisticsQuery = {
  __typename?: 'Query';
  organizationStatistics: {
    __typename?: 'OrganizationStatistics';
    started_total: number | null;
    completed_total: number | null;
    organization_series: Array<{ __typename?: 'OrganizationSeries'; date: string; started: number; completed: number }>;
    track_statistics: Array<{
      __typename?: 'TrackStatistics';
      average_review_score: number | null;
      started_total: number | null;
      completed_total: number | null;
      track: {
        __typename?: 'Track';
        title: string;
        slug: string;
        developers: Array<{
          __typename?: 'User';
          profile: { __typename?: 'UserProfile'; display_name: string | null; avatar: string | null } | null;
        }>;
      } | null;
    }>;
  } | null;
};

export type InsightsTracksQueryVariables = Exact<{
  teamSlug: Scalars['String'];
}>;

export type InsightsTracksQuery = {
  __typename?: 'Query';
  tracks: Array<{
    __typename?: 'Track';
    id: string;
    title: string;
    permalink: string | null;
    maintenance: boolean;
  }> | null;
};

export type StudyRoomLinkRedirectQueryVariables = Exact<{
  inviteID: Scalars['String'];
}>;

export type StudyRoomLinkRedirectQuery = {
  __typename?: 'Query';
  trackInvite: {
    __typename?: 'TrackInvite';
    id: string;
    team: { __typename?: 'Team'; id: string; slug: string };
  } | null;
};

export type StudyRoomQueryVariables = Exact<{ [key: string]: never }>;

export type StudyRoomQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    claims: Array<{
      __typename?: 'InviteClaim';
      id: string;
      claimedAt: string | null;
      trackInvite: {
        __typename?: 'TrackInvite';
        id: string;
        publicTitle: string | null;
        publicDescription: string | null;
        tracks: Array<{ __typename?: 'Track'; id: string; status: TrackStatus | null; completed: string }>;
        team: {
          __typename?: 'Team';
          id: string;
          slug: string;
          name: string;
          logo: string | null;
          theme: { __typename?: 'TeamTheme'; background_image: string | null; background_color: string | null } | null;
        };
      } | null;
    }>;
  } | null;
};

export type TeamSecretsUpsertTeamSecretMutationVariables = Exact<{
  teamSlug: Scalars['String'];
  name: Scalars['String'];
  description: Scalars['String'];
  secret: Scalars['String'];
}>;

export type TeamSecretsUpsertTeamSecretMutation = {
  __typename?: 'Mutation';
  upsertTeamSecret: { __typename?: 'Secret'; name: string } | null;
};

export type TeamSecretsDeleteTeamSecretMutationVariables = Exact<{
  teamSlug: Scalars['String'];
  name: Scalars['String'];
}>;

export type TeamSecretsDeleteTeamSecretMutation = { __typename?: 'Mutation'; deleteTeamSecret: boolean };

export type TeamSecretsGetTeamSecretsQueryVariables = Exact<{
  teamSlug: Scalars['String'];
}>;

export type TeamSecretsGetTeamSecretsQuery = {
  __typename?: 'Query';
  teamSecrets: Array<{
    __typename?: 'Secret';
    teamID: string;
    name: string;
    description: string;
    updated_at: string | null;
    created_at: string;
    created_by: {
      __typename?: 'User';
      id: string;
      profile: { __typename?: 'UserProfile'; avatar: string | null; display_name: string | null } | null;
    };
    updated_by: {
      __typename?: 'User';
      id: string;
      profile: { __typename?: 'UserProfile'; avatar: string | null; display_name: string | null } | null;
    } | null;
  }> | null;
};

export type GetOrganizationSvixUrlQueryVariables = Exact<{
  teamSlug: InputMaybe<Scalars['String']>;
}>;

export type GetOrganizationSvixUrlQuery = {
  __typename?: 'Query';
  team: { __typename?: 'Team'; webhook_dashboard_url: string } | null;
};

export type DeleteTrackButtonMutationVariables = Exact<{
  trackID: Scalars['String'];
}>;

export type DeleteTrackButtonMutation = { __typename?: 'Mutation'; deleteTrack: boolean };

export type SandboxPresetPreviewTrackFragment = { __typename?: 'Track'; id: string; title: string };

export type SandboxPresetPreviewHotStartPoolFragment = { __typename?: 'HotStartPool'; id: string; name: string };

export type EditorHeroTeamThemeFragment = {
  __typename?: 'TeamTheme';
  background_color: string | null;
  background_image: string | null;
  foreground_color: string | null;
};

export type TrackFilterTrackFragment = {
  __typename?: 'Track';
  id: string;
  title: string;
  slug: string;
  maintenance: boolean;
};

export type CheckUrlEmbeddableQueryVariables = Exact<{
  url: InputMaybe<Scalars['String']>;
}>;

export type CheckUrlEmbeddableQuery = { __typename?: 'Query'; isURLEmbeddable: boolean | null };

export type PlayActivityLogActivityFragment = {
  __typename?: 'PlayActivity';
  message: string;
  time: string;
  challenge: { __typename?: 'Challenge'; slug: string } | null;
};

export type PlayActivityReportsTableFragment = {
  __typename?: 'PlayReportItem';
  id: string;
  completionPercent: number;
  timeSpent: number;
  startedAt: string;
  track: { __typename?: 'Track'; id: string; slug: string; title: string };
  user: {
    __typename?: 'User';
    id: string;
    details: {
      __typename?: 'UserDetails';
      id: string;
      firstName: string | null;
      lastName: string | null;
      email: string | null;
    } | null;
    profile: { __typename?: 'UserProfile'; display_name: string | null; email: string | null } | null;
  };
};

export type UserActivityLogEventsQueryVariables = Exact<{
  claimID: Scalars['String'];
}>;

export type UserActivityLogEventsQuery = {
  __typename?: 'Query';
  trackInviteClaim: {
    __typename?: 'InviteClaim';
    events: Array<{
      __typename?: 'InviteEvent';
      time: string;
      message: string;
      participantID: string | null;
      track: { __typename?: 'Track'; id: string; slug: string } | null;
      challenge: { __typename?: 'Challenge'; id: string; slug: string } | null;
    }>;
  } | null;
};

export type UserDetailsCollectedTableDetailsFragment = {
  __typename?: 'UserDetails';
  id: string;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  companyName: string | null;
  phoneNumber: string | null;
  jobTitle: string | null;
  jobLevel: string | null;
  countryCode: string | null;
  usState: string | null;
};

export type AddTrackToArcadeMutationVariables = Exact<{
  trackID: Scalars['String'];
}>;

export type AddTrackToArcadeMutation = { __typename?: 'Mutation'; addTrackToArcade: boolean };

export type RemoveTrackFromArcadeMutationVariables = Exact<{
  trackID: Scalars['String'];
}>;

export type RemoveTrackFromArcadeMutation = { __typename?: 'Mutation'; removeTrackFromArcade: boolean };

export type ArcadeUpdateMachineUpdateArcadeMutationVariables = Exact<{
  arcade: ArcadeInput;
}>;

export type ArcadeUpdateMachineUpdateArcadeMutation = {
  __typename?: 'Mutation';
  updateArcade: { __typename?: 'Arcade'; id: string; alternative_url: string | null } | null;
};

export type CreateChallengeFormQueryVariables = Exact<{
  trackSlug: Scalars['String'];
  teamSlug: Scalars['String'];
}>;

export type CreateChallengeFormQuery = { __typename?: 'Query'; track: { __typename?: 'Track'; id: string } | null };

export type CreateChallengeMutationVariables = Exact<{
  challenge: ChallengeInput;
}>;

export type CreateChallengeMutation = {
  __typename?: 'Mutation';
  createChallenge: {
    __typename?: 'Challenge';
    id: string;
    slug: string;
    title: string;
    type: ChallengeType;
    teaser: string;
  } | null;
};

export type ChallengeFormDataFragment = {
  __typename?: 'Challenge';
  id: string;
  slug: string;
  title: string;
  type: ChallengeType;
  teaser: string;
};

export type EditChallengeFormQueryVariables = Exact<{
  trackSlug: Scalars['String'];
  teamSlug: Scalars['String'];
  challengeID: Scalars['String'];
}>;

export type EditChallengeFormQuery = {
  __typename?: 'Query';
  track: { __typename?: 'Track'; id: string } | null;
  challenge: {
    __typename?: 'Challenge';
    id: string;
    slug: string;
    title: string;
    type: ChallengeType;
    teaser: string;
  } | null;
};

export type UpdateChallengeMutationVariables = Exact<{
  challenge: ChallengeInput;
}>;

export type UpdateChallengeMutation = {
  __typename?: 'Mutation';
  updateChallenge: {
    __typename?: 'Challenge';
    id: string;
    slug: string;
    title: string;
    type: ChallengeType;
    teaser: string;
  } | null;
};

export type ChallengeFormChallengeFragment = {
  __typename?: 'Challenge';
  title: string;
  slug: string;
  type: ChallengeType;
  assignment: string;
  teaser: string;
  timelimit: number | null;
  answers: Array<string>;
  solution: Array<number>;
};

export type ChallengeNoteFormNoteFragment = {
  __typename?: 'ChallengeNote';
  contents: string | null;
  type: ChallengeNoteType;
  url: string | null;
};

export type ChallengeNoteListSortNotesMutationVariables = Exact<{
  challengeID: Scalars['String'];
  notes: Array<Scalars['String']> | Scalars['String'];
}>;

export type ChallengeNoteListSortNotesMutation = {
  __typename?: 'Mutation';
  updateChallengeNoteIndexes: Array<{ __typename?: 'ChallengeNote'; id: string; index: number }> | null;
};

export type ChallengeNoteListDeleteNoteMutationVariables = Exact<{
  noteID: Scalars['String'];
}>;

export type ChallengeNoteListDeleteNoteMutation = { __typename?: 'Mutation'; deleteChallengeNote: boolean };

export type ChallengeNoteListNoteFragment = {
  __typename?: 'ChallengeNote';
  id: string;
  type: ChallengeNoteType;
  contents: string | null;
  url: string | null;
};

export type ChallengeTabDrawerQueryVariables = Exact<{
  trackID: Scalars['String'];
}>;

export type ChallengeTabDrawerQuery = {
  __typename?: 'Query';
  track: {
    __typename?: 'Track';
    sandboxConfig: {
      __typename?: 'SandboxConfigVersion';
      resources: {
        __typename?: 'SandboxResources';
        containers: Array<{ __typename?: 'ContainerConfig'; id: string; name: string }>;
        virtualmachines: Array<{ __typename?: 'VirtualMachineConfig'; id: string; name: string }>;
        virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig'; id: string; name: string }>;
      } | null;
    } | null;
  } | null;
  trackConfig: {
    __typename?: 'TrackConfig';
    id: string;
    containers: Array<{ __typename?: 'ContainerConfig'; id: string; name: string }>;
    virtualmachines: Array<{ __typename?: 'VirtualMachineConfig'; id: string; name: string }>;
    virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig'; id: string; name: string }>;
  } | null;
};

export type UpdateChallengeTabMutationVariables = Exact<{
  tab: ChallengeTabInput;
}>;

export type UpdateChallengeTabMutation = {
  __typename?: 'Mutation';
  updateChallengeTab: { __typename?: 'ChallengeTab'; id: string; title: string } | null;
};

export type CreateChallengeTabMutationVariables = Exact<{
  tab: ChallengeTabInput;
}>;

export type CreateChallengeTabMutation = {
  __typename?: 'Mutation';
  createChallengeTab: { __typename?: 'ChallengeTab'; id: string; title: string } | null;
};

export type ChallengeTabDrawerFragment = {
  __typename?: 'ChallengeTab';
  id: string;
  title: string;
  type: ChallengeTabType;
  hostname: string | null;
  url: string | null;
  port: number | null;
  path: string | null;
  workdir: string | null;
  cmd: string | null;
  new_window: boolean;
};

export type ChallengeTabFormTabFragment = {
  __typename?: 'ChallengeTab';
  title: string;
  type: ChallengeTabType;
  hostname: string | null;
  url: string | null;
  port: number | null;
  path: string | null;
  workdir: string | null;
  cmd: string | null;
  new_window: boolean;
};

export type ChallengeTabListSortTabsMutationVariables = Exact<{
  challengeID: Scalars['String'];
  tabs: Array<Scalars['String']> | Scalars['String'];
}>;

export type ChallengeTabListSortTabsMutation = {
  __typename?: 'Mutation';
  updateChallengeTabIndexes: Array<{ __typename?: 'ChallengeTab'; id: string; title: string; index: number }> | null;
};

export type ChallengeTabListDeleteTabMutationVariables = Exact<{
  tabID: Scalars['String'];
}>;

export type ChallengeTabListDeleteTabMutation = { __typename?: 'Mutation'; deleteChallengeTab: boolean };

export type CopyTrackModalQueryVariables = Exact<{
  trackID: Scalars['String'];
}>;

export type CopyTrackModalQuery = {
  __typename?: 'Query';
  track: {
    __typename?: 'Track';
    id: string;
    version: string;
    slug: string;
    icon: string;
    title: string;
    teaser: string;
    description: string;
    level: Level | null;
    tags: Array<string>;
    owner: string | null;
    idle_timeout: number | null;
    timelimit: number | null;
    status: TrackStatus | null;
    private: boolean;
    published: boolean;
    maintenance: boolean;
    show_timer: boolean;
    skipping_enabled: boolean;
    developers: Array<{ __typename?: 'User'; profile: { __typename?: 'UserProfile'; email: string | null } | null }>;
    challenges: Array<{
      __typename?: 'Challenge';
      id: string;
      type: ChallengeType;
      slug: string;
      title: string;
      teaser: string;
      difficulty: string;
      assignment: string;
      timelimit: number | null;
      answers: Array<string>;
      solution: Array<number>;
      notes: Array<{
        __typename?: 'ChallengeNote';
        type: ChallengeNoteType;
        contents: string | null;
        url: string | null;
      }>;
      tabs: Array<{
        __typename?: 'ChallengeTab';
        cmd: string | null;
        type: ChallengeTabType;
        title: string;
        hostname: string | null;
        path: string | null;
        port: number | null;
        url: string | null;
        new_window: boolean;
      }>;
      scripts: Array<{ __typename?: 'ChallengeScript'; host: string; action: string; contents: string }>;
    }>;
    config: {
      __typename?: 'TrackConfig';
      version: string | null;
      containers: Array<{
        __typename?: 'ContainerConfig';
        name: string;
        image: string;
        entrypoint: string | null;
        cmd: string | null;
        shell: string;
        ports: Array<number> | null;
        memory: number;
        environment: Array<{ __typename?: 'EnvironmentVariable'; key: string; value: string }> | null;
      }>;
      virtualmachines: Array<{
        __typename?: 'VirtualMachineConfig';
        name: string;
        image: string;
        machine_type: string;
        allow_external_ingress: Array<string>;
        shell: string;
        memory: number | null;
        cpus: number | null;
        environment: Array<{ __typename?: 'EnvironmentVariable'; key: string; value: string }> | null;
      }>;
      gcp_projects: Array<{ __typename?: 'GcpProjectConfig'; name: string; services: Array<string> }>;
      aws_accounts: Array<{
        __typename?: 'AwsAccountConfig';
        name: string;
        iam_policy: string | null;
        managed_policies: Array<string>;
        scp_policy: string | null;
      }>;
      azure_subscriptions: Array<{
        __typename?: 'AzureSubscriptionConfig';
        name: string;
        user_only: boolean;
        roles: Array<string>;
      }>;
    };
    scripts: Array<{ __typename?: 'TrackScript'; id: string; action: string; contents: string; host: string }>;
  } | null;
};

export type TrackExistsQueryVariables = Exact<{
  trackSlug: Scalars['String'];
  teamSlug: Scalars['String'];
}>;

export type TrackExistsQuery = { __typename?: 'Query'; trackExists: boolean };

export type CreateTrackFromModalMutationVariables = Exact<{
  track: TrackInput;
}>;

export type CreateTrackFromModalMutation = {
  __typename?: 'Mutation';
  createTrack: { __typename?: 'Track'; id: string; owner: string | null; slug: string } | null;
};

export type CreateTrackSandboxPresetsFragment = {
  __typename?: 'TrackConfigPresets';
  containers: Array<{ __typename?: 'ContainerConfigPreset'; label: string; image: string; memory: number }>;
  googlecloudmachinetypes: Array<{ __typename?: 'GoogleCloudMachineTypePreset'; label: string; machine_type: string }>;
  virtualmachines: Array<{
    __typename?: 'VirtualMachineConfigPreset';
    image: string;
    label: string;
    machine_type: string;
    cpus: number;
    memory: number;
  }>;
  machinetypes: Array<{ __typename?: 'MachineTypePreset'; cpus: number; label: string; memory: number }>;
};

export type TeamExistsQueryVariables = Exact<{
  teamSlug: Scalars['String'];
}>;

export type TeamExistsQuery = { __typename?: 'Query'; teamExists: boolean };

export type UpdateLocalOrganizationMutationVariables = Exact<{
  id: Scalars['String'];
  organization: OrganizationInput;
}>;

export type UpdateLocalOrganizationMutation = {
  __typename?: 'Mutation';
  updateLocalOrganization: { __typename?: 'Organization'; id: string; slug: string } | null;
};

export type UpdateOrganizationMutationVariables = Exact<{
  organization: OrganizationInput;
}>;

export type UpdateOrganizationMutation = {
  __typename?: 'Mutation';
  updateOrganization: { __typename?: 'Organization'; id: string; slug: string } | null;
};

export type OrganizationQueryVariables = Exact<{
  teamSlug: Scalars['String'];
}>;

export type OrganizationQuery = {
  __typename?: 'Query';
  organization: {
    __typename?: 'Organization';
    id: string;
    name: string;
    logo: string | null;
    title: string | null;
    subtitle: string | null;
    slug: string;
    primary_link_text: string | null;
    primary_link_url: string | null;
    secondary_link_text: string | null;
    secondary_link_url: string | null;
    theme: {
      __typename?: 'OrganizationTheme';
      foreground_color: string | null;
      foreground_image: string | null;
      background_color: string | null;
      background_image: string | null;
      primary_foreground_color: string | null;
      primary_background_color: string | null;
      secondary_foreground_color: string | null;
      secondary_background_color: string | null;
    } | null;
  } | null;
};

export type GetOrganizationDashboardQueryVariables = Exact<{
  teamSlug: Scalars['String'];
}>;

export type GetOrganizationDashboardQuery = {
  __typename?: 'Query';
  userInTeam: boolean;
  organization: {
    __typename?: 'Organization';
    id: string;
    name: string;
    logo: string | null;
    title: string | null;
    subtitle: string | null;
    slug: string;
    primary_link_text: string | null;
    primary_link_url: string | null;
    secondary_link_text: string | null;
    secondary_link_url: string | null;
    theme: {
      __typename?: 'OrganizationTheme';
      foreground_color: string | null;
      foreground_image: string | null;
      background_color: string | null;
      background_image: string | null;
      primary_foreground_color: string | null;
      primary_background_color: string | null;
      secondary_foreground_color: string | null;
      secondary_background_color: string | null;
    } | null;
    features: {
      __typename?: 'OrganizationFeatures';
      hot_start: boolean;
      invites: boolean;
      statistics: boolean;
      webhooks: boolean;
    } | null;
  } | null;
  tracks: Array<{
    __typename?: 'Track';
    id: string;
    permalink: string | null;
    slug: string;
    icon: string;
    title: string;
    teaser: string;
    level: Level | null;
    tags: Array<string>;
    started: string;
    creating: string;
    created: string;
    failed: string;
    stopped: string;
    completed: string;
    cleaned: string;
    published: boolean;
    private: boolean;
    owner: string | null;
  }> | null;
};

export type EditorLayoutQueryVariables = Exact<{
  trackID: Scalars['String'];
  teamSlug: Scalars['String'];
}>;

export type EditorLayoutQuery = {
  __typename?: 'Query';
  userIsTrackDeveloper: boolean;
  team: {
    __typename?: 'Team';
    id: string;
    theme: {
      __typename?: 'TeamTheme';
      background_color: string | null;
      background_image: string | null;
      foreground_color: string | null;
    } | null;
  } | null;
  track: { __typename?: 'Track'; id: string; title: string } | null;
};

export type FormConfigurationFragmentFragment = {
  __typename?: 'Form';
  id: string;
  formTitle: string | null;
  consentNotice: string | null;
  fields: Array<{ __typename?: 'FormField'; id: string; fieldName: FormFieldName; isRequired: boolean }>;
};

export type GetFormConfigurationQueryVariables = Exact<{
  teamSlug: Scalars['String'];
}>;

export type GetFormConfigurationQuery = {
  __typename?: 'Query';
  team: {
    __typename?: 'Team';
    name: string;
    form: {
      __typename?: 'Form';
      id: string;
      formTitle: string | null;
      consentNotice: string | null;
      fields: Array<{ __typename?: 'FormField'; id: string; fieldName: FormFieldName; isRequired: boolean }>;
    } | null;
  } | null;
};

export type UpdateFormConfigurationMutationVariables = Exact<{
  form: FormInput;
}>;

export type UpdateFormConfigurationMutation = {
  __typename?: 'Mutation';
  updateForm: {
    __typename?: 'Form';
    id: string;
    formTitle: string | null;
    consentNotice: string | null;
    fields: Array<{ __typename?: 'FormField'; id: string; fieldName: FormFieldName; isRequired: boolean }>;
  } | null;
};

export type HotStartFormTrackFragment = {
  __typename?: 'Track';
  id: string;
  title: string;
  permalink: string | null;
  maintenance: boolean;
};

export type HotStartSandboxPresetFragment = {
  __typename?: 'SandboxConfigVersion';
  id: string;
  version: number;
  published_at: string | null;
  config: { __typename?: 'SandboxConfig'; id: string; name: string; slug: string } | null;
};

export type HotStartPagePoolFragment = {
  __typename?: 'HotStartPool';
  id: string;
  type: HotStartPoolType;
  name: string;
  created: string | null;
  status: HotStartStatus;
  starts_at: string | null;
  ends_at: string | null;
};

export type InviteFormTrackInviteFragment = {
  __typename?: 'TrackInvite';
  id: string;
  type: TrackInviteType | null;
  publicTitle: string | null;
  publicDescription: string | null;
  title: string;
  inviteLimit: number | null;
  playLimit: number | null;
  playTTL: number | null;
  allowedEmailAddresses: Array<string>;
  allowAnonymous: boolean;
  expiresAt: string | null;
  startsAt: string | null;
  enableLearnerSharing: boolean;
  tracks: Array<{ __typename?: 'Track'; id: string }>;
};

export type InviteFormTrackFragment = {
  __typename?: 'Track';
  id: string;
  published: boolean;
  title: string;
  maintenance: boolean;
  slug: string;
};

export type InviteFormTeamFragment = {
  __typename?: 'Team';
  id: string;
  form: {
    __typename?: 'Form';
    id: string;
    fields: Array<{ __typename?: 'FormField'; id: string; fieldName: FormFieldName; isRequired: boolean }>;
  } | null;
};

export type ManageCloudAccsResourcesFragment = {
  __typename?: 'SandboxResources';
  aws_accounts: Array<{
    __typename?: 'AwsAccountConfig';
    id: string;
    name: string;
    iam_policy: string | null;
    managed_policies: Array<string>;
    scp_policy: string | null;
  }>;
  azure_subscriptions: Array<{
    __typename?: 'AzureSubscriptionConfig';
    id: string;
    name: string;
    user_only: boolean;
    roles: Array<string>;
  }>;
  gcp_projects: Array<{
    __typename?: 'GcpProjectConfig';
    id: string;
    name: string;
    services: Array<string>;
    roles: Array<string>;
  }>;
};

export type ManageTrackCloudAccsResourcesFragment = {
  __typename?: 'TrackConfig';
  aws_accounts: Array<{
    __typename?: 'AwsAccountConfig';
    id: string;
    name: string;
    iam_policy: string | null;
    managed_policies: Array<string>;
    scp_policy: string | null;
  }>;
  azure_subscriptions: Array<{
    __typename?: 'AzureSubscriptionConfig';
    id: string;
    name: string;
    user_only: boolean;
    roles: Array<string>;
  }>;
  gcp_projects: Array<{
    __typename?: 'GcpProjectConfig';
    id: string;
    name: string;
    services: Array<string>;
    roles: Array<string>;
  }>;
};

export type ManageHostResourcesFragment = {
  __typename?: 'SandboxResources';
  containers: Array<{
    __typename?: 'ContainerConfig';
    id: string;
    name: string;
    image: string;
    entrypoint: string | null;
    cmd: string | null;
    ports: Array<number> | null;
    shell: string;
    memory: number;
    environment: Array<{ __typename?: 'EnvironmentVariable'; key: string; value: string }> | null;
  }>;
  virtualmachines: Array<{
    __typename?: 'VirtualMachineConfig';
    id: string;
    name: string;
    image: string;
    machine_type: string;
    allow_external_ingress: Array<string>;
    shell: string;
    memory: number | null;
    cpus: number | null;
    nested_virtualization: boolean;
    environment: Array<{ __typename?: 'EnvironmentVariable'; key: string; value: string }> | null;
  }>;
  virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig'; id: string; name: string; url: string }>;
};

export type ManageTrackHostResourcesFragment = {
  __typename?: 'TrackConfig';
  containers: Array<{
    __typename?: 'ContainerConfig';
    id: string;
    name: string;
    image: string;
    entrypoint: string | null;
    cmd: string | null;
    ports: Array<number> | null;
    shell: string;
    memory: number;
    environment: Array<{ __typename?: 'EnvironmentVariable'; key: string; value: string }> | null;
  }>;
  virtualmachines: Array<{
    __typename?: 'VirtualMachineConfig';
    id: string;
    name: string;
    image: string;
    machine_type: string;
    allow_external_ingress: Array<string>;
    shell: string;
    memory: number | null;
    cpus: number | null;
    nested_virtualization: boolean;
    environment: Array<{ __typename?: 'EnvironmentVariable'; key: string; value: string }> | null;
  }>;
  virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig'; id: string; name: string; url: string }>;
};

export type ManageNewTrackSandboxConfigVersionFragment = {
  __typename?: 'SandboxConfigVersion';
  id: string;
  description: string;
  published_at: string | null;
  status: SandboxConfigVersionStatus;
  version: number;
  resources: {
    __typename?: 'SandboxResources';
    secrets: Array<{ __typename?: 'SecretConfig'; id: string; name: string }>;
    containers: Array<{
      __typename?: 'ContainerConfig';
      id: string;
      name: string;
      image: string;
      entrypoint: string | null;
      cmd: string | null;
      ports: Array<number> | null;
      shell: string;
      memory: number;
      environment: Array<{ __typename?: 'EnvironmentVariable'; key: string; value: string }> | null;
    }>;
    virtualmachines: Array<{
      __typename?: 'VirtualMachineConfig';
      id: string;
      name: string;
      image: string;
      machine_type: string;
      allow_external_ingress: Array<string>;
      shell: string;
      memory: number | null;
      cpus: number | null;
      nested_virtualization: boolean;
      environment: Array<{ __typename?: 'EnvironmentVariable'; key: string; value: string }> | null;
    }>;
    virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig'; id: string; name: string; url: string }>;
    aws_accounts: Array<{
      __typename?: 'AwsAccountConfig';
      id: string;
      name: string;
      iam_policy: string | null;
      managed_policies: Array<string>;
      scp_policy: string | null;
    }>;
    azure_subscriptions: Array<{
      __typename?: 'AzureSubscriptionConfig';
      id: string;
      name: string;
      user_only: boolean;
      roles: Array<string>;
    }>;
    gcp_projects: Array<{
      __typename?: 'GcpProjectConfig';
      id: string;
      name: string;
      services: Array<string>;
      roles: Array<string>;
    }>;
  } | null;
  scripts: Array<{ __typename?: 'SandboxScript'; action: string; contents: string; host: string }> | null;
  config: { __typename?: 'SandboxConfig'; id: string; name: string; slug: string } | null;
  published_by: {
    __typename?: 'User';
    profile: { __typename?: 'UserProfile'; avatar: string | null; display_name: string | null } | null;
  } | null;
};

export type ManageSandboxPresetVersionFragment = {
  __typename?: 'SandboxConfigVersion';
  id: string;
  description: string;
  status: SandboxConfigVersionStatus;
  config: { __typename?: 'SandboxConfig'; id: string; name: string; slug: string } | null;
  resources: {
    __typename?: 'SandboxResources';
    secrets: Array<{ __typename?: 'SecretConfig'; id: string; name: string }>;
    containers: Array<{
      __typename?: 'ContainerConfig';
      id: string;
      name: string;
      image: string;
      entrypoint: string | null;
      cmd: string | null;
      ports: Array<number> | null;
      shell: string;
      memory: number;
      environment: Array<{ __typename?: 'EnvironmentVariable'; key: string; value: string }> | null;
    }>;
    virtualmachines: Array<{
      __typename?: 'VirtualMachineConfig';
      id: string;
      name: string;
      image: string;
      machine_type: string;
      allow_external_ingress: Array<string>;
      shell: string;
      memory: number | null;
      cpus: number | null;
      nested_virtualization: boolean;
      environment: Array<{ __typename?: 'EnvironmentVariable'; key: string; value: string }> | null;
    }>;
    virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig'; id: string; name: string; url: string }>;
    aws_accounts: Array<{
      __typename?: 'AwsAccountConfig';
      id: string;
      name: string;
      iam_policy: string | null;
      managed_policies: Array<string>;
      scp_policy: string | null;
    }>;
    azure_subscriptions: Array<{
      __typename?: 'AzureSubscriptionConfig';
      id: string;
      name: string;
      user_only: boolean;
      roles: Array<string>;
    }>;
    gcp_projects: Array<{
      __typename?: 'GcpProjectConfig';
      id: string;
      name: string;
      services: Array<string>;
      roles: Array<string>;
    }>;
  } | null;
  scripts: Array<{ __typename?: 'SandboxScript'; host: string; action: string; contents: string }> | null;
};

export type ManageTrackSandboxConfigVersionFragment = {
  __typename?: 'SandboxConfigVersion';
  id: string;
  description: string;
  published_at: string | null;
  status: SandboxConfigVersionStatus;
  version: number;
  config: { __typename?: 'SandboxConfig'; id: string; name: string; slug: string } | null;
  published_by: {
    __typename?: 'User';
    profile: { __typename?: 'UserProfile'; avatar: string | null; display_name: string | null } | null;
  } | null;
};

export type PlayActivityDrawerPlayReportItemFragment = {
  __typename?: 'PlayReportItem';
  id: string;
  mode: Mode | null;
  customParameters: Array<{ __typename?: 'CustomParameter'; key: string; value: string }>;
  track: { __typename?: 'Track'; id: string; title: string; slug: string };
  trackInvite: { __typename?: 'TrackInvite'; id: string; publicTitle: string | null } | null;
  user: {
    __typename?: 'User';
    id: string;
    details: {
      __typename?: 'UserDetails';
      firstName: string | null;
      lastName: string | null;
      email: string | null;
      companyName: string | null;
    } | null;
    profile: { __typename?: 'UserProfile'; display_name: string | null; email: string | null } | null;
  };
  activity: Array<{
    __typename?: 'PlayActivity';
    message: string;
    time: string;
    challenge: { __typename?: 'Challenge'; slug: string } | null;
  }>;
  playReview: { __typename?: 'TrackReview'; id: string; score: number; content: string } | null;
};

export type PreviewResourceSandboxResourcesFragment = {
  __typename?: 'SandboxResources';
  containers: Array<{
    __typename?: 'ContainerConfig';
    id: string;
    name: string;
    image: string;
    entrypoint: string | null;
    cmd: string | null;
    ports: Array<number> | null;
    shell: string;
    memory: number;
    environment: Array<{ __typename?: 'EnvironmentVariable'; key: string; value: string }> | null;
  }>;
  virtualmachines: Array<{
    __typename?: 'VirtualMachineConfig';
    id: string;
    name: string;
    image: string;
    machine_type: string;
    allow_external_ingress: Array<string>;
    shell: string;
    memory: number | null;
    cpus: number | null;
    nested_virtualization: boolean;
    environment: Array<{ __typename?: 'EnvironmentVariable'; key: string; value: string }> | null;
  }>;
  virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig'; id: string; name: string; url: string }>;
  aws_accounts: Array<{
    __typename?: 'AwsAccountConfig';
    id: string;
    name: string;
    iam_policy: string | null;
    managed_policies: Array<string>;
    scp_policy: string | null;
  }>;
  azure_subscriptions: Array<{
    __typename?: 'AzureSubscriptionConfig';
    id: string;
    name: string;
    user_only: boolean;
    roles: Array<string>;
  }>;
  gcp_projects: Array<{
    __typename?: 'GcpProjectConfig';
    id: string;
    name: string;
    services: Array<string>;
    roles: Array<string>;
  }>;
};

export type PreviewSandboxPresetVersionFragment = {
  __typename?: 'SandboxConfigVersion';
  change_log_entry: string;
  id: string;
  description: string;
  published_at: string | null;
  status: SandboxConfigVersionStatus;
  version: number;
  resources: {
    __typename?: 'SandboxResources';
    secrets: Array<{ __typename?: 'SecretConfig'; name: string }>;
    containers: Array<{
      __typename?: 'ContainerConfig';
      id: string;
      name: string;
      image: string;
      entrypoint: string | null;
      cmd: string | null;
      ports: Array<number> | null;
      shell: string;
      memory: number;
      environment: Array<{ __typename?: 'EnvironmentVariable'; key: string; value: string }> | null;
    }>;
    virtualmachines: Array<{
      __typename?: 'VirtualMachineConfig';
      id: string;
      name: string;
      image: string;
      machine_type: string;
      allow_external_ingress: Array<string>;
      shell: string;
      memory: number | null;
      cpus: number | null;
      nested_virtualization: boolean;
      environment: Array<{ __typename?: 'EnvironmentVariable'; key: string; value: string }> | null;
    }>;
    virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig'; id: string; name: string; url: string }>;
    aws_accounts: Array<{
      __typename?: 'AwsAccountConfig';
      id: string;
      name: string;
      iam_policy: string | null;
      managed_policies: Array<string>;
      scp_policy: string | null;
    }>;
    azure_subscriptions: Array<{
      __typename?: 'AzureSubscriptionConfig';
      id: string;
      name: string;
      user_only: boolean;
      roles: Array<string>;
    }>;
    gcp_projects: Array<{
      __typename?: 'GcpProjectConfig';
      id: string;
      name: string;
      services: Array<string>;
      roles: Array<string>;
    }>;
  } | null;
  scripts: Array<{ __typename?: 'SandboxScript'; action: string; contents: string; host: string }> | null;
  tracks: Array<{ __typename?: 'Track'; id: string; title: string } | null>;
  hot_start_pools: Array<{ __typename?: 'HotStartPool'; id: string; name: string } | null>;
  config: { __typename?: 'SandboxConfig'; id: string; name: string; slug: string } | null;
  published_by: {
    __typename?: 'User';
    profile: { __typename?: 'UserProfile'; avatar: string | null; display_name: string | null } | null;
  } | null;
};

export type PreviewSandboxHistoryPresetVersionFragment = {
  __typename?: 'SandboxConfigVersion';
  change_log_entry: string;
  id: string;
  description: string;
  published_at: string | null;
  status: SandboxConfigVersionStatus;
  version: number;
  config: { __typename?: 'SandboxConfig'; id: string; name: string; slug: string } | null;
  published_by: {
    __typename?: 'User';
    profile: { __typename?: 'UserProfile'; avatar: string | null; display_name: string | null } | null;
  } | null;
};

export type AwsAccountFormAwsAccountFragment = {
  __typename?: 'AwsAccountConfig';
  id: string;
  name: string;
  iam_policy: string | null;
  managed_policies: Array<string>;
  scp_policy: string | null;
};

export type AzureSubscriptionFormAzureSubscriptionFragment = {
  __typename?: 'AzureSubscriptionConfig';
  id: string;
  name: string;
  user_only: boolean;
  roles: Array<string>;
};

export type ContainerFormContainerPresetFragment = {
  __typename?: 'ContainerConfigPreset';
  label: string;
  image: string;
  memory: number;
};

export type ContainerFormContainerFragment = {
  __typename?: 'ContainerConfig';
  id: string;
  name: string;
  image: string;
  entrypoint: string | null;
  cmd: string | null;
  ports: Array<number> | null;
  shell: string;
  memory: number;
  environment: Array<{ __typename?: 'EnvironmentVariable'; key: string; value: string }> | null;
};

export type GoogleCloudFormGcpProjectFragment = {
  __typename?: 'GcpProjectConfig';
  id: string;
  name: string;
  services: Array<string>;
  roles: Array<string>;
};

export type GetSandboxPresetCardInfoQueryVariables = Exact<{
  configVersionID: Scalars['String'];
}>;

export type GetSandboxPresetCardInfoQuery = {
  __typename?: 'Query';
  sandboxConfigVersion: {
    __typename?: 'SandboxConfigVersion';
    id: string;
    resources: {
      __typename?: 'SandboxResources';
      secrets: Array<{ __typename?: 'SecretConfig'; name: string }>;
      containers: Array<{
        __typename?: 'ContainerConfig';
        id: string;
        name: string;
        image: string;
        entrypoint: string | null;
        cmd: string | null;
        ports: Array<number> | null;
        shell: string;
        memory: number;
        environment: Array<{ __typename?: 'EnvironmentVariable'; key: string; value: string }> | null;
      }>;
      virtualmachines: Array<{
        __typename?: 'VirtualMachineConfig';
        id: string;
        name: string;
        image: string;
        machine_type: string;
        allow_external_ingress: Array<string>;
        shell: string;
        memory: number | null;
        cpus: number | null;
        nested_virtualization: boolean;
        environment: Array<{ __typename?: 'EnvironmentVariable'; key: string; value: string }> | null;
      }>;
      virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig'; id: string; name: string; url: string }>;
      aws_accounts: Array<{
        __typename?: 'AwsAccountConfig';
        id: string;
        name: string;
        iam_policy: string | null;
        managed_policies: Array<string>;
        scp_policy: string | null;
      }>;
      azure_subscriptions: Array<{
        __typename?: 'AzureSubscriptionConfig';
        id: string;
        name: string;
        user_only: boolean;
        roles: Array<string>;
      }>;
      gcp_projects: Array<{
        __typename?: 'GcpProjectConfig';
        id: string;
        name: string;
        services: Array<string>;
        roles: Array<string>;
      }>;
    } | null;
    scripts: Array<{ __typename?: 'SandboxScript'; action: string; contents: string; host: string }> | null;
  } | null;
};

export type SandboxPresetListCardFragment = {
  __typename?: 'SandboxConfigVersion';
  id: string;
  description: string;
  published_at: string | null;
  status: SandboxConfigVersionStatus;
  version: number;
  config: { __typename?: 'SandboxConfig'; id: string; name: string; slug: string } | null;
  published_by: {
    __typename?: 'User';
    profile: { __typename?: 'UserProfile'; avatar: string | null; display_name: string | null } | null;
  } | null;
};

export type VirtualBrowserFormVirtualBrowserFragment = {
  __typename?: 'VirtualBrowserConfig';
  id: string;
  name: string;
  url: string;
};

export type VirtualMachineFormMachineTypePresetFragment = {
  __typename?: 'MachineTypePreset';
  cpus: number;
  label: string;
  memory: number;
};

export type VirtualMachineFormGoogleCloudMachineTypePresetFragment = {
  __typename?: 'GoogleCloudMachineTypePreset';
  label: string;
  machine_type: string;
};

export type VirtualMachineFormVirtualMachinePresetFragment = {
  __typename?: 'VirtualMachineConfigPreset';
  image: string;
  label: string;
  machine_type: string;
  cpus: number;
  memory: number;
};

export type VirtualMachineFormVirtualMachineFragment = {
  __typename?: 'VirtualMachineConfig';
  id: string;
  name: string;
  image: string;
  machine_type: string;
  allow_external_ingress: Array<string>;
  shell: string;
  memory: number | null;
  cpus: number | null;
  nested_virtualization: boolean;
  environment: Array<{ __typename?: 'EnvironmentVariable'; key: string; value: string }> | null;
};

export type SelectPresetSandboxConfigVersionFragment = {
  __typename?: 'SandboxConfigVersion';
  id: string;
  description: string;
  published_at: string | null;
  status: SandboxConfigVersionStatus;
  version: number;
  config: { __typename?: 'SandboxConfig'; id: string; name: string; slug: string } | null;
  published_by: {
    __typename?: 'User';
    profile: { __typename?: 'UserProfile'; avatar: string | null; display_name: string | null } | null;
  } | null;
};

export type TrackStatisticsQueryVariables = Exact<{
  trackID: InputMaybe<Scalars['String']>;
  teamSlug: InputMaybe<Scalars['String']>;
  start: InputMaybe<Scalars['Time']>;
  end: InputMaybe<Scalars['Time']>;
  filterDevelopers: InputMaybe<Scalars['Boolean']>;
}>;

export type TrackStatisticsQuery = {
  __typename?: 'Query';
  statistics: {
    __typename?: 'Statistics';
    track: {
      __typename?: 'TrackStatistics';
      started_total: number | null;
      completed_total: number | null;
      track_series: Array<{ __typename?: 'TrackSeries'; date: string; started: number; completed: number }>;
      challenge_series: Array<{
        __typename?: 'ChallengeSeries';
        date: string;
        unlocked: number;
        started: number;
        completed: number;
      }>;
      happiness: Array<{ __typename?: 'HappinessCount'; score: number; count: number }>;
      challenges: Array<{
        __typename?: 'ChallengeStatistics';
        title: string | null;
        started_total: number | null;
        completed_total: number | null;
        attempts_total: number | null;
        attempts_min: number | null;
        attempts_avg: number | null;
        attempts_max: number | null;
        duration_min: number | null;
        duration_avg: number | null;
        duration_max: number | null;
      }>;
    } | null;
  } | null;
};

export type ChallengeAttemptsChallengeStatisticsFragment = {
  __typename?: 'ChallengeStatistics';
  title: string | null;
  attempts_min: number | null;
  attempts_avg: number | null;
  attempts_max: number | null;
};

export type ChallengeDurationChallengeStatisticsFragment = {
  __typename?: 'ChallengeStatistics';
  title: string | null;
  duration_min: number | null;
  duration_avg: number | null;
  duration_max: number | null;
};

export type DailyTrackStartsChallengeSeriesFragment = {
  __typename?: 'ChallengeSeries';
  date: string;
  unlocked: number;
  started: number;
  completed: number;
};

export type DailyTrackStartsTrackSeriesFragment = {
  __typename?: 'TrackSeries';
  date: string;
  started: number;
  completed: number;
};

export type TotalChallengeStartsChallengeStatisticsFragment = {
  __typename?: 'ChallengeStatistics';
  title: string | null;
  started_total: number | null;
  completed_total: number | null;
  attempts_total: number | null;
};

export type TotalTrackStartsTrackStatisticsFragment = {
  __typename?: 'TrackStatistics';
  started_total: number | null;
  completed_total: number | null;
};

export type UserHappinessHappinessCountFragment = { __typename?: 'HappinessCount'; score: number; count: number };

export type CreateTrackFromScrachMutationVariables = Exact<{
  track: TrackInput;
}>;

export type CreateTrackFromScrachMutation = {
  __typename?: 'Mutation';
  createTrack: { __typename?: 'Track'; id: string; owner: string | null; slug: string } | null;
};

export type UpdateTrackDashboardOptionsMutationVariables = Exact<{
  track: TrackInput;
}>;

export type UpdateTrackDashboardOptionsMutation = {
  __typename?: 'Mutation';
  updateTrack: {
    __typename?: 'Track';
    id: string;
    maintenance: boolean;
    show_timer: boolean;
    skipping_enabled: boolean;
  } | null;
};

export type TrackDetailsFormQueryVariables = Exact<{
  trackSlug: Scalars['String'];
  teamSlug: Scalars['String'];
}>;

export type TrackDetailsFormQuery = {
  __typename?: 'Query';
  track: {
    __typename?: 'Track';
    id: string;
    slug: string;
    owner: string | null;
    title: string;
    timelimit: number | null;
    description: string;
    tags: Array<string>;
    idle_timeout: number | null;
    maintenance: boolean;
    show_timer: boolean;
    skipping_enabled: boolean;
    can_skip: boolean;
    lab_config: {
      __typename?: 'LabConfig';
      width: number;
      position: string;
      overlay: boolean;
      extendTTL: number | null;
    } | null;
  } | null;
};

export type UpdateTrackDetailsMutationVariables = Exact<{
  track: TrackInput;
}>;

export type UpdateTrackDetailsMutation = {
  __typename?: 'Mutation';
  updateTrack: {
    __typename?: 'Track';
    id: string;
    slug: string;
    owner: string | null;
    title: string;
    timelimit: number | null;
    description: string;
    tags: Array<string>;
    idle_timeout: number | null;
    maintenance: boolean;
    show_timer: boolean;
    skipping_enabled: boolean;
    can_skip: boolean;
    lab_config: {
      __typename?: 'LabConfig';
      width: number;
      position: string;
      overlay: boolean;
      extendTTL: number | null;
    } | null;
  } | null;
};

export type TrackDetailsFormDataFragment = {
  __typename?: 'Track';
  id: string;
  slug: string;
  owner: string | null;
  title: string;
  timelimit: number | null;
  description: string;
  tags: Array<string>;
  idle_timeout: number | null;
  maintenance: boolean;
  show_timer: boolean;
  skipping_enabled: boolean;
  can_skip: boolean;
  lab_config: {
    __typename?: 'LabConfig';
    width: number;
    position: string;
    overlay: boolean;
    extendTTL: number | null;
  } | null;
};

export type TrackInviteDetailsTrackInviteFragment = {
  __typename?: 'TrackInvite';
  id: string;
  title: string;
  publicTitle: string | null;
  publicDescription: string | null;
  inviteLimit: number | null;
  inviteCount: number | null;
  startsAt: string | null;
  expiresAt: string | null;
  playLimit: number | null;
  playTTL: number | null;
  allowAnonymous: boolean;
  allowedEmailAddressesOnly: boolean;
  status: TrackInviteStatus | null;
  type: TrackInviteType | null;
  enableLearnerSharing: boolean;
  canClaim: boolean;
  tracks: Array<{ __typename?: 'Track'; id: string; title: string; permalink: string | null }>;
  team: { __typename?: 'Team'; name: string };
};

export type TrackInvitesTableInvitesQueryVariables = Exact<{
  teamSlug: Scalars['String'];
  filters: InviteFilters;
}>;

export type TrackInvitesTableInvitesQuery = {
  __typename?: 'Query';
  trackInvites: Array<{
    __typename?: 'TrackInvite';
    id: string;
    publicTitle: string | null;
    title: string;
    inviteLimit: number | null;
    inviteCount: number | null;
    expiresAt: string | null;
    created: string | null;
    playLimit: number | null;
    type: TrackInviteType | null;
    status: TrackInviteStatus | null;
    startsAt: string | null;
    tracks: Array<{ __typename?: 'Track'; id: string; title: string }>;
  }> | null;
  team: {
    __typename?: 'Team';
    id: string;
    features: { __typename?: 'TeamFeatures'; hot_start: boolean } | null;
  } | null;
};

export type TrackInvitesTableInviteQueryVariables = Exact<{
  inviteID: Scalars['String'];
  teamSlug: Scalars['String'];
}>;

export type TrackInvitesTableInviteQuery = {
  __typename?: 'Query';
  trackInvite: {
    __typename?: 'TrackInvite';
    id: string;
    publicTitle: string | null;
    claims: Array<{
      __typename?: 'InviteClaim';
      id: string;
      claimedAt: string | null;
      playLimit: number | null;
      playTTL: string | null;
      user: {
        __typename?: 'User';
        id: string;
        profile: { __typename?: 'UserProfile'; display_name: string | null; email: string | null } | null;
        details: {
          __typename?: 'UserDetails';
          firstName: string | null;
          lastName: string | null;
          email: string | null;
          id: string;
          companyName: string | null;
          phoneNumber: string | null;
          jobTitle: string | null;
          jobLevel: string | null;
          countryCode: string | null;
          usState: string | null;
        } | null;
      };
    }>;
    team: {
      __typename?: 'Team';
      id: string;
      slug: string;
      form: {
        __typename?: 'Form';
        id: string;
        fields: Array<{ __typename?: 'FormField'; id: string; fieldName: FormFieldName }>;
      } | null;
    };
    plays: Array<{
      __typename?: 'InvitePlay';
      last_activity: string;
      time_spent: number;
      track_started_at: string;
      track_completed_at: string | null;
      completed_challenges: number;
      total_challenges: number;
      failed_challenge_attempts: number;
      track: { __typename?: 'Track'; id: string; slug: string };
      participant: { __typename?: 'Play'; id: string };
      user: {
        __typename?: 'User';
        id: string;
        is_anonymous: boolean;
        profile: { __typename?: 'UserProfile'; email: string | null; display_name: string | null } | null;
      };
    }>;
  } | null;
};

export type DeleteTrackInviteMutationVariables = Exact<{
  inviteID: Scalars['String'];
}>;

export type DeleteTrackInviteMutation = { __typename?: 'Mutation'; deleteTrackInvite: boolean };

export type TrackLimitsTableTrackFragment = {
  __typename?: 'Track';
  id: string;
  title: string;
  slug: string;
  maintenance: boolean;
  play_count: number | null;
};

export type TrackLimitsTableTrackLimitsFragment = {
  __typename?: 'TrackPlayLimit';
  rollingMonth: number;
  rollingIPAddressPerHour: number;
  calendarMonth: number;
  track: { __typename?: 'Track'; id: string } | null;
};

export type GetTeamSaasFeatureFlagQueryVariables = Exact<{
  teamSlug: Scalars['String'];
}>;

export type GetTeamSaasFeatureFlagQuery = {
  __typename?: 'Query';
  team: { __typename?: 'Team'; id: string; features: { __typename?: 'TeamFeatures'; saas: boolean } | null } | null;
};

export type WizardTrackDetailsTrackExistsQueryVariables = Exact<{
  trackSlug: Scalars['String'];
  teamSlug: Scalars['String'];
}>;

export type WizardTrackDetailsTrackExistsQuery = { __typename?: 'Query'; trackExists: boolean };

export type GetOrganizationQueryVariables = Exact<{
  teamSlug: Scalars['String'];
}>;

export type GetOrganizationQuery = {
  __typename?: 'Query';
  team: {
    __typename?: 'Team';
    id: string;
    api_key: string | null;
    features: { __typename?: 'TeamFeatures'; lti_enabled: boolean } | null;
    lti_credentials: { __typename?: 'LTICredentials'; consumer_name: string; consumer_key: string } | null;
  } | null;
};

export type GenerateOrganizationApiKeyMutationVariables = Exact<{
  teamSlug: Scalars['String'];
}>;

export type GenerateOrganizationApiKeyMutation = { __typename?: 'Mutation'; generateTeamAPIKey: string | null };

export type GenerateTeamLtiCredentialsMutationVariables = Exact<{
  teamSlug: Scalars['String'];
}>;

export type GenerateTeamLtiCredentialsMutation = {
  __typename?: 'Mutation';
  generateTeamLTICredentials: { __typename?: 'LTICredentials'; consumer_name: string; consumer_key: string } | null;
};

export type ArcadeEditPageQueryVariables = Exact<{
  arcadeID: Scalars['String'];
}>;

export type ArcadeEditPageQuery = {
  __typename?: 'Query';
  arcade: {
    __typename?: 'Arcade';
    id: string;
    serial_number: string;
    alternative_url: string | null;
    active: boolean;
  } | null;
};

export type ArcadeListPageQueryVariables = Exact<{
  teamSlug: Scalars['String'];
}>;

export type ArcadeListPageQuery = {
  __typename?: 'Query';
  arcades: Array<{
    __typename?: 'Arcade';
    id: string;
    serial_number: string;
    alternative_url: string | null;
    organization: string;
    active: boolean;
  }> | null;
  tracks: Array<{ __typename?: 'Track'; id: string; title: string }> | null;
  arcadetracks: Array<{ __typename?: 'Track'; id: string; title: string; icon: string }> | null;
};

export type ChallengeAssignmentPageQueryVariables = Exact<{
  teamSlug: Scalars['String'];
  trackSlug: Scalars['String'];
  challengeSlug: Scalars['String'];
}>;

export type ChallengeAssignmentPageQuery = {
  __typename?: 'Query';
  challenge: { __typename?: 'Challenge'; id: string; title: string } | null;
};

export type ChallengeGuardrailsPageQueryVariables = Exact<{
  teamSlug: Scalars['String'];
  trackSlug: Scalars['String'];
  challengeSlug: Scalars['String'];
}>;

export type ChallengeGuardrailsPageQuery = {
  __typename?: 'Query';
  challenge: { __typename?: 'Challenge'; id: string; title: string } | null;
};

export type GetChallengeNotesListConfigQueryVariables = Exact<{
  trackID: Scalars['String'];
  challengeID: Scalars['String'];
}>;

export type GetChallengeNotesListConfigQuery = {
  __typename?: 'Query';
  userIsTrackDeveloper: boolean;
  track: {
    __typename?: 'Track';
    lab_config: { __typename?: 'LabConfig'; width: number; position: string; overlay: boolean } | null;
  } | null;
  challenge: {
    __typename?: 'Challenge';
    id: string;
    assignment: string;
    teaser: string;
    title: string;
    type: ChallengeType;
    notes: Array<{
      __typename?: 'ChallengeNote';
      id: string;
      index: number;
      type: ChallengeNoteType;
      contents: string | null;
      url: string | null;
    }>;
    tabs: Array<{
      __typename?: 'ChallengeTab';
      id: string;
      type: ChallengeTabType;
      title: string;
      target: string | null;
      path: string | null;
      url: string | null;
      index: number;
      new_window: boolean;
    }>;
  } | null;
};

export type NotesListChallengeFragment = {
  __typename?: 'Challenge';
  id: string;
  assignment: string;
  teaser: string;
  title: string;
  type: ChallengeType;
  notes: Array<{
    __typename?: 'ChallengeNote';
    id: string;
    index: number;
    type: ChallengeNoteType;
    contents: string | null;
    url: string | null;
  }>;
  tabs: Array<{
    __typename?: 'ChallengeTab';
    id: string;
    type: ChallengeTabType;
    title: string;
    target: string | null;
    path: string | null;
    url: string | null;
    index: number;
    new_window: boolean;
  }>;
};

export type ChallengeNotesPageQueryVariables = Exact<{
  teamSlug: Scalars['String'];
  trackSlug: Scalars['String'];
  challengeSlug: Scalars['String'];
}>;

export type ChallengeNotesPageQuery = {
  __typename?: 'Query';
  challenge: { __typename?: 'Challenge'; id: string; title: string } | null;
};

export type GetChallengeScriptsEditorPageConfigQueryVariables = Exact<{
  trackID: Scalars['String'];
  challengeID: Scalars['String'];
}>;

export type GetChallengeScriptsEditorPageConfigQuery = {
  __typename?: 'Query';
  userIsTrackDeveloper: boolean;
  track: {
    __typename?: 'Track';
    sandboxConfig: {
      __typename?: 'SandboxConfigVersion';
      resources: {
        __typename?: 'SandboxResources';
        containers: Array<{ __typename?: 'ContainerConfig'; id: string; name: string }>;
        virtualmachines: Array<{ __typename?: 'VirtualMachineConfig'; id: string; name: string }>;
        virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig'; id: string; name: string }>;
      } | null;
    } | null;
  } | null;
  trackConfig: {
    __typename?: 'TrackConfig';
    id: string;
    containers: Array<{ __typename?: 'ContainerConfig'; id: string; name: string }>;
    virtualmachines: Array<{ __typename?: 'VirtualMachineConfig'; id: string; name: string }>;
    virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig'; id: string; name: string }>;
  } | null;
  challengeScripts: Array<{
    __typename?: 'ChallengeScript';
    id: string;
    host: string;
    action: string;
    contents: string;
  }> | null;
};

export type ChallengeScriptsEditorPageSaveChallengeScriptMutationVariables = Exact<{
  script: ChallengeScriptInput;
  base64Encoded: Scalars['Boolean'];
}>;

export type ChallengeScriptsEditorPageSaveChallengeScriptMutation = {
  __typename?: 'Mutation';
  saveChallengeScript: {
    __typename?: 'ChallengeScript';
    id: string;
    host: string;
    action: string;
    contents: string;
  } | null;
};

export type ChallengeScriptsEditorPageDeleteChallengeScriptMutationVariables = Exact<{
  challengeScriptID: Scalars['String'];
}>;

export type ChallengeScriptsEditorPageDeleteChallengeScriptMutation = {
  __typename?: 'Mutation';
  deleteChallengeScript: boolean;
};

export type ChallengeScriptFragment = {
  __typename?: 'ChallengeScript';
  id: string;
  host: string;
  action: string;
  contents: string;
};

export type ChallengeScriptsTrackQueryVariables = Exact<{
  teamSlug: Scalars['String'];
  trackSlug: Scalars['String'];
}>;

export type ChallengeScriptsTrackQuery = {
  __typename?: 'Query';
  track: {
    __typename?: 'Track';
    id: string;
    sandboxConfig: {
      __typename?: 'SandboxConfigVersion';
      resources: {
        __typename?: 'SandboxResources';
        containers: Array<{ __typename?: 'ContainerConfig'; id: string; name: string }>;
        virtualmachines: Array<{ __typename?: 'VirtualMachineConfig'; id: string; name: string }>;
        virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig'; id: string; name: string }>;
      } | null;
    } | null;
  } | null;
};

export type ChallengeScriptsPageQueryVariables = Exact<{
  teamSlug: Scalars['String'];
  trackID: Scalars['String'];
  trackSlug: Scalars['String'];
  challengeSlug: Scalars['String'];
}>;

export type ChallengeScriptsPageQuery = {
  __typename?: 'Query';
  trackConfig: {
    __typename?: 'TrackConfig';
    id: string;
    containers: Array<{ __typename?: 'ContainerConfig'; id: string; name: string }>;
    virtualmachines: Array<{ __typename?: 'VirtualMachineConfig'; id: string; name: string }>;
    virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig'; id: string; name: string }>;
  } | null;
  challenge: {
    __typename?: 'Challenge';
    id: string;
    title: string;
    scripts: Array<{ __typename?: 'ChallengeScript'; action: string; contents: string; host: string; id: string }>;
  } | null;
};

export type GetChallengeTabsListPageConfigQueryVariables = Exact<{
  trackID: Scalars['String'];
  challengeID: Scalars['String'];
}>;

export type GetChallengeTabsListPageConfigQuery = {
  __typename?: 'Query';
  userIsTrackDeveloper: boolean;
  track: {
    __typename?: 'Track';
    lab_config: { __typename?: 'LabConfig'; width: number; position: string; overlay: boolean } | null;
  } | null;
  challenge: {
    __typename?: 'Challenge';
    id: string;
    assignment: string;
    teaser: string;
    title: string;
    type: ChallengeType;
    tabs: Array<{
      __typename?: 'ChallengeTab';
      id: string;
      type: ChallengeTabType;
      title: string;
      target: string | null;
      path: string | null;
      url: string | null;
      index: number;
      new_window: boolean;
      hostname: string | null;
      port: number | null;
      workdir: string | null;
      cmd: string | null;
    }>;
    notes: Array<{
      __typename?: 'ChallengeNote';
      id: string;
      index: number;
      type: ChallengeNoteType;
      contents: string | null;
      url: string | null;
    }>;
  } | null;
};

export type TabsListChallengeFragment = {
  __typename?: 'Challenge';
  id: string;
  assignment: string;
  teaser: string;
  title: string;
  type: ChallengeType;
  notes: Array<{
    __typename?: 'ChallengeNote';
    id: string;
    index: number;
    type: ChallengeNoteType;
    contents: string | null;
    url: string | null;
  }>;
  tabs: Array<{
    __typename?: 'ChallengeTab';
    id: string;
    type: ChallengeTabType;
    title: string;
    target: string | null;
    path: string | null;
    url: string | null;
    index: number;
    new_window: boolean;
  }>;
};

export type TabsListChallengeTabFragment = {
  __typename?: 'ChallengeTab';
  id: string;
  index: number;
  target: string | null;
  title: string;
  type: ChallengeTabType;
  url: string | null;
  hostname: string | null;
  path: string | null;
  port: number | null;
  new_window: boolean;
  workdir: string | null;
  cmd: string | null;
};

export type ChallengeTabsPageQueryVariables = Exact<{
  teamSlug: Scalars['String'];
  trackSlug: Scalars['String'];
  challengeSlug: Scalars['String'];
}>;

export type ChallengeTabsPageQuery = {
  __typename?: 'Query';
  challenge: { __typename?: 'Challenge'; id: string; title: string } | null;
};

export type GetCreateChallengeNoteConfigQueryVariables = Exact<{
  trackID: Scalars['String'];
  challengeID: Scalars['String'];
}>;

export type GetCreateChallengeNoteConfigQuery = {
  __typename?: 'Query';
  userIsTrackDeveloper: boolean;
  challenge: { __typename?: 'Challenge'; id: string } | null;
};

export type CreateChallengeNotePageCreateChallengeNoteMutationVariables = Exact<{
  note: ChallengeNoteInput;
}>;

export type CreateChallengeNotePageCreateChallengeNoteMutation = {
  __typename?: 'Mutation';
  createChallengeNote: {
    __typename?: 'ChallengeNote';
    id: string;
    index: number;
    contents: string | null;
    type: ChallengeNoteType;
    url: string | null;
  } | null;
};

export type GetCreateChallengeTabPageConfigQueryVariables = Exact<{
  trackID: Scalars['String'];
  challengeID: Scalars['String'];
  teamSlug: Scalars['String'];
}>;

export type GetCreateChallengeTabPageConfigQuery = {
  __typename?: 'Query';
  userIsTrackDeveloper: boolean;
  challenge: { __typename?: 'Challenge'; id: string } | null;
  track: {
    __typename?: 'Track';
    sandboxConfig: {
      __typename?: 'SandboxConfigVersion';
      resources: {
        __typename?: 'SandboxResources';
        containers: Array<{ __typename?: 'ContainerConfig'; id: string; name: string }>;
        virtualmachines: Array<{ __typename?: 'VirtualMachineConfig'; id: string; name: string }>;
        virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig'; id: string; name: string }>;
      } | null;
    } | null;
  } | null;
  trackConfig: {
    __typename?: 'TrackConfig';
    id: string;
    containers: Array<{ __typename?: 'ContainerConfig'; id: string; name: string; image: string }>;
    virtualmachines: Array<{ __typename?: 'VirtualMachineConfig'; id: string; name: string }>;
    virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig'; id: string; name: string }>;
  } | null;
  team: { __typename?: 'Team'; id: string; features: { __typename?: 'TeamFeatures'; saas: boolean } | null } | null;
};

export type CreateChallengeTabPageCreateChallengeTabMutationVariables = Exact<{
  tab: ChallengeTabInput;
}>;

export type CreateChallengeTabPageCreateChallengeTabMutation = {
  __typename?: 'Mutation';
  createChallengeTab: {
    __typename?: 'ChallengeTab';
    id: string;
    index: number;
    target: string | null;
    title: string;
    type: ChallengeTabType;
    hostname: string | null;
    url: string | null;
    port: number | null;
    path: string | null;
    workdir: string | null;
    cmd: string | null;
    new_window: boolean;
  } | null;
};

export type GetCreateChallengePageConfigQueryVariables = Exact<{
  trackID: Scalars['String'];
}>;

export type GetCreateChallengePageConfigQuery = { __typename?: 'Query'; userIsTrackDeveloper: boolean };

export type CreateChallengePageCreateChallengeMutationVariables = Exact<{
  challenge: ChallengeInput;
}>;

export type CreateChallengePageCreateChallengeMutation = {
  __typename?: 'Mutation';
  createChallenge: {
    __typename?: 'Challenge';
    id: string;
    title: string;
    slug: string;
    permalink: string | null;
  } | null;
};

export type ChallengeQueryVariables = Exact<{
  challengeID: Scalars['String'];
}>;

export type ChallengeQuery = {
  __typename?: 'Query';
  challenge: {
    __typename?: 'Challenge';
    answers: Array<string>;
    assignment: string;
    slug: string;
    solution: Array<number>;
    teaser: string;
    timelimit: number | null;
    title: string;
    type: ChallengeType;
  } | null;
};

export type GetCreateTrackWizardPageConfigQueryVariables = Exact<{
  teamSlug: Scalars['String'];
  filter: SandboxConfigVersionsFilterInput;
}>;

export type GetCreateTrackWizardPageConfigQuery = {
  __typename?: 'Query';
  team: {
    __typename?: 'Team';
    id: string;
    features: {
      __typename?: 'TeamFeatures';
      containers: boolean;
      virtual_machines: boolean;
      saas: boolean;
      gcp_projects: boolean;
      aws_accounts: boolean;
      azure_subscriptions: boolean;
      custom_machine_type: boolean;
      shared_hotstart_pools: boolean;
    } | null;
  } | null;
  teamSecrets: Array<{ __typename?: 'Secret'; name: string; description: string }> | null;
  trackConfigPresets: {
    __typename?: 'TrackConfigPresets';
    containers: Array<{ __typename?: 'ContainerConfigPreset'; label: string; image: string; memory: number }>;
    googlecloudmachinetypes: Array<{
      __typename?: 'GoogleCloudMachineTypePreset';
      label: string;
      machine_type: string;
    }>;
    virtualmachines: Array<{
      __typename?: 'VirtualMachineConfigPreset';
      image: string;
      label: string;
      machine_type: string;
      cpus: number;
      memory: number;
    }>;
    machinetypes: Array<{ __typename?: 'MachineTypePreset'; cpus: number; label: string; memory: number }>;
  } | null;
  sandboxConfigVersions: Array<{
    __typename?: 'SandboxConfigVersion';
    id: string;
    description: string;
    published_at: string | null;
    status: SandboxConfigVersionStatus;
    version: number;
    resources: {
      __typename?: 'SandboxResources';
      secrets: Array<{ __typename?: 'SecretConfig'; id: string; name: string }>;
      containers: Array<{
        __typename?: 'ContainerConfig';
        id: string;
        name: string;
        image: string;
        entrypoint: string | null;
        cmd: string | null;
        ports: Array<number> | null;
        shell: string;
        memory: number;
        environment: Array<{ __typename?: 'EnvironmentVariable'; key: string; value: string }> | null;
      }>;
      virtualmachines: Array<{
        __typename?: 'VirtualMachineConfig';
        id: string;
        name: string;
        image: string;
        machine_type: string;
        allow_external_ingress: Array<string>;
        shell: string;
        memory: number | null;
        cpus: number | null;
        nested_virtualization: boolean;
        environment: Array<{ __typename?: 'EnvironmentVariable'; key: string; value: string }> | null;
      }>;
      virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig'; id: string; name: string; url: string }>;
      aws_accounts: Array<{
        __typename?: 'AwsAccountConfig';
        id: string;
        name: string;
        iam_policy: string | null;
        managed_policies: Array<string>;
        scp_policy: string | null;
      }>;
      azure_subscriptions: Array<{
        __typename?: 'AzureSubscriptionConfig';
        id: string;
        name: string;
        user_only: boolean;
        roles: Array<string>;
      }>;
      gcp_projects: Array<{
        __typename?: 'GcpProjectConfig';
        id: string;
        name: string;
        services: Array<string>;
        roles: Array<string>;
      }>;
    } | null;
    scripts: Array<{ __typename?: 'SandboxScript'; action: string; contents: string; host: string }> | null;
    config: { __typename?: 'SandboxConfig'; id: string; name: string; slug: string } | null;
    published_by: {
      __typename?: 'User';
      profile: { __typename?: 'UserProfile'; avatar: string | null; display_name: string | null } | null;
    } | null;
  }> | null;
};

export type GetTrackForWizardQueryVariables = Exact<{
  teamSlug: Scalars['String'];
  trackSlug: Scalars['String'];
}>;

export type GetTrackForWizardQuery = {
  __typename?: 'Query';
  track: { __typename?: 'Track'; id: string; permalink: string | null; slug: string; title: string } | null;
};

export type WizardCreateChallengeMutationVariables = Exact<{
  challenge: ChallengeInput;
}>;

export type WizardCreateChallengeMutation = {
  __typename?: 'Mutation';
  createChallenge: { __typename?: 'Challenge'; id: string } | null;
};

export type WizardUpdateChallengeMutationVariables = Exact<{
  challenge: ChallengeInput;
}>;

export type WizardUpdateChallengeMutation = {
  __typename?: 'Mutation';
  updateChallenge: { __typename?: 'Challenge'; id: string } | null;
};

export type WizardUpdateSandboxMutationVariables = Exact<{
  configID: Scalars['String'];
  config: SandboxConfigInput;
}>;

export type WizardUpdateSandboxMutation = {
  __typename?: 'Mutation';
  updateSandboxConfig: { __typename?: 'SandboxConfigVersion'; id: string } | null;
};

export type WizardSetTrackSandboxConfigVersionMutationVariables = Exact<{
  trackID: Scalars['String'];
  configVersionID: InputMaybe<Scalars['String']>;
}>;

export type WizardSetTrackSandboxConfigVersionMutation = {
  __typename?: 'Mutation';
  setTrackSandboxConfigVersion: boolean;
};

export type WizardCreateChallengeNoteMutationVariables = Exact<{
  note: ChallengeNoteInput;
}>;

export type WizardCreateChallengeNoteMutation = {
  __typename?: 'Mutation';
  createChallengeNote: { __typename?: 'ChallengeNote'; id: string } | null;
};

export type WizardUpdateChallengeNoteMutationVariables = Exact<{
  note: ChallengeNoteInput;
}>;

export type WizardUpdateChallengeNoteMutation = {
  __typename?: 'Mutation';
  updateChallengeNote: { __typename?: 'ChallengeNote'; id: string } | null;
};

export type WizardCreateChallengeTabMutationVariables = Exact<{
  tab: ChallengeTabInput;
}>;

export type WizardCreateChallengeTabMutation = {
  __typename?: 'Mutation';
  createChallengeTab: { __typename?: 'ChallengeTab'; id: string } | null;
};

export type WizardUpdateChallengeTabMutationVariables = Exact<{
  tab: ChallengeTabInput;
}>;

export type WizardUpdateChallengeTabMutation = {
  __typename?: 'Mutation';
  updateChallengeTab: { __typename?: 'ChallengeTab'; id: string } | null;
};

export type WizardUpdateTrackMutationVariables = Exact<{
  track: TrackInput;
}>;

export type WizardUpdateTrackMutation = {
  __typename?: 'Mutation';
  updateTrack: { __typename?: 'Track'; id: string; permalink: string | null; slug: string; title: string } | null;
};

export type GetEmbedConfigurationQueryVariables = Exact<{
  trackID: Scalars['String'];
  teamSlug: Scalars['String'];
}>;

export type GetEmbedConfigurationQuery = {
  __typename?: 'Query';
  track: { __typename?: 'Track'; embed_token: string } | null;
  team: {
    __typename?: 'Team';
    lti_credentials: { __typename?: 'LTICredentials'; consumer_name: string; consumer_key: string } | null;
  } | null;
};

export type GetHotStartPoolDetailsConfigQueryVariables = Exact<{
  id: Scalars['String'];
  teamSlug: Scalars['String'];
}>;

export type GetHotStartPoolDetailsConfigQuery = {
  __typename?: 'Query';
  team: {
    __typename?: 'Team';
    features: { __typename?: 'TeamFeatures'; shared_hotstart_pools: boolean; global_sandboxes: boolean } | null;
  } | null;
  hotStartPool: {
    __typename?: 'HotStartPool';
    id: string;
    size: number;
    created: string | null;
    name: string;
    auto_refill: boolean;
    starts_at: string | null;
    ends_at: string | null;
    status: HotStartStatus;
    type: HotStartPoolType;
    region: string | null;
    created_by: {
      __typename?: 'User';
      profile: { __typename?: 'UserProfile'; display_name: string | null } | null;
    } | null;
    tracks: Array<{
      __typename?: 'HotStartPoolTrackEdge';
      claimed: number;
      available: number;
      creating: number;
      node: { __typename?: 'Track'; id: string; title: string };
    }>;
    configs: Array<{
      __typename?: 'HotStartConfigTrackEdge';
      claimed: number;
      available: number;
      creating: number;
      node: { __typename?: 'SandboxConfig'; id: string; name: string };
    }>;
  };
};

export type GetHotStartPageConfigQueryVariables = Exact<{
  teamSlug: Scalars['String'];
}>;

export type GetHotStartPageConfigQuery = {
  __typename?: 'Query';
  team: {
    __typename?: 'Team';
    features: { __typename?: 'TeamFeatures'; shared_hotstart_pools: boolean } | null;
  } | null;
  hotStartPools: {
    __typename?: 'HotStartPoolConnection';
    edges: Array<{
      __typename?: 'HotStartPoolEdge';
      node: {
        __typename?: 'HotStartPool';
        id: string;
        type: HotStartPoolType;
        name: string;
        created: string | null;
        status: HotStartStatus;
        starts_at: string | null;
        ends_at: string | null;
      } | null;
    }>;
  } | null;
};

export type HotStartPageDeleteHotStartPoolMutationVariables = Exact<{
  poolID: Scalars['ID'];
}>;

export type HotStartPageDeleteHotStartPoolMutation = { __typename?: 'Mutation'; deleteHotStartPool: boolean };

export type GetManageCloudAccountPageConfigQueryVariables = Exact<{
  teamSlug: Scalars['String'];
  trackID: Scalars['String'];
}>;

export type GetManageCloudAccountPageConfigQuery = {
  __typename?: 'Query';
  userIsTrackDeveloper: boolean;
  team: {
    __typename?: 'Team';
    id: string;
    features: {
      __typename?: 'TeamFeatures';
      aws_accounts: boolean;
      azure_subscriptions: boolean;
      gcp_projects: boolean;
    } | null;
  } | null;
  trackConfig: {
    __typename?: 'TrackConfig';
    id: string;
    secrets: Array<{ __typename?: 'SecretConfig'; id: string; name: string }>;
    containers: Array<{
      __typename?: 'ContainerConfig';
      id: string;
      name: string;
      image: string;
      entrypoint: string | null;
      cmd: string | null;
      ports: Array<number> | null;
      shell: string;
      memory: number;
      environment: Array<{ __typename?: 'EnvironmentVariable'; key: string; value: string }> | null;
    }>;
    virtualmachines: Array<{
      __typename?: 'VirtualMachineConfig';
      id: string;
      name: string;
      image: string;
      machine_type: string;
      allow_external_ingress: Array<string>;
      shell: string;
      memory: number | null;
      cpus: number | null;
      nested_virtualization: boolean;
      environment: Array<{ __typename?: 'EnvironmentVariable'; key: string; value: string }> | null;
    }>;
    virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig'; id: string; name: string; url: string }>;
    aws_accounts: Array<{
      __typename?: 'AwsAccountConfig';
      id: string;
      name: string;
      iam_policy: string | null;
      managed_policies: Array<string>;
      scp_policy: string | null;
    }>;
    azure_subscriptions: Array<{
      __typename?: 'AzureSubscriptionConfig';
      id: string;
      name: string;
      user_only: boolean;
      roles: Array<string>;
    }>;
    gcp_projects: Array<{
      __typename?: 'GcpProjectConfig';
      id: string;
      name: string;
      services: Array<string>;
      roles: Array<string>;
    }>;
  } | null;
  trackScripts: Array<{
    __typename?: 'TrackScript';
    id: string;
    host: string;
    action: string;
    contents: string;
  }> | null;
};

export type UpdateCloudAccountsMutationVariables = Exact<{
  configID: Scalars['String'];
  config: SandboxConfigInput;
}>;

export type UpdateCloudAccountsMutation = {
  __typename?: 'Mutation';
  updateSandboxConfig: { __typename?: 'SandboxConfigVersion'; id: string } | null;
};

export type GetManageHostPageConfigQueryVariables = Exact<{
  teamSlug: Scalars['String'];
  trackID: Scalars['String'];
}>;

export type GetManageHostPageConfigQuery = {
  __typename?: 'Query';
  userIsTrackDeveloper: boolean;
  team: {
    __typename?: 'Team';
    id: string;
    features: {
      __typename?: 'TeamFeatures';
      containers: boolean;
      virtual_machines: boolean;
      saas: boolean;
      custom_machine_type: boolean;
    } | null;
  } | null;
  trackConfigPresets: {
    __typename?: 'TrackConfigPresets';
    containers: Array<{ __typename?: 'ContainerConfigPreset'; label: string; image: string; memory: number }>;
    googlecloudmachinetypes: Array<{
      __typename?: 'GoogleCloudMachineTypePreset';
      label: string;
      machine_type: string;
    }>;
    virtualmachines: Array<{
      __typename?: 'VirtualMachineConfigPreset';
      image: string;
      label: string;
      machine_type: string;
      cpus: number;
      memory: number;
    }>;
    machinetypes: Array<{ __typename?: 'MachineTypePreset'; cpus: number; label: string; memory: number }>;
  } | null;
  trackConfig: {
    __typename?: 'TrackConfig';
    id: string;
    secrets: Array<{ __typename?: 'SecretConfig'; id: string; name: string }>;
    containers: Array<{
      __typename?: 'ContainerConfig';
      id: string;
      name: string;
      image: string;
      entrypoint: string | null;
      cmd: string | null;
      ports: Array<number> | null;
      shell: string;
      memory: number;
      environment: Array<{ __typename?: 'EnvironmentVariable'; key: string; value: string }> | null;
    }>;
    virtualmachines: Array<{
      __typename?: 'VirtualMachineConfig';
      id: string;
      name: string;
      image: string;
      machine_type: string;
      allow_external_ingress: Array<string>;
      shell: string;
      memory: number | null;
      cpus: number | null;
      nested_virtualization: boolean;
      environment: Array<{ __typename?: 'EnvironmentVariable'; key: string; value: string }> | null;
    }>;
    virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig'; id: string; name: string; url: string }>;
    aws_accounts: Array<{
      __typename?: 'AwsAccountConfig';
      id: string;
      name: string;
      iam_policy: string | null;
      managed_policies: Array<string>;
      scp_policy: string | null;
    }>;
    azure_subscriptions: Array<{
      __typename?: 'AzureSubscriptionConfig';
      id: string;
      name: string;
      user_only: boolean;
      roles: Array<string>;
    }>;
    gcp_projects: Array<{
      __typename?: 'GcpProjectConfig';
      id: string;
      name: string;
      services: Array<string>;
      roles: Array<string>;
    }>;
  } | null;
  trackScripts: Array<{
    __typename?: 'TrackScript';
    id: string;
    host: string;
    action: string;
    contents: string;
  }> | null;
};

export type UpdateHostsMutationVariables = Exact<{
  configID: Scalars['String'];
  config: SandboxConfigInput;
}>;

export type UpdateHostsMutation = {
  __typename?: 'Mutation';
  updateSandboxConfig: { __typename?: 'SandboxConfigVersion'; id: string } | null;
};

export type ManageHostPageRenameHostMutationVariables = Exact<{
  configID: Scalars['String'];
  hostName: Scalars['String'];
  newName: Scalars['String'];
}>;

export type ManageHostPageRenameHostMutation = {
  __typename?: 'Mutation';
  renameSandboxConfigHost: { __typename?: 'SandboxConfigVersion'; id: string } | null;
};

export type GetManageHotStartPageConfigQueryVariables = Exact<{
  teamSlug: Scalars['String'];
  filter: SandboxConfigVersionsFilterInput;
}>;

export type GetManageHotStartPageConfigQuery = {
  __typename?: 'Query';
  team: {
    __typename?: 'Team';
    features: {
      __typename?: 'TeamFeatures';
      max_hot_start_pool_size_always_on: number;
      max_hot_start_pool_size_scheduled: number;
      shared_hotstart_pools: boolean;
      global_sandboxes: boolean;
    } | null;
  } | null;
  tracks: Array<{
    __typename?: 'Track';
    id: string;
    title: string;
    permalink: string | null;
    maintenance: boolean;
  }> | null;
  sandboxConfigVersions: Array<{
    __typename?: 'SandboxConfigVersion';
    id: string;
    version: number;
    published_at: string | null;
    config: { __typename?: 'SandboxConfig'; id: string; name: string; slug: string } | null;
  }> | null;
};

export type CreateHotStartPoolMutationVariables = Exact<{
  input: HotStartPoolInput;
}>;

export type CreateHotStartPoolMutation = {
  __typename?: 'Mutation';
  createHotStartPool: { __typename?: 'HotStartPool'; id: string } | null;
};

export type UpdateHotStartPoolMutationVariables = Exact<{
  poolID: Scalars['ID'];
  input: HotStartPoolInput;
}>;

export type UpdateHotStartPoolMutation = {
  __typename?: 'Mutation';
  updateHotStartPool: { __typename?: 'HotStartPool'; id: string } | null;
};

export type GetHotStartPoolToDuplicateQueryVariables = Exact<{
  poolID: Scalars['String'];
  teamSlug: Scalars['String'];
}>;

export type GetHotStartPoolToDuplicateQuery = {
  __typename?: 'Query';
  hotStartPool: {
    __typename?: 'HotStartPool';
    id: string;
    type: HotStartPoolType;
    size: number;
    name: string;
    starts_at: string | null;
    ends_at: string | null;
    status: HotStartStatus;
    region: string | null;
    tracks: Array<{ __typename?: 'HotStartPoolTrackEdge'; node: { __typename?: 'Track'; id: string } }>;
    configs: Array<{ __typename?: 'HotStartConfigTrackEdge'; node: { __typename?: 'SandboxConfig'; id: string } }>;
  };
};

export type GetHotStartInviteQueryVariables = Exact<{
  inviteID: Scalars['String'];
}>;

export type GetHotStartInviteQuery = {
  __typename?: 'Query';
  trackInvite: {
    __typename?: 'TrackInvite';
    expiresAt: string | null;
    publicTitle: string | null;
    status: TrackInviteStatus | null;
    startsAt: string | null;
    tracks: Array<{ __typename?: 'Track'; id: string }>;
  } | null;
};

export type GetHotStartPoolExistingPoolQueryVariables = Exact<{
  teamSlug: Scalars['String'];
  poolID: Scalars['String'];
}>;

export type GetHotStartPoolExistingPoolQuery = {
  __typename?: 'Query';
  hotStartPool: {
    __typename?: 'HotStartPool';
    id: string;
    type: HotStartPoolType;
    size: number;
    name: string;
    starts_at: string | null;
    ends_at: string | null;
    status: HotStartStatus;
    region: string | null;
    tracks: Array<{ __typename?: 'HotStartPoolTrackEdge'; node: { __typename?: 'Track'; id: string } }>;
    configs: Array<{ __typename?: 'HotStartConfigTrackEdge'; node: { __typename?: 'SandboxConfig'; id: string } }>;
  };
};

export type HotStartPoolExistingPoolFragment = {
  __typename?: 'HotStartPool';
  id: string;
  type: HotStartPoolType;
  size: number;
  name: string;
  starts_at: string | null;
  ends_at: string | null;
  status: HotStartStatus;
  region: string | null;
  tracks: Array<{ __typename?: 'HotStartPoolTrackEdge'; node: { __typename?: 'Track'; id: string } }>;
  configs: Array<{ __typename?: 'HotStartConfigTrackEdge'; node: { __typename?: 'SandboxConfig'; id: string } }>;
};

export type HotStartInviteFragment = {
  __typename?: 'TrackInvite';
  expiresAt: string | null;
  publicTitle: string | null;
  status: TrackInviteStatus | null;
  startsAt: string | null;
  tracks: Array<{ __typename?: 'Track'; id: string }>;
};

export type GetManageSandboxPresetConfigQueryVariables = Exact<{
  teamSlug: Scalars['String'];
}>;

export type GetManageSandboxPresetConfigQuery = {
  __typename?: 'Query';
  userInTeam: boolean;
  team: {
    __typename?: 'Team';
    id: string;
    features: {
      __typename?: 'TeamFeatures';
      containers: boolean;
      virtual_machines: boolean;
      saas: boolean;
      custom_machine_type: boolean;
      aws_accounts: boolean;
      azure_subscriptions: boolean;
      gcp_projects: boolean;
      shared_hotstart_pools: boolean;
    } | null;
  } | null;
  trackConfigPresets: {
    __typename?: 'TrackConfigPresets';
    containers: Array<{ __typename?: 'ContainerConfigPreset'; label: string; image: string; memory: number }>;
    googlecloudmachinetypes: Array<{
      __typename?: 'GoogleCloudMachineTypePreset';
      label: string;
      machine_type: string;
    }>;
    virtualmachines: Array<{
      __typename?: 'VirtualMachineConfigPreset';
      image: string;
      label: string;
      machine_type: string;
      cpus: number;
      memory: number;
    }>;
    machinetypes: Array<{ __typename?: 'MachineTypePreset'; cpus: number; label: string; memory: number }>;
  } | null;
  teamSecrets: Array<{ __typename?: 'Secret'; name: string; description: string }> | null;
};

export type ManageSandboxPresetCreatePresetMutationVariables = Exact<{
  teamID: Scalars['String'];
  teamSlug: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
  config: SandboxConfigInput;
}>;

export type ManageSandboxPresetCreatePresetMutation = {
  __typename?: 'Mutation';
  createSandboxConfig: {
    __typename?: 'SandboxConfigVersion';
    id: string;
    config: { __typename?: 'SandboxConfig'; id: string } | null;
  } | null;
};

export type ManageSandboxPresetUpdatePresetMutationVariables = Exact<{
  configID: Scalars['String'];
  config: SandboxConfigInput;
}>;

export type ManageSandboxPresetUpdatePresetMutation = {
  __typename?: 'Mutation';
  updateSandboxConfig: {
    __typename?: 'SandboxConfigVersion';
    id: string;
    config: { __typename?: 'SandboxConfig'; id: string } | null;
  } | null;
};

export type ManageSandboxPresetPublishConfigMutationVariables = Exact<{
  configID: Scalars['String'];
  changeLogEntry: Scalars['String'];
}>;

export type ManageSandboxPresetPublishConfigMutation = {
  __typename?: 'Mutation';
  publishSandboxConfig: { __typename?: 'SandboxConfigVersion'; id: string } | null;
};

export type ManageSandboxPresetRenameSandboxMutationVariables = Exact<{
  configID: Scalars['String'];
  name: Scalars['String'];
}>;

export type ManageSandboxPresetRenameSandboxMutation = {
  __typename?: 'Mutation';
  renameSandboxConfig: { __typename?: 'SandboxConfig'; id: string } | null;
};

export type GetManageSandboxPresetVersionQueryVariables = Exact<{
  teamSlug: Scalars['String'];
  filter: SandboxConfigVersionsFilterInput;
}>;

export type GetManageSandboxPresetVersionQuery = {
  __typename?: 'Query';
  sandboxConfigVersions: Array<{
    __typename?: 'SandboxConfigVersion';
    id: string;
    description: string;
    status: SandboxConfigVersionStatus;
    config: { __typename?: 'SandboxConfig'; id: string; name: string; slug: string } | null;
    resources: {
      __typename?: 'SandboxResources';
      secrets: Array<{ __typename?: 'SecretConfig'; id: string; name: string }>;
      containers: Array<{
        __typename?: 'ContainerConfig';
        id: string;
        name: string;
        image: string;
        entrypoint: string | null;
        cmd: string | null;
        ports: Array<number> | null;
        shell: string;
        memory: number;
        environment: Array<{ __typename?: 'EnvironmentVariable'; key: string; value: string }> | null;
      }>;
      virtualmachines: Array<{
        __typename?: 'VirtualMachineConfig';
        id: string;
        name: string;
        image: string;
        machine_type: string;
        allow_external_ingress: Array<string>;
        shell: string;
        memory: number | null;
        cpus: number | null;
        nested_virtualization: boolean;
        environment: Array<{ __typename?: 'EnvironmentVariable'; key: string; value: string }> | null;
      }>;
      virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig'; id: string; name: string; url: string }>;
      aws_accounts: Array<{
        __typename?: 'AwsAccountConfig';
        id: string;
        name: string;
        iam_policy: string | null;
        managed_policies: Array<string>;
        scp_policy: string | null;
      }>;
      azure_subscriptions: Array<{
        __typename?: 'AzureSubscriptionConfig';
        id: string;
        name: string;
        user_only: boolean;
        roles: Array<string>;
      }>;
      gcp_projects: Array<{
        __typename?: 'GcpProjectConfig';
        id: string;
        name: string;
        services: Array<string>;
        roles: Array<string>;
      }>;
    } | null;
    scripts: Array<{ __typename?: 'SandboxScript'; host: string; action: string; contents: string }> | null;
  }> | null;
};

export type GetManageSandboxPresetTrackQueryVariables = Exact<{
  trackID: Scalars['String'];
}>;

export type GetManageSandboxPresetTrackQuery = {
  __typename?: 'Query';
  trackConfig: {
    __typename?: 'TrackConfig';
    secrets: Array<{ __typename?: 'SecretConfig'; id: string; name: string }>;
    containers: Array<{
      __typename?: 'ContainerConfig';
      id: string;
      name: string;
      image: string;
      entrypoint: string | null;
      cmd: string | null;
      ports: Array<number> | null;
      shell: string;
      memory: number;
      environment: Array<{ __typename?: 'EnvironmentVariable'; key: string; value: string }> | null;
    }>;
    virtualmachines: Array<{
      __typename?: 'VirtualMachineConfig';
      id: string;
      name: string;
      image: string;
      machine_type: string;
      allow_external_ingress: Array<string>;
      shell: string;
      memory: number | null;
      cpus: number | null;
      nested_virtualization: boolean;
      environment: Array<{ __typename?: 'EnvironmentVariable'; key: string; value: string }> | null;
    }>;
    virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig'; id: string; name: string; url: string }>;
    aws_accounts: Array<{
      __typename?: 'AwsAccountConfig';
      id: string;
      name: string;
      iam_policy: string | null;
      managed_policies: Array<string>;
      scp_policy: string | null;
    }>;
    azure_subscriptions: Array<{
      __typename?: 'AzureSubscriptionConfig';
      id: string;
      name: string;
      user_only: boolean;
      roles: Array<string>;
    }>;
    gcp_projects: Array<{
      __typename?: 'GcpProjectConfig';
      id: string;
      name: string;
      services: Array<string>;
      roles: Array<string>;
    }>;
  } | null;
  trackScripts: Array<{ __typename?: 'TrackScript'; host: string; action: string; contents: string }> | null;
};

export type PlayActivityReportPageQueryVariables = Exact<{
  playReportInput: PlayReportInput;
  teamSlug: Scalars['String'];
}>;

export type PlayActivityReportPageQuery = {
  __typename?: 'Query';
  playReports: {
    __typename?: 'PlayReportPage';
    totalItems: number;
    items: Array<{
      __typename?: 'PlayReportItem';
      id: string;
      completionPercent: number;
      timeSpent: number;
      startedAt: string;
      mode: Mode | null;
      track: { __typename?: 'Track'; id: string; slug: string; title: string };
      user: {
        __typename?: 'User';
        id: string;
        details: {
          __typename?: 'UserDetails';
          id: string;
          firstName: string | null;
          lastName: string | null;
          email: string | null;
          companyName: string | null;
        } | null;
        profile: { __typename?: 'UserProfile'; display_name: string | null; email: string | null } | null;
      };
      customParameters: Array<{ __typename?: 'CustomParameter'; key: string; value: string }>;
      trackInvite: { __typename?: 'TrackInvite'; id: string; publicTitle: string | null } | null;
      activity: Array<{
        __typename?: 'PlayActivity';
        message: string;
        time: string;
        challenge: { __typename?: 'Challenge'; slug: string } | null;
      }>;
      playReview: { __typename?: 'TrackReview'; id: string; score: number; content: string } | null;
    }>;
  };
};

export type PlayActivityReportPageTracksQueryVariables = Exact<{
  teamSlug: Scalars['String'];
}>;

export type PlayActivityReportPageTracksQuery = {
  __typename?: 'Query';
  tracks: Array<{ __typename?: 'Track'; id: string; title: string; slug: string; maintenance: boolean }> | null;
};

export type GetPreviewSandboxPresetPageConfigQueryVariables = Exact<{
  teamSlug: Scalars['String'];
  filter: SandboxConfigVersionsFilterInput;
}>;

export type GetPreviewSandboxPresetPageConfigQuery = {
  __typename?: 'Query';
  userInTeam: boolean;
  team: {
    __typename?: 'Team';
    id: string;
    features: {
      __typename?: 'TeamFeatures';
      containers: boolean;
      virtual_machines: boolean;
      saas: boolean;
      custom_machine_type: boolean;
      aws_accounts: boolean;
      azure_subscriptions: boolean;
      gcp_projects: boolean;
      shared_hotstart_pools: boolean;
    } | null;
  } | null;
  sandboxConfigVersions: Array<{
    __typename?: 'SandboxConfigVersion';
    change_log_entry: string;
    id: string;
    description: string;
    published_at: string | null;
    status: SandboxConfigVersionStatus;
    version: number;
    resources: {
      __typename?: 'SandboxResources';
      secrets: Array<{ __typename?: 'SecretConfig'; name: string }>;
      containers: Array<{
        __typename?: 'ContainerConfig';
        id: string;
        name: string;
        image: string;
        entrypoint: string | null;
        cmd: string | null;
        ports: Array<number> | null;
        shell: string;
        memory: number;
        environment: Array<{ __typename?: 'EnvironmentVariable'; key: string; value: string }> | null;
      }>;
      virtualmachines: Array<{
        __typename?: 'VirtualMachineConfig';
        id: string;
        name: string;
        image: string;
        machine_type: string;
        allow_external_ingress: Array<string>;
        shell: string;
        memory: number | null;
        cpus: number | null;
        nested_virtualization: boolean;
        environment: Array<{ __typename?: 'EnvironmentVariable'; key: string; value: string }> | null;
      }>;
      virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig'; id: string; name: string; url: string }>;
      aws_accounts: Array<{
        __typename?: 'AwsAccountConfig';
        id: string;
        name: string;
        iam_policy: string | null;
        managed_policies: Array<string>;
        scp_policy: string | null;
      }>;
      azure_subscriptions: Array<{
        __typename?: 'AzureSubscriptionConfig';
        id: string;
        name: string;
        user_only: boolean;
        roles: Array<string>;
      }>;
      gcp_projects: Array<{
        __typename?: 'GcpProjectConfig';
        id: string;
        name: string;
        services: Array<string>;
        roles: Array<string>;
      }>;
    } | null;
    scripts: Array<{ __typename?: 'SandboxScript'; action: string; contents: string; host: string }> | null;
    tracks: Array<{ __typename?: 'Track'; id: string; title: string } | null>;
    hot_start_pools: Array<{ __typename?: 'HotStartPool'; id: string; name: string } | null>;
    config: { __typename?: 'SandboxConfig'; id: string; name: string; slug: string } | null;
    published_by: {
      __typename?: 'User';
      profile: { __typename?: 'UserProfile'; avatar: string | null; display_name: string | null } | null;
    } | null;
  }> | null;
};

export type PreviewSandboxPresetDeleteSandboxConfigMutationVariables = Exact<{
  configVersionID: Scalars['String'];
}>;

export type PreviewSandboxPresetDeleteSandboxConfigMutation = { __typename?: 'Mutation'; deleteSandboxConfig: boolean };

export type GetSandboxConfigQueryVariables = Exact<{
  trackID: Scalars['String'];
  teamSlug: Scalars['String'];
  filter: SandboxConfigVersionsFilterInput;
}>;

export type GetSandboxConfigQuery = {
  __typename?: 'Query';
  userIsTrackDeveloper: boolean;
  userInTeam: boolean;
  team: {
    __typename?: 'Team';
    id: string;
    features: {
      __typename?: 'TeamFeatures';
      containers: boolean;
      virtual_machines: boolean;
      gcp_projects: boolean;
      aws_accounts: boolean;
      azure_subscriptions: boolean;
      saas: boolean;
      shared_hotstart_pools: boolean;
    } | null;
  } | null;
  track: {
    __typename?: 'Track';
    sandboxConfig: {
      __typename?: 'SandboxConfigVersion';
      id: string;
      description: string;
      published_at: string | null;
      status: SandboxConfigVersionStatus;
      version: number;
      config: { __typename?: 'SandboxConfig'; id: string; name: string; slug: string } | null;
      published_by: {
        __typename?: 'User';
        profile: { __typename?: 'UserProfile'; avatar: string | null; display_name: string | null } | null;
      } | null;
    } | null;
  } | null;
  trackConfig: {
    __typename?: 'TrackConfig';
    id: string;
    containers: Array<{
      __typename?: 'ContainerConfig';
      id: string;
      name: string;
      image: string;
      entrypoint: string | null;
      cmd: string | null;
      ports: Array<number> | null;
      shell: string;
      memory: number;
      environment: Array<{ __typename?: 'EnvironmentVariable'; key: string; value: string }> | null;
    }>;
    virtualmachines: Array<{
      __typename?: 'VirtualMachineConfig';
      id: string;
      name: string;
      image: string;
      machine_type: string;
      allow_external_ingress: Array<string>;
      shell: string;
      memory: number | null;
      cpus: number | null;
      nested_virtualization: boolean;
      environment: Array<{ __typename?: 'EnvironmentVariable'; key: string; value: string }> | null;
    }>;
    virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig'; id: string; name: string; url: string }>;
    gcp_projects: Array<{
      __typename?: 'GcpProjectConfig';
      id: string;
      name: string;
      services: Array<string>;
      roles: Array<string>;
    }>;
    aws_accounts: Array<{
      __typename?: 'AwsAccountConfig';
      id: string;
      name: string;
      iam_policy: string | null;
      managed_policies: Array<string>;
      scp_policy: string | null;
    }>;
    azure_subscriptions: Array<{
      __typename?: 'AzureSubscriptionConfig';
      id: string;
      name: string;
      user_only: boolean;
      roles: Array<string>;
    }>;
    secrets: Array<{ __typename?: 'SecretConfig'; id: string; name: string }>;
  } | null;
  teamSecrets: Array<{ __typename?: 'Secret'; name: string; description: string }> | null;
  sandboxConfigVersions: Array<{
    __typename?: 'SandboxConfigVersion';
    id: string;
    description: string;
    published_at: string | null;
    status: SandboxConfigVersionStatus;
    version: number;
    config: { __typename?: 'SandboxConfig'; id: string; name: string; slug: string } | null;
    published_by: {
      __typename?: 'User';
      profile: { __typename?: 'UserProfile'; avatar: string | null; display_name: string | null } | null;
    } | null;
  }> | null;
  trackScripts: Array<{
    __typename?: 'TrackScript';
    id: string;
    host: string;
    action: string;
    contents: string;
  }> | null;
};

export type GetSandboxPagePresetResourcesQueryVariables = Exact<{
  configVersionID: Scalars['String'];
}>;

export type GetSandboxPagePresetResourcesQuery = {
  __typename?: 'Query';
  sandboxConfigVersion: {
    __typename?: 'SandboxConfigVersion';
    resources: {
      __typename?: 'SandboxResources';
      secrets: Array<{ __typename?: 'SecretConfig'; id: string; name: string }>;
      containers: Array<{
        __typename?: 'ContainerConfig';
        id: string;
        name: string;
        image: string;
        entrypoint: string | null;
        cmd: string | null;
        ports: Array<number> | null;
        shell: string;
        memory: number;
        environment: Array<{ __typename?: 'EnvironmentVariable'; key: string; value: string }> | null;
      }>;
      virtualmachines: Array<{
        __typename?: 'VirtualMachineConfig';
        id: string;
        name: string;
        image: string;
        machine_type: string;
        allow_external_ingress: Array<string>;
        shell: string;
        memory: number | null;
        cpus: number | null;
        nested_virtualization: boolean;
        environment: Array<{ __typename?: 'EnvironmentVariable'; key: string; value: string }> | null;
      }>;
      virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig'; id: string; name: string; url: string }>;
      aws_accounts: Array<{
        __typename?: 'AwsAccountConfig';
        id: string;
        name: string;
        iam_policy: string | null;
        managed_policies: Array<string>;
        scp_policy: string | null;
      }>;
      azure_subscriptions: Array<{
        __typename?: 'AzureSubscriptionConfig';
        id: string;
        name: string;
        user_only: boolean;
        roles: Array<string>;
      }>;
      gcp_projects: Array<{
        __typename?: 'GcpProjectConfig';
        id: string;
        name: string;
        services: Array<string>;
        roles: Array<string>;
      }>;
    } | null;
    scripts: Array<{ __typename?: 'SandboxScript'; action: string; contents: string; host: string }> | null;
  } | null;
};

export type SandboxConfigPageDeleteHostMutationVariables = Exact<{
  configID: Scalars['String'];
  hostName: Scalars['String'];
}>;

export type SandboxConfigPageDeleteHostMutation = {
  __typename?: 'Mutation';
  deleteSandboxConfigHost: { __typename?: 'SandboxConfigVersion'; id: string } | null;
};

export type SandboxConfigPageRenameHostMutationVariables = Exact<{
  configID: Scalars['String'];
  hostName: Scalars['String'];
  newName: Scalars['String'];
}>;

export type SandboxConfigPageRenameHostMutation = {
  __typename?: 'Mutation';
  renameSandboxConfigHost: { __typename?: 'SandboxConfigVersion'; id: string } | null;
};

export type SandboxConfigPageSetPresetMutationVariables = Exact<{
  trackID: Scalars['String'];
  configVersionID: InputMaybe<Scalars['String']>;
}>;

export type SandboxConfigPageSetPresetMutation = { __typename?: 'Mutation'; setTrackSandboxConfigVersion: boolean };

export type SandboxConfigPageUpdateSandboxConfigMutationVariables = Exact<{
  configID: Scalars['String'];
  config: SandboxConfigInput;
}>;

export type SandboxConfigPageUpdateSandboxConfigMutation = {
  __typename?: 'Mutation';
  updateSandboxConfig: { __typename?: 'SandboxConfigVersion'; id: string } | null;
};

export type SandboxConfigPageSaveTrackScriptMutationVariables = Exact<{
  script: TrackScriptInput;
  base64Encoded: Scalars['Boolean'];
}>;

export type SandboxConfigPageSaveTrackScriptMutation = {
  __typename?: 'Mutation';
  saveTrackScript: { __typename?: 'TrackScript'; id: string; host: string; action: string; contents: string } | null;
};

export type SandboxConfigSecretFragment = { __typename?: 'SecretConfig'; id: string; name: string };

export type TrackScriptDataFragment = {
  __typename?: 'TrackScript';
  id: string;
  host: string;
  action: string;
  contents: string;
};

export type GetSandboxPresetsListPageConfigQueryVariables = Exact<{
  teamSlug: Scalars['String'];
  filter: SandboxConfigVersionsFilterInput;
}>;

export type GetSandboxPresetsListPageConfigQuery = {
  __typename?: 'Query';
  team: {
    __typename?: 'Team';
    id: string;
    features: { __typename?: 'TeamFeatures'; shared_hotstart_pools: boolean } | null;
  } | null;
  sandboxConfigVersions: Array<{
    __typename?: 'SandboxConfigVersion';
    id: string;
    description: string;
    published_at: string | null;
    status: SandboxConfigVersionStatus;
    version: number;
    config: { __typename?: 'SandboxConfig'; id: string; name: string; slug: string } | null;
    published_by: {
      __typename?: 'User';
      profile: { __typename?: 'UserProfile'; avatar: string | null; display_name: string | null } | null;
    } | null;
  }> | null;
};

export type SandboxPresetsListPagePublishConfigMutationVariables = Exact<{
  configID: Scalars['String'];
  changeLogEntry: Scalars['String'];
}>;

export type SandboxPresetsListPagePublishConfigMutation = {
  __typename?: 'Mutation';
  publishSandboxConfig: { __typename?: 'SandboxConfigVersion'; id: string } | null;
};

export type SandboxPresetsListDeleteSandboxConfigMutationVariables = Exact<{
  configVersionID: Scalars['String'];
}>;

export type SandboxPresetsListDeleteSandboxConfigMutation = { __typename?: 'Mutation'; deleteSandboxConfig: boolean };

export type SandboxesFormDataQueryVariables = Exact<{
  teamSlug: Scalars['String'];
}>;

export type SandboxesFormDataQuery = {
  __typename?: 'Query';
  tracks: Array<{ __typename?: 'Track'; id: string; title: string }> | null;
  trackInvites: Array<{ __typename?: 'TrackInvite'; id: string; title: string; publicTitle: string | null }> | null;
  hotStartPools: {
    __typename?: 'HotStartPoolConnection';
    edges: Array<{
      __typename?: 'HotStartPoolEdge';
      node: { __typename?: 'HotStartPool'; id: string; name: string } | null;
    }>;
  } | null;
};

export type SandboxesQueryVariables = Exact<{
  teamSlug: Scalars['String'];
  filter: SandboxFilterInput;
  paging: Pagination;
  ordering: Ordering;
}>;

export type SandboxesQuery = {
  __typename?: 'Query';
  sandboxes: {
    __typename?: 'SandboxConnection';
    totalCount: number;
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor: string | null;
      endCursor: string | null;
    };
    edges: Array<{
      __typename?: 'SandboxEdge';
      node: {
        __typename?: 'Sandbox';
        created: string | null;
        ttl: string | null;
        state: SandboxState;
        id: string;
        hot_start_pool: { __typename?: 'HotStartPool'; id: string; name: string } | null;
        invite: { __typename?: 'TrackInvite'; id: string; title: string; publicTitle: string | null } | null;
        track: { __typename?: 'Track'; id: string; slug: string; title: string } | null;
        user: {
          __typename?: 'User';
          id: string;
          profile: { __typename?: 'UserProfile'; display_name: string | null } | null;
        } | null;
      } | null;
    }>;
  } | null;
};

export type UpdateSandboxTtlMutationVariables = Exact<{
  sandboxID: Scalars['String'];
  until: Scalars['Time'];
}>;

export type UpdateSandboxTtlMutation = {
  __typename?: 'Mutation';
  updateSandboxTTL: { __typename?: 'Sandbox'; id: string } | null;
};

export type StopSandboxMutationVariables = Exact<{
  sandboxID: Scalars['String'];
}>;

export type StopSandboxMutation = {
  __typename?: 'Mutation';
  stopSandbox: { __typename?: 'Sandbox'; id: string } | null;
};

export type TeamPageQueryVariables = Exact<{
  teamSlug: Scalars['String'];
}>;

export type TeamPageQuery = {
  __typename?: 'Query';
  organization: {
    __typename?: 'Organization';
    id: string;
    name: string;
    logo: string | null;
    title: string | null;
    subtitle: string | null;
    slug: string;
    primary_link_text: string | null;
    primary_link_url: string | null;
    secondary_link_text: string | null;
    secondary_link_url: string | null;
    theme: {
      __typename?: 'OrganizationTheme';
      foreground_color: string | null;
      foreground_image: string | null;
      background_color: string | null;
      background_image: string | null;
      primary_foreground_color: string | null;
      primary_background_color: string | null;
      secondary_foreground_color: string | null;
      secondary_background_color: string | null;
    } | null;
  } | null;
  tracks: Array<{
    __typename?: 'Track';
    icon: string;
    id: string;
    last_update: string;
    createdAt: string;
    permalink: string | null;
    slug: string;
    teaser: string;
    tags: Array<string>;
    title: string;
    description: string;
    maintenance: boolean;
    developers: Array<{
      __typename?: 'User';
      id: string;
      profile: { __typename?: 'UserProfile'; avatar: string | null; display_name: string | null } | null;
    }>;
    updated_by: {
      __typename?: 'User';
      id: string;
      profile: { __typename?: 'UserProfile'; avatar: string | null; display_name: string | null } | null;
    } | null;
  }> | null;
};

export type DeleteTrackMutationVariables = Exact<{
  trackID: Scalars['String'];
}>;

export type DeleteTrackMutation = { __typename?: 'Mutation'; deleteTrack: boolean };

export type GetTemplateTracksQueryVariables = Exact<{
  teamSlug: Scalars['String'];
}>;

export type GetTemplateTracksQuery = {
  __typename?: 'Query';
  tracks: Array<{
    __typename?: 'Track';
    id: string;
    version: string;
    slug: string;
    icon: string;
    title: string;
    teaser: string;
    description: string;
    level: Level | null;
    tags: Array<string>;
    owner: string | null;
    idle_timeout: number | null;
    timelimit: number | null;
    status: TrackStatus | null;
    private: boolean;
    published: boolean;
    maintenance: boolean;
    show_timer: boolean;
    skipping_enabled: boolean;
    developers: Array<{ __typename?: 'User'; profile: { __typename?: 'UserProfile'; email: string | null } | null }>;
    challenges: Array<{
      __typename?: 'Challenge';
      id: string;
      type: ChallengeType;
      slug: string;
      title: string;
      teaser: string;
      difficulty: string;
      assignment: string;
      timelimit: number | null;
      answers: Array<string>;
      solution: Array<number>;
      notes: Array<{
        __typename?: 'ChallengeNote';
        type: ChallengeNoteType;
        contents: string | null;
        url: string | null;
      }>;
      tabs: Array<{
        __typename?: 'ChallengeTab';
        cmd: string | null;
        type: ChallengeTabType;
        title: string;
        hostname: string | null;
        path: string | null;
        port: number | null;
        url: string | null;
        new_window: boolean;
      }>;
      scripts: Array<{ __typename?: 'ChallengeScript'; host: string; action: string; contents: string }>;
    }>;
    config: {
      __typename?: 'TrackConfig';
      version: string | null;
      containers: Array<{
        __typename?: 'ContainerConfig';
        name: string;
        image: string;
        entrypoint: string | null;
        cmd: string | null;
        shell: string;
        ports: Array<number> | null;
        memory: number;
        environment: Array<{ __typename?: 'EnvironmentVariable'; key: string; value: string }> | null;
      }>;
      virtualmachines: Array<{
        __typename?: 'VirtualMachineConfig';
        name: string;
        image: string;
        machine_type: string;
        allow_external_ingress: Array<string>;
        shell: string;
        memory: number | null;
        cpus: number | null;
        environment: Array<{ __typename?: 'EnvironmentVariable'; key: string; value: string }> | null;
      }>;
      gcp_projects: Array<{ __typename?: 'GcpProjectConfig'; name: string; services: Array<string> }>;
      aws_accounts: Array<{
        __typename?: 'AwsAccountConfig';
        name: string;
        iam_policy: string | null;
        managed_policies: Array<string>;
        scp_policy: string | null;
      }>;
      azure_subscriptions: Array<{
        __typename?: 'AzureSubscriptionConfig';
        name: string;
        user_only: boolean;
        roles: Array<string>;
      }>;
    };
    scripts: Array<{ __typename?: 'TrackScript'; id: string; action: string; contents: string; host: string }>;
  }> | null;
};

export type TrackDashboardQueryVariables = Exact<{
  trackSlug: Scalars['String'];
  teamSlug: Scalars['String'];
}>;

export type TrackDashboardQuery = {
  __typename?: 'Query';
  statistics: {
    __typename?: 'Statistics';
    track: {
      __typename?: 'TrackStatistics';
      started_total: number | null;
      completed_total: number | null;
      happiness: Array<{ __typename?: 'HappinessCount'; score: number; count: number }>;
    } | null;
  } | null;
  track: {
    __typename?: 'Track';
    id: string;
    permalink: string | null;
    slug: string;
    owner: string | null;
    icon: string;
    title: string;
    timelimit: number | null;
    description: string;
    tags: Array<string>;
    idle_timeout: number | null;
    completed: string;
    maintenance: boolean;
    show_timer: boolean;
    skipping_enabled: boolean;
    can_skip: boolean;
    createdAt: string;
    last_update: string;
    lab_config: {
      __typename?: 'LabConfig';
      width: number;
      position: string;
      overlay: boolean;
      extendTTL: number | null;
    } | null;
    challenges: Array<{
      __typename?: 'Challenge';
      id: string;
      permalink: string | null;
      slug: string;
      title: string;
      index: number;
      type: ChallengeType;
      timelimit: number | null;
      teaser: string;
    }>;
    developers: Array<{
      __typename?: 'User';
      id: string;
      profile: {
        __typename?: 'UserProfile';
        slug: string | null;
        avatar: string | null;
        display_name: string | null;
        email: string | null;
      } | null;
    }>;
  } | null;
};

export type DashboardStatisticsFragment = {
  __typename?: 'TrackStatistics';
  started_total: number | null;
  completed_total: number | null;
  happiness: Array<{ __typename?: 'HappinessCount'; score: number; count: number }>;
};

export type DashboardTrackFragment = {
  __typename?: 'Track';
  id: string;
  permalink: string | null;
  slug: string;
  owner: string | null;
  icon: string;
  title: string;
  timelimit: number | null;
  description: string;
  tags: Array<string>;
  idle_timeout: number | null;
  completed: string;
  maintenance: boolean;
  show_timer: boolean;
  skipping_enabled: boolean;
  can_skip: boolean;
  createdAt: string;
  last_update: string;
  lab_config: {
    __typename?: 'LabConfig';
    width: number;
    position: string;
    overlay: boolean;
    extendTTL: number | null;
  } | null;
  challenges: Array<{
    __typename?: 'Challenge';
    id: string;
    permalink: string | null;
    slug: string;
    title: string;
    index: number;
    type: ChallengeType;
    timelimit: number | null;
    teaser: string;
  }>;
  developers: Array<{
    __typename?: 'User';
    id: string;
    profile: {
      __typename?: 'UserProfile';
      slug: string | null;
      avatar: string | null;
      display_name: string | null;
      email: string | null;
    } | null;
  }>;
};

export type DashboardDeveloperFragment = {
  __typename?: 'User';
  id: string;
  profile: {
    __typename?: 'UserProfile';
    slug: string | null;
    avatar: string | null;
    display_name: string | null;
    email: string | null;
  } | null;
};

export type DashboardChallengeFragment = {
  __typename?: 'Challenge';
  id: string;
  permalink: string | null;
  slug: string;
  title: string;
  index: number;
  type: ChallengeType;
  timelimit: number | null;
  teaser: string;
};

export type ActivityReportPageQueryVariables = Exact<{
  teamSlug: Scalars['String'];
  inviteID: Scalars['String'];
}>;

export type ActivityReportPageQuery = {
  __typename?: 'Query';
  trackInvite: {
    __typename?: 'TrackInvite';
    id: string;
    type: TrackInviteType | null;
    allowAnonymous: boolean;
    allowedEmailAddressesOnly: boolean;
    title: string;
    publicTitle: string | null;
    claims: Array<{
      __typename?: 'InviteClaim';
      id: string;
      claimedAt: string | null;
      playLimit: number | null;
      playTTL: string | null;
      user: {
        __typename?: 'User';
        id: string;
        profile: { __typename?: 'UserProfile'; display_name: string | null; email: string | null } | null;
        details: {
          __typename?: 'UserDetails';
          firstName: string | null;
          lastName: string | null;
          email: string | null;
          id: string;
          companyName: string | null;
          phoneNumber: string | null;
          jobTitle: string | null;
          jobLevel: string | null;
          countryCode: string | null;
          usState: string | null;
        } | null;
      };
    }>;
    team: {
      __typename?: 'Team';
      id: string;
      slug: string;
      form: {
        __typename?: 'Form';
        id: string;
        fields: Array<{ __typename?: 'FormField'; id: string; fieldName: FormFieldName }>;
      } | null;
    };
    plays: Array<{
      __typename?: 'InvitePlay';
      last_activity: string;
      time_spent: number;
      track_started_at: string;
      track_completed_at: string | null;
      completed_challenges: number;
      total_challenges: number;
      failed_challenge_attempts: number;
      track: { __typename?: 'Track'; id: string; slug: string };
      participant: { __typename?: 'Play'; id: string };
      user: {
        __typename?: 'User';
        id: string;
        is_anonymous: boolean;
        profile: { __typename?: 'UserProfile'; email: string | null; display_name: string | null } | null;
      };
    }>;
  } | null;
};

export type CreateInvitePageQueryVariables = Exact<{
  teamSlug: Scalars['String'];
}>;

export type CreateInvitePageQuery = {
  __typename?: 'Query';
  tracks: Array<{
    __typename?: 'Track';
    id: string;
    published: boolean;
    title: string;
    maintenance: boolean;
    slug: string;
  }> | null;
  team: {
    __typename?: 'Team';
    id: string;
    form: {
      __typename?: 'Form';
      id: string;
      fields: Array<{ __typename?: 'FormField'; id: string; fieldName: FormFieldName; isRequired: boolean }>;
    } | null;
  } | null;
};

export type CreateInviteCreateTrackInviteMutationVariables = Exact<{
  invite: TrackInviteInput;
}>;

export type CreateInviteCreateTrackInviteMutation = {
  __typename?: 'Mutation';
  createTrackInvite: { __typename?: 'TrackInvite'; id: string } | null;
};

export type DuplicateInvitePageQueryVariables = Exact<{
  inviteID: Scalars['String'];
  teamSlug: Scalars['String'];
}>;

export type DuplicateInvitePageQuery = {
  __typename?: 'Query';
  trackInvite: {
    __typename?: 'TrackInvite';
    id: string;
    type: TrackInviteType | null;
    publicTitle: string | null;
    publicDescription: string | null;
    title: string;
    inviteLimit: number | null;
    playLimit: number | null;
    playTTL: number | null;
    allowedEmailAddresses: Array<string>;
    allowAnonymous: boolean;
    expiresAt: string | null;
    startsAt: string | null;
    enableLearnerSharing: boolean;
    tracks: Array<{ __typename?: 'Track'; id: string }>;
  } | null;
  tracks: Array<{
    __typename?: 'Track';
    id: string;
    published: boolean;
    title: string;
    maintenance: boolean;
    slug: string;
  }> | null;
  team: {
    __typename?: 'Team';
    id: string;
    form: {
      __typename?: 'Form';
      id: string;
      fields: Array<{ __typename?: 'FormField'; id: string; fieldName: FormFieldName; isRequired: boolean }>;
    } | null;
  } | null;
};

export type DuplicateInviteCreateTrackInviteMutationVariables = Exact<{
  invite: TrackInviteInput;
}>;

export type DuplicateInviteCreateTrackInviteMutation = {
  __typename?: 'Mutation';
  createTrackInvite: { __typename?: 'TrackInvite'; id: string } | null;
};

export type EditInvitePageQueryVariables = Exact<{
  inviteID: Scalars['String'];
  teamSlug: Scalars['String'];
}>;

export type EditInvitePageQuery = {
  __typename?: 'Query';
  trackInvite: {
    __typename?: 'TrackInvite';
    id: string;
    type: TrackInviteType | null;
    publicTitle: string | null;
    publicDescription: string | null;
    title: string;
    inviteLimit: number | null;
    playLimit: number | null;
    playTTL: number | null;
    allowedEmailAddresses: Array<string>;
    allowAnonymous: boolean;
    expiresAt: string | null;
    startsAt: string | null;
    enableLearnerSharing: boolean;
    tracks: Array<{ __typename?: 'Track'; id: string }>;
  } | null;
  tracks: Array<{
    __typename?: 'Track';
    id: string;
    published: boolean;
    title: string;
    maintenance: boolean;
    slug: string;
  }> | null;
  team: {
    __typename?: 'Team';
    id: string;
    form: {
      __typename?: 'Form';
      id: string;
      fields: Array<{ __typename?: 'FormField'; id: string; fieldName: FormFieldName; isRequired: boolean }>;
    } | null;
  } | null;
};

export type EditInviteUpdateTrackInviteMutationVariables = Exact<{
  invite: TrackInviteInput;
}>;

export type EditInviteUpdateTrackInviteMutation = {
  __typename?: 'Mutation';
  updateTrackInvite: { __typename?: 'TrackInvite'; id: string } | null;
};

export type ViewInvitePageQueryVariables = Exact<{
  inviteID: Scalars['String'];
}>;

export type ViewInvitePageQuery = {
  __typename?: 'Query';
  trackInvite: {
    __typename?: 'TrackInvite';
    id: string;
    title: string;
    publicTitle: string | null;
    publicDescription: string | null;
    inviteLimit: number | null;
    inviteCount: number | null;
    startsAt: string | null;
    expiresAt: string | null;
    playLimit: number | null;
    playTTL: number | null;
    allowAnonymous: boolean;
    allowedEmailAddressesOnly: boolean;
    status: TrackInviteStatus | null;
    type: TrackInviteType | null;
    enableLearnerSharing: boolean;
    canClaim: boolean;
    tracks: Array<{ __typename?: 'Track'; id: string; title: string; permalink: string | null }>;
    team: { __typename?: 'Team'; name: string };
  } | null;
};

export type DownloadTrackInviteCsvTrackInviteFragment = {
  __typename?: 'TrackInvite';
  id: string;
  publicTitle: string | null;
  team: {
    __typename?: 'Team';
    id: string;
    slug: string;
    form: {
      __typename?: 'Form';
      id: string;
      fields: Array<{ __typename?: 'FormField'; id: string; fieldName: FormFieldName }>;
    } | null;
  };
  plays: Array<{
    __typename?: 'InvitePlay';
    last_activity: string;
    time_spent: number;
    track_started_at: string;
    track_completed_at: string | null;
    completed_challenges: number;
    total_challenges: number;
    failed_challenge_attempts: number;
    track: { __typename?: 'Track'; id: string; slug: string };
    participant: { __typename?: 'Play'; id: string };
    user: {
      __typename?: 'User';
      id: string;
      is_anonymous: boolean;
      profile: { __typename?: 'UserProfile'; email: string | null; display_name: string | null } | null;
    };
  }>;
};

export type GetTrackLimitsPageConfigQueryVariables = Exact<{
  teamSlug: Scalars['String'];
}>;

export type GetTrackLimitsPageConfigQuery = {
  __typename?: 'Query';
  team: { __typename?: 'Team'; id: string } | null;
  tracks: Array<{
    __typename?: 'Track';
    id: string;
    title: string;
    slug: string;
    maintenance: boolean;
    play_count: number | null;
  }> | null;
  trackPlayLimits: Array<{
    __typename?: 'TrackPlayLimit';
    rollingMonth: number;
    rollingIPAddressPerHour: number;
    calendarMonth: number;
    track: { __typename?: 'Track'; id: string } | null;
  }>;
};

export type LimitsPageSaveLimitsMutationVariables = Exact<{
  trackID: InputMaybe<Scalars['String']>;
  teamSlug: Scalars['String'];
  trackPlayLimits: TrackPlayLimitInput;
}>;

export type LimitsPageSaveLimitsMutation = {
  __typename?: 'Mutation';
  saveTrackPlayLimits: Array<{
    __typename?: 'TrackPlayLimit';
    rollingMonth: number;
    rollingIPAddressPerHour: number;
    calendarMonth: number;
    track: { __typename?: 'Track'; id: string } | null;
  }>;
};

export type GetUpdateChallengeNotePageConfigQueryVariables = Exact<{
  trackID: Scalars['String'];
  challengeID: Scalars['String'];
  noteID: Scalars['String'];
}>;

export type GetUpdateChallengeNotePageConfigQuery = {
  __typename?: 'Query';
  userIsTrackDeveloper: boolean;
  challenge: { __typename?: 'Challenge'; id: string } | null;
  note: {
    __typename?: 'ChallengeNote';
    id: string;
    index: number;
    contents: string | null;
    type: ChallengeNoteType;
    url: string | null;
  } | null;
};

export type UpdateChallengeNotePageUpdateChallengeNoteMutationVariables = Exact<{
  note: ChallengeNoteInput;
}>;

export type UpdateChallengeNotePageUpdateChallengeNoteMutation = {
  __typename?: 'Mutation';
  updateChallengeNote: {
    __typename?: 'ChallengeNote';
    id: string;
    index: number;
    contents: string | null;
    type: ChallengeNoteType;
    url: string | null;
  } | null;
};

export type GetUpdateChallengeTabPageConfigQueryVariables = Exact<{
  trackID: Scalars['String'];
  challengeID: Scalars['String'];
  tabID: Scalars['String'];
  teamSlug: Scalars['String'];
}>;

export type GetUpdateChallengeTabPageConfigQuery = {
  __typename?: 'Query';
  userIsTrackDeveloper: boolean;
  challenge: { __typename?: 'Challenge'; id: string } | null;
  tab: {
    __typename?: 'ChallengeTab';
    id: string;
    index: number;
    target: string | null;
    title: string;
    type: ChallengeTabType;
    hostname: string | null;
    url: string | null;
    port: number | null;
    path: string | null;
    workdir: string | null;
    cmd: string | null;
    new_window: boolean;
  } | null;
  track: {
    __typename?: 'Track';
    sandboxConfig: {
      __typename?: 'SandboxConfigVersion';
      resources: {
        __typename?: 'SandboxResources';
        containers: Array<{ __typename?: 'ContainerConfig'; id: string; name: string }>;
        virtualmachines: Array<{ __typename?: 'VirtualMachineConfig'; id: string; name: string }>;
        virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig'; id: string; name: string }>;
      } | null;
    } | null;
  } | null;
  trackConfig: {
    __typename?: 'TrackConfig';
    id: string;
    containers: Array<{ __typename?: 'ContainerConfig'; id: string; name: string; image: string }>;
    virtualmachines: Array<{ __typename?: 'VirtualMachineConfig'; id: string; name: string }>;
    virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig'; id: string; name: string }>;
  } | null;
  team: { __typename?: 'Team'; id: string; features: { __typename?: 'TeamFeatures'; saas: boolean } | null } | null;
};

export type UpdateChallengeTabPageUpdateChallengeTabMutationVariables = Exact<{
  tab: ChallengeTabInput;
}>;

export type UpdateChallengeTabPageUpdateChallengeTabMutation = {
  __typename?: 'Mutation';
  updateChallengeTab: {
    __typename?: 'ChallengeTab';
    id: string;
    index: number;
    target: string | null;
    title: string;
    type: ChallengeTabType;
    hostname: string | null;
    url: string | null;
    port: number | null;
    path: string | null;
    workdir: string | null;
    cmd: string | null;
    new_window: boolean;
  } | null;
};

export type UpdateChallengeTabChallengeTabFragment = {
  __typename?: 'ChallengeTab';
  id: string;
  index: number;
  target: string | null;
  title: string;
  type: ChallengeTabType;
  hostname: string | null;
  url: string | null;
  port: number | null;
  path: string | null;
  workdir: string | null;
  cmd: string | null;
  new_window: boolean;
};

export type GetUpdateChallengePageConfigQueryVariables = Exact<{
  trackID: Scalars['String'];
  challengeID: Scalars['String'];
}>;

export type GetUpdateChallengePageConfigQuery = {
  __typename?: 'Query';
  userIsTrackDeveloper: boolean;
  track: {
    __typename?: 'Track';
    lab_config: {
      __typename?: 'LabConfig';
      position: string;
      width: number;
      overlay: boolean;
      extendTTL: number | null;
    } | null;
  } | null;
  challenge: {
    __typename?: 'Challenge';
    id: string;
    index: number;
    difficulty: string;
    title: string;
    slug: string;
    type: ChallengeType;
    assignment: string;
    teaser: string;
    timelimit: number | null;
    answers: Array<string>;
    solution: Array<number>;
  } | null;
};

export type UpdateChallengePageUpdateChallengeMutationVariables = Exact<{
  challenge: ChallengeInput;
}>;

export type UpdateChallengePageUpdateChallengeMutation = {
  __typename?: 'Mutation';
  updateChallenge: {
    __typename?: 'Challenge';
    id: string;
    index: number;
    difficulty: string;
    title: string;
    slug: string;
    type: ChallengeType;
    assignment: string;
    teaser: string;
    timelimit: number | null;
    answers: Array<string>;
    solution: Array<number>;
  } | null;
};

export type UpdateChallengePageDeleteChallengeMutationVariables = Exact<{
  challengeID: Scalars['String'];
}>;

export type UpdateChallengePageDeleteChallengeMutation = { __typename?: 'Mutation'; deleteChallenge: boolean };

export type UpdateChallengePageChallengeFragment = {
  __typename?: 'Challenge';
  id: string;
  index: number;
  difficulty: string;
  title: string;
  slug: string;
  type: ChallengeType;
  assignment: string;
  teaser: string;
  timelimit: number | null;
  answers: Array<string>;
  solution: Array<number>;
};

export type GetUpdateScriptsPageQueryQueryVariables = Exact<{
  trackSlug: Scalars['String'];
  teamSlug: Scalars['String'];
}>;

export type GetUpdateScriptsPageQueryQuery = {
  __typename?: 'Query';
  userIsTrackDeveloper: boolean;
  track: {
    __typename?: 'Track';
    id: string;
    scripts: Array<{ __typename?: 'TrackScript'; action: string; contents: string; host: string; id: string }>;
    sandboxConfig: {
      __typename?: 'SandboxConfigVersion';
      resources: {
        __typename?: 'SandboxResources';
        containers: Array<{ __typename?: 'ContainerConfig'; id: string; name: string }>;
        virtualmachines: Array<{ __typename?: 'VirtualMachineConfig'; id: string; name: string }>;
        virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig'; id: string; name: string }>;
      } | null;
    } | null;
    challenges: Array<{
      __typename?: 'Challenge';
      id: string;
      title: string;
      scripts: Array<{ __typename?: 'ChallengeScript'; action: string; contents: string; host: string; id: string }>;
    }>;
  } | null;
};

export type GetUpdateScriptsTrackConfigQueryQueryVariables = Exact<{
  trackID: Scalars['String'];
}>;

export type GetUpdateScriptsTrackConfigQueryQuery = {
  __typename?: 'Query';
  trackConfig: {
    __typename?: 'TrackConfig';
    id: string;
    containers: Array<{ __typename?: 'ContainerConfig'; id: string; name: string }>;
    virtualmachines: Array<{ __typename?: 'VirtualMachineConfig'; id: string; name: string }>;
    virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig'; id: string; name: string }>;
  } | null;
};

export type UpdateTrackScriptsFragment = {
  __typename?: 'Track';
  id: string;
  scripts: Array<{ __typename?: 'TrackScript'; action: string; contents: string; host: string; id: string }>;
  sandboxConfig: {
    __typename?: 'SandboxConfigVersion';
    resources: {
      __typename?: 'SandboxResources';
      containers: Array<{ __typename?: 'ContainerConfig'; id: string; name: string }>;
      virtualmachines: Array<{ __typename?: 'VirtualMachineConfig'; id: string; name: string }>;
      virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig'; id: string; name: string }>;
    } | null;
  } | null;
  challenges: Array<{
    __typename?: 'Challenge';
    id: string;
    title: string;
    scripts: Array<{ __typename?: 'ChallengeScript'; action: string; contents: string; host: string; id: string }>;
  }>;
};

export type UpdateChallengeScriptsFragment = {
  __typename?: 'Challenge';
  id: string;
  title: string;
  scripts: Array<{ __typename?: 'ChallengeScript'; action: string; contents: string; host: string; id: string }>;
};

export type UpdateTrackScriptMutationVariables = Exact<{
  script: TrackScriptInput;
  base64Encoded: Scalars['Boolean'];
}>;

export type UpdateTrackScriptMutation = {
  __typename?: 'Mutation';
  saveTrackScript: { __typename?: 'TrackScript'; id: string; host: string; action: string; contents: string } | null;
};

export type UpdateChallengeScriptMutationVariables = Exact<{
  script: ChallengeScriptInput;
  base64Encoded: Scalars['Boolean'];
}>;

export type UpdateChallengeScriptMutation = {
  __typename?: 'Mutation';
  saveChallengeScript: {
    __typename?: 'ChallengeScript';
    id: string;
    host: string;
    action: string;
    contents: string;
  } | null;
};

export type DeleteChallengeScriptMutationVariables = Exact<{
  challengeScriptID: Scalars['String'];
}>;

export type DeleteChallengeScriptMutation = { __typename?: 'Mutation'; deleteChallengeScript: boolean };

export type UpdateChallengeScriptResultFragment = {
  __typename?: 'ChallengeScript';
  id: string;
  host: string;
  action: string;
  contents: string;
};

export type UpdateTrackScriptResultFragment = {
  __typename?: 'TrackScript';
  id: string;
  host: string;
  action: string;
  contents: string;
};

export type UpdateTrackPageUpdateTrackMutationVariables = Exact<{
  track: TrackInput;
}>;

export type UpdateTrackPageUpdateTrackMutation = {
  __typename?: 'Mutation';
  updateTrack: { __typename?: 'Track'; id: string; slug: string } | null;
};

export type TrackReviewsQueryVariables = Exact<{
  trackID: Scalars['String'];
}>;

export type TrackReviewsQuery = {
  __typename?: 'Query';
  trackReviews: {
    __typename?: 'TrackReviewConnection';
    nodes: Array<{ __typename?: 'TrackReview'; id: string; score: number; created_at: string; content: string }>;
  } | null;
  statistics: {
    __typename?: 'Statistics';
    track: {
      __typename?: 'TrackStatistics';
      happiness: Array<{ __typename?: 'HappinessCount'; score: number; count: number }>;
    } | null;
  } | null;
};

export type AttemptsChallengeAttemptFragment = { __typename?: 'ChallengeAttempt'; message: string };

export type WorkspaceChallengeFragment = {
  __typename?: 'Challenge';
  type: ChallengeType;
  answers: Array<string>;
  attempts: Array<{ __typename?: 'ChallengeAttempt'; timestamp: string; message: string }>;
  tabs: Array<{
    __typename?: 'ChallengeTab';
    id: string;
    index: number;
    type: ChallengeTabType;
    title: string;
    target: string | null;
    new_window: boolean;
    path: string | null;
  }>;
};

export type CheckChallengeMutationVariables = Exact<{
  challengeID: Scalars['String'];
  inviteID: InputMaybe<Scalars['String']>;
  userID: InputMaybe<Scalars['String']>;
}>;

export type CheckChallengeMutation = {
  __typename?: 'Mutation';
  checkChallenge: {
    __typename?: 'Challenge';
    id: string;
    status: ChallengeStatus;
    attempts: Array<{ __typename?: 'ChallengeAttempt'; timestamp: string; message: string }>;
    unlocks: { __typename?: 'Challenge'; id: string; permalink: string | null } | null;
  } | null;
};

export type CheckQuizMutationVariables = Exact<{
  challengeID: Scalars['String'];
  userID: InputMaybe<Scalars['String']>;
  inviteID: InputMaybe<Scalars['String']>;
  solution: Array<Scalars['Int']> | Scalars['Int'];
}>;

export type CheckQuizMutation = {
  __typename?: 'Mutation';
  checkQuiz: {
    __typename?: 'Challenge';
    id: string;
    status: ChallengeStatus;
    attempts: Array<{ __typename?: 'ChallengeAttempt'; timestamp: string; message: string }>;
    unlocks: { __typename?: 'Challenge'; id: string; permalink: string | null } | null;
  } | null;
};

export type LearnEnvironmentKeepAliveMutationVariables = Exact<{
  trackId: Scalars['ID'];
}>;

export type LearnEnvironmentKeepAliveMutation = { __typename?: 'Mutation'; keepAlive: boolean };

export type LearnEnvironmentLegacyQueryVariables = Exact<{
  trackSlug: Scalars['String'];
  challengeSlug: Scalars['String'];
  teamSlug: Scalars['String'];
  userID: InputMaybe<Scalars['String']>;
  inviteID: InputMaybe<Scalars['String']>;
}>;

export type LearnEnvironmentLegacyQuery = {
  __typename?: 'Query';
  userInTeam: boolean;
  userIsTrackDeveloper: boolean;
  team: {
    __typename?: 'Team';
    id: string;
    slug: string;
    name: string;
    features: {
      __typename?: 'TeamFeatures';
      track_reviews: boolean;
      service_tab_focus_overlay: boolean;
      members_skip_to_challenge: boolean;
      use_new_terminal: boolean;
    } | null;
  } | null;
  track: {
    __typename?: 'Track';
    id: string;
    title: string;
    permalink: string | null;
    slug: string;
    status: TrackStatus | null;
    started: string;
    creating: string;
    created: string;
    failed: string;
    stopped: string;
    completed: string;
    cleaned: string;
    show_timer: boolean;
    ttl: string | null;
    idle_timeout: number | null;
    median_starttime: number | null;
    challenges: Array<{
      __typename?: 'Challenge';
      id: string;
      status: ChallengeStatus;
      index: number;
      permalink: string | null;
      slug: string;
      title: string;
      failed: number;
      type: ChallengeType;
    }>;
    participant: { __typename?: 'Play'; id: string } | null;
  } | null;
  challenge: {
    __typename?: 'Challenge';
    id: string;
    type: ChallengeType;
    index: number;
    teaser: string;
    permalink: string | null;
    title: string;
    slug: string;
    status: ChallengeStatus;
    assignment: string;
    answers: Array<string>;
    can_check: boolean | null;
    failed: number;
    notes: Array<{
      __typename?: 'ChallengeNote';
      id: string;
      type: ChallengeNoteType;
      contents: string | null;
      url: string | null;
    }>;
    attempts: Array<{ __typename?: 'ChallengeAttempt'; timestamp: string; message: string }>;
    tabs: Array<{
      __typename?: 'ChallengeTab';
      id: string;
      index: number;
      type: ChallengeTabType;
      title: string;
      target: string | null;
      new_window: boolean;
      path: string | null;
    }>;
  } | null;
  skippingEnabledTrack: { __typename?: 'Track'; skipping_enabled: boolean; can_skip: boolean } | null;
};

export type LearnEnvironmentStopTrackMutationVariables = Exact<{
  trackID: Scalars['String'];
}>;

export type LearnEnvironmentStopTrackMutation = {
  __typename?: 'Mutation';
  stopTrack: { __typename?: 'Track'; id: string } | null;
};

export type LearnEnvironmentInviteQueryVariables = Exact<{
  inviteID: Scalars['String'];
}>;

export type LearnEnvironmentInviteQuery = {
  __typename?: 'Query';
  trackInvite: {
    __typename?: 'TrackInvite';
    id: string;
    canClaim: boolean;
    enableLearnerSharing: boolean;
    allowAnonymous: boolean;
    allowedEmailAddresses: Array<string>;
  } | null;
};

export type RecapLegacyQueryVariables = Exact<{
  trackSlug: Scalars['String'];
  teamSlug: Scalars['String'];
}>;

export type RecapLegacyQuery = {
  __typename?: 'Query';
  userInTeam: boolean;
  userIsTrackDeveloper: boolean;
  track: {
    __typename?: 'Track';
    id: string;
    title: string;
    permalink: string | null;
    slug: string;
    status: TrackStatus | null;
    median_starttime: number | null;
    challenges: Array<{
      __typename?: 'Challenge';
      permalink: string | null;
      id: string;
      status: ChallengeStatus;
      slug: string;
      title: string;
      failed: number;
      type: ChallengeType;
      index: number;
    }>;
    participant: { __typename?: 'Play'; id: string } | null;
  } | null;
  team: {
    __typename?: 'Team';
    features: { __typename?: 'TeamFeatures'; members_skip_to_challenge: boolean } | null;
  } | null;
  skippingEnabledTrack: { __typename?: 'Track'; skipping_enabled: boolean; can_skip: boolean } | null;
};

export type RecapTrackInviteQueryVariables = Exact<{
  inviteID: Scalars['String'];
}>;

export type RecapTrackInviteQuery = {
  __typename?: 'Query';
  trackInvite: {
    __typename?: 'TrackInvite';
    id: string;
    canClaim: boolean;
    enableLearnerSharing: boolean;
    allowAnonymous: boolean;
    allowedEmailAddresses: Array<string>;
  } | null;
};

export type ExpiredScreenTrackFragment = {
  __typename?: 'Track';
  slug: string;
  permalink: string | null;
  challenges: Array<{ __typename?: 'Challenge'; permalink: string | null }>;
};

export type ProgressModalChallengeFragment = {
  __typename?: 'Challenge';
  id: string;
  status: ChallengeStatus;
  slug: string;
  title: string;
  permalink: string | null;
  failed: number;
  type: ChallengeType;
  index: number;
};

export type ProgressModalTrackFragment = {
  __typename?: 'Track';
  id: string;
  slug: string;
  status: TrackStatus | null;
  median_starttime: number | null;
};

export type StopTrackMutationVariables = Exact<{
  trackID: Scalars['String'];
}>;

export type StopTrackMutation = {
  __typename?: 'Mutation';
  stopTrack: {
    __typename?: 'Track';
    id: string;
    status: TrackStatus | null;
    challenges: Array<{
      __typename?: 'Challenge';
      id: string;
      slug: string;
      title: string;
      teaser: string;
      status: ChallengeStatus;
    }>;
  } | null;
};

export type ProgressChallengeFragment = {
  __typename?: 'Challenge';
  id: string;
  status: ChallengeStatus;
  slug: string;
  title: string;
  permalink: string | null;
  failed: number;
  type: ChallengeType;
  index: number;
};

export type ProgressTrackFragment = {
  __typename?: 'Track';
  id: string;
  slug: string;
  status: TrackStatus | null;
  median_starttime: number | null;
};

export type UpdateTrackReviewMutationVariables = Exact<{
  id: Scalars['String'];
  content: Scalars['String'];
}>;

export type UpdateTrackReviewMutation = {
  __typename?: 'Mutation';
  updateTrackReview: { __typename?: 'TrackReview'; id: string } | null;
};

export type TrackReviewSaveRatingMutationVariables = Exact<{
  trackID: Scalars['String'];
  participantID: Scalars['String'];
  score: Scalars['Int'];
}>;

export type TrackReviewSaveRatingMutation = {
  __typename?: 'Mutation';
  createTrackReview: { __typename?: 'TrackReview'; id: string } | null;
};

export type TrackReviewRatingGetTrackQueryVariables = Exact<{
  trackID: Scalars['String'];
  teamSlug: Scalars['String'];
}>;

export type TrackReviewRatingGetTrackQuery = {
  __typename?: 'Query';
  track: {
    __typename?: 'Track';
    id: string;
    slug: string;
    participant: { __typename?: 'Play'; id: string } | null;
  } | null;
};

export type TrackAndChallengeStatusQueryVariables = Exact<{
  trackID: Scalars['String'];
  challengeID: Scalars['String'];
  userID: InputMaybe<Scalars['String']>;
  inviteID: InputMaybe<Scalars['String']>;
}>;

export type TrackAndChallengeStatusQuery = {
  __typename?: 'Query';
  track: { __typename?: 'Track'; id: string; status: TrackStatus | null; creating: string } | null;
  challenge: { __typename?: 'Challenge'; id: string; status: ChallengeStatus; failMessage: string | null } | null;
};

export type SetupChallengeMutationVariables = Exact<{
  challengeID: Scalars['String'];
}>;

export type SetupChallengeMutation = {
  __typename?: 'Mutation';
  setupChallenge: { __typename?: 'Challenge'; id: string } | null;
};

export type TabContentChallengeTabFragment = {
  __typename?: 'ChallengeTab';
  id: string;
  type: ChallengeTabType;
  target: string | null;
  path: string | null;
  new_window: boolean;
};

export type TabContentChallengeChallengeTabFragment = {
  __typename?: 'ChallengeTab';
  id: string;
  type: ChallengeTabType;
  target: string | null;
  path: string | null;
  new_window: boolean;
};

export type CompletionGetTrackQueryVariables = Exact<{
  trackSlug: Scalars['String'];
  teamSlug: Scalars['String'];
}>;

export type CompletionGetTrackQuery = {
  __typename?: 'Query';
  track: {
    __typename?: 'Track';
    id: string;
    title: string;
    permalink: string | null;
    challenges: Array<{ __typename?: 'Challenge'; permalink: string | null }>;
    participant: { __typename?: 'Play'; id: string } | null;
  } | null;
};

export type CompletionScreenUpdateTrackReviewMutationVariables = Exact<{
  id: Scalars['String'];
  content: Scalars['String'];
}>;

export type CompletionScreenUpdateTrackReviewMutation = {
  __typename?: 'Mutation';
  updateTrackReview: { __typename?: 'TrackReview'; id: string } | null;
};

export type CompletionScreenSaveRatingMutationVariables = Exact<{
  trackID: Scalars['String'];
  participantID: Scalars['String'];
  score: Scalars['Int'];
}>;

export type CompletionScreenSaveRatingMutation = {
  __typename?: 'Mutation';
  createTrackReview: { __typename?: 'TrackReview'; id: string } | null;
};

export type CompletionStopTrackMutationVariables = Exact<{
  trackID: Scalars['String'];
}>;

export type CompletionStopTrackMutation = {
  __typename?: 'Mutation';
  stopTrack: {
    __typename?: 'Track';
    id: string;
    status: TrackStatus | null;
    challenges: Array<{
      __typename?: 'Challenge';
      id: string;
      slug: string;
      title: string;
      teaser: string;
      status: ChallengeStatus;
    }>;
  } | null;
};

export type LearnEnvironmentQueryVariables = Exact<{
  trackSlug: Scalars['String'];
  challengeSlug: Scalars['String'];
  teamSlug: Scalars['String'];
  userID: InputMaybe<Scalars['String']>;
  inviteID: InputMaybe<Scalars['String']>;
}>;

export type LearnEnvironmentQuery = {
  __typename?: 'Query';
  userInTeam: boolean;
  userIsTrackDeveloper: boolean;
  team: {
    __typename?: 'Team';
    id: string;
    slug: string;
    name: string;
    features: {
      __typename?: 'TeamFeatures';
      track_reviews: boolean;
      service_tab_focus_overlay: boolean;
      members_skip_to_challenge: boolean;
      use_new_terminal: boolean;
    } | null;
  } | null;
  track: {
    __typename?: 'Track';
    id: string;
    title: string;
    permalink: string | null;
    slug: string;
    status: TrackStatus | null;
    started: string;
    creating: string;
    created: string;
    failed: string;
    stopped: string;
    completed: string;
    cleaned: string;
    show_timer: boolean;
    ttl: string | null;
    idle_timeout: number | null;
    median_starttime: number | null;
    challenges: Array<{
      __typename?: 'Challenge';
      id: string;
      status: ChallengeStatus;
      index: number;
      permalink: string | null;
      slug: string;
      title: string;
      failed: number;
      type: ChallengeType;
    }>;
    participant: { __typename?: 'Play'; id: string; ttlExtendedByUser: boolean } | null;
    lab_config: {
      __typename?: 'LabConfig';
      overlay: boolean;
      position: string;
      width: number;
      extendTTL: number | null;
    } | null;
  } | null;
  challenge: {
    __typename?: 'Challenge';
    id: string;
    type: ChallengeType;
    index: number;
    teaser: string;
    permalink: string | null;
    title: string;
    slug: string;
    status: ChallengeStatus;
    assignment: string;
    answers: Array<string>;
    can_check: boolean | null;
    failed: number;
    notes: Array<{
      __typename?: 'ChallengeNote';
      id: string;
      type: ChallengeNoteType;
      contents: string | null;
      url: string | null;
    }>;
    attempts: Array<{ __typename?: 'ChallengeAttempt'; timestamp: string; message: string }>;
    tabs: Array<{
      __typename?: 'ChallengeTab';
      id: string;
      index: number;
      type: ChallengeTabType;
      title: string;
      target: string | null;
      new_window: boolean;
      path: string | null;
    }>;
  } | null;
  skippingEnabledTrack: { __typename?: 'Track'; skipping_enabled: boolean; can_skip: boolean } | null;
};

export type ExtendSandboxTtlMutationVariables = Exact<{
  sandboxID: Scalars['String'];
  until: Scalars['Time'];
}>;

export type ExtendSandboxTtlMutation = {
  __typename?: 'Mutation';
  updateSandboxTTL: {
    __typename?: 'Sandbox';
    id: string;
    track: {
      __typename?: 'Track';
      id: string;
      ttl: string | null;
      participant: { __typename?: 'Play'; id: string; ttlExtendedByUser: boolean } | null;
    } | null;
  } | null;
};

export type NotesContainerStartTrackMutationVariables = Exact<{
  trackID: Scalars['String'];
  inviteID: InputMaybe<Scalars['String']>;
  mode: InputMaybe<Mode>;
  customParameters: InputMaybe<Array<CustomParametersInput> | CustomParametersInput>;
  forceStart: InputMaybe<Scalars['Boolean']>;
  region: InputMaybe<Scalars['String']>;
}>;

export type NotesContainerStartTrackMutation = {
  __typename?: 'Mutation';
  startTrack: {
    __typename?: 'Track';
    id: string;
    status: TrackStatus | null;
    permalink: string | null;
    challenges: Array<{ __typename?: 'Challenge'; id: string; slug: string; status: ChallengeStatus }>;
  } | null;
};

export type NotesContainerStartChallengeMutationVariables = Exact<{
  challengeID: Scalars['String'];
}>;

export type NotesContainerStartChallengeMutation = {
  __typename?: 'Mutation';
  startChallenge: {
    __typename?: 'Challenge';
    id: string;
    status: ChallengeStatus;
    assignment: string;
    tabs: Array<{ __typename?: 'ChallengeTab'; type: ChallengeTabType; title: string; target: string | null }>;
  } | null;
};

export type NotesContainerQueryVariables = Exact<{
  trackSlug: InputMaybe<Scalars['String']>;
  challengeSlug: Scalars['String'];
  teamSlug: Scalars['String'];
  inviteID: InputMaybe<Scalars['String']>;
  userID: InputMaybe<Scalars['String']>;
}>;

export type NotesContainerQuery = {
  __typename?: 'Query';
  userInTeam: boolean;
  userIsTrackDeveloper: boolean;
  track: {
    __typename?: 'Track';
    id: string;
    permalink: string | null;
    slug: string;
    status: TrackStatus | null;
    creating: string;
    completed: string;
    median_starttime: number | null;
    owner: string | null;
    participant: { __typename?: 'Play'; id: string } | null;
    challenges: Array<{
      __typename?: 'Challenge';
      id: string;
      title: string;
      status: ChallengeStatus;
      permalink: string | null;
      slug: string;
      failed: number;
      type: ChallengeType;
      index: number;
    }>;
  } | null;
  challenge: {
    __typename?: 'Challenge';
    id: string;
    index: number;
    title: string;
    permalink: string | null;
    slug: string;
    status: ChallengeStatus;
    teaser: string;
    type: ChallengeType;
    failed: number;
    notes: Array<{
      __typename?: 'ChallengeNote';
      id: string;
      type: ChallengeNoteType;
      contents: string | null;
      url: string | null;
    }>;
  } | null;
  team: {
    __typename?: 'Team';
    features: { __typename?: 'TeamFeatures'; members_skip_to_challenge: boolean } | null;
  } | null;
  skippingEnabledTrack: { __typename?: 'Track'; skipping_enabled: boolean; can_skip: boolean } | null;
};

export type NotesContainerInviteQueryVariables = Exact<{
  inviteID: Scalars['String'];
}>;

export type NotesContainerInviteQuery = {
  __typename?: 'Query';
  trackInvite: {
    __typename?: 'TrackInvite';
    id: string;
    canClaim: boolean;
    enableLearnerSharing: boolean;
    allowAnonymous: boolean;
    allowedEmailAddresses: Array<string>;
  } | null;
};

export type RecapQueryVariables = Exact<{
  trackSlug: Scalars['String'];
  teamSlug: Scalars['String'];
}>;

export type RecapQuery = {
  __typename?: 'Query';
  userInTeam: boolean;
  userIsTrackDeveloper: boolean;
  track: {
    __typename?: 'Track';
    id: string;
    title: string;
    permalink: string | null;
    slug: string;
    status: TrackStatus | null;
    median_starttime: number | null;
    challenges: Array<{
      __typename?: 'Challenge';
      permalink: string | null;
      id: string;
      status: ChallengeStatus;
      slug: string;
      title: string;
      failed: number;
      type: ChallengeType;
      index: number;
    }>;
    participant: { __typename?: 'Play'; id: string } | null;
    lab_config: { __typename?: 'LabConfig'; overlay: boolean; position: string; width: number } | null;
  } | null;
  team: {
    __typename?: 'Team';
    features: { __typename?: 'TeamFeatures'; members_skip_to_challenge: boolean } | null;
  } | null;
  skippingEnabledTrack: { __typename?: 'Track'; skipping_enabled: boolean; can_skip: boolean } | null;
};

export type SplashScreenQueryVariables = Exact<{
  teamSlug: Scalars['String'];
  trackSlug: Scalars['String'];
}>;

export type SplashScreenQuery = {
  __typename?: 'Query';
  userInTeam: boolean;
  userIsTrackDeveloper: boolean;
  track: {
    __typename?: 'Track';
    id: string;
    title: string;
    teaser: string;
    status: TrackStatus | null;
    challenges: Array<{
      __typename?: 'Challenge';
      status: ChallengeStatus;
      slug: string;
      started: number;
      permalink: string | null;
      completed: number;
      title: string;
    }>;
    participant: { __typename?: 'Play'; id: string } | null;
  } | null;
  team: {
    __typename?: 'Team';
    features: { __typename?: 'TeamFeatures'; members_skip_to_challenge: boolean } | null;
  } | null;
  skippingEnabledTrack: { __typename?: 'Track'; skipping_enabled: boolean; can_skip: boolean } | null;
};

export type IsSkippingEnabledQueryFragment = {
  __typename?: 'Query';
  userInTeam: boolean;
  userIsTrackDeveloper: boolean;
  team: {
    __typename?: 'Team';
    features: { __typename?: 'TeamFeatures'; members_skip_to_challenge: boolean } | null;
  } | null;
  skippingEnabledTrack: { __typename?: 'Track'; skipping_enabled: boolean; can_skip: boolean } | null;
};

export type ChallengeStatusQueryVariables = Exact<{
  challengeID: Scalars['String'];
  userID: InputMaybe<Scalars['String']>;
  inviteID: InputMaybe<Scalars['String']>;
}>;

export type ChallengeStatusQuery = {
  __typename?: 'Query';
  challenge: { __typename?: 'Challenge'; status: ChallengeStatus; failed: number; failMessage: string | null } | null;
};

export type AmplitudeUserFragment = {
  __typename?: 'User';
  id: string;
  segments: Array<UserSegment>;
  teams: Array<{ __typename?: 'UserTeamEdge'; node: { __typename?: 'Team'; slug: string } | null }>;
};

export const BrandedOrganizationFragmentDoc = gql`
  fragment BrandedOrganization on Organization {
    name
    logo
    title
    subtitle
    slug
    primary_link_text
    primary_link_url
    secondary_link_text
    secondary_link_url
    theme {
      foreground_color
      foreground_image
      background_color
      background_image
      primary_foreground_color
      primary_background_color
      secondary_foreground_color
      secondary_background_color
    }
  }
`;
export const SandboxFragmentDoc = gql`
  fragment Sandbox on Sandbox {
    created
    last_activity_at
    ttl
    state
    id
    track {
      title
    }
  }
`;
export const StudentNameFragmentDoc = gql`
  fragment StudentName on User {
    id
    profile {
      display_name
    }
    details(teamSlug: $teamSlug) {
      id
      firstName
      lastName
    }
  }
`;
export const AmplitudeUserFragmentDoc = gql`
  fragment AmplitudeUser on User {
    id
    segments
    teams {
      node {
        slug
      }
    }
  }
`;
export const AuthenticationUserFragmentDoc = gql`
  fragment AuthenticationUser on User {
    id
    segments
    is_global_admin
    profile {
      email
      display_name
      avatar
      slug
    }
    teams {
      role
      node {
        id
        slug
        name
        features {
          hot_start
          invites
          statistics
          arcades
          webhooks
          track_reviews
          shared_hotstart_pools
        }
      }
    }
    ...AmplitudeUser
  }
  ${AmplitudeUserFragmentDoc}
`;
export const InvitesTeamFragmentDoc = gql`
  fragment InvitesTeam on Team {
    id
    invites {
      email
      role
    }
  }
`;
export const RoleSelectTeamFragmentDoc = gql`
  fragment RoleSelectTeam on Team {
    id
    members {
      role
      user {
        id
      }
    }
  }
`;
export const MembersTeamFragmentDoc = gql`
  fragment MembersTeam on Team {
    id
    members {
      role
      user {
        id
        profile {
          display_name
          avatar
          slug
        }
      }
    }
    ...RoleSelectTeam
  }
  ${RoleSelectTeamFragmentDoc}
`;
export const TrackInviteListItemTrackFragmentDoc = gql`
  fragment TrackInviteListItemTrack on Track {
    id
    title
    teaser
    icon
    status
    completed
    maintenance
  }
`;
export const TrackInviteListTrackFragmentDoc = gql`
  fragment TrackInviteListTrack on Track {
    id
    status
    ...TrackInviteListItemTrack
  }
  ${TrackInviteListItemTrackFragmentDoc}
`;
export const TrackInviteListItemInviteFragmentDoc = gql`
  fragment TrackInviteListItemInvite on TrackInvite {
    playLimit
    currentUserClaim {
      trackLibrary {
        playCount
        track {
          id
        }
      }
    }
  }
`;
export const SortableChallengesChallengeFragmentDoc = gql`
  fragment SortableChallengesChallenge on Challenge {
    id
    title
    teaser
  }
`;
export const StudyRoomClaimFragmentDoc = gql`
  fragment StudyRoomClaim on InviteClaim {
    id
    claimedAt
    trackInvite {
      id
      publicTitle
      publicDescription
      tracks {
        id
        status
        completed
      }
      team {
        id
        slug
        name
        logo
        theme {
          background_image
          background_color
        }
      }
    }
  }
`;
export const TrackDetailsTeamDataFragmentDoc = gql`
  fragment TrackDetailsTeamData on Team {
    id
    name
    logo
    theme {
      foreground_color
      foreground_image
      background_color
      background_image
      primary_foreground_color
      primary_background_color
    }
    features {
      statistics
      embedded
      members_skip_to_challenge
    }
  }
`;
export const TrackDetailsTrackDataFragmentDoc = gql`
  fragment TrackDetailsTrackData on Track {
    id
    permalink
    slug
    owner
    icon
    title
    teaser
    timelimit
    description
    level
    tags
    idle_timeout
    status
    completed
    maintenance
    show_timer
    skipping_enabled
    can_skip
    lab_config {
      width
      position
      overlay
      extendTTL
    }
    challenges {
      id
      permalink
      slug
      title
      teaser
      status
      index
      type
      timelimit
      started
      completed
      failed
      failMessage
    }
    developers {
      id
      profile {
        slug
        avatar
        display_name
        email
      }
    }
  }
`;
export const TrackStatisticsTableTrackStatisticsFragmentDoc = gql`
  fragment TrackStatisticsTableTrackStatistics on TrackStatistics {
    average_review_score
    started_total
    completed_total
    track {
      title
      slug
      developers {
        profile {
          display_name
          avatar
        }
      }
    }
  }
`;
export const EditorHeroTeamThemeFragmentDoc = gql`
  fragment EditorHeroTeamTheme on TeamTheme {
    background_color
    background_image
    foreground_color
  }
`;
export const TrackFilterTrackFragmentDoc = gql`
  fragment TrackFilterTrack on Track {
    id
    title
    slug
    maintenance
  }
`;
export const PlayActivityReportsTableFragmentDoc = gql`
  fragment PlayActivityReportsTable on PlayReportItem {
    id
    completionPercent
    timeSpent
    track {
      id
      slug
      title
    }
    user {
      id
      details(teamSlug: $teamSlug) {
        id
        firstName
        lastName
        email
      }
      profile {
        display_name
        email
      }
    }
    startedAt
  }
`;
export const UserDetailsCollectedTableDetailsFragmentDoc = gql`
  fragment UserDetailsCollectedTableDetails on UserDetails {
    id
    firstName
    lastName
    email
    companyName
    phoneNumber
    jobTitle
    jobLevel
    countryCode
    usState
  }
`;
export const ChallengeFormDataFragmentDoc = gql`
  fragment ChallengeFormData on Challenge {
    id
    slug
    title
    type
    teaser
  }
`;
export const ChallengeNoteFormNoteFragmentDoc = gql`
  fragment ChallengeNoteFormNote on ChallengeNote {
    contents
    type
    url
  }
`;
export const ChallengeNoteListNoteFragmentDoc = gql`
  fragment ChallengeNoteListNote on ChallengeNote {
    id
    type
    contents
    url
  }
`;
export const ChallengeTabDrawerFragmentDoc = gql`
  fragment ChallengeTabDrawer on ChallengeTab {
    id
    title
    type
    hostname
    url
    port
    path
    workdir
    cmd
    new_window
  }
`;
export const ContainerFormContainerPresetFragmentDoc = gql`
  fragment ContainerFormContainerPreset on ContainerConfigPreset {
    label
    image
    memory
  }
`;
export const VirtualMachineFormGoogleCloudMachineTypePresetFragmentDoc = gql`
  fragment VirtualMachineFormGoogleCloudMachineTypePreset on GoogleCloudMachineTypePreset {
    label
    machine_type
  }
`;
export const VirtualMachineFormVirtualMachinePresetFragmentDoc = gql`
  fragment VirtualMachineFormVirtualMachinePreset on VirtualMachineConfigPreset {
    image
    label
    machine_type
    cpus
    memory
  }
`;
export const VirtualMachineFormMachineTypePresetFragmentDoc = gql`
  fragment VirtualMachineFormMachineTypePreset on MachineTypePreset {
    cpus
    label
    memory
  }
`;
export const CreateTrackSandboxPresetsFragmentDoc = gql`
  fragment CreateTrackSandboxPresets on TrackConfigPresets {
    containers {
      ...ContainerFormContainerPreset
    }
    googlecloudmachinetypes {
      ...VirtualMachineFormGoogleCloudMachineTypePreset
    }
    virtualmachines {
      ...VirtualMachineFormVirtualMachinePreset
    }
    machinetypes {
      ...VirtualMachineFormMachineTypePreset
    }
  }
  ${ContainerFormContainerPresetFragmentDoc}
  ${VirtualMachineFormGoogleCloudMachineTypePresetFragmentDoc}
  ${VirtualMachineFormVirtualMachinePresetFragmentDoc}
  ${VirtualMachineFormMachineTypePresetFragmentDoc}
`;
export const FormConfigurationFragmentFragmentDoc = gql`
  fragment FormConfigurationFragment on Form {
    id
    formTitle
    consentNotice
    fields {
      id
      fieldName
      isRequired
    }
  }
`;
export const HotStartFormTrackFragmentDoc = gql`
  fragment HotStartFormTrack on Track {
    id
    title
    permalink
    maintenance
  }
`;
export const HotStartSandboxPresetFragmentDoc = gql`
  fragment HotStartSandboxPreset on SandboxConfigVersion {
    id
    config {
      id
      name
      slug
    }
    version
    published_at
  }
`;
export const HotStartPagePoolFragmentDoc = gql`
  fragment HotStartPagePool on HotStartPool {
    id
    type
    name
    created
    status
    starts_at
    ends_at
  }
`;
export const InviteFormTrackInviteFragmentDoc = gql`
  fragment InviteFormTrackInvite on TrackInvite {
    id
    type
    publicTitle
    publicDescription
    title
    inviteLimit
    playLimit
    playTTL
    allowedEmailAddresses
    allowAnonymous
    expiresAt
    startsAt
    enableLearnerSharing
    tracks {
      id
    }
  }
`;
export const InviteFormTrackFragmentDoc = gql`
  fragment InviteFormTrack on Track {
    id
    published
    title
    maintenance
    slug
  }
`;
export const InviteFormTeamFragmentDoc = gql`
  fragment InviteFormTeam on Team {
    id
    form {
      id
      fields {
        id
        fieldName
        isRequired
      }
    }
  }
`;
export const AwsAccountFormAwsAccountFragmentDoc = gql`
  fragment AwsAccountFormAwsAccount on AwsAccountConfig {
    id
    name
    iam_policy
    managed_policies
    scp_policy
  }
`;
export const AzureSubscriptionFormAzureSubscriptionFragmentDoc = gql`
  fragment AzureSubscriptionFormAzureSubscription on AzureSubscriptionConfig {
    id
    name
    user_only
    roles
  }
`;
export const GoogleCloudFormGcpProjectFragmentDoc = gql`
  fragment GoogleCloudFormGcpProject on GcpProjectConfig {
    id
    name
    services
    roles
  }
`;
export const ManageTrackCloudAccsResourcesFragmentDoc = gql`
  fragment ManageTrackCloudAccsResources on TrackConfig {
    aws_accounts {
      ...AwsAccountFormAwsAccount
    }
    azure_subscriptions {
      ...AzureSubscriptionFormAzureSubscription
    }
    gcp_projects {
      ...GoogleCloudFormGcpProject
    }
  }
  ${AwsAccountFormAwsAccountFragmentDoc}
  ${AzureSubscriptionFormAzureSubscriptionFragmentDoc}
  ${GoogleCloudFormGcpProjectFragmentDoc}
`;
export const ContainerFormContainerFragmentDoc = gql`
  fragment ContainerFormContainer on ContainerConfig {
    id
    name
    image
    entrypoint
    cmd
    ports
    shell
    environment {
      key
      value
    }
    memory
  }
`;
export const VirtualMachineFormVirtualMachineFragmentDoc = gql`
  fragment VirtualMachineFormVirtualMachine on VirtualMachineConfig {
    id
    name
    image
    machine_type
    allow_external_ingress
    shell
    environment {
      key
      value
    }
    memory
    cpus
    nested_virtualization
  }
`;
export const VirtualBrowserFormVirtualBrowserFragmentDoc = gql`
  fragment VirtualBrowserFormVirtualBrowser on VirtualBrowserConfig {
    id
    name
    url
  }
`;
export const ManageTrackHostResourcesFragmentDoc = gql`
  fragment ManageTrackHostResources on TrackConfig {
    containers {
      ...ContainerFormContainer
    }
    virtualmachines {
      ...VirtualMachineFormVirtualMachine
    }
    virtualbrowsers {
      ...VirtualBrowserFormVirtualBrowser
    }
  }
  ${ContainerFormContainerFragmentDoc}
  ${VirtualMachineFormVirtualMachineFragmentDoc}
  ${VirtualBrowserFormVirtualBrowserFragmentDoc}
`;
export const SandboxPresetListCardFragmentDoc = gql`
  fragment SandboxPresetListCard on SandboxConfigVersion {
    id
    config {
      id
      name
      slug
    }
    description
    published_at
    published_by {
      profile {
        avatar
        display_name
      }
    }
    status
    version
  }
`;
export const SelectPresetSandboxConfigVersionFragmentDoc = gql`
  fragment SelectPresetSandboxConfigVersion on SandboxConfigVersion {
    ...SandboxPresetListCard
  }
  ${SandboxPresetListCardFragmentDoc}
`;
export const ManageHostResourcesFragmentDoc = gql`
  fragment ManageHostResources on SandboxResources {
    containers {
      ...ContainerFormContainer
    }
    virtualmachines {
      ...VirtualMachineFormVirtualMachine
    }
    virtualbrowsers {
      ...VirtualBrowserFormVirtualBrowser
    }
  }
  ${ContainerFormContainerFragmentDoc}
  ${VirtualMachineFormVirtualMachineFragmentDoc}
  ${VirtualBrowserFormVirtualBrowserFragmentDoc}
`;
export const ManageCloudAccsResourcesFragmentDoc = gql`
  fragment ManageCloudAccsResources on SandboxResources {
    aws_accounts {
      ...AwsAccountFormAwsAccount
    }
    azure_subscriptions {
      ...AzureSubscriptionFormAzureSubscription
    }
    gcp_projects {
      ...GoogleCloudFormGcpProject
    }
  }
  ${AwsAccountFormAwsAccountFragmentDoc}
  ${AzureSubscriptionFormAzureSubscriptionFragmentDoc}
  ${GoogleCloudFormGcpProjectFragmentDoc}
`;
export const SandboxConfigSecretFragmentDoc = gql`
  fragment SandboxConfigSecret on SecretConfig {
    id
    name
  }
`;
export const ManageNewTrackSandboxConfigVersionFragmentDoc = gql`
  fragment ManageNewTrackSandboxConfigVersion on SandboxConfigVersion {
    ...SelectPresetSandboxConfigVersion
    resources {
      ...ManageHostResources
      ...ManageCloudAccsResources
      secrets {
        ...SandboxConfigSecret
      }
    }
    scripts {
      action
      contents
      host
    }
  }
  ${SelectPresetSandboxConfigVersionFragmentDoc}
  ${ManageHostResourcesFragmentDoc}
  ${ManageCloudAccsResourcesFragmentDoc}
  ${SandboxConfigSecretFragmentDoc}
`;
export const ManageSandboxPresetVersionFragmentDoc = gql`
  fragment ManageSandboxPresetVersion on SandboxConfigVersion {
    id
    config {
      id
      name
      slug
    }
    description
    status
    resources {
      ...ManageHostResources
      ...ManageCloudAccsResources
      secrets {
        ...SandboxConfigSecret
      }
    }
    scripts {
      host
      action
      contents
    }
  }
  ${ManageHostResourcesFragmentDoc}
  ${ManageCloudAccsResourcesFragmentDoc}
  ${SandboxConfigSecretFragmentDoc}
`;
export const ManageTrackSandboxConfigVersionFragmentDoc = gql`
  fragment ManageTrackSandboxConfigVersion on SandboxConfigVersion {
    ...SelectPresetSandboxConfigVersion
  }
  ${SelectPresetSandboxConfigVersionFragmentDoc}
`;
export const PlayActivityLogActivityFragmentDoc = gql`
  fragment PlayActivityLogActivity on PlayActivity {
    message
    time
    challenge {
      slug
    }
  }
`;
export const PlayActivityDrawerPlayReportItemFragmentDoc = gql`
  fragment PlayActivityDrawerPlayReportItem on PlayReportItem {
    id
    mode
    customParameters {
      key
      value
    }
    track {
      id
      title
      slug
    }
    trackInvite {
      id
      publicTitle
    }
    user {
      id
      details(teamSlug: $teamSlug) {
        firstName
        lastName
        email
        companyName
      }
      profile {
        display_name
        email
      }
    }
    activity {
      ...PlayActivityLogActivity
    }
    playReview {
      id
      score
      content
    }
  }
  ${PlayActivityLogActivityFragmentDoc}
`;
export const PreviewResourceSandboxResourcesFragmentDoc = gql`
  fragment PreviewResourceSandboxResources on SandboxResources {
    containers {
      ...ContainerFormContainer
    }
    virtualmachines {
      ...VirtualMachineFormVirtualMachine
    }
    virtualbrowsers {
      ...VirtualBrowserFormVirtualBrowser
    }
    aws_accounts {
      ...AwsAccountFormAwsAccount
    }
    azure_subscriptions {
      ...AzureSubscriptionFormAzureSubscription
    }
    gcp_projects {
      ...GoogleCloudFormGcpProject
    }
  }
  ${ContainerFormContainerFragmentDoc}
  ${VirtualMachineFormVirtualMachineFragmentDoc}
  ${VirtualBrowserFormVirtualBrowserFragmentDoc}
  ${AwsAccountFormAwsAccountFragmentDoc}
  ${AzureSubscriptionFormAzureSubscriptionFragmentDoc}
  ${GoogleCloudFormGcpProjectFragmentDoc}
`;
export const SandboxPresetPreviewTrackFragmentDoc = gql`
  fragment SandboxPresetPreviewTrack on Track {
    id
    title
  }
`;
export const SandboxPresetPreviewHotStartPoolFragmentDoc = gql`
  fragment SandboxPresetPreviewHotStartPool on HotStartPool {
    id
    name
  }
`;
export const PreviewSandboxPresetVersionFragmentDoc = gql`
  fragment PreviewSandboxPresetVersion on SandboxConfigVersion {
    ...SandboxPresetListCard
    change_log_entry
    resources {
      ...PreviewResourceSandboxResources
      secrets {
        name
      }
    }
    scripts {
      action
      contents
      host
    }
    tracks {
      ...SandboxPresetPreviewTrack
    }
    hot_start_pools {
      ...SandboxPresetPreviewHotStartPool
    }
  }
  ${SandboxPresetListCardFragmentDoc}
  ${PreviewResourceSandboxResourcesFragmentDoc}
  ${SandboxPresetPreviewTrackFragmentDoc}
  ${SandboxPresetPreviewHotStartPoolFragmentDoc}
`;
export const PreviewSandboxHistoryPresetVersionFragmentDoc = gql`
  fragment PreviewSandboxHistoryPresetVersion on SandboxConfigVersion {
    ...SandboxPresetListCard
    change_log_entry
  }
  ${SandboxPresetListCardFragmentDoc}
`;
export const ChallengeAttemptsChallengeStatisticsFragmentDoc = gql`
  fragment ChallengeAttemptsChallengeStatistics on ChallengeStatistics {
    title
    attempts_min
    attempts_avg
    attempts_max
  }
`;
export const ChallengeDurationChallengeStatisticsFragmentDoc = gql`
  fragment ChallengeDurationChallengeStatistics on ChallengeStatistics {
    title
    duration_min
    duration_avg
    duration_max
  }
`;
export const DailyTrackStartsChallengeSeriesFragmentDoc = gql`
  fragment DailyTrackStartsChallengeSeries on ChallengeSeries {
    date
    unlocked
    started
    completed
  }
`;
export const DailyTrackStartsTrackSeriesFragmentDoc = gql`
  fragment DailyTrackStartsTrackSeries on TrackSeries {
    date
    started
    completed
  }
`;
export const TotalChallengeStartsChallengeStatisticsFragmentDoc = gql`
  fragment TotalChallengeStartsChallengeStatistics on ChallengeStatistics {
    title
    started_total
    completed_total
    attempts_total
  }
`;
export const TotalTrackStartsTrackStatisticsFragmentDoc = gql`
  fragment TotalTrackStartsTrackStatistics on TrackStatistics {
    started_total
    completed_total
  }
`;
export const UserHappinessHappinessCountFragmentDoc = gql`
  fragment UserHappinessHappinessCount on HappinessCount {
    score
    count
  }
`;
export const TrackDetailsFormDataFragmentDoc = gql`
  fragment TrackDetailsFormData on Track {
    id
    slug
    owner
    title
    timelimit
    description
    tags
    idle_timeout
    maintenance
    show_timer
    skipping_enabled
    can_skip
    lab_config {
      width
      position
      overlay
      extendTTL
    }
  }
`;
export const TrackInviteDetailsTrackInviteFragmentDoc = gql`
  fragment TrackInviteDetailsTrackInvite on TrackInvite {
    id
    title
    publicTitle
    publicDescription
    inviteLimit
    inviteCount
    startsAt
    expiresAt
    playLimit
    playTTL
    allowAnonymous
    allowedEmailAddressesOnly
    status
    type
    enableLearnerSharing
    canClaim
    tracks {
      id
      title
      permalink
    }
    team {
      name
    }
  }
`;
export const TrackLimitsTableTrackFragmentDoc = gql`
  fragment TrackLimitsTableTrack on Track {
    id
    title
    slug
    maintenance
    play_count
  }
`;
export const TrackLimitsTableTrackLimitsFragmentDoc = gql`
  fragment TrackLimitsTableTrackLimits on TrackPlayLimit {
    track {
      id
    }
    rollingMonth
    rollingIPAddressPerHour
    calendarMonth
  }
`;
export const NotesListChallengeFragmentDoc = gql`
  fragment NotesListChallenge on Challenge {
    id
    assignment
    teaser
    title
    type
    notes {
      id
      index
      type
      contents
      url
    }
    tabs {
      id
      type
      title
      target
      path
      url
      index
      new_window
    }
  }
`;
export const ChallengeScriptFragmentDoc = gql`
  fragment ChallengeScript on ChallengeScript {
    id
    host
    action
    contents
  }
`;
export const TabsListChallengeFragmentDoc = gql`
  fragment TabsListChallenge on Challenge {
    id
    assignment
    teaser
    title
    type
    notes {
      id
      index
      type
      contents
      url
    }
    tabs {
      id
      type
      title
      target
      path
      url
      index
      new_window
    }
  }
`;
export const TabsListChallengeTabFragmentDoc = gql`
  fragment TabsListChallengeTab on ChallengeTab {
    id
    index
    target
    title
    type
    url
    hostname
    path
    port
    new_window
    workdir
    cmd
  }
`;
export const HotStartPoolExistingPoolFragmentDoc = gql`
  fragment HotStartPoolExistingPool on HotStartPool {
    id
    type
    size
    name
    starts_at
    ends_at
    status
    region
    tracks {
      node {
        id
      }
    }
    configs {
      node {
        id
      }
    }
  }
`;
export const HotStartInviteFragmentDoc = gql`
  fragment HotStartInvite on TrackInvite {
    expiresAt
    publicTitle
    status
    startsAt
    tracks {
      id
    }
  }
`;
export const TrackScriptDataFragmentDoc = gql`
  fragment TrackScriptData on TrackScript {
    id
    host
    action
    contents
  }
`;
export const DashboardStatisticsFragmentDoc = gql`
  fragment DashboardStatistics on TrackStatistics {
    started_total
    completed_total
    happiness {
      score
      count
    }
  }
`;
export const DashboardChallengeFragmentDoc = gql`
  fragment DashboardChallenge on Challenge {
    id
    permalink
    slug
    title
    index
    type
    timelimit
    teaser
  }
`;
export const DashboardDeveloperFragmentDoc = gql`
  fragment DashboardDeveloper on User {
    id
    profile {
      slug
      avatar
      display_name
      email
    }
  }
`;
export const DashboardTrackFragmentDoc = gql`
  fragment DashboardTrack on Track {
    id
    permalink
    slug
    owner
    icon
    title
    timelimit
    description
    tags
    idle_timeout
    completed
    maintenance
    show_timer
    skipping_enabled
    can_skip
    createdAt
    last_update
    lab_config {
      width
      position
      overlay
      extendTTL
    }
    challenges {
      ...DashboardChallenge
    }
    developers {
      ...DashboardDeveloper
    }
  }
  ${DashboardChallengeFragmentDoc}
  ${DashboardDeveloperFragmentDoc}
`;
export const DownloadTrackInviteCsvTrackInviteFragmentDoc = gql`
  fragment DownloadTrackInviteCsvTrackInvite on TrackInvite {
    id
    publicTitle
    team {
      id
      slug
      form {
        id
        fields {
          id
          fieldName
        }
      }
    }
    plays {
      last_activity
      time_spent
      track_started_at
      track_completed_at
      completed_challenges
      total_challenges
      failed_challenge_attempts
      track {
        id
        slug
      }
      participant {
        id
      }
      user {
        id
        is_anonymous
        profile {
          email
          display_name
        }
      }
    }
  }
`;
export const ChallengeTabFormTabFragmentDoc = gql`
  fragment ChallengeTabFormTab on ChallengeTab {
    title
    type
    hostname
    url
    port
    path
    workdir
    cmd
    new_window
  }
`;
export const UpdateChallengeTabChallengeTabFragmentDoc = gql`
  fragment UpdateChallengeTabChallengeTab on ChallengeTab {
    id
    index
    target
    ...ChallengeTabFormTab
  }
  ${ChallengeTabFormTabFragmentDoc}
`;
export const ChallengeFormChallengeFragmentDoc = gql`
  fragment ChallengeFormChallenge on Challenge {
    title
    slug
    type
    assignment
    teaser
    timelimit
    answers
    solution
  }
`;
export const UpdateChallengePageChallengeFragmentDoc = gql`
  fragment UpdateChallengePageChallenge on Challenge {
    id
    index
    difficulty
    ...ChallengeFormChallenge
  }
  ${ChallengeFormChallengeFragmentDoc}
`;
export const UpdateChallengeScriptsFragmentDoc = gql`
  fragment UpdateChallengeScripts on Challenge {
    id
    title
    scripts {
      action
      contents
      host
      id
    }
  }
`;
export const UpdateTrackScriptsFragmentDoc = gql`
  fragment UpdateTrackScripts on Track {
    id
    scripts {
      action
      contents
      host
      id
    }
    sandboxConfig {
      resources {
        containers {
          id
          name
        }
        virtualmachines {
          id
          name
        }
        virtualbrowsers {
          id
          name
        }
      }
    }
    challenges {
      ...UpdateChallengeScripts
    }
  }
  ${UpdateChallengeScriptsFragmentDoc}
`;
export const UpdateChallengeScriptResultFragmentDoc = gql`
  fragment UpdateChallengeScriptResult on ChallengeScript {
    id
    host
    action
    contents
  }
`;
export const UpdateTrackScriptResultFragmentDoc = gql`
  fragment UpdateTrackScriptResult on TrackScript {
    id
    host
    action
    contents
  }
`;
export const AttemptsChallengeAttemptFragmentDoc = gql`
  fragment AttemptsChallengeAttempt on ChallengeAttempt {
    message
  }
`;
export const TabContentChallengeChallengeTabFragmentDoc = gql`
  fragment TabContentChallengeChallengeTab on ChallengeTab {
    id
    type
    target
    path
    new_window
  }
`;
export const TabContentChallengeTabFragmentDoc = gql`
  fragment TabContentChallengeTab on ChallengeTab {
    id
    ...TabContentChallengeChallengeTab
  }
  ${TabContentChallengeChallengeTabFragmentDoc}
`;
export const WorkspaceChallengeFragmentDoc = gql`
  fragment WorkspaceChallenge on Challenge {
    type
    answers
    attempts {
      timestamp
      ...AttemptsChallengeAttempt
    }
    tabs {
      id
      index
      type
      title
      target
      new_window
      ...TabContentChallengeTab
    }
  }
  ${AttemptsChallengeAttemptFragmentDoc}
  ${TabContentChallengeTabFragmentDoc}
`;
export const ExpiredScreenTrackFragmentDoc = gql`
  fragment ExpiredScreenTrack on Track {
    slug
    permalink
    challenges {
      permalink
    }
  }
`;
export const ProgressModalChallengeFragmentDoc = gql`
  fragment ProgressModalChallenge on Challenge {
    id
    status
    slug
    title
    permalink
    failed
    type
    index
  }
`;
export const ProgressChallengeFragmentDoc = gql`
  fragment ProgressChallenge on Challenge {
    id
    status
    ...ProgressModalChallenge
  }
  ${ProgressModalChallengeFragmentDoc}
`;
export const ProgressModalTrackFragmentDoc = gql`
  fragment ProgressModalTrack on Track {
    id
    slug
    status
    median_starttime
  }
`;
export const ProgressTrackFragmentDoc = gql`
  fragment ProgressTrack on Track {
    ...ProgressModalTrack
  }
  ${ProgressModalTrackFragmentDoc}
`;
export const IsSkippingEnabledQueryFragmentDoc = gql`
  fragment IsSkippingEnabledQuery on Query {
    userInTeam(teamSlug: $teamSlug)
    userIsTrackDeveloper(trackSlug: $trackSlug, teamSlug: $teamSlug)
    team(teamSlug: $teamSlug) {
      features {
        members_skip_to_challenge
      }
    }
    skippingEnabledTrack: track(trackSlug: $trackSlug, teamSlug: $teamSlug) {
      skipping_enabled
      can_skip
    }
  }
`;
export const ArcadeIdleTimerStopTrackDocument = gql`
  mutation ArcadeIdleTimerStopTrack($trackID: String!) {
    stopTrack(trackID: $trackID) {
      id
      started
      creating
      created
      failed
      stopped
      completed
      cleaned
      published
    }
  }
`;
export type ArcadeIdleTimerStopTrackMutationFn = Apollo.MutationFunction<
  ArcadeIdleTimerStopTrackMutation,
  ArcadeIdleTimerStopTrackMutationVariables
>;

/**
 * __useArcadeIdleTimerStopTrackMutation__
 *
 * To run a mutation, you first call `useArcadeIdleTimerStopTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArcadeIdleTimerStopTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [arcadeIdleTimerStopTrackMutation, { data, loading, error }] = useArcadeIdleTimerStopTrackMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useArcadeIdleTimerStopTrackMutation(
  baseOptions?: Apollo.MutationHookOptions<ArcadeIdleTimerStopTrackMutation, ArcadeIdleTimerStopTrackMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ArcadeIdleTimerStopTrackMutation, ArcadeIdleTimerStopTrackMutationVariables>(
    ArcadeIdleTimerStopTrackDocument,
    options,
  );
}
export type ArcadeIdleTimerStopTrackMutationHookResult = ReturnType<typeof useArcadeIdleTimerStopTrackMutation>;
export type ArcadeIdleTimerStopTrackMutationResult = Apollo.MutationResult<ArcadeIdleTimerStopTrackMutation>;
export type ArcadeIdleTimerStopTrackMutationOptions = Apollo.BaseMutationOptions<
  ArcadeIdleTimerStopTrackMutation,
  ArcadeIdleTimerStopTrackMutationVariables
>;
export const ArcadeAssignmentDocument = gql`
  query ArcadeAssignment($trackID: String!, $challengeID: String!, $teamSlug: String!) {
    team(teamSlug: $teamSlug) {
      id
      features {
        use_new_terminal
      }
    }
    track(trackID: $trackID) {
      id
      status
    }
    challenge(challengeID: $challengeID) {
      id
      status
      timelimit
      started
      assignment
      tabs {
        type
        title
        target
        path
        url
        index
      }
      attempts {
        timestamp
        message
      }
      notes {
        type
        contents
      }
    }
  }
`;

/**
 * __useArcadeAssignmentQuery__
 *
 * To run a query within a React component, call `useArcadeAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useArcadeAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArcadeAssignmentQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      challengeID: // value for 'challengeID'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useArcadeAssignmentQuery(
  baseOptions: Apollo.QueryHookOptions<ArcadeAssignmentQuery, ArcadeAssignmentQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ArcadeAssignmentQuery, ArcadeAssignmentQueryVariables>(ArcadeAssignmentDocument, options);
}
export function useArcadeAssignmentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ArcadeAssignmentQuery, ArcadeAssignmentQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ArcadeAssignmentQuery, ArcadeAssignmentQueryVariables>(ArcadeAssignmentDocument, options);
}
export type ArcadeAssignmentQueryHookResult = ReturnType<typeof useArcadeAssignmentQuery>;
export type ArcadeAssignmentLazyQueryHookResult = ReturnType<typeof useArcadeAssignmentLazyQuery>;
export type ArcadeAssignmentQueryResult = Apollo.QueryResult<ArcadeAssignmentQuery, ArcadeAssignmentQueryVariables>;
export const ArcadeChallengeCheckDocument = gql`
  mutation ArcadeChallengeCheck($playerID: String!, $challengeID: String!) {
    checkArcadeChallenge(playerID: $playerID, challengeID: $challengeID) {
      id
      status
      started
      completed
      attempts {
        timestamp
        message
      }
      unlocks {
        id
      }
    }
  }
`;
export type ArcadeChallengeCheckMutationFn = Apollo.MutationFunction<
  ArcadeChallengeCheckMutation,
  ArcadeChallengeCheckMutationVariables
>;

/**
 * __useArcadeChallengeCheckMutation__
 *
 * To run a mutation, you first call `useArcadeChallengeCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArcadeChallengeCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [arcadeChallengeCheckMutation, { data, loading, error }] = useArcadeChallengeCheckMutation({
 *   variables: {
 *      playerID: // value for 'playerID'
 *      challengeID: // value for 'challengeID'
 *   },
 * });
 */
export function useArcadeChallengeCheckMutation(
  baseOptions?: Apollo.MutationHookOptions<ArcadeChallengeCheckMutation, ArcadeChallengeCheckMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ArcadeChallengeCheckMutation, ArcadeChallengeCheckMutationVariables>(
    ArcadeChallengeCheckDocument,
    options,
  );
}
export type ArcadeChallengeCheckMutationHookResult = ReturnType<typeof useArcadeChallengeCheckMutation>;
export type ArcadeChallengeCheckMutationResult = Apollo.MutationResult<ArcadeChallengeCheckMutation>;
export type ArcadeChallengeCheckMutationOptions = Apollo.BaseMutationOptions<
  ArcadeChallengeCheckMutation,
  ArcadeChallengeCheckMutationVariables
>;
export const ArcadeChallengeDocument = gql`
  query ArcadeChallenge($trackID: String!, $challengeID: String!) {
    track(trackID: $trackID) {
      id
      challenges {
        id
      }
    }
    challenge(challengeID: $challengeID) {
      id
      index
      title
      started
      timelimit
      assignment
      tabs {
        type
        title
        target
      }
      notes {
        type
        contents
        url
      }
    }
  }
`;

/**
 * __useArcadeChallengeQuery__
 *
 * To run a query within a React component, call `useArcadeChallengeQuery` and pass it any options that fit your needs.
 * When your component renders, `useArcadeChallengeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArcadeChallengeQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      challengeID: // value for 'challengeID'
 *   },
 * });
 */
export function useArcadeChallengeQuery(
  baseOptions: Apollo.QueryHookOptions<ArcadeChallengeQuery, ArcadeChallengeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ArcadeChallengeQuery, ArcadeChallengeQueryVariables>(ArcadeChallengeDocument, options);
}
export function useArcadeChallengeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ArcadeChallengeQuery, ArcadeChallengeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ArcadeChallengeQuery, ArcadeChallengeQueryVariables>(ArcadeChallengeDocument, options);
}
export type ArcadeChallengeQueryHookResult = ReturnType<typeof useArcadeChallengeQuery>;
export type ArcadeChallengeLazyQueryHookResult = ReturnType<typeof useArcadeChallengeLazyQuery>;
export type ArcadeChallengeQueryResult = Apollo.QueryResult<ArcadeChallengeQuery, ArcadeChallengeQueryVariables>;
export const ArcadeStartStatusDocument = gql`
  query ArcadeStartStatus($trackID: String!, $challengeID: String!) {
    track(trackID: $trackID) {
      id
      status
    }
    challenge(challengeID: $challengeID) {
      id
      status
    }
  }
`;

/**
 * __useArcadeStartStatusQuery__
 *
 * To run a query within a React component, call `useArcadeStartStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useArcadeStartStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArcadeStartStatusQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      challengeID: // value for 'challengeID'
 *   },
 * });
 */
export function useArcadeStartStatusQuery(
  baseOptions: Apollo.QueryHookOptions<ArcadeStartStatusQuery, ArcadeStartStatusQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ArcadeStartStatusQuery, ArcadeStartStatusQueryVariables>(ArcadeStartStatusDocument, options);
}
export function useArcadeStartStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ArcadeStartStatusQuery, ArcadeStartStatusQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ArcadeStartStatusQuery, ArcadeStartStatusQueryVariables>(
    ArcadeStartStatusDocument,
    options,
  );
}
export type ArcadeStartStatusQueryHookResult = ReturnType<typeof useArcadeStartStatusQuery>;
export type ArcadeStartStatusLazyQueryHookResult = ReturnType<typeof useArcadeStartStatusLazyQuery>;
export type ArcadeStartStatusQueryResult = Apollo.QueryResult<ArcadeStartStatusQuery, ArcadeStartStatusQueryVariables>;
export const ArcadeChallengeStartDocument = gql`
  mutation ArcadeChallengeStart($challengeID: String!) {
    startChallenge(challengeID: $challengeID) {
      id
      status
      started
      timelimit
    }
  }
`;
export type ArcadeChallengeStartMutationFn = Apollo.MutationFunction<
  ArcadeChallengeStartMutation,
  ArcadeChallengeStartMutationVariables
>;

/**
 * __useArcadeChallengeStartMutation__
 *
 * To run a mutation, you first call `useArcadeChallengeStartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArcadeChallengeStartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [arcadeChallengeStartMutation, { data, loading, error }] = useArcadeChallengeStartMutation({
 *   variables: {
 *      challengeID: // value for 'challengeID'
 *   },
 * });
 */
export function useArcadeChallengeStartMutation(
  baseOptions?: Apollo.MutationHookOptions<ArcadeChallengeStartMutation, ArcadeChallengeStartMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ArcadeChallengeStartMutation, ArcadeChallengeStartMutationVariables>(
    ArcadeChallengeStartDocument,
    options,
  );
}
export type ArcadeChallengeStartMutationHookResult = ReturnType<typeof useArcadeChallengeStartMutation>;
export type ArcadeChallengeStartMutationResult = Apollo.MutationResult<ArcadeChallengeStartMutation>;
export type ArcadeChallengeStartMutationOptions = Apollo.BaseMutationOptions<
  ArcadeChallengeStartMutation,
  ArcadeChallengeStartMutationVariables
>;
export const ArcadeChallengeSetupDocument = gql`
  mutation ArcadeChallengeSetup($challengeID: String!) {
    setupChallenge(challengeID: $challengeID) {
      id
      status
    }
  }
`;
export type ArcadeChallengeSetupMutationFn = Apollo.MutationFunction<
  ArcadeChallengeSetupMutation,
  ArcadeChallengeSetupMutationVariables
>;

/**
 * __useArcadeChallengeSetupMutation__
 *
 * To run a mutation, you first call `useArcadeChallengeSetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArcadeChallengeSetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [arcadeChallengeSetupMutation, { data, loading, error }] = useArcadeChallengeSetupMutation({
 *   variables: {
 *      challengeID: // value for 'challengeID'
 *   },
 * });
 */
export function useArcadeChallengeSetupMutation(
  baseOptions?: Apollo.MutationHookOptions<ArcadeChallengeSetupMutation, ArcadeChallengeSetupMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ArcadeChallengeSetupMutation, ArcadeChallengeSetupMutationVariables>(
    ArcadeChallengeSetupDocument,
    options,
  );
}
export type ArcadeChallengeSetupMutationHookResult = ReturnType<typeof useArcadeChallengeSetupMutation>;
export type ArcadeChallengeSetupMutationResult = Apollo.MutationResult<ArcadeChallengeSetupMutation>;
export type ArcadeChallengeSetupMutationOptions = Apollo.BaseMutationOptions<
  ArcadeChallengeSetupMutation,
  ArcadeChallengeSetupMutationVariables
>;
export const ArcadeInputContainerDocument = gql`
  query ArcadeInputContainer($trackID: String!) {
    track(trackID: $trackID) {
      id
      status
    }
  }
`;

/**
 * __useArcadeInputContainerQuery__
 *
 * To run a query within a React component, call `useArcadeInputContainerQuery` and pass it any options that fit your needs.
 * When your component renders, `useArcadeInputContainerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArcadeInputContainerQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useArcadeInputContainerQuery(
  baseOptions: Apollo.QueryHookOptions<ArcadeInputContainerQuery, ArcadeInputContainerQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ArcadeInputContainerQuery, ArcadeInputContainerQueryVariables>(
    ArcadeInputContainerDocument,
    options,
  );
}
export function useArcadeInputContainerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ArcadeInputContainerQuery, ArcadeInputContainerQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ArcadeInputContainerQuery, ArcadeInputContainerQueryVariables>(
    ArcadeInputContainerDocument,
    options,
  );
}
export type ArcadeInputContainerQueryHookResult = ReturnType<typeof useArcadeInputContainerQuery>;
export type ArcadeInputContainerLazyQueryHookResult = ReturnType<typeof useArcadeInputContainerLazyQuery>;
export type ArcadeInputContainerQueryResult = Apollo.QueryResult<
  ArcadeInputContainerQuery,
  ArcadeInputContainerQueryVariables
>;
export const InputContainerRegisterScoreDocument = gql`
  mutation InputContainerRegisterScore(
    $playerID: String!
    $trackID: String!
    $handle: String!
    $difficulty: String!
    $teamSlug: String
  ) {
    registerScore(
      playerID: $playerID
      trackID: $trackID
      handle: $handle
      difficulty: $difficulty
      organizationSlug: $teamSlug
    ) {
      id
      player {
        id
        lives
      }
      track {
        id
        title
      }
      handle
      score
    }
  }
`;
export type InputContainerRegisterScoreMutationFn = Apollo.MutationFunction<
  InputContainerRegisterScoreMutation,
  InputContainerRegisterScoreMutationVariables
>;

/**
 * __useInputContainerRegisterScoreMutation__
 *
 * To run a mutation, you first call `useInputContainerRegisterScoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInputContainerRegisterScoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inputContainerRegisterScoreMutation, { data, loading, error }] = useInputContainerRegisterScoreMutation({
 *   variables: {
 *      playerID: // value for 'playerID'
 *      trackID: // value for 'trackID'
 *      handle: // value for 'handle'
 *      difficulty: // value for 'difficulty'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useInputContainerRegisterScoreMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InputContainerRegisterScoreMutation,
    InputContainerRegisterScoreMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<InputContainerRegisterScoreMutation, InputContainerRegisterScoreMutationVariables>(
    InputContainerRegisterScoreDocument,
    options,
  );
}
export type InputContainerRegisterScoreMutationHookResult = ReturnType<typeof useInputContainerRegisterScoreMutation>;
export type InputContainerRegisterScoreMutationResult = Apollo.MutationResult<InputContainerRegisterScoreMutation>;
export type InputContainerRegisterScoreMutationOptions = Apollo.BaseMutationOptions<
  InputContainerRegisterScoreMutation,
  InputContainerRegisterScoreMutationVariables
>;
export const InputContainerStopTrackDocument = gql`
  mutation InputContainerStopTrack($trackID: String!) {
    stopTrack(trackID: $trackID) {
      id
      started
      creating
      created
      failed
      stopped
      completed
      cleaned
      published
    }
  }
`;
export type InputContainerStopTrackMutationFn = Apollo.MutationFunction<
  InputContainerStopTrackMutation,
  InputContainerStopTrackMutationVariables
>;

/**
 * __useInputContainerStopTrackMutation__
 *
 * To run a mutation, you first call `useInputContainerStopTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInputContainerStopTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inputContainerStopTrackMutation, { data, loading, error }] = useInputContainerStopTrackMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useInputContainerStopTrackMutation(
  baseOptions?: Apollo.MutationHookOptions<InputContainerStopTrackMutation, InputContainerStopTrackMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<InputContainerStopTrackMutation, InputContainerStopTrackMutationVariables>(
    InputContainerStopTrackDocument,
    options,
  );
}
export type InputContainerStopTrackMutationHookResult = ReturnType<typeof useInputContainerStopTrackMutation>;
export type InputContainerStopTrackMutationResult = Apollo.MutationResult<InputContainerStopTrackMutation>;
export type InputContainerStopTrackMutationOptions = Apollo.BaseMutationOptions<
  InputContainerStopTrackMutation,
  InputContainerStopTrackMutationVariables
>;
export const ArcadeLeaderboardDocument = gql`
  query ArcadeLeaderboard($trackID: String!) {
    track(trackID: $trackID) {
      id
      title
      teaser
    }
    rankings(trackID: $trackID) {
      id
      difficulty
      handle
      score
    }
  }
`;

/**
 * __useArcadeLeaderboardQuery__
 *
 * To run a query within a React component, call `useArcadeLeaderboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useArcadeLeaderboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArcadeLeaderboardQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useArcadeLeaderboardQuery(
  baseOptions: Apollo.QueryHookOptions<ArcadeLeaderboardQuery, ArcadeLeaderboardQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ArcadeLeaderboardQuery, ArcadeLeaderboardQueryVariables>(ArcadeLeaderboardDocument, options);
}
export function useArcadeLeaderboardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ArcadeLeaderboardQuery, ArcadeLeaderboardQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ArcadeLeaderboardQuery, ArcadeLeaderboardQueryVariables>(
    ArcadeLeaderboardDocument,
    options,
  );
}
export type ArcadeLeaderboardQueryHookResult = ReturnType<typeof useArcadeLeaderboardQuery>;
export type ArcadeLeaderboardLazyQueryHookResult = ReturnType<typeof useArcadeLeaderboardLazyQuery>;
export type ArcadeLeaderboardQueryResult = Apollo.QueryResult<ArcadeLeaderboardQuery, ArcadeLeaderboardQueryVariables>;
export const ArcadeLeaderboardsDocument = gql`
  query ArcadeLeaderboards($teamSlug: String!) {
    arcadetracks(organizationSlug: $teamSlug) {
      id
      title
      teaser
    }
  }
`;

/**
 * __useArcadeLeaderboardsQuery__
 *
 * To run a query within a React component, call `useArcadeLeaderboardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArcadeLeaderboardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArcadeLeaderboardsQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useArcadeLeaderboardsQuery(
  baseOptions: Apollo.QueryHookOptions<ArcadeLeaderboardsQuery, ArcadeLeaderboardsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ArcadeLeaderboardsQuery, ArcadeLeaderboardsQueryVariables>(
    ArcadeLeaderboardsDocument,
    options,
  );
}
export function useArcadeLeaderboardsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ArcadeLeaderboardsQuery, ArcadeLeaderboardsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ArcadeLeaderboardsQuery, ArcadeLeaderboardsQueryVariables>(
    ArcadeLeaderboardsDocument,
    options,
  );
}
export type ArcadeLeaderboardsQueryHookResult = ReturnType<typeof useArcadeLeaderboardsQuery>;
export type ArcadeLeaderboardsLazyQueryHookResult = ReturnType<typeof useArcadeLeaderboardsLazyQuery>;
export type ArcadeLeaderboardsQueryResult = Apollo.QueryResult<
  ArcadeLeaderboardsQuery,
  ArcadeLeaderboardsQueryVariables
>;
export const ArcadeLeaderboardsRankingsDocument = gql`
  query ArcadeLeaderboardsRankings($trackID: String!) {
    rankings(trackID: $trackID) {
      id
      difficulty
      handle
      score
    }
  }
`;

/**
 * __useArcadeLeaderboardsRankingsQuery__
 *
 * To run a query within a React component, call `useArcadeLeaderboardsRankingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArcadeLeaderboardsRankingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArcadeLeaderboardsRankingsQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useArcadeLeaderboardsRankingsQuery(
  baseOptions: Apollo.QueryHookOptions<ArcadeLeaderboardsRankingsQuery, ArcadeLeaderboardsRankingsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ArcadeLeaderboardsRankingsQuery, ArcadeLeaderboardsRankingsQueryVariables>(
    ArcadeLeaderboardsRankingsDocument,
    options,
  );
}
export function useArcadeLeaderboardsRankingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ArcadeLeaderboardsRankingsQuery, ArcadeLeaderboardsRankingsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ArcadeLeaderboardsRankingsQuery, ArcadeLeaderboardsRankingsQueryVariables>(
    ArcadeLeaderboardsRankingsDocument,
    options,
  );
}
export type ArcadeLeaderboardsRankingsQueryHookResult = ReturnType<typeof useArcadeLeaderboardsRankingsQuery>;
export type ArcadeLeaderboardsRankingsLazyQueryHookResult = ReturnType<typeof useArcadeLeaderboardsRankingsLazyQuery>;
export type ArcadeLeaderboardsRankingsQueryResult = Apollo.QueryResult<
  ArcadeLeaderboardsRankingsQuery,
  ArcadeLeaderboardsRankingsQueryVariables
>;
export const ArcadeLoginDocument = gql`
  query ArcadeLogin($token: String!) {
    arcadeLogin(token: $token) {
      token
      alternative_url
      organization {
        id
        slug
      }
    }
  }
`;

/**
 * __useArcadeLoginQuery__
 *
 * To run a query within a React component, call `useArcadeLoginQuery` and pass it any options that fit your needs.
 * When your component renders, `useArcadeLoginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArcadeLoginQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useArcadeLoginQuery(baseOptions: Apollo.QueryHookOptions<ArcadeLoginQuery, ArcadeLoginQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ArcadeLoginQuery, ArcadeLoginQueryVariables>(ArcadeLoginDocument, options);
}
export function useArcadeLoginLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ArcadeLoginQuery, ArcadeLoginQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ArcadeLoginQuery, ArcadeLoginQueryVariables>(ArcadeLoginDocument, options);
}
export type ArcadeLoginQueryHookResult = ReturnType<typeof useArcadeLoginQuery>;
export type ArcadeLoginLazyQueryHookResult = ReturnType<typeof useArcadeLoginLazyQuery>;
export type ArcadeLoginQueryResult = Apollo.QueryResult<ArcadeLoginQuery, ArcadeLoginQueryVariables>;
export const ArcadeDifficultyCreatePlayerDocument = gql`
  mutation ArcadeDifficultyCreatePlayer($trackID: String!, $difficulty: String!) {
    createPlayer(trackID: $trackID, difficulty: $difficulty) {
      id
      lives
    }
  }
`;
export type ArcadeDifficultyCreatePlayerMutationFn = Apollo.MutationFunction<
  ArcadeDifficultyCreatePlayerMutation,
  ArcadeDifficultyCreatePlayerMutationVariables
>;

/**
 * __useArcadeDifficultyCreatePlayerMutation__
 *
 * To run a mutation, you first call `useArcadeDifficultyCreatePlayerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArcadeDifficultyCreatePlayerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [arcadeDifficultyCreatePlayerMutation, { data, loading, error }] = useArcadeDifficultyCreatePlayerMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      difficulty: // value for 'difficulty'
 *   },
 * });
 */
export function useArcadeDifficultyCreatePlayerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArcadeDifficultyCreatePlayerMutation,
    ArcadeDifficultyCreatePlayerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ArcadeDifficultyCreatePlayerMutation, ArcadeDifficultyCreatePlayerMutationVariables>(
    ArcadeDifficultyCreatePlayerDocument,
    options,
  );
}
export type ArcadeDifficultyCreatePlayerMutationHookResult = ReturnType<typeof useArcadeDifficultyCreatePlayerMutation>;
export type ArcadeDifficultyCreatePlayerMutationResult = Apollo.MutationResult<ArcadeDifficultyCreatePlayerMutation>;
export type ArcadeDifficultyCreatePlayerMutationOptions = Apollo.BaseMutationOptions<
  ArcadeDifficultyCreatePlayerMutation,
  ArcadeDifficultyCreatePlayerMutationVariables
>;
export const ArcadeTracksDocument = gql`
  query ArcadeTracks($teamSlug: String) {
    arcadetracks(organizationSlug: $teamSlug) {
      id
      slug
      title
      teaser
      icon
    }
  }
`;

/**
 * __useArcadeTracksQuery__
 *
 * To run a query within a React component, call `useArcadeTracksQuery` and pass it any options that fit your needs.
 * When your component renders, `useArcadeTracksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArcadeTracksQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useArcadeTracksQuery(
  baseOptions?: Apollo.QueryHookOptions<ArcadeTracksQuery, ArcadeTracksQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ArcadeTracksQuery, ArcadeTracksQueryVariables>(ArcadeTracksDocument, options);
}
export function useArcadeTracksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ArcadeTracksQuery, ArcadeTracksQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ArcadeTracksQuery, ArcadeTracksQueryVariables>(ArcadeTracksDocument, options);
}
export type ArcadeTracksQueryHookResult = ReturnType<typeof useArcadeTracksQuery>;
export type ArcadeTracksLazyQueryHookResult = ReturnType<typeof useArcadeTracksLazyQuery>;
export type ArcadeTracksQueryResult = Apollo.QueryResult<ArcadeTracksQuery, ArcadeTracksQueryVariables>;
export const ArcadeTracksStartTrackDocument = gql`
  mutation ArcadeTracksStartTrack($trackID: String!, $region: String) {
    startTrack(trackID: $trackID, region: $region, force: true) {
      id
      started
      creating
      created
      failed
      stopped
      completed
      cleaned
      published
      challenges {
        id
        title
        teaser
        status
      }
    }
  }
`;
export type ArcadeTracksStartTrackMutationFn = Apollo.MutationFunction<
  ArcadeTracksStartTrackMutation,
  ArcadeTracksStartTrackMutationVariables
>;

/**
 * __useArcadeTracksStartTrackMutation__
 *
 * To run a mutation, you first call `useArcadeTracksStartTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArcadeTracksStartTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [arcadeTracksStartTrackMutation, { data, loading, error }] = useArcadeTracksStartTrackMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      region: // value for 'region'
 *   },
 * });
 */
export function useArcadeTracksStartTrackMutation(
  baseOptions?: Apollo.MutationHookOptions<ArcadeTracksStartTrackMutation, ArcadeTracksStartTrackMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ArcadeTracksStartTrackMutation, ArcadeTracksStartTrackMutationVariables>(
    ArcadeTracksStartTrackDocument,
    options,
  );
}
export type ArcadeTracksStartTrackMutationHookResult = ReturnType<typeof useArcadeTracksStartTrackMutation>;
export type ArcadeTracksStartTrackMutationResult = Apollo.MutationResult<ArcadeTracksStartTrackMutation>;
export type ArcadeTracksStartTrackMutationOptions = Apollo.BaseMutationOptions<
  ArcadeTracksStartTrackMutation,
  ArcadeTracksStartTrackMutationVariables
>;
export const ArcadeTvLeaderboardsDocument = gql`
  query ArcadeTVLeaderboards($teamSlug: String!) {
    arcadetracks(organizationSlug: $teamSlug) {
      id
      title
      teaser
    }
    team(teamSlug: $teamSlug) {
      id
      name
    }
  }
`;

/**
 * __useArcadeTvLeaderboardsQuery__
 *
 * To run a query within a React component, call `useArcadeTvLeaderboardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArcadeTvLeaderboardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArcadeTvLeaderboardsQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useArcadeTvLeaderboardsQuery(
  baseOptions: Apollo.QueryHookOptions<ArcadeTvLeaderboardsQuery, ArcadeTvLeaderboardsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ArcadeTvLeaderboardsQuery, ArcadeTvLeaderboardsQueryVariables>(
    ArcadeTvLeaderboardsDocument,
    options,
  );
}
export function useArcadeTvLeaderboardsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ArcadeTvLeaderboardsQuery, ArcadeTvLeaderboardsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ArcadeTvLeaderboardsQuery, ArcadeTvLeaderboardsQueryVariables>(
    ArcadeTvLeaderboardsDocument,
    options,
  );
}
export type ArcadeTvLeaderboardsQueryHookResult = ReturnType<typeof useArcadeTvLeaderboardsQuery>;
export type ArcadeTvLeaderboardsLazyQueryHookResult = ReturnType<typeof useArcadeTvLeaderboardsLazyQuery>;
export type ArcadeTvLeaderboardsQueryResult = Apollo.QueryResult<
  ArcadeTvLeaderboardsQuery,
  ArcadeTvLeaderboardsQueryVariables
>;
export const ArcadeTvLeaderboardsRankingsDocument = gql`
  query ArcadeTVLeaderboardsRankings($trackID: String!) {
    rankings(trackID: $trackID) {
      id
      difficulty
      handle
      score
    }
  }
`;

/**
 * __useArcadeTvLeaderboardsRankingsQuery__
 *
 * To run a query within a React component, call `useArcadeTvLeaderboardsRankingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArcadeTvLeaderboardsRankingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArcadeTvLeaderboardsRankingsQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useArcadeTvLeaderboardsRankingsQuery(
  baseOptions: Apollo.QueryHookOptions<ArcadeTvLeaderboardsRankingsQuery, ArcadeTvLeaderboardsRankingsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ArcadeTvLeaderboardsRankingsQuery, ArcadeTvLeaderboardsRankingsQueryVariables>(
    ArcadeTvLeaderboardsRankingsDocument,
    options,
  );
}
export function useArcadeTvLeaderboardsRankingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ArcadeTvLeaderboardsRankingsQuery,
    ArcadeTvLeaderboardsRankingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ArcadeTvLeaderboardsRankingsQuery, ArcadeTvLeaderboardsRankingsQueryVariables>(
    ArcadeTvLeaderboardsRankingsDocument,
    options,
  );
}
export type ArcadeTvLeaderboardsRankingsQueryHookResult = ReturnType<typeof useArcadeTvLeaderboardsRankingsQuery>;
export type ArcadeTvLeaderboardsRankingsLazyQueryHookResult = ReturnType<
  typeof useArcadeTvLeaderboardsRankingsLazyQuery
>;
export type ArcadeTvLeaderboardsRankingsQueryResult = Apollo.QueryResult<
  ArcadeTvLeaderboardsRankingsQuery,
  ArcadeTvLeaderboardsRankingsQueryVariables
>;
export const GetActivityPageDocument = gql`
  query GetActivityPage($inviteID: ID!, $inviteIDLegacy: String!, $userID: ID!, $teamSlug: String!) {
    student(inviteID: $inviteID, userID: $userID) {
      activeSandboxesTotal
      inspectable
      user {
        ...StudentName
      }
    }
    trackInvite(inviteID: $inviteIDLegacy) {
      expiresAt
      publicDescription
      publicTitle
      startsAt
      status
      type
    }
    students(inviteID: $inviteID) {
      user {
        ...StudentName
      }
    }
  }
  ${StudentNameFragmentDoc}
`;

/**
 * __useGetActivityPageQuery__
 *
 * To run a query within a React component, call `useGetActivityPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityPageQuery({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *      inviteIDLegacy: // value for 'inviteIDLegacy'
 *      userID: // value for 'userID'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useGetActivityPageQuery(
  baseOptions: Apollo.QueryHookOptions<GetActivityPageQuery, GetActivityPageQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetActivityPageQuery, GetActivityPageQueryVariables>(GetActivityPageDocument, options);
}
export function useGetActivityPageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetActivityPageQuery, GetActivityPageQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetActivityPageQuery, GetActivityPageQueryVariables>(GetActivityPageDocument, options);
}
export type GetActivityPageQueryHookResult = ReturnType<typeof useGetActivityPageQuery>;
export type GetActivityPageLazyQueryHookResult = ReturnType<typeof useGetActivityPageLazyQuery>;
export type GetActivityPageQueryResult = Apollo.QueryResult<GetActivityPageQuery, GetActivityPageQueryVariables>;
export const GetActivityLogAndSandboxesDocument = gql`
  query GetActivityLogAndSandboxes(
    $teamSlug: String!
    $inviteID: String!
    $userID: String!
    $filter: SandboxFilterInput!
  ) {
    trackInviteClaim(inviteID: $inviteID, userID: $userID) {
      events {
        challenge {
          slug
        }
        message
        participantID
        time
        track {
          slug
        }
      }
      user {
        profile {
          display_name
        }
      }
    }
    sandboxes(teamSlug: $teamSlug, filter: $filter) {
      totalCount
      edges {
        node {
          ...Sandbox
        }
      }
    }
  }
  ${SandboxFragmentDoc}
`;

/**
 * __useGetActivityLogAndSandboxesQuery__
 *
 * To run a query within a React component, call `useGetActivityLogAndSandboxesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityLogAndSandboxesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityLogAndSandboxesQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      inviteID: // value for 'inviteID'
 *      userID: // value for 'userID'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetActivityLogAndSandboxesQuery(
  baseOptions: Apollo.QueryHookOptions<GetActivityLogAndSandboxesQuery, GetActivityLogAndSandboxesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetActivityLogAndSandboxesQuery, GetActivityLogAndSandboxesQueryVariables>(
    GetActivityLogAndSandboxesDocument,
    options,
  );
}
export function useGetActivityLogAndSandboxesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetActivityLogAndSandboxesQuery, GetActivityLogAndSandboxesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetActivityLogAndSandboxesQuery, GetActivityLogAndSandboxesQueryVariables>(
    GetActivityLogAndSandboxesDocument,
    options,
  );
}
export type GetActivityLogAndSandboxesQueryHookResult = ReturnType<typeof useGetActivityLogAndSandboxesQuery>;
export type GetActivityLogAndSandboxesLazyQueryHookResult = ReturnType<typeof useGetActivityLogAndSandboxesLazyQuery>;
export type GetActivityLogAndSandboxesQueryResult = Apollo.QueryResult<
  GetActivityLogAndSandboxesQuery,
  GetActivityLogAndSandboxesQueryVariables
>;
export const GetClassroomPageDocument = gql`
  query GetClassroomPage($inviteID: ID!, $inviteIDLegacy: String!, $teamSlug: String!) {
    team(teamSlug: $teamSlug) {
      id
      features {
        hot_start
      }
    }
    studentStatistics(inviteID: $inviteID) {
      inProgressTotal
      completedTotal
    }
    trackInvite(inviteID: $inviteIDLegacy) {
      id
      inviteLimit
      expiresAt
      publicDescription
      publicTitle
      startsAt
      tracks {
        icon
        id
        studentStatistics(inviteID: $inviteID) {
          inProgressTotal
          completedTotal
        }
        title
      }
      type
      status
    }
  }
`;

/**
 * __useGetClassroomPageQuery__
 *
 * To run a query within a React component, call `useGetClassroomPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassroomPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassroomPageQuery({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *      inviteIDLegacy: // value for 'inviteIDLegacy'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useGetClassroomPageQuery(
  baseOptions: Apollo.QueryHookOptions<GetClassroomPageQuery, GetClassroomPageQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetClassroomPageQuery, GetClassroomPageQueryVariables>(GetClassroomPageDocument, options);
}
export function useGetClassroomPageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetClassroomPageQuery, GetClassroomPageQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetClassroomPageQuery, GetClassroomPageQueryVariables>(GetClassroomPageDocument, options);
}
export type GetClassroomPageQueryHookResult = ReturnType<typeof useGetClassroomPageQuery>;
export type GetClassroomPageLazyQueryHookResult = ReturnType<typeof useGetClassroomPageLazyQuery>;
export type GetClassroomPageQueryResult = Apollo.QueryResult<GetClassroomPageQuery, GetClassroomPageQueryVariables>;
export const GetStudentsDocument = gql`
  query GetStudents($inviteID: ID!, $teamSlug: String!) {
    students(inviteID: $inviteID) {
      completed_at
      activeSandboxesTotal
      inspectable
      last_activity_at
      accessed_at
      challenge {
        index
        started
        title
      }
      claim {
        id
      }
      track {
        challenges {
          id
        }
        id
        title
      }
      user {
        ...StudentName
      }
    }
  }
  ${StudentNameFragmentDoc}
`;

/**
 * __useGetStudentsQuery__
 *
 * To run a query within a React component, call `useGetStudentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentsQuery({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useGetStudentsQuery(baseOptions: Apollo.QueryHookOptions<GetStudentsQuery, GetStudentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetStudentsQuery, GetStudentsQueryVariables>(GetStudentsDocument, options);
}
export function useGetStudentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetStudentsQuery, GetStudentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetStudentsQuery, GetStudentsQueryVariables>(GetStudentsDocument, options);
}
export type GetStudentsQueryHookResult = ReturnType<typeof useGetStudentsQuery>;
export type GetStudentsLazyQueryHookResult = ReturnType<typeof useGetStudentsLazyQuery>;
export type GetStudentsQueryResult = Apollo.QueryResult<GetStudentsQuery, GetStudentsQueryVariables>;
export const DeleteTrackInviteClaimDocument = gql`
  mutation deleteTrackInviteClaim($claimID: String!) {
    deleteTrackInviteClaim(claimID: $claimID)
  }
`;
export type DeleteTrackInviteClaimMutationFn = Apollo.MutationFunction<
  DeleteTrackInviteClaimMutation,
  DeleteTrackInviteClaimMutationVariables
>;

/**
 * __useDeleteTrackInviteClaimMutation__
 *
 * To run a mutation, you first call `useDeleteTrackInviteClaimMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTrackInviteClaimMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTrackInviteClaimMutation, { data, loading, error }] = useDeleteTrackInviteClaimMutation({
 *   variables: {
 *      claimID: // value for 'claimID'
 *   },
 * });
 */
export function useDeleteTrackInviteClaimMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteTrackInviteClaimMutation, DeleteTrackInviteClaimMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteTrackInviteClaimMutation, DeleteTrackInviteClaimMutationVariables>(
    DeleteTrackInviteClaimDocument,
    options,
  );
}
export type DeleteTrackInviteClaimMutationHookResult = ReturnType<typeof useDeleteTrackInviteClaimMutation>;
export type DeleteTrackInviteClaimMutationResult = Apollo.MutationResult<DeleteTrackInviteClaimMutation>;
export type DeleteTrackInviteClaimMutationOptions = Apollo.BaseMutationOptions<
  DeleteTrackInviteClaimMutation,
  DeleteTrackInviteClaimMutationVariables
>;
export const GetInspectStudentPageDocument = gql`
  query GetInspectStudentPage($inviteID: ID!, $userID: ID!, $teamSlug: String!) {
    student(inviteID: $inviteID, userID: $userID) {
      inspectable
      last_activity_at
      challenge {
        index
        permalink
      }
      user {
        ...StudentName
      }
    }
    students(inviteID: $inviteID) {
      user {
        ...StudentName
      }
    }
  }
  ${StudentNameFragmentDoc}
`;

/**
 * __useGetInspectStudentPageQuery__
 *
 * To run a query within a React component, call `useGetInspectStudentPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInspectStudentPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInspectStudentPageQuery({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *      userID: // value for 'userID'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useGetInspectStudentPageQuery(
  baseOptions: Apollo.QueryHookOptions<GetInspectStudentPageQuery, GetInspectStudentPageQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetInspectStudentPageQuery, GetInspectStudentPageQueryVariables>(
    GetInspectStudentPageDocument,
    options,
  );
}
export function useGetInspectStudentPageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetInspectStudentPageQuery, GetInspectStudentPageQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetInspectStudentPageQuery, GetInspectStudentPageQueryVariables>(
    GetInspectStudentPageDocument,
    options,
  );
}
export type GetInspectStudentPageQueryHookResult = ReturnType<typeof useGetInspectStudentPageQuery>;
export type GetInspectStudentPageLazyQueryHookResult = ReturnType<typeof useGetInspectStudentPageLazyQuery>;
export type GetInspectStudentPageQueryResult = Apollo.QueryResult<
  GetInspectStudentPageQuery,
  GetInspectStudentPageQueryVariables
>;
export const CreateInstruqtUserDocument = gql`
  mutation CreateInstruqtUser($inviteToken: String) {
    login(inviteToken: $inviteToken) {
      ...AuthenticationUser
    }
  }
  ${AuthenticationUserFragmentDoc}
`;
export type CreateInstruqtUserMutationFn = Apollo.MutationFunction<
  CreateInstruqtUserMutation,
  CreateInstruqtUserMutationVariables
>;

/**
 * __useCreateInstruqtUserMutation__
 *
 * To run a mutation, you first call `useCreateInstruqtUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInstruqtUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInstruqtUserMutation, { data, loading, error }] = useCreateInstruqtUserMutation({
 *   variables: {
 *      inviteToken: // value for 'inviteToken'
 *   },
 * });
 */
export function useCreateInstruqtUserMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateInstruqtUserMutation, CreateInstruqtUserMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateInstruqtUserMutation, CreateInstruqtUserMutationVariables>(
    CreateInstruqtUserDocument,
    options,
  );
}
export type CreateInstruqtUserMutationHookResult = ReturnType<typeof useCreateInstruqtUserMutation>;
export type CreateInstruqtUserMutationResult = Apollo.MutationResult<CreateInstruqtUserMutation>;
export type CreateInstruqtUserMutationOptions = Apollo.BaseMutationOptions<
  CreateInstruqtUserMutation,
  CreateInstruqtUserMutationVariables
>;
export const GetInstruqtUserDocument = gql`
  query GetInstruqtUser {
    me {
      ...AuthenticationUser
    }
  }
  ${AuthenticationUserFragmentDoc}
`;

/**
 * __useGetInstruqtUserQuery__
 *
 * To run a query within a React component, call `useGetInstruqtUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstruqtUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstruqtUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInstruqtUserQuery(
  baseOptions?: Apollo.QueryHookOptions<GetInstruqtUserQuery, GetInstruqtUserQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetInstruqtUserQuery, GetInstruqtUserQueryVariables>(GetInstruqtUserDocument, options);
}
export function useGetInstruqtUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetInstruqtUserQuery, GetInstruqtUserQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetInstruqtUserQuery, GetInstruqtUserQueryVariables>(GetInstruqtUserDocument, options);
}
export type GetInstruqtUserQueryHookResult = ReturnType<typeof useGetInstruqtUserQuery>;
export type GetInstruqtUserLazyQueryHookResult = ReturnType<typeof useGetInstruqtUserLazyQuery>;
export type GetInstruqtUserQueryResult = Apollo.QueryResult<GetInstruqtUserQuery, GetInstruqtUserQueryVariables>;
export const DeleteTeamInviteDocument = gql`
  mutation deleteTeamInvite($teamID: String!, $email: String!) {
    deleteTeamInvite(teamID: $teamID, email: $email) {
      ...InvitesTeam
    }
  }
  ${InvitesTeamFragmentDoc}
`;
export type DeleteTeamInviteMutationFn = Apollo.MutationFunction<
  DeleteTeamInviteMutation,
  DeleteTeamInviteMutationVariables
>;

/**
 * __useDeleteTeamInviteMutation__
 *
 * To run a mutation, you first call `useDeleteTeamInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeamInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeamInviteMutation, { data, loading, error }] = useDeleteTeamInviteMutation({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useDeleteTeamInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteTeamInviteMutation, DeleteTeamInviteMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteTeamInviteMutation, DeleteTeamInviteMutationVariables>(
    DeleteTeamInviteDocument,
    options,
  );
}
export type DeleteTeamInviteMutationHookResult = ReturnType<typeof useDeleteTeamInviteMutation>;
export type DeleteTeamInviteMutationResult = Apollo.MutationResult<DeleteTeamInviteMutation>;
export type DeleteTeamInviteMutationOptions = Apollo.BaseMutationOptions<
  DeleteTeamInviteMutation,
  DeleteTeamInviteMutationVariables
>;
export const RemoveTeamUserDocument = gql`
  mutation removeTeamUser($teamID: String!, $userID: String!) {
    removeTeamUser(teamID: $teamID, userID: $userID) {
      ...MembersTeam
    }
  }
  ${MembersTeamFragmentDoc}
`;
export type RemoveTeamUserMutationFn = Apollo.MutationFunction<RemoveTeamUserMutation, RemoveTeamUserMutationVariables>;

/**
 * __useRemoveTeamUserMutation__
 *
 * To run a mutation, you first call `useRemoveTeamUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTeamUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTeamUserMutation, { data, loading, error }] = useRemoveTeamUserMutation({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useRemoveTeamUserMutation(
  baseOptions?: Apollo.MutationHookOptions<RemoveTeamUserMutation, RemoveTeamUserMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveTeamUserMutation, RemoveTeamUserMutationVariables>(RemoveTeamUserDocument, options);
}
export type RemoveTeamUserMutationHookResult = ReturnType<typeof useRemoveTeamUserMutation>;
export type RemoveTeamUserMutationResult = Apollo.MutationResult<RemoveTeamUserMutation>;
export type RemoveTeamUserMutationOptions = Apollo.BaseMutationOptions<
  RemoveTeamUserMutation,
  RemoveTeamUserMutationVariables
>;
export const ChangeTeamUserRoleDocument = gql`
  mutation changeTeamUserRole($teamID: String!, $userID: String!, $role: RoleName!) {
    changeTeamUserRole(teamID: $teamID, userID: $userID, role: $role) {
      ...RoleSelectTeam
    }
  }
  ${RoleSelectTeamFragmentDoc}
`;
export type ChangeTeamUserRoleMutationFn = Apollo.MutationFunction<
  ChangeTeamUserRoleMutation,
  ChangeTeamUserRoleMutationVariables
>;

/**
 * __useChangeTeamUserRoleMutation__
 *
 * To run a mutation, you first call `useChangeTeamUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeTeamUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeTeamUserRoleMutation, { data, loading, error }] = useChangeTeamUserRoleMutation({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      userID: // value for 'userID'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useChangeTeamUserRoleMutation(
  baseOptions?: Apollo.MutationHookOptions<ChangeTeamUserRoleMutation, ChangeTeamUserRoleMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ChangeTeamUserRoleMutation, ChangeTeamUserRoleMutationVariables>(
    ChangeTeamUserRoleDocument,
    options,
  );
}
export type ChangeTeamUserRoleMutationHookResult = ReturnType<typeof useChangeTeamUserRoleMutation>;
export type ChangeTeamUserRoleMutationResult = Apollo.MutationResult<ChangeTeamUserRoleMutation>;
export type ChangeTeamUserRoleMutationOptions = Apollo.BaseMutationOptions<
  ChangeTeamUserRoleMutation,
  ChangeTeamUserRoleMutationVariables
>;
export const TrackTagsGetTrackDocument = gql`
  query TrackTagsGetTrack($trackID: String!) {
    track(trackID: $trackID) {
      ...TrackDetailsTrackData
    }
  }
  ${TrackDetailsTrackDataFragmentDoc}
`;

/**
 * __useTrackTagsGetTrackQuery__
 *
 * To run a query within a React component, call `useTrackTagsGetTrackQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackTagsGetTrackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackTagsGetTrackQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useTrackTagsGetTrackQuery(
  baseOptions: Apollo.QueryHookOptions<TrackTagsGetTrackQuery, TrackTagsGetTrackQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TrackTagsGetTrackQuery, TrackTagsGetTrackQueryVariables>(TrackTagsGetTrackDocument, options);
}
export function useTrackTagsGetTrackLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TrackTagsGetTrackQuery, TrackTagsGetTrackQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TrackTagsGetTrackQuery, TrackTagsGetTrackQueryVariables>(
    TrackTagsGetTrackDocument,
    options,
  );
}
export type TrackTagsGetTrackQueryHookResult = ReturnType<typeof useTrackTagsGetTrackQuery>;
export type TrackTagsGetTrackLazyQueryHookResult = ReturnType<typeof useTrackTagsGetTrackLazyQuery>;
export type TrackTagsGetTrackQueryResult = Apollo.QueryResult<TrackTagsGetTrackQuery, TrackTagsGetTrackQueryVariables>;
export const UpdateTrackTagsDocument = gql`
  mutation UpdateTrackTags($track: TrackInput!) {
    updateTrack(track: $track) {
      ...TrackDetailsTrackData
    }
  }
  ${TrackDetailsTrackDataFragmentDoc}
`;
export type UpdateTrackTagsMutationFn = Apollo.MutationFunction<
  UpdateTrackTagsMutation,
  UpdateTrackTagsMutationVariables
>;

/**
 * __useUpdateTrackTagsMutation__
 *
 * To run a mutation, you first call `useUpdateTrackTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrackTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrackTagsMutation, { data, loading, error }] = useUpdateTrackTagsMutation({
 *   variables: {
 *      track: // value for 'track'
 *   },
 * });
 */
export function useUpdateTrackTagsMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateTrackTagsMutation, UpdateTrackTagsMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateTrackTagsMutation, UpdateTrackTagsMutationVariables>(
    UpdateTrackTagsDocument,
    options,
  );
}
export type UpdateTrackTagsMutationHookResult = ReturnType<typeof useUpdateTrackTagsMutation>;
export type UpdateTrackTagsMutationResult = Apollo.MutationResult<UpdateTrackTagsMutation>;
export type UpdateTrackTagsMutationOptions = Apollo.BaseMutationOptions<
  UpdateTrackTagsMutation,
  UpdateTrackTagsMutationVariables
>;
export const AddTeamMemberSlugCheckDocument = gql`
  query AddTeamMemberSlugCheck($slug: String, $email: String) {
    user(slug: $slug, email: $email) {
      id
      profile {
        slug
      }
    }
  }
`;

/**
 * __useAddTeamMemberSlugCheckQuery__
 *
 * To run a query within a React component, call `useAddTeamMemberSlugCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddTeamMemberSlugCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddTeamMemberSlugCheckQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useAddTeamMemberSlugCheckQuery(
  baseOptions?: Apollo.QueryHookOptions<AddTeamMemberSlugCheckQuery, AddTeamMemberSlugCheckQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AddTeamMemberSlugCheckQuery, AddTeamMemberSlugCheckQueryVariables>(
    AddTeamMemberSlugCheckDocument,
    options,
  );
}
export function useAddTeamMemberSlugCheckLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AddTeamMemberSlugCheckQuery, AddTeamMemberSlugCheckQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AddTeamMemberSlugCheckQuery, AddTeamMemberSlugCheckQueryVariables>(
    AddTeamMemberSlugCheckDocument,
    options,
  );
}
export type AddTeamMemberSlugCheckQueryHookResult = ReturnType<typeof useAddTeamMemberSlugCheckQuery>;
export type AddTeamMemberSlugCheckLazyQueryHookResult = ReturnType<typeof useAddTeamMemberSlugCheckLazyQuery>;
export type AddTeamMemberSlugCheckQueryResult = Apollo.QueryResult<
  AddTeamMemberSlugCheckQuery,
  AddTeamMemberSlugCheckQueryVariables
>;
export const AddTeamMemberDocument = gql`
  mutation AddTeamMember($teamID: String!, $userID: String, $email: String, $role: RoleName) {
    inviteTeamUser(teamID: $teamID, userID: $userID, email: $email, role: $role) {
      id
      name
      slug
      members {
        role
        user {
          id
          profile {
            display_name
            avatar
            slug
          }
        }
      }
      invites {
        email
        role
      }
    }
  }
`;
export type AddTeamMemberMutationFn = Apollo.MutationFunction<AddTeamMemberMutation, AddTeamMemberMutationVariables>;

/**
 * __useAddTeamMemberMutation__
 *
 * To run a mutation, you first call `useAddTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTeamMemberMutation, { data, loading, error }] = useAddTeamMemberMutation({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      userID: // value for 'userID'
 *      email: // value for 'email'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useAddTeamMemberMutation(
  baseOptions?: Apollo.MutationHookOptions<AddTeamMemberMutation, AddTeamMemberMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddTeamMemberMutation, AddTeamMemberMutationVariables>(AddTeamMemberDocument, options);
}
export type AddTeamMemberMutationHookResult = ReturnType<typeof useAddTeamMemberMutation>;
export type AddTeamMemberMutationResult = Apollo.MutationResult<AddTeamMemberMutation>;
export type AddTeamMemberMutationOptions = Apollo.BaseMutationOptions<
  AddTeamMemberMutation,
  AddTeamMemberMutationVariables
>;
export const StartDocument = gql`
  mutation start($trackID: String!, $inviteID: String) {
    startTrack(trackID: $trackID, inviteID: $inviteID, recaptchaToken: "") {
      id
      status
      permalink
      challenges {
        id
        index
        slug
        title
        teaser
        status
        started
        completed
        timelimit
        failed
        failMessage
      }
    }
  }
`;
export type StartMutationFn = Apollo.MutationFunction<StartMutation, StartMutationVariables>;

/**
 * __useStartMutation__
 *
 * To run a mutation, you first call `useStartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startMutation, { data, loading, error }] = useStartMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      inviteID: // value for 'inviteID'
 *   },
 * });
 */
export function useStartMutation(baseOptions?: Apollo.MutationHookOptions<StartMutation, StartMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<StartMutation, StartMutationVariables>(StartDocument, options);
}
export type StartMutationHookResult = ReturnType<typeof useStartMutation>;
export type StartMutationResult = Apollo.MutationResult<StartMutation>;
export type StartMutationOptions = Apollo.BaseMutationOptions<StartMutation, StartMutationVariables>;
export const GetChallengeToDuplicateDocument = gql`
  query GetChallengeToDuplicate($challengeID: String!) {
    challenge(challengeID: $challengeID) {
      slug
      title
      teaser
      started
      timelimit
      assignment
      type
      difficulty
      tabs {
        cmd
        index
        new_window
        type
        title
        target
        hostname
        path
        port
        url
        workdir
      }
      notes {
        type
        contents
        url
        index
      }
      scripts {
        action
        contents
        host
      }
      answers
      solution
    }
  }
`;

/**
 * __useGetChallengeToDuplicateQuery__
 *
 * To run a query within a React component, call `useGetChallengeToDuplicateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChallengeToDuplicateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChallengeToDuplicateQuery({
 *   variables: {
 *      challengeID: // value for 'challengeID'
 *   },
 * });
 */
export function useGetChallengeToDuplicateQuery(
  baseOptions: Apollo.QueryHookOptions<GetChallengeToDuplicateQuery, GetChallengeToDuplicateQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetChallengeToDuplicateQuery, GetChallengeToDuplicateQueryVariables>(
    GetChallengeToDuplicateDocument,
    options,
  );
}
export function useGetChallengeToDuplicateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetChallengeToDuplicateQuery, GetChallengeToDuplicateQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetChallengeToDuplicateQuery, GetChallengeToDuplicateQueryVariables>(
    GetChallengeToDuplicateDocument,
    options,
  );
}
export type GetChallengeToDuplicateQueryHookResult = ReturnType<typeof useGetChallengeToDuplicateQuery>;
export type GetChallengeToDuplicateLazyQueryHookResult = ReturnType<typeof useGetChallengeToDuplicateLazyQuery>;
export type GetChallengeToDuplicateQueryResult = Apollo.QueryResult<
  GetChallengeToDuplicateQuery,
  GetChallengeToDuplicateQueryVariables
>;
export const DuplicateChallengeDocument = gql`
  mutation DuplicateChallenge($challenge: ChallengeInput!) {
    createChallenge(challenge: $challenge) {
      id
    }
  }
`;
export type DuplicateChallengeMutationFn = Apollo.MutationFunction<
  DuplicateChallengeMutation,
  DuplicateChallengeMutationVariables
>;

/**
 * __useDuplicateChallengeMutation__
 *
 * To run a mutation, you first call `useDuplicateChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateChallengeMutation, { data, loading, error }] = useDuplicateChallengeMutation({
 *   variables: {
 *      challenge: // value for 'challenge'
 *   },
 * });
 */
export function useDuplicateChallengeMutation(
  baseOptions?: Apollo.MutationHookOptions<DuplicateChallengeMutation, DuplicateChallengeMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DuplicateChallengeMutation, DuplicateChallengeMutationVariables>(
    DuplicateChallengeDocument,
    options,
  );
}
export type DuplicateChallengeMutationHookResult = ReturnType<typeof useDuplicateChallengeMutation>;
export type DuplicateChallengeMutationResult = Apollo.MutationResult<DuplicateChallengeMutation>;
export type DuplicateChallengeMutationOptions = Apollo.BaseMutationOptions<
  DuplicateChallengeMutation,
  DuplicateChallengeMutationVariables
>;
export const SkippingToDocument = gql`
  query SkippingTo($trackSlug: String!, $teamSlug: String!) {
    track(trackSlug: $trackSlug, teamSlug: $teamSlug) {
      id
      status
      skipping_to {
        id
      }
      challenges {
        id
        title
        slug
        index
        status
        started
        completed
        failed
        failMessage
      }
    }
  }
`;

/**
 * __useSkippingToQuery__
 *
 * To run a query within a React component, call `useSkippingToQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkippingToQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkippingToQuery({
 *   variables: {
 *      trackSlug: // value for 'trackSlug'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useSkippingToQuery(baseOptions: Apollo.QueryHookOptions<SkippingToQuery, SkippingToQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SkippingToQuery, SkippingToQueryVariables>(SkippingToDocument, options);
}
export function useSkippingToLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SkippingToQuery, SkippingToQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SkippingToQuery, SkippingToQueryVariables>(SkippingToDocument, options);
}
export type SkippingToQueryHookResult = ReturnType<typeof useSkippingToQuery>;
export type SkippingToLazyQueryHookResult = ReturnType<typeof useSkippingToLazyQuery>;
export type SkippingToQueryResult = Apollo.QueryResult<SkippingToQuery, SkippingToQueryVariables>;
export const SkipAChallengeDocument = gql`
  query SkipAChallenge($trackSlug: String!, $teamSlug: String!) {
    team(teamSlug: $teamSlug) {
      id
      features {
        members_skip_to_challenge
      }
    }
    userIsTrackDeveloper(trackSlug: $trackSlug, teamSlug: $teamSlug)
    userInTeam(teamSlug: $teamSlug)
    track(trackSlug: $trackSlug, teamSlug: $teamSlug) {
      id
      status
      skipping_to {
        id
      }
      skipping_enabled
      can_skip
      challenges {
        id
        type
        title
        index
        status
        started
        completed
      }
    }
  }
`;

/**
 * __useSkipAChallengeQuery__
 *
 * To run a query within a React component, call `useSkipAChallengeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkipAChallengeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkipAChallengeQuery({
 *   variables: {
 *      trackSlug: // value for 'trackSlug'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useSkipAChallengeQuery(
  baseOptions: Apollo.QueryHookOptions<SkipAChallengeQuery, SkipAChallengeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SkipAChallengeQuery, SkipAChallengeQueryVariables>(SkipAChallengeDocument, options);
}
export function useSkipAChallengeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SkipAChallengeQuery, SkipAChallengeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SkipAChallengeQuery, SkipAChallengeQueryVariables>(SkipAChallengeDocument, options);
}
export type SkipAChallengeQueryHookResult = ReturnType<typeof useSkipAChallengeQuery>;
export type SkipAChallengeLazyQueryHookResult = ReturnType<typeof useSkipAChallengeLazyQuery>;
export type SkipAChallengeQueryResult = Apollo.QueryResult<SkipAChallengeQuery, SkipAChallengeQueryVariables>;
export const Skip_StartTrackDocument = gql`
  mutation Skip_StartTrack($trackID: String!, $inviteID: String) {
    startTrack(trackID: $trackID, inviteID: $inviteID) {
      id
      status
    }
  }
`;
export type Skip_StartTrackMutationFn = Apollo.MutationFunction<
  Skip_StartTrackMutation,
  Skip_StartTrackMutationVariables
>;

/**
 * __useSkip_StartTrackMutation__
 *
 * To run a mutation, you first call `useSkip_StartTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkip_StartTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipStartTrackMutation, { data, loading, error }] = useSkip_StartTrackMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      inviteID: // value for 'inviteID'
 *   },
 * });
 */
export function useSkip_StartTrackMutation(
  baseOptions?: Apollo.MutationHookOptions<Skip_StartTrackMutation, Skip_StartTrackMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Skip_StartTrackMutation, Skip_StartTrackMutationVariables>(
    Skip_StartTrackDocument,
    options,
  );
}
export type Skip_StartTrackMutationHookResult = ReturnType<typeof useSkip_StartTrackMutation>;
export type Skip_StartTrackMutationResult = Apollo.MutationResult<Skip_StartTrackMutation>;
export type Skip_StartTrackMutationOptions = Apollo.BaseMutationOptions<
  Skip_StartTrackMutation,
  Skip_StartTrackMutationVariables
>;
export const StartingTrackModalDocument = gql`
  query StartingTrackModal($trackSlug: String!, $teamSlug: String!) {
    track(trackSlug: $trackSlug, teamSlug: $teamSlug) {
      id
      status
      median_starttime
      challenges {
        id
        index
        status
      }
    }
  }
`;

/**
 * __useStartingTrackModalQuery__
 *
 * To run a query within a React component, call `useStartingTrackModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useStartingTrackModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStartingTrackModalQuery({
 *   variables: {
 *      trackSlug: // value for 'trackSlug'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useStartingTrackModalQuery(
  baseOptions: Apollo.QueryHookOptions<StartingTrackModalQuery, StartingTrackModalQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<StartingTrackModalQuery, StartingTrackModalQueryVariables>(
    StartingTrackModalDocument,
    options,
  );
}
export function useStartingTrackModalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<StartingTrackModalQuery, StartingTrackModalQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<StartingTrackModalQuery, StartingTrackModalQueryVariables>(
    StartingTrackModalDocument,
    options,
  );
}
export type StartingTrackModalQueryHookResult = ReturnType<typeof useStartingTrackModalQuery>;
export type StartingTrackModalLazyQueryHookResult = ReturnType<typeof useStartingTrackModalLazyQuery>;
export type StartingTrackModalQueryResult = Apollo.QueryResult<
  StartingTrackModalQuery,
  StartingTrackModalQueryVariables
>;
export const SkipChallengeDocument = gql`
  mutation SkipChallenge($trackID: String!, $challengeID: String!, $userID: String, $inviteID: String) {
    skipChallenge(trackID: $trackID, challengeID: $challengeID, userID: $userID, inviteID: $inviteID)
  }
`;
export type SkipChallengeMutationFn = Apollo.MutationFunction<SkipChallengeMutation, SkipChallengeMutationVariables>;

/**
 * __useSkipChallengeMutation__
 *
 * To run a mutation, you first call `useSkipChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkipChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipChallengeMutation, { data, loading, error }] = useSkipChallengeMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      challengeID: // value for 'challengeID'
 *      userID: // value for 'userID'
 *      inviteID: // value for 'inviteID'
 *   },
 * });
 */
export function useSkipChallengeMutation(
  baseOptions?: Apollo.MutationHookOptions<SkipChallengeMutation, SkipChallengeMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SkipChallengeMutation, SkipChallengeMutationVariables>(SkipChallengeDocument, options);
}
export type SkipChallengeMutationHookResult = ReturnType<typeof useSkipChallengeMutation>;
export type SkipChallengeMutationResult = Apollo.MutationResult<SkipChallengeMutation>;
export type SkipChallengeMutationOptions = Apollo.BaseMutationOptions<
  SkipChallengeMutation,
  SkipChallengeMutationVariables
>;
export const SkipToChallengeDocument = gql`
  mutation SkipToChallenge(
    $trackID: String!
    $challengeID: String!
    $userID: String
    $inviteID: String
    $force: Boolean
  ) {
    skipToChallenge(trackID: $trackID, challengeID: $challengeID, userID: $userID, inviteID: $inviteID, force: $force) {
      id
      status
    }
  }
`;
export type SkipToChallengeMutationFn = Apollo.MutationFunction<
  SkipToChallengeMutation,
  SkipToChallengeMutationVariables
>;

/**
 * __useSkipToChallengeMutation__
 *
 * To run a mutation, you first call `useSkipToChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkipToChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipToChallengeMutation, { data, loading, error }] = useSkipToChallengeMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      challengeID: // value for 'challengeID'
 *      userID: // value for 'userID'
 *      inviteID: // value for 'inviteID'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useSkipToChallengeMutation(
  baseOptions?: Apollo.MutationHookOptions<SkipToChallengeMutation, SkipToChallengeMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SkipToChallengeMutation, SkipToChallengeMutationVariables>(
    SkipToChallengeDocument,
    options,
  );
}
export type SkipToChallengeMutationHookResult = ReturnType<typeof useSkipToChallengeMutation>;
export type SkipToChallengeMutationResult = Apollo.MutationResult<SkipToChallengeMutation>;
export type SkipToChallengeMutationOptions = Apollo.BaseMutationOptions<
  SkipToChallengeMutation,
  SkipToChallengeMutationVariables
>;
export const UpdateChallengeIndexesDocument = gql`
  mutation UpdateChallengeIndexes($trackID: String!, $challenges: [String!]!) {
    updateChallengeIndexes(trackID: $trackID, challenges: $challenges) {
      id
      title
      index
    }
  }
`;
export type UpdateChallengeIndexesMutationFn = Apollo.MutationFunction<
  UpdateChallengeIndexesMutation,
  UpdateChallengeIndexesMutationVariables
>;

/**
 * __useUpdateChallengeIndexesMutation__
 *
 * To run a mutation, you first call `useUpdateChallengeIndexesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChallengeIndexesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChallengeIndexesMutation, { data, loading, error }] = useUpdateChallengeIndexesMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      challenges: // value for 'challenges'
 *   },
 * });
 */
export function useUpdateChallengeIndexesMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateChallengeIndexesMutation, UpdateChallengeIndexesMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateChallengeIndexesMutation, UpdateChallengeIndexesMutationVariables>(
    UpdateChallengeIndexesDocument,
    options,
  );
}
export type UpdateChallengeIndexesMutationHookResult = ReturnType<typeof useUpdateChallengeIndexesMutation>;
export type UpdateChallengeIndexesMutationResult = Apollo.MutationResult<UpdateChallengeIndexesMutation>;
export type UpdateChallengeIndexesMutationOptions = Apollo.BaseMutationOptions<
  UpdateChallengeIndexesMutation,
  UpdateChallengeIndexesMutationVariables
>;
export const StartLearningStopTrackDocument = gql`
  mutation StartLearningStopTrack($trackID: String!) {
    stopTrack(trackID: $trackID) {
      id
      status
      challenges {
        id
        slug
        title
        teaser
        status
      }
    }
  }
`;
export type StartLearningStopTrackMutationFn = Apollo.MutationFunction<
  StartLearningStopTrackMutation,
  StartLearningStopTrackMutationVariables
>;

/**
 * __useStartLearningStopTrackMutation__
 *
 * To run a mutation, you first call `useStartLearningStopTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartLearningStopTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startLearningStopTrackMutation, { data, loading, error }] = useStartLearningStopTrackMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useStartLearningStopTrackMutation(
  baseOptions?: Apollo.MutationHookOptions<StartLearningStopTrackMutation, StartLearningStopTrackMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<StartLearningStopTrackMutation, StartLearningStopTrackMutationVariables>(
    StartLearningStopTrackDocument,
    options,
  );
}
export type StartLearningStopTrackMutationHookResult = ReturnType<typeof useStartLearningStopTrackMutation>;
export type StartLearningStopTrackMutationResult = Apollo.MutationResult<StartLearningStopTrackMutation>;
export type StartLearningStopTrackMutationOptions = Apollo.BaseMutationOptions<
  StartLearningStopTrackMutation,
  StartLearningStopTrackMutationVariables
>;
export const FindUsersDocument = gql`
  query FindUsers($searchTerm: String!, $teamSlug: String!) {
    findUsers(searchTerm: $searchTerm, organizationSlug: $teamSlug) {
      id
      profile {
        avatar
        display_name
        slug
      }
    }
  }
`;

/**
 * __useFindUsersQuery__
 *
 * To run a query within a React component, call `useFindUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUsersQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useFindUsersQuery(baseOptions: Apollo.QueryHookOptions<FindUsersQuery, FindUsersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FindUsersQuery, FindUsersQueryVariables>(FindUsersDocument, options);
}
export function useFindUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FindUsersQuery, FindUsersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FindUsersQuery, FindUsersQueryVariables>(FindUsersDocument, options);
}
export type FindUsersQueryHookResult = ReturnType<typeof useFindUsersQuery>;
export type FindUsersLazyQueryHookResult = ReturnType<typeof useFindUsersLazyQuery>;
export type FindUsersQueryResult = Apollo.QueryResult<FindUsersQuery, FindUsersQueryVariables>;
export const CreateTrackDeveloperDocument = gql`
  mutation createTrackDeveloper($trackID: String!, $userID: String!) {
    createTrackDeveloper(trackID: $trackID, userID: $userID) {
      id
      developers {
        id
        profile {
          slug
          avatar
          display_name
        }
      }
    }
  }
`;
export type CreateTrackDeveloperMutationFn = Apollo.MutationFunction<
  CreateTrackDeveloperMutation,
  CreateTrackDeveloperMutationVariables
>;

/**
 * __useCreateTrackDeveloperMutation__
 *
 * To run a mutation, you first call `useCreateTrackDeveloperMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTrackDeveloperMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTrackDeveloperMutation, { data, loading, error }] = useCreateTrackDeveloperMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useCreateTrackDeveloperMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateTrackDeveloperMutation, CreateTrackDeveloperMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateTrackDeveloperMutation, CreateTrackDeveloperMutationVariables>(
    CreateTrackDeveloperDocument,
    options,
  );
}
export type CreateTrackDeveloperMutationHookResult = ReturnType<typeof useCreateTrackDeveloperMutation>;
export type CreateTrackDeveloperMutationResult = Apollo.MutationResult<CreateTrackDeveloperMutation>;
export type CreateTrackDeveloperMutationOptions = Apollo.BaseMutationOptions<
  CreateTrackDeveloperMutation,
  CreateTrackDeveloperMutationVariables
>;
export const RemoveTrackDeveloperDocument = gql`
  mutation removeTrackDeveloper($trackID: String!, $userID: String!) {
    removeTrackDeveloper(trackID: $trackID, userID: $userID)
  }
`;
export type RemoveTrackDeveloperMutationFn = Apollo.MutationFunction<
  RemoveTrackDeveloperMutation,
  RemoveTrackDeveloperMutationVariables
>;

/**
 * __useRemoveTrackDeveloperMutation__
 *
 * To run a mutation, you first call `useRemoveTrackDeveloperMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTrackDeveloperMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTrackDeveloperMutation, { data, loading, error }] = useRemoveTrackDeveloperMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useRemoveTrackDeveloperMutation(
  baseOptions?: Apollo.MutationHookOptions<RemoveTrackDeveloperMutation, RemoveTrackDeveloperMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveTrackDeveloperMutation, RemoveTrackDeveloperMutationVariables>(
    RemoveTrackDeveloperDocument,
    options,
  );
}
export type RemoveTrackDeveloperMutationHookResult = ReturnType<typeof useRemoveTrackDeveloperMutation>;
export type RemoveTrackDeveloperMutationResult = Apollo.MutationResult<RemoveTrackDeveloperMutation>;
export type RemoveTrackDeveloperMutationOptions = Apollo.BaseMutationOptions<
  RemoveTrackDeveloperMutation,
  RemoveTrackDeveloperMutationVariables
>;
export const GetDevelopersDocument = gql`
  query getDevelopers($trackID: String!) {
    track(trackID: $trackID) {
      id
      developers {
        id
        profile {
          slug
          avatar
          display_name
        }
      }
    }
  }
`;

/**
 * __useGetDevelopersQuery__
 *
 * To run a query within a React component, call `useGetDevelopersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDevelopersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDevelopersQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useGetDevelopersQuery(
  baseOptions: Apollo.QueryHookOptions<GetDevelopersQuery, GetDevelopersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDevelopersQuery, GetDevelopersQueryVariables>(GetDevelopersDocument, options);
}
export function useGetDevelopersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetDevelopersQuery, GetDevelopersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDevelopersQuery, GetDevelopersQueryVariables>(GetDevelopersDocument, options);
}
export type GetDevelopersQueryHookResult = ReturnType<typeof useGetDevelopersQuery>;
export type GetDevelopersLazyQueryHookResult = ReturnType<typeof useGetDevelopersLazyQuery>;
export type GetDevelopersQueryResult = Apollo.QueryResult<GetDevelopersQuery, GetDevelopersQueryVariables>;
export const TrackDetailsDocument = gql`
  query TrackDetails($inviteID: String, $trackSlug: String!, $teamSlug: String!) {
    team(teamSlug: $teamSlug) {
      ...TrackDetailsTeamData
    }
    userIsTrackDeveloper(trackSlug: $trackSlug, teamSlug: $teamSlug)
    userInTeam(teamSlug: $teamSlug)
    track(inviteID: $inviteID, trackSlug: $trackSlug, teamSlug: $teamSlug) {
      ...TrackDetailsTrackData
    }
  }
  ${TrackDetailsTeamDataFragmentDoc}
  ${TrackDetailsTrackDataFragmentDoc}
`;

/**
 * __useTrackDetailsQuery__
 *
 * To run a query within a React component, call `useTrackDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackDetailsQuery({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *      trackSlug: // value for 'trackSlug'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useTrackDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<TrackDetailsQuery, TrackDetailsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TrackDetailsQuery, TrackDetailsQueryVariables>(TrackDetailsDocument, options);
}
export function useTrackDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TrackDetailsQuery, TrackDetailsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TrackDetailsQuery, TrackDetailsQueryVariables>(TrackDetailsDocument, options);
}
export type TrackDetailsQueryHookResult = ReturnType<typeof useTrackDetailsQuery>;
export type TrackDetailsLazyQueryHookResult = ReturnType<typeof useTrackDetailsLazyQuery>;
export type TrackDetailsQueryResult = Apollo.QueryResult<TrackDetailsQuery, TrackDetailsQueryVariables>;
export const UpdateTrackOptionsDocument = gql`
  mutation UpdateTrackOptions($track: TrackInput!) {
    updateTrack(track: $track) {
      id
      maintenance
      show_timer
      skipping_enabled
    }
  }
`;
export type UpdateTrackOptionsMutationFn = Apollo.MutationFunction<
  UpdateTrackOptionsMutation,
  UpdateTrackOptionsMutationVariables
>;

/**
 * __useUpdateTrackOptionsMutation__
 *
 * To run a mutation, you first call `useUpdateTrackOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrackOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrackOptionsMutation, { data, loading, error }] = useUpdateTrackOptionsMutation({
 *   variables: {
 *      track: // value for 'track'
 *   },
 * });
 */
export function useUpdateTrackOptionsMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateTrackOptionsMutation, UpdateTrackOptionsMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateTrackOptionsMutation, UpdateTrackOptionsMutationVariables>(
    UpdateTrackOptionsDocument,
    options,
  );
}
export type UpdateTrackOptionsMutationHookResult = ReturnType<typeof useUpdateTrackOptionsMutation>;
export type UpdateTrackOptionsMutationResult = Apollo.MutationResult<UpdateTrackOptionsMutation>;
export type UpdateTrackOptionsMutationOptions = Apollo.BaseMutationOptions<
  UpdateTrackOptionsMutation,
  UpdateTrackOptionsMutationVariables
>;
export const UpdateUserDocument = gql`
  mutation UpdateUser($userID: String!, $displayName: String!) {
    updateUser(userID: $userID, displayName: $displayName) {
      id
      profile {
        display_name
      }
    }
  }
`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      userID: // value for 'userID'
 *      displayName: // value for 'displayName'
 *   },
 * });
 */
export function useUpdateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
}
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const SignupPageDocument = gql`
  query SignupPage($teamID: String!, $skipTeam: Boolean!, $token: String!, $skipInvite: Boolean!) {
    team(teamID: $teamID) @skip(if: $skipTeam) {
      id
      name
      privacy_policy
    }
    teamInvite(token: $token) @skip(if: $skipInvite) {
      email
      token_expired
      team {
        id
        name
      }
      accepted_at
      created_by {
        id
        profile {
          email
          display_name
        }
      }
    }
  }
`;

/**
 * __useSignupPageQuery__
 *
 * To run a query within a React component, call `useSignupPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignupPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignupPageQuery({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      skipTeam: // value for 'skipTeam'
 *      token: // value for 'token'
 *      skipInvite: // value for 'skipInvite'
 *   },
 * });
 */
export function useSignupPageQuery(baseOptions: Apollo.QueryHookOptions<SignupPageQuery, SignupPageQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SignupPageQuery, SignupPageQueryVariables>(SignupPageDocument, options);
}
export function useSignupPageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SignupPageQuery, SignupPageQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SignupPageQuery, SignupPageQueryVariables>(SignupPageDocument, options);
}
export type SignupPageQueryHookResult = ReturnType<typeof useSignupPageQuery>;
export type SignupPageLazyQueryHookResult = ReturnType<typeof useSignupPageLazyQuery>;
export type SignupPageQueryResult = Apollo.QueryResult<SignupPageQuery, SignupPageQueryVariables>;
export const ConsentToTeamPrivacyPolicyDocument = gql`
  mutation ConsentToTeamPrivacyPolicy($teamID: String!, $consent: Boolean!) {
    consentToTeamPrivacyPolicy(teamID: $teamID, consent: $consent)
  }
`;
export type ConsentToTeamPrivacyPolicyMutationFn = Apollo.MutationFunction<
  ConsentToTeamPrivacyPolicyMutation,
  ConsentToTeamPrivacyPolicyMutationVariables
>;

/**
 * __useConsentToTeamPrivacyPolicyMutation__
 *
 * To run a mutation, you first call `useConsentToTeamPrivacyPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsentToTeamPrivacyPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consentToTeamPrivacyPolicyMutation, { data, loading, error }] = useConsentToTeamPrivacyPolicyMutation({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      consent: // value for 'consent'
 *   },
 * });
 */
export function useConsentToTeamPrivacyPolicyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsentToTeamPrivacyPolicyMutation,
    ConsentToTeamPrivacyPolicyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ConsentToTeamPrivacyPolicyMutation, ConsentToTeamPrivacyPolicyMutationVariables>(
    ConsentToTeamPrivacyPolicyDocument,
    options,
  );
}
export type ConsentToTeamPrivacyPolicyMutationHookResult = ReturnType<typeof useConsentToTeamPrivacyPolicyMutation>;
export type ConsentToTeamPrivacyPolicyMutationResult = Apollo.MutationResult<ConsentToTeamPrivacyPolicyMutation>;
export type ConsentToTeamPrivacyPolicyMutationOptions = Apollo.BaseMutationOptions<
  ConsentToTeamPrivacyPolicyMutation,
  ConsentToTeamPrivacyPolicyMutationVariables
>;
export const MergeAnonymousUserDocument = gql`
  mutation MergeAnonymousUser($token: String!) {
    mergeAnonymousUser(token: $token)
  }
`;
export type MergeAnonymousUserMutationFn = Apollo.MutationFunction<
  MergeAnonymousUserMutation,
  MergeAnonymousUserMutationVariables
>;

/**
 * __useMergeAnonymousUserMutation__
 *
 * To run a mutation, you first call `useMergeAnonymousUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeAnonymousUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeAnonymousUserMutation, { data, loading, error }] = useMergeAnonymousUserMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useMergeAnonymousUserMutation(
  baseOptions?: Apollo.MutationHookOptions<MergeAnonymousUserMutation, MergeAnonymousUserMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<MergeAnonymousUserMutation, MergeAnonymousUserMutationVariables>(
    MergeAnonymousUserDocument,
    options,
  );
}
export type MergeAnonymousUserMutationHookResult = ReturnType<typeof useMergeAnonymousUserMutation>;
export type MergeAnonymousUserMutationResult = Apollo.MutationResult<MergeAnonymousUserMutation>;
export type MergeAnonymousUserMutationOptions = Apollo.BaseMutationOptions<
  MergeAnonymousUserMutation,
  MergeAnonymousUserMutationVariables
>;
export const UpdateDisplayNameDocument = gql`
  mutation UpdateDisplayName($userID: String!, $displayName: String!) {
    updateUser(userID: $userID, displayName: $displayName) {
      id
      profile {
        display_name
      }
    }
  }
`;
export type UpdateDisplayNameMutationFn = Apollo.MutationFunction<
  UpdateDisplayNameMutation,
  UpdateDisplayNameMutationVariables
>;

/**
 * __useUpdateDisplayNameMutation__
 *
 * To run a mutation, you first call `useUpdateDisplayNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDisplayNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDisplayNameMutation, { data, loading, error }] = useUpdateDisplayNameMutation({
 *   variables: {
 *      userID: // value for 'userID'
 *      displayName: // value for 'displayName'
 *   },
 * });
 */
export function useUpdateDisplayNameMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateDisplayNameMutation, UpdateDisplayNameMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateDisplayNameMutation, UpdateDisplayNameMutationVariables>(
    UpdateDisplayNameDocument,
    options,
  );
}
export type UpdateDisplayNameMutationHookResult = ReturnType<typeof useUpdateDisplayNameMutation>;
export type UpdateDisplayNameMutationResult = Apollo.MutationResult<UpdateDisplayNameMutation>;
export type UpdateDisplayNameMutationOptions = Apollo.BaseMutationOptions<
  UpdateDisplayNameMutation,
  UpdateDisplayNameMutationVariables
>;
export const DeleteUserDocument = gql`
  mutation DeleteUser {
    deleteUser
  }
`;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteUserMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
}
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const GetTemplateDocument = gql`
  query GetTemplate($trackSlug: String!, $teamSlug: String!) {
    track(trackSlug: $trackSlug, teamSlug: $teamSlug) {
      id
      permalink
      slug
      icon
      title
      teaser
      description
      tags
    }
  }
`;

/**
 * __useGetTemplateQuery__
 *
 * To run a query within a React component, call `useGetTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemplateQuery({
 *   variables: {
 *      trackSlug: // value for 'trackSlug'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useGetTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetTemplateQuery, GetTemplateQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTemplateQuery, GetTemplateQueryVariables>(GetTemplateDocument, options);
}
export function useGetTemplateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTemplateQuery, GetTemplateQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTemplateQuery, GetTemplateQueryVariables>(GetTemplateDocument, options);
}
export type GetTemplateQueryHookResult = ReturnType<typeof useGetTemplateQuery>;
export type GetTemplateLazyQueryHookResult = ReturnType<typeof useGetTemplateLazyQuery>;
export type GetTemplateQueryResult = Apollo.QueryResult<GetTemplateQuery, GetTemplateQueryVariables>;
export const UpdateCompleteTrackDocument = gql`
  mutation UpdateCompleteTrack($track: TrackInput!) {
    updateCompleteTrack(track: $track) {
      id
      slug
      owner
      title
      permalink
    }
  }
`;
export type UpdateCompleteTrackMutationFn = Apollo.MutationFunction<
  UpdateCompleteTrackMutation,
  UpdateCompleteTrackMutationVariables
>;

/**
 * __useUpdateCompleteTrackMutation__
 *
 * To run a mutation, you first call `useUpdateCompleteTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompleteTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompleteTrackMutation, { data, loading, error }] = useUpdateCompleteTrackMutation({
 *   variables: {
 *      track: // value for 'track'
 *   },
 * });
 */
export function useUpdateCompleteTrackMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateCompleteTrackMutation, UpdateCompleteTrackMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateCompleteTrackMutation, UpdateCompleteTrackMutationVariables>(
    UpdateCompleteTrackDocument,
    options,
  );
}
export type UpdateCompleteTrackMutationHookResult = ReturnType<typeof useUpdateCompleteTrackMutation>;
export type UpdateCompleteTrackMutationResult = Apollo.MutationResult<UpdateCompleteTrackMutation>;
export type UpdateCompleteTrackMutationOptions = Apollo.BaseMutationOptions<
  UpdateCompleteTrackMutation,
  UpdateCompleteTrackMutationVariables
>;
export const InspirationLibraryDocument = gql`
  query InspirationLibrary {
    templates: tracks(teamSlug: "templates") {
      challenges {
        permalink
      }
      icon
      id
      maintenance
      slug
      teaser
      title
    }
    examples: tracks(teamSlug: "examples") {
      challenges {
        permalink
      }
      icon
      id
      maintenance
      slug
      teaser
      title
    }
    tutorials: tracks(teamSlug: "tutorials") {
      challenges {
        permalink
      }
      icon
      id
      maintenance
      slug
      teaser
      title
    }
  }
`;

/**
 * __useInspirationLibraryQuery__
 *
 * To run a query within a React component, call `useInspirationLibraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useInspirationLibraryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInspirationLibraryQuery({
 *   variables: {
 *   },
 * });
 */
export function useInspirationLibraryQuery(
  baseOptions?: Apollo.QueryHookOptions<InspirationLibraryQuery, InspirationLibraryQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InspirationLibraryQuery, InspirationLibraryQueryVariables>(
    InspirationLibraryDocument,
    options,
  );
}
export function useInspirationLibraryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<InspirationLibraryQuery, InspirationLibraryQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<InspirationLibraryQuery, InspirationLibraryQueryVariables>(
    InspirationLibraryDocument,
    options,
  );
}
export type InspirationLibraryQueryHookResult = ReturnType<typeof useInspirationLibraryQuery>;
export type InspirationLibraryLazyQueryHookResult = ReturnType<typeof useInspirationLibraryLazyQuery>;
export type InspirationLibraryQueryResult = Apollo.QueryResult<
  InspirationLibraryQuery,
  InspirationLibraryQueryVariables
>;
export const InviteEntryPageDocument = gql`
  query InviteEntryPage($inviteID: String!) {
    invitePublic: trackInvite(inviteID: $inviteID) {
      id
      accessSetting
      currentUserAllowed
      currentUserClaimed
      startsAt
      tracks {
        id
      }
      team {
        id
        slug
        name
        logo
        features {
          accept_terms_checkbox
        }
        theme {
          background_image
          background_color
        }
      }
    }
    invitePrivate: viewInvite(inviteID: $inviteID) {
      id
    }
  }
`;

/**
 * __useInviteEntryPageQuery__
 *
 * To run a query within a React component, call `useInviteEntryPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useInviteEntryPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInviteEntryPageQuery({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *   },
 * });
 */
export function useInviteEntryPageQuery(
  baseOptions: Apollo.QueryHookOptions<InviteEntryPageQuery, InviteEntryPageQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InviteEntryPageQuery, InviteEntryPageQueryVariables>(InviteEntryPageDocument, options);
}
export function useInviteEntryPageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<InviteEntryPageQuery, InviteEntryPageQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<InviteEntryPageQuery, InviteEntryPageQueryVariables>(InviteEntryPageDocument, options);
}
export type InviteEntryPageQueryHookResult = ReturnType<typeof useInviteEntryPageQuery>;
export type InviteEntryPageLazyQueryHookResult = ReturnType<typeof useInviteEntryPageLazyQuery>;
export type InviteEntryPageQueryResult = Apollo.QueryResult<InviteEntryPageQuery, InviteEntryPageQueryVariables>;
export const GainAccessContainerDocument = gql`
  query GainAccessContainer($inviteID: String!) {
    invitePublic: trackInvite(inviteID: $inviteID) {
      id
      currentUserClaimed
      team {
        id
        name
        slug
        logo
        features {
          accept_terms_checkbox
        }
        theme {
          background_image
          background_color
        }
      }
    }
    invitePrivate: viewInvite(inviteID: $inviteID) {
      id
      allowAnonymous
      allowedEmailAddressesOnly
      currentUserAllowed
      startsAt
    }
  }
`;

/**
 * __useGainAccessContainerQuery__
 *
 * To run a query within a React component, call `useGainAccessContainerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGainAccessContainerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGainAccessContainerQuery({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *   },
 * });
 */
export function useGainAccessContainerQuery(
  baseOptions: Apollo.QueryHookOptions<GainAccessContainerQuery, GainAccessContainerQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GainAccessContainerQuery, GainAccessContainerQueryVariables>(
    GainAccessContainerDocument,
    options,
  );
}
export function useGainAccessContainerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GainAccessContainerQuery, GainAccessContainerQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GainAccessContainerQuery, GainAccessContainerQueryVariables>(
    GainAccessContainerDocument,
    options,
  );
}
export type GainAccessContainerQueryHookResult = ReturnType<typeof useGainAccessContainerQuery>;
export type GainAccessContainerLazyQueryHookResult = ReturnType<typeof useGainAccessContainerLazyQuery>;
export type GainAccessContainerQueryResult = Apollo.QueryResult<
  GainAccessContainerQuery,
  GainAccessContainerQueryVariables
>;
export const ClaimTrackInviteDocument = gql`
  mutation ClaimTrackInvite($inviteID: String!) {
    claimTrackInvite(inviteID: $inviteID) {
      id
      trackInvite {
        id
        currentUserClaimed
      }
    }
  }
`;
export type ClaimTrackInviteMutationFn = Apollo.MutationFunction<
  ClaimTrackInviteMutation,
  ClaimTrackInviteMutationVariables
>;

/**
 * __useClaimTrackInviteMutation__
 *
 * To run a mutation, you first call `useClaimTrackInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClaimTrackInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [claimTrackInviteMutation, { data, loading, error }] = useClaimTrackInviteMutation({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *   },
 * });
 */
export function useClaimTrackInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<ClaimTrackInviteMutation, ClaimTrackInviteMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ClaimTrackInviteMutation, ClaimTrackInviteMutationVariables>(
    ClaimTrackInviteDocument,
    options,
  );
}
export type ClaimTrackInviteMutationHookResult = ReturnType<typeof useClaimTrackInviteMutation>;
export type ClaimTrackInviteMutationResult = Apollo.MutationResult<ClaimTrackInviteMutation>;
export type ClaimTrackInviteMutationOptions = Apollo.BaseMutationOptions<
  ClaimTrackInviteMutation,
  ClaimTrackInviteMutationVariables
>;
export const TrackInvitePageDocument = gql`
  query TrackInvitePage($inviteID: String!, $teamSlug: String!) {
    me {
      id
      details(teamSlug: $teamSlug) {
        id
        firstName
        lastName
        email
        companyName
        phoneNumber
        jobTitle
        jobLevel
        countryCode
        usState
        consent
      }
    }
    trackInvite(inviteID: $inviteID) {
      id
      title
      publicTitle
      publicDescription
      enableLearnerSharing
      accessSetting
      canClaim
      currentUserClaimed
      ...TrackInviteListItemInvite
      tracks {
        id
        owner
        permalink
        slug
        title
        challenges {
          completed
          index
          slug
          started
          status
        }
        ...TrackInviteListTrack
      }
      team {
        id
        name
        logo
        privacy_policy
        form {
          formTitle
          consentNotice
          fields {
            id
            fieldName
            isRequired
          }
        }
        theme {
          foreground_color
          background_color
          background_image
        }
        features {
          accept_terms_checkbox
        }
      }
    }
  }
  ${TrackInviteListItemInviteFragmentDoc}
  ${TrackInviteListTrackFragmentDoc}
`;

/**
 * __useTrackInvitePageQuery__
 *
 * To run a query within a React component, call `useTrackInvitePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackInvitePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackInvitePageQuery({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useTrackInvitePageQuery(
  baseOptions: Apollo.QueryHookOptions<TrackInvitePageQuery, TrackInvitePageQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TrackInvitePageQuery, TrackInvitePageQueryVariables>(TrackInvitePageDocument, options);
}
export function useTrackInvitePageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TrackInvitePageQuery, TrackInvitePageQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TrackInvitePageQuery, TrackInvitePageQueryVariables>(TrackInvitePageDocument, options);
}
export type TrackInvitePageQueryHookResult = ReturnType<typeof useTrackInvitePageQuery>;
export type TrackInvitePageLazyQueryHookResult = ReturnType<typeof useTrackInvitePageLazyQuery>;
export type TrackInvitePageQueryResult = Apollo.QueryResult<TrackInvitePageQuery, TrackInvitePageQueryVariables>;
export const TrackInviteOverviewClaimTrackInviteDocument = gql`
  mutation TrackInviteOverviewClaimTrackInvite(
    $inviteID: String!
    $userDetails: UserDetailsInput
    $customParameters: [CustomParametersInput!]
  ) {
    claimTrackInvite(inviteID: $inviteID, userDetails: $userDetails, customParameters: $customParameters) {
      id
      trackInvite {
        id
        currentUserClaimed
      }
    }
  }
`;
export type TrackInviteOverviewClaimTrackInviteMutationFn = Apollo.MutationFunction<
  TrackInviteOverviewClaimTrackInviteMutation,
  TrackInviteOverviewClaimTrackInviteMutationVariables
>;

/**
 * __useTrackInviteOverviewClaimTrackInviteMutation__
 *
 * To run a mutation, you first call `useTrackInviteOverviewClaimTrackInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackInviteOverviewClaimTrackInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackInviteOverviewClaimTrackInviteMutation, { data, loading, error }] = useTrackInviteOverviewClaimTrackInviteMutation({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *      userDetails: // value for 'userDetails'
 *      customParameters: // value for 'customParameters'
 *   },
 * });
 */
export function useTrackInviteOverviewClaimTrackInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TrackInviteOverviewClaimTrackInviteMutation,
    TrackInviteOverviewClaimTrackInviteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TrackInviteOverviewClaimTrackInviteMutation,
    TrackInviteOverviewClaimTrackInviteMutationVariables
  >(TrackInviteOverviewClaimTrackInviteDocument, options);
}
export type TrackInviteOverviewClaimTrackInviteMutationHookResult = ReturnType<
  typeof useTrackInviteOverviewClaimTrackInviteMutation
>;
export type TrackInviteOverviewClaimTrackInviteMutationResult =
  Apollo.MutationResult<TrackInviteOverviewClaimTrackInviteMutation>;
export type TrackInviteOverviewClaimTrackInviteMutationOptions = Apollo.BaseMutationOptions<
  TrackInviteOverviewClaimTrackInviteMutation,
  TrackInviteOverviewClaimTrackInviteMutationVariables
>;
export const TrackInviteOverviewConsentToTeamPrivacyPolicyDocument = gql`
  mutation TrackInviteOverviewConsentToTeamPrivacyPolicy($teamID: String!, $consent: Boolean!) {
    consentToTeamPrivacyPolicy(teamID: $teamID, consent: $consent)
  }
`;
export type TrackInviteOverviewConsentToTeamPrivacyPolicyMutationFn = Apollo.MutationFunction<
  TrackInviteOverviewConsentToTeamPrivacyPolicyMutation,
  TrackInviteOverviewConsentToTeamPrivacyPolicyMutationVariables
>;

/**
 * __useTrackInviteOverviewConsentToTeamPrivacyPolicyMutation__
 *
 * To run a mutation, you first call `useTrackInviteOverviewConsentToTeamPrivacyPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackInviteOverviewConsentToTeamPrivacyPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackInviteOverviewConsentToTeamPrivacyPolicyMutation, { data, loading, error }] = useTrackInviteOverviewConsentToTeamPrivacyPolicyMutation({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      consent: // value for 'consent'
 *   },
 * });
 */
export function useTrackInviteOverviewConsentToTeamPrivacyPolicyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TrackInviteOverviewConsentToTeamPrivacyPolicyMutation,
    TrackInviteOverviewConsentToTeamPrivacyPolicyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TrackInviteOverviewConsentToTeamPrivacyPolicyMutation,
    TrackInviteOverviewConsentToTeamPrivacyPolicyMutationVariables
  >(TrackInviteOverviewConsentToTeamPrivacyPolicyDocument, options);
}
export type TrackInviteOverviewConsentToTeamPrivacyPolicyMutationHookResult = ReturnType<
  typeof useTrackInviteOverviewConsentToTeamPrivacyPolicyMutation
>;
export type TrackInviteOverviewConsentToTeamPrivacyPolicyMutationResult =
  Apollo.MutationResult<TrackInviteOverviewConsentToTeamPrivacyPolicyMutation>;
export type TrackInviteOverviewConsentToTeamPrivacyPolicyMutationOptions = Apollo.BaseMutationOptions<
  TrackInviteOverviewConsentToTeamPrivacyPolicyMutation,
  TrackInviteOverviewConsentToTeamPrivacyPolicyMutationVariables
>;
export const TrackInviteOverviewStopTrackDocument = gql`
  mutation TrackInviteOverviewStopTrack($trackID: String!) {
    stopTrack(trackID: $trackID) {
      id
      status
    }
  }
`;
export type TrackInviteOverviewStopTrackMutationFn = Apollo.MutationFunction<
  TrackInviteOverviewStopTrackMutation,
  TrackInviteOverviewStopTrackMutationVariables
>;

/**
 * __useTrackInviteOverviewStopTrackMutation__
 *
 * To run a mutation, you first call `useTrackInviteOverviewStopTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackInviteOverviewStopTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackInviteOverviewStopTrackMutation, { data, loading, error }] = useTrackInviteOverviewStopTrackMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useTrackInviteOverviewStopTrackMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TrackInviteOverviewStopTrackMutation,
    TrackInviteOverviewStopTrackMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TrackInviteOverviewStopTrackMutation, TrackInviteOverviewStopTrackMutationVariables>(
    TrackInviteOverviewStopTrackDocument,
    options,
  );
}
export type TrackInviteOverviewStopTrackMutationHookResult = ReturnType<typeof useTrackInviteOverviewStopTrackMutation>;
export type TrackInviteOverviewStopTrackMutationResult = Apollo.MutationResult<TrackInviteOverviewStopTrackMutation>;
export type TrackInviteOverviewStopTrackMutationOptions = Apollo.BaseMutationOptions<
  TrackInviteOverviewStopTrackMutation,
  TrackInviteOverviewStopTrackMutationVariables
>;
export const MembersPageDocument = gql`
  query MembersPage($teamSlug: String!) {
    userInTeam(teamSlug: $teamSlug)
    team(teamSlug: $teamSlug) {
      id
      ...MembersTeam
      ...InvitesTeam
    }
  }
  ${MembersTeamFragmentDoc}
  ${InvitesTeamFragmentDoc}
`;

/**
 * __useMembersPageQuery__
 *
 * To run a query within a React component, call `useMembersPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembersPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembersPageQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useMembersPageQuery(baseOptions: Apollo.QueryHookOptions<MembersPageQuery, MembersPageQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MembersPageQuery, MembersPageQueryVariables>(MembersPageDocument, options);
}
export function useMembersPageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MembersPageQuery, MembersPageQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MembersPageQuery, MembersPageQueryVariables>(MembersPageDocument, options);
}
export type MembersPageQueryHookResult = ReturnType<typeof useMembersPageQuery>;
export type MembersPageLazyQueryHookResult = ReturnType<typeof useMembersPageLazyQuery>;
export type MembersPageQueryResult = Apollo.QueryResult<MembersPageQuery, MembersPageQueryVariables>;
export const InsightsStatisticsDocument = gql`
  query InsightsStatistics(
    $teamSlug: String!
    $trackIDs: [String!]
    $start: Time
    $end: Time
    $filterDevelopers: Boolean
  ) {
    organizationStatistics(
      organizationSlug: $teamSlug
      trackIDs: $trackIDs
      start: $start
      end: $end
      filterDevelopers: $filterDevelopers
    ) {
      started_total
      completed_total
      organization_series {
        date
        started
        completed
      }
      track_statistics {
        ...TrackStatisticsTableTrackStatistics
      }
    }
  }
  ${TrackStatisticsTableTrackStatisticsFragmentDoc}
`;

/**
 * __useInsightsStatisticsQuery__
 *
 * To run a query within a React component, call `useInsightsStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightsStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightsStatisticsQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      trackIDs: // value for 'trackIDs'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      filterDevelopers: // value for 'filterDevelopers'
 *   },
 * });
 */
export function useInsightsStatisticsQuery(
  baseOptions: Apollo.QueryHookOptions<InsightsStatisticsQuery, InsightsStatisticsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InsightsStatisticsQuery, InsightsStatisticsQueryVariables>(
    InsightsStatisticsDocument,
    options,
  );
}
export function useInsightsStatisticsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<InsightsStatisticsQuery, InsightsStatisticsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<InsightsStatisticsQuery, InsightsStatisticsQueryVariables>(
    InsightsStatisticsDocument,
    options,
  );
}
export type InsightsStatisticsQueryHookResult = ReturnType<typeof useInsightsStatisticsQuery>;
export type InsightsStatisticsLazyQueryHookResult = ReturnType<typeof useInsightsStatisticsLazyQuery>;
export type InsightsStatisticsQueryResult = Apollo.QueryResult<
  InsightsStatisticsQuery,
  InsightsStatisticsQueryVariables
>;
export const InsightsTracksDocument = gql`
  query InsightsTracks($teamSlug: String!) {
    tracks(teamSlug: $teamSlug) {
      id
      title
      permalink
      maintenance
    }
  }
`;

/**
 * __useInsightsTracksQuery__
 *
 * To run a query within a React component, call `useInsightsTracksQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightsTracksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightsTracksQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useInsightsTracksQuery(
  baseOptions: Apollo.QueryHookOptions<InsightsTracksQuery, InsightsTracksQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InsightsTracksQuery, InsightsTracksQueryVariables>(InsightsTracksDocument, options);
}
export function useInsightsTracksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<InsightsTracksQuery, InsightsTracksQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<InsightsTracksQuery, InsightsTracksQueryVariables>(InsightsTracksDocument, options);
}
export type InsightsTracksQueryHookResult = ReturnType<typeof useInsightsTracksQuery>;
export type InsightsTracksLazyQueryHookResult = ReturnType<typeof useInsightsTracksLazyQuery>;
export type InsightsTracksQueryResult = Apollo.QueryResult<InsightsTracksQuery, InsightsTracksQueryVariables>;
export const StudyRoomLinkRedirectDocument = gql`
  query StudyRoomLinkRedirect($inviteID: String!) {
    trackInvite(inviteID: $inviteID) {
      id
      team {
        id
        slug
      }
    }
  }
`;

/**
 * __useStudyRoomLinkRedirectQuery__
 *
 * To run a query within a React component, call `useStudyRoomLinkRedirectQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudyRoomLinkRedirectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudyRoomLinkRedirectQuery({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *   },
 * });
 */
export function useStudyRoomLinkRedirectQuery(
  baseOptions: Apollo.QueryHookOptions<StudyRoomLinkRedirectQuery, StudyRoomLinkRedirectQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<StudyRoomLinkRedirectQuery, StudyRoomLinkRedirectQueryVariables>(
    StudyRoomLinkRedirectDocument,
    options,
  );
}
export function useStudyRoomLinkRedirectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<StudyRoomLinkRedirectQuery, StudyRoomLinkRedirectQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<StudyRoomLinkRedirectQuery, StudyRoomLinkRedirectQueryVariables>(
    StudyRoomLinkRedirectDocument,
    options,
  );
}
export type StudyRoomLinkRedirectQueryHookResult = ReturnType<typeof useStudyRoomLinkRedirectQuery>;
export type StudyRoomLinkRedirectLazyQueryHookResult = ReturnType<typeof useStudyRoomLinkRedirectLazyQuery>;
export type StudyRoomLinkRedirectQueryResult = Apollo.QueryResult<
  StudyRoomLinkRedirectQuery,
  StudyRoomLinkRedirectQueryVariables
>;
export const StudyRoomDocument = gql`
  query StudyRoom {
    me {
      claims {
        ...StudyRoomClaim
      }
    }
  }
  ${StudyRoomClaimFragmentDoc}
`;

/**
 * __useStudyRoomQuery__
 *
 * To run a query within a React component, call `useStudyRoomQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudyRoomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudyRoomQuery({
 *   variables: {
 *   },
 * });
 */
export function useStudyRoomQuery(baseOptions?: Apollo.QueryHookOptions<StudyRoomQuery, StudyRoomQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<StudyRoomQuery, StudyRoomQueryVariables>(StudyRoomDocument, options);
}
export function useStudyRoomLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<StudyRoomQuery, StudyRoomQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<StudyRoomQuery, StudyRoomQueryVariables>(StudyRoomDocument, options);
}
export type StudyRoomQueryHookResult = ReturnType<typeof useStudyRoomQuery>;
export type StudyRoomLazyQueryHookResult = ReturnType<typeof useStudyRoomLazyQuery>;
export type StudyRoomQueryResult = Apollo.QueryResult<StudyRoomQuery, StudyRoomQueryVariables>;
export const TeamSecretsUpsertTeamSecretDocument = gql`
  mutation TeamSecretsUpsertTeamSecret($teamSlug: String!, $name: String!, $description: String!, $secret: String!) {
    upsertTeamSecret(teamSlug: $teamSlug, name: $name, description: $description, secret: $secret) {
      name
    }
  }
`;
export type TeamSecretsUpsertTeamSecretMutationFn = Apollo.MutationFunction<
  TeamSecretsUpsertTeamSecretMutation,
  TeamSecretsUpsertTeamSecretMutationVariables
>;

/**
 * __useTeamSecretsUpsertTeamSecretMutation__
 *
 * To run a mutation, you first call `useTeamSecretsUpsertTeamSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTeamSecretsUpsertTeamSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [teamSecretsUpsertTeamSecretMutation, { data, loading, error }] = useTeamSecretsUpsertTeamSecretMutation({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      secret: // value for 'secret'
 *   },
 * });
 */
export function useTeamSecretsUpsertTeamSecretMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TeamSecretsUpsertTeamSecretMutation,
    TeamSecretsUpsertTeamSecretMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TeamSecretsUpsertTeamSecretMutation, TeamSecretsUpsertTeamSecretMutationVariables>(
    TeamSecretsUpsertTeamSecretDocument,
    options,
  );
}
export type TeamSecretsUpsertTeamSecretMutationHookResult = ReturnType<typeof useTeamSecretsUpsertTeamSecretMutation>;
export type TeamSecretsUpsertTeamSecretMutationResult = Apollo.MutationResult<TeamSecretsUpsertTeamSecretMutation>;
export type TeamSecretsUpsertTeamSecretMutationOptions = Apollo.BaseMutationOptions<
  TeamSecretsUpsertTeamSecretMutation,
  TeamSecretsUpsertTeamSecretMutationVariables
>;
export const TeamSecretsDeleteTeamSecretDocument = gql`
  mutation TeamSecretsDeleteTeamSecret($teamSlug: String!, $name: String!) {
    deleteTeamSecret(teamSlug: $teamSlug, name: $name)
  }
`;
export type TeamSecretsDeleteTeamSecretMutationFn = Apollo.MutationFunction<
  TeamSecretsDeleteTeamSecretMutation,
  TeamSecretsDeleteTeamSecretMutationVariables
>;

/**
 * __useTeamSecretsDeleteTeamSecretMutation__
 *
 * To run a mutation, you first call `useTeamSecretsDeleteTeamSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTeamSecretsDeleteTeamSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [teamSecretsDeleteTeamSecretMutation, { data, loading, error }] = useTeamSecretsDeleteTeamSecretMutation({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useTeamSecretsDeleteTeamSecretMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TeamSecretsDeleteTeamSecretMutation,
    TeamSecretsDeleteTeamSecretMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TeamSecretsDeleteTeamSecretMutation, TeamSecretsDeleteTeamSecretMutationVariables>(
    TeamSecretsDeleteTeamSecretDocument,
    options,
  );
}
export type TeamSecretsDeleteTeamSecretMutationHookResult = ReturnType<typeof useTeamSecretsDeleteTeamSecretMutation>;
export type TeamSecretsDeleteTeamSecretMutationResult = Apollo.MutationResult<TeamSecretsDeleteTeamSecretMutation>;
export type TeamSecretsDeleteTeamSecretMutationOptions = Apollo.BaseMutationOptions<
  TeamSecretsDeleteTeamSecretMutation,
  TeamSecretsDeleteTeamSecretMutationVariables
>;
export const TeamSecretsGetTeamSecretsDocument = gql`
  query TeamSecretsGetTeamSecrets($teamSlug: String!) {
    teamSecrets(teamSlug: $teamSlug) {
      teamID
      name
      description
      updated_at
      created_at
      created_by {
        id
        profile {
          avatar
          display_name
        }
      }
      updated_by {
        id
        profile {
          avatar
          display_name
        }
      }
    }
  }
`;

/**
 * __useTeamSecretsGetTeamSecretsQuery__
 *
 * To run a query within a React component, call `useTeamSecretsGetTeamSecretsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamSecretsGetTeamSecretsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamSecretsGetTeamSecretsQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useTeamSecretsGetTeamSecretsQuery(
  baseOptions: Apollo.QueryHookOptions<TeamSecretsGetTeamSecretsQuery, TeamSecretsGetTeamSecretsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TeamSecretsGetTeamSecretsQuery, TeamSecretsGetTeamSecretsQueryVariables>(
    TeamSecretsGetTeamSecretsDocument,
    options,
  );
}
export function useTeamSecretsGetTeamSecretsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TeamSecretsGetTeamSecretsQuery, TeamSecretsGetTeamSecretsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TeamSecretsGetTeamSecretsQuery, TeamSecretsGetTeamSecretsQueryVariables>(
    TeamSecretsGetTeamSecretsDocument,
    options,
  );
}
export type TeamSecretsGetTeamSecretsQueryHookResult = ReturnType<typeof useTeamSecretsGetTeamSecretsQuery>;
export type TeamSecretsGetTeamSecretsLazyQueryHookResult = ReturnType<typeof useTeamSecretsGetTeamSecretsLazyQuery>;
export type TeamSecretsGetTeamSecretsQueryResult = Apollo.QueryResult<
  TeamSecretsGetTeamSecretsQuery,
  TeamSecretsGetTeamSecretsQueryVariables
>;
export const GetOrganizationSvixUrlDocument = gql`
  query GetOrganizationSvixURL($teamSlug: String) {
    team(teamSlug: $teamSlug) {
      webhook_dashboard_url
    }
  }
`;

/**
 * __useGetOrganizationSvixUrlQuery__
 *
 * To run a query within a React component, call `useGetOrganizationSvixUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationSvixUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationSvixUrlQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useGetOrganizationSvixUrlQuery(
  baseOptions?: Apollo.QueryHookOptions<GetOrganizationSvixUrlQuery, GetOrganizationSvixUrlQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOrganizationSvixUrlQuery, GetOrganizationSvixUrlQueryVariables>(
    GetOrganizationSvixUrlDocument,
    options,
  );
}
export function useGetOrganizationSvixUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationSvixUrlQuery, GetOrganizationSvixUrlQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetOrganizationSvixUrlQuery, GetOrganizationSvixUrlQueryVariables>(
    GetOrganizationSvixUrlDocument,
    options,
  );
}
export type GetOrganizationSvixUrlQueryHookResult = ReturnType<typeof useGetOrganizationSvixUrlQuery>;
export type GetOrganizationSvixUrlLazyQueryHookResult = ReturnType<typeof useGetOrganizationSvixUrlLazyQuery>;
export type GetOrganizationSvixUrlQueryResult = Apollo.QueryResult<
  GetOrganizationSvixUrlQuery,
  GetOrganizationSvixUrlQueryVariables
>;
export const DeleteTrackButtonDocument = gql`
  mutation DeleteTrackButton($trackID: String!) {
    deleteTrack(trackID: $trackID)
  }
`;
export type DeleteTrackButtonMutationFn = Apollo.MutationFunction<
  DeleteTrackButtonMutation,
  DeleteTrackButtonMutationVariables
>;

/**
 * __useDeleteTrackButtonMutation__
 *
 * To run a mutation, you first call `useDeleteTrackButtonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTrackButtonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTrackButtonMutation, { data, loading, error }] = useDeleteTrackButtonMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useDeleteTrackButtonMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteTrackButtonMutation, DeleteTrackButtonMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteTrackButtonMutation, DeleteTrackButtonMutationVariables>(
    DeleteTrackButtonDocument,
    options,
  );
}
export type DeleteTrackButtonMutationHookResult = ReturnType<typeof useDeleteTrackButtonMutation>;
export type DeleteTrackButtonMutationResult = Apollo.MutationResult<DeleteTrackButtonMutation>;
export type DeleteTrackButtonMutationOptions = Apollo.BaseMutationOptions<
  DeleteTrackButtonMutation,
  DeleteTrackButtonMutationVariables
>;
export const CheckUrlEmbeddableDocument = gql`
  query CheckURLEmbeddable($url: String) {
    isURLEmbeddable(url: $url)
  }
`;

/**
 * __useCheckUrlEmbeddableQuery__
 *
 * To run a query within a React component, call `useCheckUrlEmbeddableQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckUrlEmbeddableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckUrlEmbeddableQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useCheckUrlEmbeddableQuery(
  baseOptions?: Apollo.QueryHookOptions<CheckUrlEmbeddableQuery, CheckUrlEmbeddableQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CheckUrlEmbeddableQuery, CheckUrlEmbeddableQueryVariables>(
    CheckUrlEmbeddableDocument,
    options,
  );
}
export function useCheckUrlEmbeddableLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CheckUrlEmbeddableQuery, CheckUrlEmbeddableQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CheckUrlEmbeddableQuery, CheckUrlEmbeddableQueryVariables>(
    CheckUrlEmbeddableDocument,
    options,
  );
}
export type CheckUrlEmbeddableQueryHookResult = ReturnType<typeof useCheckUrlEmbeddableQuery>;
export type CheckUrlEmbeddableLazyQueryHookResult = ReturnType<typeof useCheckUrlEmbeddableLazyQuery>;
export type CheckUrlEmbeddableQueryResult = Apollo.QueryResult<
  CheckUrlEmbeddableQuery,
  CheckUrlEmbeddableQueryVariables
>;
export const UserActivityLogEventsDocument = gql`
  query UserActivityLogEvents($claimID: String!) {
    trackInviteClaim(claimID: $claimID) {
      events {
        time
        message
        participantID
        track {
          id
          slug
        }
        challenge {
          id
          slug
        }
      }
    }
  }
`;

/**
 * __useUserActivityLogEventsQuery__
 *
 * To run a query within a React component, call `useUserActivityLogEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserActivityLogEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserActivityLogEventsQuery({
 *   variables: {
 *      claimID: // value for 'claimID'
 *   },
 * });
 */
export function useUserActivityLogEventsQuery(
  baseOptions: Apollo.QueryHookOptions<UserActivityLogEventsQuery, UserActivityLogEventsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserActivityLogEventsQuery, UserActivityLogEventsQueryVariables>(
    UserActivityLogEventsDocument,
    options,
  );
}
export function useUserActivityLogEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<UserActivityLogEventsQuery, UserActivityLogEventsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UserActivityLogEventsQuery, UserActivityLogEventsQueryVariables>(
    UserActivityLogEventsDocument,
    options,
  );
}
export type UserActivityLogEventsQueryHookResult = ReturnType<typeof useUserActivityLogEventsQuery>;
export type UserActivityLogEventsLazyQueryHookResult = ReturnType<typeof useUserActivityLogEventsLazyQuery>;
export type UserActivityLogEventsQueryResult = Apollo.QueryResult<
  UserActivityLogEventsQuery,
  UserActivityLogEventsQueryVariables
>;
export const AddTrackToArcadeDocument = gql`
  mutation AddTrackToArcade($trackID: String!) {
    addTrackToArcade(trackID: $trackID)
  }
`;
export type AddTrackToArcadeMutationFn = Apollo.MutationFunction<
  AddTrackToArcadeMutation,
  AddTrackToArcadeMutationVariables
>;

/**
 * __useAddTrackToArcadeMutation__
 *
 * To run a mutation, you first call `useAddTrackToArcadeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTrackToArcadeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTrackToArcadeMutation, { data, loading, error }] = useAddTrackToArcadeMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useAddTrackToArcadeMutation(
  baseOptions?: Apollo.MutationHookOptions<AddTrackToArcadeMutation, AddTrackToArcadeMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddTrackToArcadeMutation, AddTrackToArcadeMutationVariables>(
    AddTrackToArcadeDocument,
    options,
  );
}
export type AddTrackToArcadeMutationHookResult = ReturnType<typeof useAddTrackToArcadeMutation>;
export type AddTrackToArcadeMutationResult = Apollo.MutationResult<AddTrackToArcadeMutation>;
export type AddTrackToArcadeMutationOptions = Apollo.BaseMutationOptions<
  AddTrackToArcadeMutation,
  AddTrackToArcadeMutationVariables
>;
export const RemoveTrackFromArcadeDocument = gql`
  mutation RemoveTrackFromArcade($trackID: String!) {
    removeTrackFromArcade(trackID: $trackID)
  }
`;
export type RemoveTrackFromArcadeMutationFn = Apollo.MutationFunction<
  RemoveTrackFromArcadeMutation,
  RemoveTrackFromArcadeMutationVariables
>;

/**
 * __useRemoveTrackFromArcadeMutation__
 *
 * To run a mutation, you first call `useRemoveTrackFromArcadeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTrackFromArcadeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTrackFromArcadeMutation, { data, loading, error }] = useRemoveTrackFromArcadeMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useRemoveTrackFromArcadeMutation(
  baseOptions?: Apollo.MutationHookOptions<RemoveTrackFromArcadeMutation, RemoveTrackFromArcadeMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveTrackFromArcadeMutation, RemoveTrackFromArcadeMutationVariables>(
    RemoveTrackFromArcadeDocument,
    options,
  );
}
export type RemoveTrackFromArcadeMutationHookResult = ReturnType<typeof useRemoveTrackFromArcadeMutation>;
export type RemoveTrackFromArcadeMutationResult = Apollo.MutationResult<RemoveTrackFromArcadeMutation>;
export type RemoveTrackFromArcadeMutationOptions = Apollo.BaseMutationOptions<
  RemoveTrackFromArcadeMutation,
  RemoveTrackFromArcadeMutationVariables
>;
export const ArcadeUpdateMachineUpdateArcadeDocument = gql`
  mutation ArcadeUpdateMachineUpdateArcade($arcade: ArcadeInput!) {
    updateArcade(arcade: $arcade) {
      id
      alternative_url
    }
  }
`;
export type ArcadeUpdateMachineUpdateArcadeMutationFn = Apollo.MutationFunction<
  ArcadeUpdateMachineUpdateArcadeMutation,
  ArcadeUpdateMachineUpdateArcadeMutationVariables
>;

/**
 * __useArcadeUpdateMachineUpdateArcadeMutation__
 *
 * To run a mutation, you first call `useArcadeUpdateMachineUpdateArcadeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArcadeUpdateMachineUpdateArcadeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [arcadeUpdateMachineUpdateArcadeMutation, { data, loading, error }] = useArcadeUpdateMachineUpdateArcadeMutation({
 *   variables: {
 *      arcade: // value for 'arcade'
 *   },
 * });
 */
export function useArcadeUpdateMachineUpdateArcadeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArcadeUpdateMachineUpdateArcadeMutation,
    ArcadeUpdateMachineUpdateArcadeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ArcadeUpdateMachineUpdateArcadeMutation, ArcadeUpdateMachineUpdateArcadeMutationVariables>(
    ArcadeUpdateMachineUpdateArcadeDocument,
    options,
  );
}
export type ArcadeUpdateMachineUpdateArcadeMutationHookResult = ReturnType<
  typeof useArcadeUpdateMachineUpdateArcadeMutation
>;
export type ArcadeUpdateMachineUpdateArcadeMutationResult =
  Apollo.MutationResult<ArcadeUpdateMachineUpdateArcadeMutation>;
export type ArcadeUpdateMachineUpdateArcadeMutationOptions = Apollo.BaseMutationOptions<
  ArcadeUpdateMachineUpdateArcadeMutation,
  ArcadeUpdateMachineUpdateArcadeMutationVariables
>;
export const CreateChallengeFormDocument = gql`
  query CreateChallengeForm($trackSlug: String!, $teamSlug: String!) {
    track(trackSlug: $trackSlug, teamSlug: $teamSlug) {
      id
    }
  }
`;

/**
 * __useCreateChallengeFormQuery__
 *
 * To run a query within a React component, call `useCreateChallengeFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateChallengeFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateChallengeFormQuery({
 *   variables: {
 *      trackSlug: // value for 'trackSlug'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useCreateChallengeFormQuery(
  baseOptions: Apollo.QueryHookOptions<CreateChallengeFormQuery, CreateChallengeFormQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CreateChallengeFormQuery, CreateChallengeFormQueryVariables>(
    CreateChallengeFormDocument,
    options,
  );
}
export function useCreateChallengeFormLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CreateChallengeFormQuery, CreateChallengeFormQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CreateChallengeFormQuery, CreateChallengeFormQueryVariables>(
    CreateChallengeFormDocument,
    options,
  );
}
export type CreateChallengeFormQueryHookResult = ReturnType<typeof useCreateChallengeFormQuery>;
export type CreateChallengeFormLazyQueryHookResult = ReturnType<typeof useCreateChallengeFormLazyQuery>;
export type CreateChallengeFormQueryResult = Apollo.QueryResult<
  CreateChallengeFormQuery,
  CreateChallengeFormQueryVariables
>;
export const CreateChallengeDocument = gql`
  mutation CreateChallenge($challenge: ChallengeInput!) {
    createChallenge(challenge: $challenge) {
      ...ChallengeFormData
    }
  }
  ${ChallengeFormDataFragmentDoc}
`;
export type CreateChallengeMutationFn = Apollo.MutationFunction<
  CreateChallengeMutation,
  CreateChallengeMutationVariables
>;

/**
 * __useCreateChallengeMutation__
 *
 * To run a mutation, you first call `useCreateChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChallengeMutation, { data, loading, error }] = useCreateChallengeMutation({
 *   variables: {
 *      challenge: // value for 'challenge'
 *   },
 * });
 */
export function useCreateChallengeMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateChallengeMutation, CreateChallengeMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateChallengeMutation, CreateChallengeMutationVariables>(
    CreateChallengeDocument,
    options,
  );
}
export type CreateChallengeMutationHookResult = ReturnType<typeof useCreateChallengeMutation>;
export type CreateChallengeMutationResult = Apollo.MutationResult<CreateChallengeMutation>;
export type CreateChallengeMutationOptions = Apollo.BaseMutationOptions<
  CreateChallengeMutation,
  CreateChallengeMutationVariables
>;
export const EditChallengeFormDocument = gql`
  query EditChallengeForm($trackSlug: String!, $teamSlug: String!, $challengeID: String!) {
    track(trackSlug: $trackSlug, teamSlug: $teamSlug) {
      id
    }
    challenge(challengeID: $challengeID) {
      ...ChallengeFormData
    }
  }
  ${ChallengeFormDataFragmentDoc}
`;

/**
 * __useEditChallengeFormQuery__
 *
 * To run a query within a React component, call `useEditChallengeFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditChallengeFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditChallengeFormQuery({
 *   variables: {
 *      trackSlug: // value for 'trackSlug'
 *      teamSlug: // value for 'teamSlug'
 *      challengeID: // value for 'challengeID'
 *   },
 * });
 */
export function useEditChallengeFormQuery(
  baseOptions: Apollo.QueryHookOptions<EditChallengeFormQuery, EditChallengeFormQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EditChallengeFormQuery, EditChallengeFormQueryVariables>(EditChallengeFormDocument, options);
}
export function useEditChallengeFormLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<EditChallengeFormQuery, EditChallengeFormQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<EditChallengeFormQuery, EditChallengeFormQueryVariables>(
    EditChallengeFormDocument,
    options,
  );
}
export type EditChallengeFormQueryHookResult = ReturnType<typeof useEditChallengeFormQuery>;
export type EditChallengeFormLazyQueryHookResult = ReturnType<typeof useEditChallengeFormLazyQuery>;
export type EditChallengeFormQueryResult = Apollo.QueryResult<EditChallengeFormQuery, EditChallengeFormQueryVariables>;
export const UpdateChallengeDocument = gql`
  mutation UpdateChallenge($challenge: ChallengeInput!) {
    updateChallenge(challenge: $challenge) {
      ...ChallengeFormData
    }
  }
  ${ChallengeFormDataFragmentDoc}
`;
export type UpdateChallengeMutationFn = Apollo.MutationFunction<
  UpdateChallengeMutation,
  UpdateChallengeMutationVariables
>;

/**
 * __useUpdateChallengeMutation__
 *
 * To run a mutation, you first call `useUpdateChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChallengeMutation, { data, loading, error }] = useUpdateChallengeMutation({
 *   variables: {
 *      challenge: // value for 'challenge'
 *   },
 * });
 */
export function useUpdateChallengeMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateChallengeMutation, UpdateChallengeMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateChallengeMutation, UpdateChallengeMutationVariables>(
    UpdateChallengeDocument,
    options,
  );
}
export type UpdateChallengeMutationHookResult = ReturnType<typeof useUpdateChallengeMutation>;
export type UpdateChallengeMutationResult = Apollo.MutationResult<UpdateChallengeMutation>;
export type UpdateChallengeMutationOptions = Apollo.BaseMutationOptions<
  UpdateChallengeMutation,
  UpdateChallengeMutationVariables
>;
export const ChallengeNoteListSortNotesDocument = gql`
  mutation ChallengeNoteListSortNotes($challengeID: String!, $notes: [String!]!) {
    updateChallengeNoteIndexes(challengeID: $challengeID, notes: $notes) {
      id
      index
    }
  }
`;
export type ChallengeNoteListSortNotesMutationFn = Apollo.MutationFunction<
  ChallengeNoteListSortNotesMutation,
  ChallengeNoteListSortNotesMutationVariables
>;

/**
 * __useChallengeNoteListSortNotesMutation__
 *
 * To run a mutation, you first call `useChallengeNoteListSortNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChallengeNoteListSortNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [challengeNoteListSortNotesMutation, { data, loading, error }] = useChallengeNoteListSortNotesMutation({
 *   variables: {
 *      challengeID: // value for 'challengeID'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useChallengeNoteListSortNotesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChallengeNoteListSortNotesMutation,
    ChallengeNoteListSortNotesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ChallengeNoteListSortNotesMutation, ChallengeNoteListSortNotesMutationVariables>(
    ChallengeNoteListSortNotesDocument,
    options,
  );
}
export type ChallengeNoteListSortNotesMutationHookResult = ReturnType<typeof useChallengeNoteListSortNotesMutation>;
export type ChallengeNoteListSortNotesMutationResult = Apollo.MutationResult<ChallengeNoteListSortNotesMutation>;
export type ChallengeNoteListSortNotesMutationOptions = Apollo.BaseMutationOptions<
  ChallengeNoteListSortNotesMutation,
  ChallengeNoteListSortNotesMutationVariables
>;
export const ChallengeNoteListDeleteNoteDocument = gql`
  mutation ChallengeNoteListDeleteNote($noteID: String!) {
    deleteChallengeNote(noteID: $noteID)
  }
`;
export type ChallengeNoteListDeleteNoteMutationFn = Apollo.MutationFunction<
  ChallengeNoteListDeleteNoteMutation,
  ChallengeNoteListDeleteNoteMutationVariables
>;

/**
 * __useChallengeNoteListDeleteNoteMutation__
 *
 * To run a mutation, you first call `useChallengeNoteListDeleteNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChallengeNoteListDeleteNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [challengeNoteListDeleteNoteMutation, { data, loading, error }] = useChallengeNoteListDeleteNoteMutation({
 *   variables: {
 *      noteID: // value for 'noteID'
 *   },
 * });
 */
export function useChallengeNoteListDeleteNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChallengeNoteListDeleteNoteMutation,
    ChallengeNoteListDeleteNoteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ChallengeNoteListDeleteNoteMutation, ChallengeNoteListDeleteNoteMutationVariables>(
    ChallengeNoteListDeleteNoteDocument,
    options,
  );
}
export type ChallengeNoteListDeleteNoteMutationHookResult = ReturnType<typeof useChallengeNoteListDeleteNoteMutation>;
export type ChallengeNoteListDeleteNoteMutationResult = Apollo.MutationResult<ChallengeNoteListDeleteNoteMutation>;
export type ChallengeNoteListDeleteNoteMutationOptions = Apollo.BaseMutationOptions<
  ChallengeNoteListDeleteNoteMutation,
  ChallengeNoteListDeleteNoteMutationVariables
>;
export const ChallengeTabDrawerDocument = gql`
  query ChallengeTabDrawer($trackID: String!) {
    track(trackID: $trackID) {
      sandboxConfig {
        resources {
          containers {
            id
            name
          }
          virtualmachines {
            id
            name
          }
          virtualbrowsers {
            id
            name
          }
        }
      }
    }
    trackConfig(trackID: $trackID) {
      id
      containers {
        id
        name
      }
      virtualmachines {
        id
        name
      }
      virtualbrowsers {
        id
        name
      }
    }
  }
`;

/**
 * __useChallengeTabDrawerQuery__
 *
 * To run a query within a React component, call `useChallengeTabDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useChallengeTabDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChallengeTabDrawerQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useChallengeTabDrawerQuery(
  baseOptions: Apollo.QueryHookOptions<ChallengeTabDrawerQuery, ChallengeTabDrawerQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ChallengeTabDrawerQuery, ChallengeTabDrawerQueryVariables>(
    ChallengeTabDrawerDocument,
    options,
  );
}
export function useChallengeTabDrawerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ChallengeTabDrawerQuery, ChallengeTabDrawerQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ChallengeTabDrawerQuery, ChallengeTabDrawerQueryVariables>(
    ChallengeTabDrawerDocument,
    options,
  );
}
export type ChallengeTabDrawerQueryHookResult = ReturnType<typeof useChallengeTabDrawerQuery>;
export type ChallengeTabDrawerLazyQueryHookResult = ReturnType<typeof useChallengeTabDrawerLazyQuery>;
export type ChallengeTabDrawerQueryResult = Apollo.QueryResult<
  ChallengeTabDrawerQuery,
  ChallengeTabDrawerQueryVariables
>;
export const UpdateChallengeTabDocument = gql`
  mutation updateChallengeTab($tab: ChallengeTabInput!) {
    updateChallengeTab(tab: $tab) {
      id
      title
    }
  }
`;
export type UpdateChallengeTabMutationFn = Apollo.MutationFunction<
  UpdateChallengeTabMutation,
  UpdateChallengeTabMutationVariables
>;

/**
 * __useUpdateChallengeTabMutation__
 *
 * To run a mutation, you first call `useUpdateChallengeTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChallengeTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChallengeTabMutation, { data, loading, error }] = useUpdateChallengeTabMutation({
 *   variables: {
 *      tab: // value for 'tab'
 *   },
 * });
 */
export function useUpdateChallengeTabMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateChallengeTabMutation, UpdateChallengeTabMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateChallengeTabMutation, UpdateChallengeTabMutationVariables>(
    UpdateChallengeTabDocument,
    options,
  );
}
export type UpdateChallengeTabMutationHookResult = ReturnType<typeof useUpdateChallengeTabMutation>;
export type UpdateChallengeTabMutationResult = Apollo.MutationResult<UpdateChallengeTabMutation>;
export type UpdateChallengeTabMutationOptions = Apollo.BaseMutationOptions<
  UpdateChallengeTabMutation,
  UpdateChallengeTabMutationVariables
>;
export const CreateChallengeTabDocument = gql`
  mutation createChallengeTab($tab: ChallengeTabInput!) {
    createChallengeTab(tab: $tab) {
      id
      title
    }
  }
`;
export type CreateChallengeTabMutationFn = Apollo.MutationFunction<
  CreateChallengeTabMutation,
  CreateChallengeTabMutationVariables
>;

/**
 * __useCreateChallengeTabMutation__
 *
 * To run a mutation, you first call `useCreateChallengeTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChallengeTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChallengeTabMutation, { data, loading, error }] = useCreateChallengeTabMutation({
 *   variables: {
 *      tab: // value for 'tab'
 *   },
 * });
 */
export function useCreateChallengeTabMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateChallengeTabMutation, CreateChallengeTabMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateChallengeTabMutation, CreateChallengeTabMutationVariables>(
    CreateChallengeTabDocument,
    options,
  );
}
export type CreateChallengeTabMutationHookResult = ReturnType<typeof useCreateChallengeTabMutation>;
export type CreateChallengeTabMutationResult = Apollo.MutationResult<CreateChallengeTabMutation>;
export type CreateChallengeTabMutationOptions = Apollo.BaseMutationOptions<
  CreateChallengeTabMutation,
  CreateChallengeTabMutationVariables
>;
export const ChallengeTabListSortTabsDocument = gql`
  mutation ChallengeTabListSortTabs($challengeID: String!, $tabs: [String!]!) {
    updateChallengeTabIndexes(challengeID: $challengeID, tabs: $tabs) {
      id
      title
      index
    }
  }
`;
export type ChallengeTabListSortTabsMutationFn = Apollo.MutationFunction<
  ChallengeTabListSortTabsMutation,
  ChallengeTabListSortTabsMutationVariables
>;

/**
 * __useChallengeTabListSortTabsMutation__
 *
 * To run a mutation, you first call `useChallengeTabListSortTabsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChallengeTabListSortTabsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [challengeTabListSortTabsMutation, { data, loading, error }] = useChallengeTabListSortTabsMutation({
 *   variables: {
 *      challengeID: // value for 'challengeID'
 *      tabs: // value for 'tabs'
 *   },
 * });
 */
export function useChallengeTabListSortTabsMutation(
  baseOptions?: Apollo.MutationHookOptions<ChallengeTabListSortTabsMutation, ChallengeTabListSortTabsMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ChallengeTabListSortTabsMutation, ChallengeTabListSortTabsMutationVariables>(
    ChallengeTabListSortTabsDocument,
    options,
  );
}
export type ChallengeTabListSortTabsMutationHookResult = ReturnType<typeof useChallengeTabListSortTabsMutation>;
export type ChallengeTabListSortTabsMutationResult = Apollo.MutationResult<ChallengeTabListSortTabsMutation>;
export type ChallengeTabListSortTabsMutationOptions = Apollo.BaseMutationOptions<
  ChallengeTabListSortTabsMutation,
  ChallengeTabListSortTabsMutationVariables
>;
export const ChallengeTabListDeleteTabDocument = gql`
  mutation ChallengeTabListDeleteTab($tabID: String!) {
    deleteChallengeTab(tabID: $tabID)
  }
`;
export type ChallengeTabListDeleteTabMutationFn = Apollo.MutationFunction<
  ChallengeTabListDeleteTabMutation,
  ChallengeTabListDeleteTabMutationVariables
>;

/**
 * __useChallengeTabListDeleteTabMutation__
 *
 * To run a mutation, you first call `useChallengeTabListDeleteTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChallengeTabListDeleteTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [challengeTabListDeleteTabMutation, { data, loading, error }] = useChallengeTabListDeleteTabMutation({
 *   variables: {
 *      tabID: // value for 'tabID'
 *   },
 * });
 */
export function useChallengeTabListDeleteTabMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChallengeTabListDeleteTabMutation,
    ChallengeTabListDeleteTabMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ChallengeTabListDeleteTabMutation, ChallengeTabListDeleteTabMutationVariables>(
    ChallengeTabListDeleteTabDocument,
    options,
  );
}
export type ChallengeTabListDeleteTabMutationHookResult = ReturnType<typeof useChallengeTabListDeleteTabMutation>;
export type ChallengeTabListDeleteTabMutationResult = Apollo.MutationResult<ChallengeTabListDeleteTabMutation>;
export type ChallengeTabListDeleteTabMutationOptions = Apollo.BaseMutationOptions<
  ChallengeTabListDeleteTabMutation,
  ChallengeTabListDeleteTabMutationVariables
>;
export const CopyTrackModalDocument = gql`
  query CopyTrackModal($trackID: String!) {
    track(trackID: $trackID) {
      id
      version
      slug
      icon
      title
      teaser
      description
      level
      tags
      owner
      idle_timeout
      timelimit
      status
      developers {
        profile {
          email
        }
      }
      private
      published
      maintenance
      show_timer
      skipping_enabled
      challenges {
        id
        type
        slug
        title
        teaser
        notes {
          type
          contents
          url
        }
        difficulty
        assignment
        timelimit
        tabs {
          cmd
          type
          title
          hostname
          path
          port
          url
          new_window
        }
        scripts {
          host
          action
          contents
        }
        answers
        solution
      }
      config {
        version
        containers {
          name
          image
          entrypoint
          cmd
          shell
          ports
          environment {
            key
            value
          }
          memory
        }
        virtualmachines {
          name
          image
          machine_type
          allow_external_ingress
          shell
          environment {
            key
            value
          }
          memory
          cpus
        }
        gcp_projects {
          name
          services
        }
        aws_accounts {
          name
          iam_policy
          managed_policies
          scp_policy
        }
        azure_subscriptions {
          name
          user_only
          roles
        }
      }
      scripts {
        id
        action
        contents
        host
      }
    }
  }
`;

/**
 * __useCopyTrackModalQuery__
 *
 * To run a query within a React component, call `useCopyTrackModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useCopyTrackModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCopyTrackModalQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useCopyTrackModalQuery(
  baseOptions: Apollo.QueryHookOptions<CopyTrackModalQuery, CopyTrackModalQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CopyTrackModalQuery, CopyTrackModalQueryVariables>(CopyTrackModalDocument, options);
}
export function useCopyTrackModalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CopyTrackModalQuery, CopyTrackModalQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CopyTrackModalQuery, CopyTrackModalQueryVariables>(CopyTrackModalDocument, options);
}
export type CopyTrackModalQueryHookResult = ReturnType<typeof useCopyTrackModalQuery>;
export type CopyTrackModalLazyQueryHookResult = ReturnType<typeof useCopyTrackModalLazyQuery>;
export type CopyTrackModalQueryResult = Apollo.QueryResult<CopyTrackModalQuery, CopyTrackModalQueryVariables>;
export const TrackExistsDocument = gql`
  query TrackExists($trackSlug: String!, $teamSlug: String!) {
    trackExists(trackSlug: $trackSlug, organizationSlug: $teamSlug)
  }
`;

/**
 * __useTrackExistsQuery__
 *
 * To run a query within a React component, call `useTrackExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackExistsQuery({
 *   variables: {
 *      trackSlug: // value for 'trackSlug'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useTrackExistsQuery(baseOptions: Apollo.QueryHookOptions<TrackExistsQuery, TrackExistsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TrackExistsQuery, TrackExistsQueryVariables>(TrackExistsDocument, options);
}
export function useTrackExistsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TrackExistsQuery, TrackExistsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TrackExistsQuery, TrackExistsQueryVariables>(TrackExistsDocument, options);
}
export type TrackExistsQueryHookResult = ReturnType<typeof useTrackExistsQuery>;
export type TrackExistsLazyQueryHookResult = ReturnType<typeof useTrackExistsLazyQuery>;
export type TrackExistsQueryResult = Apollo.QueryResult<TrackExistsQuery, TrackExistsQueryVariables>;
export const CreateTrackFromModalDocument = gql`
  mutation CreateTrackFromModal($track: TrackInput!) {
    createTrack(track: $track) {
      id
      owner
      slug
    }
  }
`;
export type CreateTrackFromModalMutationFn = Apollo.MutationFunction<
  CreateTrackFromModalMutation,
  CreateTrackFromModalMutationVariables
>;

/**
 * __useCreateTrackFromModalMutation__
 *
 * To run a mutation, you first call `useCreateTrackFromModalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTrackFromModalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTrackFromModalMutation, { data, loading, error }] = useCreateTrackFromModalMutation({
 *   variables: {
 *      track: // value for 'track'
 *   },
 * });
 */
export function useCreateTrackFromModalMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateTrackFromModalMutation, CreateTrackFromModalMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateTrackFromModalMutation, CreateTrackFromModalMutationVariables>(
    CreateTrackFromModalDocument,
    options,
  );
}
export type CreateTrackFromModalMutationHookResult = ReturnType<typeof useCreateTrackFromModalMutation>;
export type CreateTrackFromModalMutationResult = Apollo.MutationResult<CreateTrackFromModalMutation>;
export type CreateTrackFromModalMutationOptions = Apollo.BaseMutationOptions<
  CreateTrackFromModalMutation,
  CreateTrackFromModalMutationVariables
>;
export const TeamExistsDocument = gql`
  query teamExists($teamSlug: String!) {
    teamExists(teamSlug: $teamSlug)
  }
`;

/**
 * __useTeamExistsQuery__
 *
 * To run a query within a React component, call `useTeamExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamExistsQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useTeamExistsQuery(baseOptions: Apollo.QueryHookOptions<TeamExistsQuery, TeamExistsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TeamExistsQuery, TeamExistsQueryVariables>(TeamExistsDocument, options);
}
export function useTeamExistsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TeamExistsQuery, TeamExistsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TeamExistsQuery, TeamExistsQueryVariables>(TeamExistsDocument, options);
}
export type TeamExistsQueryHookResult = ReturnType<typeof useTeamExistsQuery>;
export type TeamExistsLazyQueryHookResult = ReturnType<typeof useTeamExistsLazyQuery>;
export type TeamExistsQueryResult = Apollo.QueryResult<TeamExistsQuery, TeamExistsQueryVariables>;
export const UpdateLocalOrganizationDocument = gql`
  mutation updateLocalOrganization($id: String!, $organization: OrganizationInput!) {
    updateLocalOrganization(id: $id, organization: $organization) @client {
      id
      slug
    }
  }
`;
export type UpdateLocalOrganizationMutationFn = Apollo.MutationFunction<
  UpdateLocalOrganizationMutation,
  UpdateLocalOrganizationMutationVariables
>;

/**
 * __useUpdateLocalOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateLocalOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocalOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocalOrganizationMutation, { data, loading, error }] = useUpdateLocalOrganizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      organization: // value for 'organization'
 *   },
 * });
 */
export function useUpdateLocalOrganizationMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateLocalOrganizationMutation, UpdateLocalOrganizationMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateLocalOrganizationMutation, UpdateLocalOrganizationMutationVariables>(
    UpdateLocalOrganizationDocument,
    options,
  );
}
export type UpdateLocalOrganizationMutationHookResult = ReturnType<typeof useUpdateLocalOrganizationMutation>;
export type UpdateLocalOrganizationMutationResult = Apollo.MutationResult<UpdateLocalOrganizationMutation>;
export type UpdateLocalOrganizationMutationOptions = Apollo.BaseMutationOptions<
  UpdateLocalOrganizationMutation,
  UpdateLocalOrganizationMutationVariables
>;
export const UpdateOrganizationDocument = gql`
  mutation updateOrganization($organization: OrganizationInput!) {
    updateOrganization(organization: $organization) {
      id
      slug
    }
  }
`;
export type UpdateOrganizationMutationFn = Apollo.MutationFunction<
  UpdateOrganizationMutation,
  UpdateOrganizationMutationVariables
>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      organization: // value for 'organization'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>(
    UpdateOrganizationDocument,
    options,
  );
}
export type UpdateOrganizationMutationHookResult = ReturnType<typeof useUpdateOrganizationMutation>;
export type UpdateOrganizationMutationResult = Apollo.MutationResult<UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<
  UpdateOrganizationMutation,
  UpdateOrganizationMutationVariables
>;
export const OrganizationDocument = gql`
  query organization($teamSlug: String!) {
    organization(organizationSlug: $teamSlug) {
      id
      name
      logo
      title
      subtitle
      slug
      primary_link_text
      primary_link_url
      secondary_link_text
      secondary_link_url
      theme {
        foreground_color
        foreground_image
        background_color
        background_image
        primary_foreground_color
        primary_background_color
        secondary_foreground_color
        secondary_background_color
      }
    }
  }
`;

/**
 * __useOrganizationQuery__
 *
 * To run a query within a React component, call `useOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useOrganizationQuery(
  baseOptions: Apollo.QueryHookOptions<OrganizationQuery, OrganizationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
}
export function useOrganizationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OrganizationQuery, OrganizationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
}
export type OrganizationQueryHookResult = ReturnType<typeof useOrganizationQuery>;
export type OrganizationLazyQueryHookResult = ReturnType<typeof useOrganizationLazyQuery>;
export type OrganizationQueryResult = Apollo.QueryResult<OrganizationQuery, OrganizationQueryVariables>;
export const GetOrganizationDashboardDocument = gql`
  query getOrganizationDashboard($teamSlug: String!) {
    userInTeam(teamSlug: $teamSlug)
    organization(organizationSlug: $teamSlug) {
      id
      name
      logo
      title
      subtitle
      slug
      primary_link_text
      primary_link_url
      secondary_link_text
      secondary_link_url
      theme {
        foreground_color
        foreground_image
        background_color
        background_image
        primary_foreground_color
        primary_background_color
        secondary_foreground_color
        secondary_background_color
      }
      features {
        hot_start
        invites
        statistics
        webhooks
      }
    }
    tracks(teamSlug: $teamSlug) {
      id
      permalink
      slug
      icon
      title
      teaser
      level
      tags
      started
      creating
      created
      failed
      stopped
      completed
      cleaned
      published
      private
      owner
    }
  }
`;

/**
 * __useGetOrganizationDashboardQuery__
 *
 * To run a query within a React component, call `useGetOrganizationDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationDashboardQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useGetOrganizationDashboardQuery(
  baseOptions: Apollo.QueryHookOptions<GetOrganizationDashboardQuery, GetOrganizationDashboardQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOrganizationDashboardQuery, GetOrganizationDashboardQueryVariables>(
    GetOrganizationDashboardDocument,
    options,
  );
}
export function useGetOrganizationDashboardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationDashboardQuery, GetOrganizationDashboardQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetOrganizationDashboardQuery, GetOrganizationDashboardQueryVariables>(
    GetOrganizationDashboardDocument,
    options,
  );
}
export type GetOrganizationDashboardQueryHookResult = ReturnType<typeof useGetOrganizationDashboardQuery>;
export type GetOrganizationDashboardLazyQueryHookResult = ReturnType<typeof useGetOrganizationDashboardLazyQuery>;
export type GetOrganizationDashboardQueryResult = Apollo.QueryResult<
  GetOrganizationDashboardQuery,
  GetOrganizationDashboardQueryVariables
>;
export const EditorLayoutDocument = gql`
  query EditorLayout($trackID: String!, $teamSlug: String!) {
    team(teamSlug: $teamSlug) {
      id
      theme {
        ...EditorHeroTeamTheme
      }
    }
    userIsTrackDeveloper(trackID: $trackID, teamSlug: $teamSlug)
    track(trackID: $trackID, teamSlug: $teamSlug) {
      id
      title
    }
  }
  ${EditorHeroTeamThemeFragmentDoc}
`;

/**
 * __useEditorLayoutQuery__
 *
 * To run a query within a React component, call `useEditorLayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditorLayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditorLayoutQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useEditorLayoutQuery(
  baseOptions: Apollo.QueryHookOptions<EditorLayoutQuery, EditorLayoutQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EditorLayoutQuery, EditorLayoutQueryVariables>(EditorLayoutDocument, options);
}
export function useEditorLayoutLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<EditorLayoutQuery, EditorLayoutQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<EditorLayoutQuery, EditorLayoutQueryVariables>(EditorLayoutDocument, options);
}
export type EditorLayoutQueryHookResult = ReturnType<typeof useEditorLayoutQuery>;
export type EditorLayoutLazyQueryHookResult = ReturnType<typeof useEditorLayoutLazyQuery>;
export type EditorLayoutQueryResult = Apollo.QueryResult<EditorLayoutQuery, EditorLayoutQueryVariables>;
export const GetFormConfigurationDocument = gql`
  query GetFormConfiguration($teamSlug: String!) {
    team(teamSlug: $teamSlug) {
      name
      form {
        ...FormConfigurationFragment
      }
    }
  }
  ${FormConfigurationFragmentFragmentDoc}
`;

/**
 * __useGetFormConfigurationQuery__
 *
 * To run a query within a React component, call `useGetFormConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormConfigurationQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useGetFormConfigurationQuery(
  baseOptions: Apollo.QueryHookOptions<GetFormConfigurationQuery, GetFormConfigurationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFormConfigurationQuery, GetFormConfigurationQueryVariables>(
    GetFormConfigurationDocument,
    options,
  );
}
export function useGetFormConfigurationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetFormConfigurationQuery, GetFormConfigurationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetFormConfigurationQuery, GetFormConfigurationQueryVariables>(
    GetFormConfigurationDocument,
    options,
  );
}
export type GetFormConfigurationQueryHookResult = ReturnType<typeof useGetFormConfigurationQuery>;
export type GetFormConfigurationLazyQueryHookResult = ReturnType<typeof useGetFormConfigurationLazyQuery>;
export type GetFormConfigurationQueryResult = Apollo.QueryResult<
  GetFormConfigurationQuery,
  GetFormConfigurationQueryVariables
>;
export const UpdateFormConfigurationDocument = gql`
  mutation UpdateFormConfiguration($form: FormInput!) {
    updateForm(form: $form) {
      ...FormConfigurationFragment
    }
  }
  ${FormConfigurationFragmentFragmentDoc}
`;
export type UpdateFormConfigurationMutationFn = Apollo.MutationFunction<
  UpdateFormConfigurationMutation,
  UpdateFormConfigurationMutationVariables
>;

/**
 * __useUpdateFormConfigurationMutation__
 *
 * To run a mutation, you first call `useUpdateFormConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormConfigurationMutation, { data, loading, error }] = useUpdateFormConfigurationMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useUpdateFormConfigurationMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateFormConfigurationMutation, UpdateFormConfigurationMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateFormConfigurationMutation, UpdateFormConfigurationMutationVariables>(
    UpdateFormConfigurationDocument,
    options,
  );
}
export type UpdateFormConfigurationMutationHookResult = ReturnType<typeof useUpdateFormConfigurationMutation>;
export type UpdateFormConfigurationMutationResult = Apollo.MutationResult<UpdateFormConfigurationMutation>;
export type UpdateFormConfigurationMutationOptions = Apollo.BaseMutationOptions<
  UpdateFormConfigurationMutation,
  UpdateFormConfigurationMutationVariables
>;
export const GetSandboxPresetCardInfoDocument = gql`
  query getSandboxPresetCardInfo($configVersionID: String!) {
    sandboxConfigVersion(configVersionID: $configVersionID) {
      id
      resources {
        ...PreviewResourceSandboxResources
        secrets {
          name
        }
      }
      scripts {
        action
        contents
        host
      }
    }
  }
  ${PreviewResourceSandboxResourcesFragmentDoc}
`;

/**
 * __useGetSandboxPresetCardInfoQuery__
 *
 * To run a query within a React component, call `useGetSandboxPresetCardInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSandboxPresetCardInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSandboxPresetCardInfoQuery({
 *   variables: {
 *      configVersionID: // value for 'configVersionID'
 *   },
 * });
 */
export function useGetSandboxPresetCardInfoQuery(
  baseOptions: Apollo.QueryHookOptions<GetSandboxPresetCardInfoQuery, GetSandboxPresetCardInfoQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSandboxPresetCardInfoQuery, GetSandboxPresetCardInfoQueryVariables>(
    GetSandboxPresetCardInfoDocument,
    options,
  );
}
export function useGetSandboxPresetCardInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSandboxPresetCardInfoQuery, GetSandboxPresetCardInfoQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSandboxPresetCardInfoQuery, GetSandboxPresetCardInfoQueryVariables>(
    GetSandboxPresetCardInfoDocument,
    options,
  );
}
export type GetSandboxPresetCardInfoQueryHookResult = ReturnType<typeof useGetSandboxPresetCardInfoQuery>;
export type GetSandboxPresetCardInfoLazyQueryHookResult = ReturnType<typeof useGetSandboxPresetCardInfoLazyQuery>;
export type GetSandboxPresetCardInfoQueryResult = Apollo.QueryResult<
  GetSandboxPresetCardInfoQuery,
  GetSandboxPresetCardInfoQueryVariables
>;
export const TrackStatisticsDocument = gql`
  query TrackStatistics($trackID: String, $teamSlug: String, $start: Time, $end: Time, $filterDevelopers: Boolean) {
    statistics(trackID: $trackID, teamSlug: $teamSlug, start: $start, end: $end, filterDevelopers: $filterDevelopers) {
      track {
        ...TotalTrackStartsTrackStatistics
        track_series {
          ...DailyTrackStartsTrackSeries
        }
        challenge_series {
          ...DailyTrackStartsChallengeSeries
        }
        happiness {
          ...UserHappinessHappinessCount
        }
        challenges {
          ...TotalChallengeStartsChallengeStatistics
          ...ChallengeAttemptsChallengeStatistics
          ...ChallengeDurationChallengeStatistics
        }
      }
    }
  }
  ${TotalTrackStartsTrackStatisticsFragmentDoc}
  ${DailyTrackStartsTrackSeriesFragmentDoc}
  ${DailyTrackStartsChallengeSeriesFragmentDoc}
  ${UserHappinessHappinessCountFragmentDoc}
  ${TotalChallengeStartsChallengeStatisticsFragmentDoc}
  ${ChallengeAttemptsChallengeStatisticsFragmentDoc}
  ${ChallengeDurationChallengeStatisticsFragmentDoc}
`;

/**
 * __useTrackStatisticsQuery__
 *
 * To run a query within a React component, call `useTrackStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackStatisticsQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      teamSlug: // value for 'teamSlug'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      filterDevelopers: // value for 'filterDevelopers'
 *   },
 * });
 */
export function useTrackStatisticsQuery(
  baseOptions?: Apollo.QueryHookOptions<TrackStatisticsQuery, TrackStatisticsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TrackStatisticsQuery, TrackStatisticsQueryVariables>(TrackStatisticsDocument, options);
}
export function useTrackStatisticsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TrackStatisticsQuery, TrackStatisticsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TrackStatisticsQuery, TrackStatisticsQueryVariables>(TrackStatisticsDocument, options);
}
export type TrackStatisticsQueryHookResult = ReturnType<typeof useTrackStatisticsQuery>;
export type TrackStatisticsLazyQueryHookResult = ReturnType<typeof useTrackStatisticsLazyQuery>;
export type TrackStatisticsQueryResult = Apollo.QueryResult<TrackStatisticsQuery, TrackStatisticsQueryVariables>;
export const CreateTrackFromScrachDocument = gql`
  mutation CreateTrackFromScrach($track: TrackInput!) {
    createTrack(track: $track) {
      id
      owner
      slug
    }
  }
`;
export type CreateTrackFromScrachMutationFn = Apollo.MutationFunction<
  CreateTrackFromScrachMutation,
  CreateTrackFromScrachMutationVariables
>;

/**
 * __useCreateTrackFromScrachMutation__
 *
 * To run a mutation, you first call `useCreateTrackFromScrachMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTrackFromScrachMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTrackFromScrachMutation, { data, loading, error }] = useCreateTrackFromScrachMutation({
 *   variables: {
 *      track: // value for 'track'
 *   },
 * });
 */
export function useCreateTrackFromScrachMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateTrackFromScrachMutation, CreateTrackFromScrachMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateTrackFromScrachMutation, CreateTrackFromScrachMutationVariables>(
    CreateTrackFromScrachDocument,
    options,
  );
}
export type CreateTrackFromScrachMutationHookResult = ReturnType<typeof useCreateTrackFromScrachMutation>;
export type CreateTrackFromScrachMutationResult = Apollo.MutationResult<CreateTrackFromScrachMutation>;
export type CreateTrackFromScrachMutationOptions = Apollo.BaseMutationOptions<
  CreateTrackFromScrachMutation,
  CreateTrackFromScrachMutationVariables
>;
export const UpdateTrackDashboardOptionsDocument = gql`
  mutation UpdateTrackDashboardOptions($track: TrackInput!) {
    updateTrack(track: $track) {
      id
      maintenance
      show_timer
      skipping_enabled
    }
  }
`;
export type UpdateTrackDashboardOptionsMutationFn = Apollo.MutationFunction<
  UpdateTrackDashboardOptionsMutation,
  UpdateTrackDashboardOptionsMutationVariables
>;

/**
 * __useUpdateTrackDashboardOptionsMutation__
 *
 * To run a mutation, you first call `useUpdateTrackDashboardOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrackDashboardOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrackDashboardOptionsMutation, { data, loading, error }] = useUpdateTrackDashboardOptionsMutation({
 *   variables: {
 *      track: // value for 'track'
 *   },
 * });
 */
export function useUpdateTrackDashboardOptionsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTrackDashboardOptionsMutation,
    UpdateTrackDashboardOptionsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateTrackDashboardOptionsMutation, UpdateTrackDashboardOptionsMutationVariables>(
    UpdateTrackDashboardOptionsDocument,
    options,
  );
}
export type UpdateTrackDashboardOptionsMutationHookResult = ReturnType<typeof useUpdateTrackDashboardOptionsMutation>;
export type UpdateTrackDashboardOptionsMutationResult = Apollo.MutationResult<UpdateTrackDashboardOptionsMutation>;
export type UpdateTrackDashboardOptionsMutationOptions = Apollo.BaseMutationOptions<
  UpdateTrackDashboardOptionsMutation,
  UpdateTrackDashboardOptionsMutationVariables
>;
export const TrackDetailsFormDocument = gql`
  query TrackDetailsForm($trackSlug: String!, $teamSlug: String!) {
    track(trackSlug: $trackSlug, teamSlug: $teamSlug) {
      ...TrackDetailsFormData
    }
  }
  ${TrackDetailsFormDataFragmentDoc}
`;

/**
 * __useTrackDetailsFormQuery__
 *
 * To run a query within a React component, call `useTrackDetailsFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackDetailsFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackDetailsFormQuery({
 *   variables: {
 *      trackSlug: // value for 'trackSlug'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useTrackDetailsFormQuery(
  baseOptions: Apollo.QueryHookOptions<TrackDetailsFormQuery, TrackDetailsFormQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TrackDetailsFormQuery, TrackDetailsFormQueryVariables>(TrackDetailsFormDocument, options);
}
export function useTrackDetailsFormLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TrackDetailsFormQuery, TrackDetailsFormQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TrackDetailsFormQuery, TrackDetailsFormQueryVariables>(TrackDetailsFormDocument, options);
}
export type TrackDetailsFormQueryHookResult = ReturnType<typeof useTrackDetailsFormQuery>;
export type TrackDetailsFormLazyQueryHookResult = ReturnType<typeof useTrackDetailsFormLazyQuery>;
export type TrackDetailsFormQueryResult = Apollo.QueryResult<TrackDetailsFormQuery, TrackDetailsFormQueryVariables>;
export const UpdateTrackDetailsDocument = gql`
  mutation updateTrackDetails($track: TrackInput!) {
    updateTrack(track: $track) {
      ...TrackDetailsFormData
    }
  }
  ${TrackDetailsFormDataFragmentDoc}
`;
export type UpdateTrackDetailsMutationFn = Apollo.MutationFunction<
  UpdateTrackDetailsMutation,
  UpdateTrackDetailsMutationVariables
>;

/**
 * __useUpdateTrackDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateTrackDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrackDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrackDetailsMutation, { data, loading, error }] = useUpdateTrackDetailsMutation({
 *   variables: {
 *      track: // value for 'track'
 *   },
 * });
 */
export function useUpdateTrackDetailsMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateTrackDetailsMutation, UpdateTrackDetailsMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateTrackDetailsMutation, UpdateTrackDetailsMutationVariables>(
    UpdateTrackDetailsDocument,
    options,
  );
}
export type UpdateTrackDetailsMutationHookResult = ReturnType<typeof useUpdateTrackDetailsMutation>;
export type UpdateTrackDetailsMutationResult = Apollo.MutationResult<UpdateTrackDetailsMutation>;
export type UpdateTrackDetailsMutationOptions = Apollo.BaseMutationOptions<
  UpdateTrackDetailsMutation,
  UpdateTrackDetailsMutationVariables
>;
export const TrackInvitesTableInvitesDocument = gql`
  query TrackInvitesTableInvites($teamSlug: String!, $filters: InviteFilters!) {
    trackInvites(teamSlug: $teamSlug, filters: $filters) {
      id
      publicTitle
      title
      tracks {
        id
        title
      }
      inviteLimit
      inviteCount
      expiresAt
      created
      playLimit
      type
      status
      startsAt
    }
    team(teamSlug: $teamSlug) {
      id
      features {
        hot_start
      }
    }
  }
`;

/**
 * __useTrackInvitesTableInvitesQuery__
 *
 * To run a query within a React component, call `useTrackInvitesTableInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackInvitesTableInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackInvitesTableInvitesQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useTrackInvitesTableInvitesQuery(
  baseOptions: Apollo.QueryHookOptions<TrackInvitesTableInvitesQuery, TrackInvitesTableInvitesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TrackInvitesTableInvitesQuery, TrackInvitesTableInvitesQueryVariables>(
    TrackInvitesTableInvitesDocument,
    options,
  );
}
export function useTrackInvitesTableInvitesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TrackInvitesTableInvitesQuery, TrackInvitesTableInvitesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TrackInvitesTableInvitesQuery, TrackInvitesTableInvitesQueryVariables>(
    TrackInvitesTableInvitesDocument,
    options,
  );
}
export type TrackInvitesTableInvitesQueryHookResult = ReturnType<typeof useTrackInvitesTableInvitesQuery>;
export type TrackInvitesTableInvitesLazyQueryHookResult = ReturnType<typeof useTrackInvitesTableInvitesLazyQuery>;
export type TrackInvitesTableInvitesQueryResult = Apollo.QueryResult<
  TrackInvitesTableInvitesQuery,
  TrackInvitesTableInvitesQueryVariables
>;
export const TrackInvitesTableInviteDocument = gql`
  query TrackInvitesTableInvite($inviteID: String!, $teamSlug: String!) {
    trackInvite(inviteID: $inviteID) {
      claims {
        id
        claimedAt
        playLimit
        playTTL
        user {
          id
          profile {
            display_name
            email
          }
          details(teamSlug: $teamSlug) {
            firstName
            lastName
            email
            ...UserDetailsCollectedTableDetails
          }
        }
      }
      ...DownloadTrackInviteCsvTrackInvite
    }
  }
  ${UserDetailsCollectedTableDetailsFragmentDoc}
  ${DownloadTrackInviteCsvTrackInviteFragmentDoc}
`;

/**
 * __useTrackInvitesTableInviteQuery__
 *
 * To run a query within a React component, call `useTrackInvitesTableInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackInvitesTableInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackInvitesTableInviteQuery({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useTrackInvitesTableInviteQuery(
  baseOptions: Apollo.QueryHookOptions<TrackInvitesTableInviteQuery, TrackInvitesTableInviteQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TrackInvitesTableInviteQuery, TrackInvitesTableInviteQueryVariables>(
    TrackInvitesTableInviteDocument,
    options,
  );
}
export function useTrackInvitesTableInviteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TrackInvitesTableInviteQuery, TrackInvitesTableInviteQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TrackInvitesTableInviteQuery, TrackInvitesTableInviteQueryVariables>(
    TrackInvitesTableInviteDocument,
    options,
  );
}
export type TrackInvitesTableInviteQueryHookResult = ReturnType<typeof useTrackInvitesTableInviteQuery>;
export type TrackInvitesTableInviteLazyQueryHookResult = ReturnType<typeof useTrackInvitesTableInviteLazyQuery>;
export type TrackInvitesTableInviteQueryResult = Apollo.QueryResult<
  TrackInvitesTableInviteQuery,
  TrackInvitesTableInviteQueryVariables
>;
export const DeleteTrackInviteDocument = gql`
  mutation deleteTrackInvite($inviteID: String!) {
    deleteTrackInvite(inviteID: $inviteID)
  }
`;
export type DeleteTrackInviteMutationFn = Apollo.MutationFunction<
  DeleteTrackInviteMutation,
  DeleteTrackInviteMutationVariables
>;

/**
 * __useDeleteTrackInviteMutation__
 *
 * To run a mutation, you first call `useDeleteTrackInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTrackInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTrackInviteMutation, { data, loading, error }] = useDeleteTrackInviteMutation({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *   },
 * });
 */
export function useDeleteTrackInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteTrackInviteMutation, DeleteTrackInviteMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteTrackInviteMutation, DeleteTrackInviteMutationVariables>(
    DeleteTrackInviteDocument,
    options,
  );
}
export type DeleteTrackInviteMutationHookResult = ReturnType<typeof useDeleteTrackInviteMutation>;
export type DeleteTrackInviteMutationResult = Apollo.MutationResult<DeleteTrackInviteMutation>;
export type DeleteTrackInviteMutationOptions = Apollo.BaseMutationOptions<
  DeleteTrackInviteMutation,
  DeleteTrackInviteMutationVariables
>;
export const GetTeamSaasFeatureFlagDocument = gql`
  query getTeamSaasFeatureFlag($teamSlug: String!) {
    team(teamSlug: $teamSlug) {
      id
      features {
        saas
      }
    }
  }
`;

/**
 * __useGetTeamSaasFeatureFlagQuery__
 *
 * To run a query within a React component, call `useGetTeamSaasFeatureFlagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamSaasFeatureFlagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamSaasFeatureFlagQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useGetTeamSaasFeatureFlagQuery(
  baseOptions: Apollo.QueryHookOptions<GetTeamSaasFeatureFlagQuery, GetTeamSaasFeatureFlagQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTeamSaasFeatureFlagQuery, GetTeamSaasFeatureFlagQueryVariables>(
    GetTeamSaasFeatureFlagDocument,
    options,
  );
}
export function useGetTeamSaasFeatureFlagLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTeamSaasFeatureFlagQuery, GetTeamSaasFeatureFlagQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTeamSaasFeatureFlagQuery, GetTeamSaasFeatureFlagQueryVariables>(
    GetTeamSaasFeatureFlagDocument,
    options,
  );
}
export type GetTeamSaasFeatureFlagQueryHookResult = ReturnType<typeof useGetTeamSaasFeatureFlagQuery>;
export type GetTeamSaasFeatureFlagLazyQueryHookResult = ReturnType<typeof useGetTeamSaasFeatureFlagLazyQuery>;
export type GetTeamSaasFeatureFlagQueryResult = Apollo.QueryResult<
  GetTeamSaasFeatureFlagQuery,
  GetTeamSaasFeatureFlagQueryVariables
>;
export const WizardTrackDetailsTrackExistsDocument = gql`
  query WizardTrackDetailsTrackExists($trackSlug: String!, $teamSlug: String!) {
    trackExists(trackSlug: $trackSlug, organizationSlug: $teamSlug)
  }
`;

/**
 * __useWizardTrackDetailsTrackExistsQuery__
 *
 * To run a query within a React component, call `useWizardTrackDetailsTrackExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWizardTrackDetailsTrackExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWizardTrackDetailsTrackExistsQuery({
 *   variables: {
 *      trackSlug: // value for 'trackSlug'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useWizardTrackDetailsTrackExistsQuery(
  baseOptions: Apollo.QueryHookOptions<WizardTrackDetailsTrackExistsQuery, WizardTrackDetailsTrackExistsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WizardTrackDetailsTrackExistsQuery, WizardTrackDetailsTrackExistsQueryVariables>(
    WizardTrackDetailsTrackExistsDocument,
    options,
  );
}
export function useWizardTrackDetailsTrackExistsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WizardTrackDetailsTrackExistsQuery,
    WizardTrackDetailsTrackExistsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<WizardTrackDetailsTrackExistsQuery, WizardTrackDetailsTrackExistsQueryVariables>(
    WizardTrackDetailsTrackExistsDocument,
    options,
  );
}
export type WizardTrackDetailsTrackExistsQueryHookResult = ReturnType<typeof useWizardTrackDetailsTrackExistsQuery>;
export type WizardTrackDetailsTrackExistsLazyQueryHookResult = ReturnType<
  typeof useWizardTrackDetailsTrackExistsLazyQuery
>;
export type WizardTrackDetailsTrackExistsQueryResult = Apollo.QueryResult<
  WizardTrackDetailsTrackExistsQuery,
  WizardTrackDetailsTrackExistsQueryVariables
>;
export const GetOrganizationDocument = gql`
  query getOrganization($teamSlug: String!) {
    team(teamSlug: $teamSlug) {
      id
      api_key
      features {
        lti_enabled
      }
      lti_credentials {
        consumer_name
        consumer_key
      }
    }
  }
`;

/**
 * __useGetOrganizationQuery__
 *
 * To run a query within a React component, call `useGetOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useGetOrganizationQuery(
  baseOptions: Apollo.QueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
}
export function useGetOrganizationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
}
export type GetOrganizationQueryHookResult = ReturnType<typeof useGetOrganizationQuery>;
export type GetOrganizationLazyQueryHookResult = ReturnType<typeof useGetOrganizationLazyQuery>;
export type GetOrganizationQueryResult = Apollo.QueryResult<GetOrganizationQuery, GetOrganizationQueryVariables>;
export const GenerateOrganizationApiKeyDocument = gql`
  mutation generateOrganizationAPIKey($teamSlug: String!) {
    generateTeamAPIKey(teamSlug: $teamSlug)
  }
`;
export type GenerateOrganizationApiKeyMutationFn = Apollo.MutationFunction<
  GenerateOrganizationApiKeyMutation,
  GenerateOrganizationApiKeyMutationVariables
>;

/**
 * __useGenerateOrganizationApiKeyMutation__
 *
 * To run a mutation, you first call `useGenerateOrganizationApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateOrganizationApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateOrganizationApiKeyMutation, { data, loading, error }] = useGenerateOrganizationApiKeyMutation({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useGenerateOrganizationApiKeyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateOrganizationApiKeyMutation,
    GenerateOrganizationApiKeyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<GenerateOrganizationApiKeyMutation, GenerateOrganizationApiKeyMutationVariables>(
    GenerateOrganizationApiKeyDocument,
    options,
  );
}
export type GenerateOrganizationApiKeyMutationHookResult = ReturnType<typeof useGenerateOrganizationApiKeyMutation>;
export type GenerateOrganizationApiKeyMutationResult = Apollo.MutationResult<GenerateOrganizationApiKeyMutation>;
export type GenerateOrganizationApiKeyMutationOptions = Apollo.BaseMutationOptions<
  GenerateOrganizationApiKeyMutation,
  GenerateOrganizationApiKeyMutationVariables
>;
export const GenerateTeamLtiCredentialsDocument = gql`
  mutation generateTeamLTICredentials($teamSlug: String!) {
    generateTeamLTICredentials(teamSlug: $teamSlug) {
      consumer_name
      consumer_key
    }
  }
`;
export type GenerateTeamLtiCredentialsMutationFn = Apollo.MutationFunction<
  GenerateTeamLtiCredentialsMutation,
  GenerateTeamLtiCredentialsMutationVariables
>;

/**
 * __useGenerateTeamLtiCredentialsMutation__
 *
 * To run a mutation, you first call `useGenerateTeamLtiCredentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateTeamLtiCredentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateTeamLtiCredentialsMutation, { data, loading, error }] = useGenerateTeamLtiCredentialsMutation({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useGenerateTeamLtiCredentialsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateTeamLtiCredentialsMutation,
    GenerateTeamLtiCredentialsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<GenerateTeamLtiCredentialsMutation, GenerateTeamLtiCredentialsMutationVariables>(
    GenerateTeamLtiCredentialsDocument,
    options,
  );
}
export type GenerateTeamLtiCredentialsMutationHookResult = ReturnType<typeof useGenerateTeamLtiCredentialsMutation>;
export type GenerateTeamLtiCredentialsMutationResult = Apollo.MutationResult<GenerateTeamLtiCredentialsMutation>;
export type GenerateTeamLtiCredentialsMutationOptions = Apollo.BaseMutationOptions<
  GenerateTeamLtiCredentialsMutation,
  GenerateTeamLtiCredentialsMutationVariables
>;
export const ArcadeEditPageDocument = gql`
  query ArcadeEditPage($arcadeID: String!) {
    arcade(arcadeID: $arcadeID) {
      id
      serial_number
      alternative_url
      active
    }
  }
`;

/**
 * __useArcadeEditPageQuery__
 *
 * To run a query within a React component, call `useArcadeEditPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useArcadeEditPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArcadeEditPageQuery({
 *   variables: {
 *      arcadeID: // value for 'arcadeID'
 *   },
 * });
 */
export function useArcadeEditPageQuery(
  baseOptions: Apollo.QueryHookOptions<ArcadeEditPageQuery, ArcadeEditPageQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ArcadeEditPageQuery, ArcadeEditPageQueryVariables>(ArcadeEditPageDocument, options);
}
export function useArcadeEditPageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ArcadeEditPageQuery, ArcadeEditPageQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ArcadeEditPageQuery, ArcadeEditPageQueryVariables>(ArcadeEditPageDocument, options);
}
export type ArcadeEditPageQueryHookResult = ReturnType<typeof useArcadeEditPageQuery>;
export type ArcadeEditPageLazyQueryHookResult = ReturnType<typeof useArcadeEditPageLazyQuery>;
export type ArcadeEditPageQueryResult = Apollo.QueryResult<ArcadeEditPageQuery, ArcadeEditPageQueryVariables>;
export const ArcadeListPageDocument = gql`
  query ArcadeListPage($teamSlug: String!) {
    arcades(organizationSlug: $teamSlug) {
      id
      serial_number
      alternative_url
      organization
      active
    }
    tracks(teamSlug: $teamSlug) {
      id
      title
    }
    arcadetracks(organizationSlug: $teamSlug) {
      id
      title
      icon
    }
  }
`;

/**
 * __useArcadeListPageQuery__
 *
 * To run a query within a React component, call `useArcadeListPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useArcadeListPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArcadeListPageQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useArcadeListPageQuery(
  baseOptions: Apollo.QueryHookOptions<ArcadeListPageQuery, ArcadeListPageQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ArcadeListPageQuery, ArcadeListPageQueryVariables>(ArcadeListPageDocument, options);
}
export function useArcadeListPageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ArcadeListPageQuery, ArcadeListPageQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ArcadeListPageQuery, ArcadeListPageQueryVariables>(ArcadeListPageDocument, options);
}
export type ArcadeListPageQueryHookResult = ReturnType<typeof useArcadeListPageQuery>;
export type ArcadeListPageLazyQueryHookResult = ReturnType<typeof useArcadeListPageLazyQuery>;
export type ArcadeListPageQueryResult = Apollo.QueryResult<ArcadeListPageQuery, ArcadeListPageQueryVariables>;
export const ChallengeAssignmentPageDocument = gql`
  query ChallengeAssignmentPage($teamSlug: String!, $trackSlug: String!, $challengeSlug: String!) {
    challenge(teamSlug: $teamSlug, trackSlug: $trackSlug, challengeSlug: $challengeSlug) {
      id
      title
    }
  }
`;

/**
 * __useChallengeAssignmentPageQuery__
 *
 * To run a query within a React component, call `useChallengeAssignmentPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useChallengeAssignmentPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChallengeAssignmentPageQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      trackSlug: // value for 'trackSlug'
 *      challengeSlug: // value for 'challengeSlug'
 *   },
 * });
 */
export function useChallengeAssignmentPageQuery(
  baseOptions: Apollo.QueryHookOptions<ChallengeAssignmentPageQuery, ChallengeAssignmentPageQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ChallengeAssignmentPageQuery, ChallengeAssignmentPageQueryVariables>(
    ChallengeAssignmentPageDocument,
    options,
  );
}
export function useChallengeAssignmentPageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ChallengeAssignmentPageQuery, ChallengeAssignmentPageQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ChallengeAssignmentPageQuery, ChallengeAssignmentPageQueryVariables>(
    ChallengeAssignmentPageDocument,
    options,
  );
}
export type ChallengeAssignmentPageQueryHookResult = ReturnType<typeof useChallengeAssignmentPageQuery>;
export type ChallengeAssignmentPageLazyQueryHookResult = ReturnType<typeof useChallengeAssignmentPageLazyQuery>;
export type ChallengeAssignmentPageQueryResult = Apollo.QueryResult<
  ChallengeAssignmentPageQuery,
  ChallengeAssignmentPageQueryVariables
>;
export const ChallengeGuardrailsPageDocument = gql`
  query ChallengeGuardrailsPage($teamSlug: String!, $trackSlug: String!, $challengeSlug: String!) {
    challenge(teamSlug: $teamSlug, trackSlug: $trackSlug, challengeSlug: $challengeSlug) {
      id
      title
    }
  }
`;

/**
 * __useChallengeGuardrailsPageQuery__
 *
 * To run a query within a React component, call `useChallengeGuardrailsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useChallengeGuardrailsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChallengeGuardrailsPageQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      trackSlug: // value for 'trackSlug'
 *      challengeSlug: // value for 'challengeSlug'
 *   },
 * });
 */
export function useChallengeGuardrailsPageQuery(
  baseOptions: Apollo.QueryHookOptions<ChallengeGuardrailsPageQuery, ChallengeGuardrailsPageQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ChallengeGuardrailsPageQuery, ChallengeGuardrailsPageQueryVariables>(
    ChallengeGuardrailsPageDocument,
    options,
  );
}
export function useChallengeGuardrailsPageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ChallengeGuardrailsPageQuery, ChallengeGuardrailsPageQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ChallengeGuardrailsPageQuery, ChallengeGuardrailsPageQueryVariables>(
    ChallengeGuardrailsPageDocument,
    options,
  );
}
export type ChallengeGuardrailsPageQueryHookResult = ReturnType<typeof useChallengeGuardrailsPageQuery>;
export type ChallengeGuardrailsPageLazyQueryHookResult = ReturnType<typeof useChallengeGuardrailsPageLazyQuery>;
export type ChallengeGuardrailsPageQueryResult = Apollo.QueryResult<
  ChallengeGuardrailsPageQuery,
  ChallengeGuardrailsPageQueryVariables
>;
export const GetChallengeNotesListConfigDocument = gql`
  query getChallengeNotesListConfig($trackID: String!, $challengeID: String!) {
    userIsTrackDeveloper(trackID: $trackID)
    track(trackID: $trackID) {
      lab_config {
        width
        position
        overlay
      }
    }
    challenge(challengeID: $challengeID) {
      ...NotesListChallenge
    }
  }
  ${NotesListChallengeFragmentDoc}
`;

/**
 * __useGetChallengeNotesListConfigQuery__
 *
 * To run a query within a React component, call `useGetChallengeNotesListConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChallengeNotesListConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChallengeNotesListConfigQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      challengeID: // value for 'challengeID'
 *   },
 * });
 */
export function useGetChallengeNotesListConfigQuery(
  baseOptions: Apollo.QueryHookOptions<GetChallengeNotesListConfigQuery, GetChallengeNotesListConfigQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetChallengeNotesListConfigQuery, GetChallengeNotesListConfigQueryVariables>(
    GetChallengeNotesListConfigDocument,
    options,
  );
}
export function useGetChallengeNotesListConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetChallengeNotesListConfigQuery,
    GetChallengeNotesListConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetChallengeNotesListConfigQuery, GetChallengeNotesListConfigQueryVariables>(
    GetChallengeNotesListConfigDocument,
    options,
  );
}
export type GetChallengeNotesListConfigQueryHookResult = ReturnType<typeof useGetChallengeNotesListConfigQuery>;
export type GetChallengeNotesListConfigLazyQueryHookResult = ReturnType<typeof useGetChallengeNotesListConfigLazyQuery>;
export type GetChallengeNotesListConfigQueryResult = Apollo.QueryResult<
  GetChallengeNotesListConfigQuery,
  GetChallengeNotesListConfigQueryVariables
>;
export const ChallengeNotesPageDocument = gql`
  query ChallengeNotesPage($teamSlug: String!, $trackSlug: String!, $challengeSlug: String!) {
    challenge(teamSlug: $teamSlug, trackSlug: $trackSlug, challengeSlug: $challengeSlug) {
      id
      title
    }
  }
`;

/**
 * __useChallengeNotesPageQuery__
 *
 * To run a query within a React component, call `useChallengeNotesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useChallengeNotesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChallengeNotesPageQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      trackSlug: // value for 'trackSlug'
 *      challengeSlug: // value for 'challengeSlug'
 *   },
 * });
 */
export function useChallengeNotesPageQuery(
  baseOptions: Apollo.QueryHookOptions<ChallengeNotesPageQuery, ChallengeNotesPageQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ChallengeNotesPageQuery, ChallengeNotesPageQueryVariables>(
    ChallengeNotesPageDocument,
    options,
  );
}
export function useChallengeNotesPageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ChallengeNotesPageQuery, ChallengeNotesPageQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ChallengeNotesPageQuery, ChallengeNotesPageQueryVariables>(
    ChallengeNotesPageDocument,
    options,
  );
}
export type ChallengeNotesPageQueryHookResult = ReturnType<typeof useChallengeNotesPageQuery>;
export type ChallengeNotesPageLazyQueryHookResult = ReturnType<typeof useChallengeNotesPageLazyQuery>;
export type ChallengeNotesPageQueryResult = Apollo.QueryResult<
  ChallengeNotesPageQuery,
  ChallengeNotesPageQueryVariables
>;
export const GetChallengeScriptsEditorPageConfigDocument = gql`
  query getChallengeScriptsEditorPageConfig($trackID: String!, $challengeID: String!) {
    userIsTrackDeveloper(trackID: $trackID)
    track(trackID: $trackID) {
      sandboxConfig {
        resources {
          containers {
            id
            name
          }
          virtualmachines {
            id
            name
          }
          virtualbrowsers {
            id
            name
          }
        }
      }
    }
    trackConfig(trackID: $trackID) {
      id
      containers {
        id
        name
      }
      virtualmachines {
        id
        name
      }
      virtualbrowsers {
        id
        name
      }
    }
    challengeScripts(challengeID: $challengeID) {
      ...ChallengeScript
    }
  }
  ${ChallengeScriptFragmentDoc}
`;

/**
 * __useGetChallengeScriptsEditorPageConfigQuery__
 *
 * To run a query within a React component, call `useGetChallengeScriptsEditorPageConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChallengeScriptsEditorPageConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChallengeScriptsEditorPageConfigQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      challengeID: // value for 'challengeID'
 *   },
 * });
 */
export function useGetChallengeScriptsEditorPageConfigQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetChallengeScriptsEditorPageConfigQuery,
    GetChallengeScriptsEditorPageConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetChallengeScriptsEditorPageConfigQuery, GetChallengeScriptsEditorPageConfigQueryVariables>(
    GetChallengeScriptsEditorPageConfigDocument,
    options,
  );
}
export function useGetChallengeScriptsEditorPageConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetChallengeScriptsEditorPageConfigQuery,
    GetChallengeScriptsEditorPageConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetChallengeScriptsEditorPageConfigQuery,
    GetChallengeScriptsEditorPageConfigQueryVariables
  >(GetChallengeScriptsEditorPageConfigDocument, options);
}
export type GetChallengeScriptsEditorPageConfigQueryHookResult = ReturnType<
  typeof useGetChallengeScriptsEditorPageConfigQuery
>;
export type GetChallengeScriptsEditorPageConfigLazyQueryHookResult = ReturnType<
  typeof useGetChallengeScriptsEditorPageConfigLazyQuery
>;
export type GetChallengeScriptsEditorPageConfigQueryResult = Apollo.QueryResult<
  GetChallengeScriptsEditorPageConfigQuery,
  GetChallengeScriptsEditorPageConfigQueryVariables
>;
export const ChallengeScriptsEditorPageSaveChallengeScriptDocument = gql`
  mutation challengeScriptsEditorPageSaveChallengeScript($script: ChallengeScriptInput!, $base64Encoded: Boolean!) {
    saveChallengeScript(script: $script, base64Encoded: $base64Encoded) {
      ...ChallengeScript
    }
  }
  ${ChallengeScriptFragmentDoc}
`;
export type ChallengeScriptsEditorPageSaveChallengeScriptMutationFn = Apollo.MutationFunction<
  ChallengeScriptsEditorPageSaveChallengeScriptMutation,
  ChallengeScriptsEditorPageSaveChallengeScriptMutationVariables
>;

/**
 * __useChallengeScriptsEditorPageSaveChallengeScriptMutation__
 *
 * To run a mutation, you first call `useChallengeScriptsEditorPageSaveChallengeScriptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChallengeScriptsEditorPageSaveChallengeScriptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [challengeScriptsEditorPageSaveChallengeScriptMutation, { data, loading, error }] = useChallengeScriptsEditorPageSaveChallengeScriptMutation({
 *   variables: {
 *      script: // value for 'script'
 *      base64Encoded: // value for 'base64Encoded'
 *   },
 * });
 */
export function useChallengeScriptsEditorPageSaveChallengeScriptMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChallengeScriptsEditorPageSaveChallengeScriptMutation,
    ChallengeScriptsEditorPageSaveChallengeScriptMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ChallengeScriptsEditorPageSaveChallengeScriptMutation,
    ChallengeScriptsEditorPageSaveChallengeScriptMutationVariables
  >(ChallengeScriptsEditorPageSaveChallengeScriptDocument, options);
}
export type ChallengeScriptsEditorPageSaveChallengeScriptMutationHookResult = ReturnType<
  typeof useChallengeScriptsEditorPageSaveChallengeScriptMutation
>;
export type ChallengeScriptsEditorPageSaveChallengeScriptMutationResult =
  Apollo.MutationResult<ChallengeScriptsEditorPageSaveChallengeScriptMutation>;
export type ChallengeScriptsEditorPageSaveChallengeScriptMutationOptions = Apollo.BaseMutationOptions<
  ChallengeScriptsEditorPageSaveChallengeScriptMutation,
  ChallengeScriptsEditorPageSaveChallengeScriptMutationVariables
>;
export const ChallengeScriptsEditorPageDeleteChallengeScriptDocument = gql`
  mutation challengeScriptsEditorPageDeleteChallengeScript($challengeScriptID: String!) {
    deleteChallengeScript(challengeScriptID: $challengeScriptID)
  }
`;
export type ChallengeScriptsEditorPageDeleteChallengeScriptMutationFn = Apollo.MutationFunction<
  ChallengeScriptsEditorPageDeleteChallengeScriptMutation,
  ChallengeScriptsEditorPageDeleteChallengeScriptMutationVariables
>;

/**
 * __useChallengeScriptsEditorPageDeleteChallengeScriptMutation__
 *
 * To run a mutation, you first call `useChallengeScriptsEditorPageDeleteChallengeScriptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChallengeScriptsEditorPageDeleteChallengeScriptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [challengeScriptsEditorPageDeleteChallengeScriptMutation, { data, loading, error }] = useChallengeScriptsEditorPageDeleteChallengeScriptMutation({
 *   variables: {
 *      challengeScriptID: // value for 'challengeScriptID'
 *   },
 * });
 */
export function useChallengeScriptsEditorPageDeleteChallengeScriptMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChallengeScriptsEditorPageDeleteChallengeScriptMutation,
    ChallengeScriptsEditorPageDeleteChallengeScriptMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ChallengeScriptsEditorPageDeleteChallengeScriptMutation,
    ChallengeScriptsEditorPageDeleteChallengeScriptMutationVariables
  >(ChallengeScriptsEditorPageDeleteChallengeScriptDocument, options);
}
export type ChallengeScriptsEditorPageDeleteChallengeScriptMutationHookResult = ReturnType<
  typeof useChallengeScriptsEditorPageDeleteChallengeScriptMutation
>;
export type ChallengeScriptsEditorPageDeleteChallengeScriptMutationResult =
  Apollo.MutationResult<ChallengeScriptsEditorPageDeleteChallengeScriptMutation>;
export type ChallengeScriptsEditorPageDeleteChallengeScriptMutationOptions = Apollo.BaseMutationOptions<
  ChallengeScriptsEditorPageDeleteChallengeScriptMutation,
  ChallengeScriptsEditorPageDeleteChallengeScriptMutationVariables
>;
export const ChallengeScriptsTrackDocument = gql`
  query ChallengeScriptsTrack($teamSlug: String!, $trackSlug: String!) {
    track(trackSlug: $trackSlug, teamSlug: $teamSlug) {
      id
      sandboxConfig {
        resources {
          containers {
            id
            name
          }
          virtualmachines {
            id
            name
          }
          virtualbrowsers {
            id
            name
          }
        }
      }
    }
  }
`;

/**
 * __useChallengeScriptsTrackQuery__
 *
 * To run a query within a React component, call `useChallengeScriptsTrackQuery` and pass it any options that fit your needs.
 * When your component renders, `useChallengeScriptsTrackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChallengeScriptsTrackQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      trackSlug: // value for 'trackSlug'
 *   },
 * });
 */
export function useChallengeScriptsTrackQuery(
  baseOptions: Apollo.QueryHookOptions<ChallengeScriptsTrackQuery, ChallengeScriptsTrackQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ChallengeScriptsTrackQuery, ChallengeScriptsTrackQueryVariables>(
    ChallengeScriptsTrackDocument,
    options,
  );
}
export function useChallengeScriptsTrackLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ChallengeScriptsTrackQuery, ChallengeScriptsTrackQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ChallengeScriptsTrackQuery, ChallengeScriptsTrackQueryVariables>(
    ChallengeScriptsTrackDocument,
    options,
  );
}
export type ChallengeScriptsTrackQueryHookResult = ReturnType<typeof useChallengeScriptsTrackQuery>;
export type ChallengeScriptsTrackLazyQueryHookResult = ReturnType<typeof useChallengeScriptsTrackLazyQuery>;
export type ChallengeScriptsTrackQueryResult = Apollo.QueryResult<
  ChallengeScriptsTrackQuery,
  ChallengeScriptsTrackQueryVariables
>;
export const ChallengeScriptsPageDocument = gql`
  query ChallengeScriptsPage($teamSlug: String!, $trackID: String!, $trackSlug: String!, $challengeSlug: String!) {
    trackConfig(trackID: $trackID) {
      id
      containers {
        id
        name
      }
      virtualmachines {
        id
        name
      }
      virtualbrowsers {
        id
        name
      }
    }
    challenge(teamSlug: $teamSlug, trackSlug: $trackSlug, challengeSlug: $challengeSlug) {
      id
      title
      scripts {
        action
        contents
        host
        id
      }
    }
  }
`;

/**
 * __useChallengeScriptsPageQuery__
 *
 * To run a query within a React component, call `useChallengeScriptsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useChallengeScriptsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChallengeScriptsPageQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      trackID: // value for 'trackID'
 *      trackSlug: // value for 'trackSlug'
 *      challengeSlug: // value for 'challengeSlug'
 *   },
 * });
 */
export function useChallengeScriptsPageQuery(
  baseOptions: Apollo.QueryHookOptions<ChallengeScriptsPageQuery, ChallengeScriptsPageQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ChallengeScriptsPageQuery, ChallengeScriptsPageQueryVariables>(
    ChallengeScriptsPageDocument,
    options,
  );
}
export function useChallengeScriptsPageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ChallengeScriptsPageQuery, ChallengeScriptsPageQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ChallengeScriptsPageQuery, ChallengeScriptsPageQueryVariables>(
    ChallengeScriptsPageDocument,
    options,
  );
}
export type ChallengeScriptsPageQueryHookResult = ReturnType<typeof useChallengeScriptsPageQuery>;
export type ChallengeScriptsPageLazyQueryHookResult = ReturnType<typeof useChallengeScriptsPageLazyQuery>;
export type ChallengeScriptsPageQueryResult = Apollo.QueryResult<
  ChallengeScriptsPageQuery,
  ChallengeScriptsPageQueryVariables
>;
export const GetChallengeTabsListPageConfigDocument = gql`
  query getChallengeTabsListPageConfig($trackID: String!, $challengeID: String!) {
    userIsTrackDeveloper(trackID: $trackID)
    track(trackID: $trackID) {
      lab_config {
        width
        position
        overlay
      }
    }
    challenge(challengeID: $challengeID) {
      ...TabsListChallenge
      tabs {
        ...TabsListChallengeTab
      }
    }
  }
  ${TabsListChallengeFragmentDoc}
  ${TabsListChallengeTabFragmentDoc}
`;

/**
 * __useGetChallengeTabsListPageConfigQuery__
 *
 * To run a query within a React component, call `useGetChallengeTabsListPageConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChallengeTabsListPageConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChallengeTabsListPageConfigQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      challengeID: // value for 'challengeID'
 *   },
 * });
 */
export function useGetChallengeTabsListPageConfigQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetChallengeTabsListPageConfigQuery,
    GetChallengeTabsListPageConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetChallengeTabsListPageConfigQuery, GetChallengeTabsListPageConfigQueryVariables>(
    GetChallengeTabsListPageConfigDocument,
    options,
  );
}
export function useGetChallengeTabsListPageConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetChallengeTabsListPageConfigQuery,
    GetChallengeTabsListPageConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetChallengeTabsListPageConfigQuery, GetChallengeTabsListPageConfigQueryVariables>(
    GetChallengeTabsListPageConfigDocument,
    options,
  );
}
export type GetChallengeTabsListPageConfigQueryHookResult = ReturnType<typeof useGetChallengeTabsListPageConfigQuery>;
export type GetChallengeTabsListPageConfigLazyQueryHookResult = ReturnType<
  typeof useGetChallengeTabsListPageConfigLazyQuery
>;
export type GetChallengeTabsListPageConfigQueryResult = Apollo.QueryResult<
  GetChallengeTabsListPageConfigQuery,
  GetChallengeTabsListPageConfigQueryVariables
>;
export const ChallengeTabsPageDocument = gql`
  query ChallengeTabsPage($teamSlug: String!, $trackSlug: String!, $challengeSlug: String!) {
    challenge(teamSlug: $teamSlug, trackSlug: $trackSlug, challengeSlug: $challengeSlug) {
      id
      title
    }
  }
`;

/**
 * __useChallengeTabsPageQuery__
 *
 * To run a query within a React component, call `useChallengeTabsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useChallengeTabsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChallengeTabsPageQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      trackSlug: // value for 'trackSlug'
 *      challengeSlug: // value for 'challengeSlug'
 *   },
 * });
 */
export function useChallengeTabsPageQuery(
  baseOptions: Apollo.QueryHookOptions<ChallengeTabsPageQuery, ChallengeTabsPageQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ChallengeTabsPageQuery, ChallengeTabsPageQueryVariables>(ChallengeTabsPageDocument, options);
}
export function useChallengeTabsPageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ChallengeTabsPageQuery, ChallengeTabsPageQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ChallengeTabsPageQuery, ChallengeTabsPageQueryVariables>(
    ChallengeTabsPageDocument,
    options,
  );
}
export type ChallengeTabsPageQueryHookResult = ReturnType<typeof useChallengeTabsPageQuery>;
export type ChallengeTabsPageLazyQueryHookResult = ReturnType<typeof useChallengeTabsPageLazyQuery>;
export type ChallengeTabsPageQueryResult = Apollo.QueryResult<ChallengeTabsPageQuery, ChallengeTabsPageQueryVariables>;
export const GetCreateChallengeNoteConfigDocument = gql`
  query getCreateChallengeNoteConfig($trackID: String!, $challengeID: String!) {
    userIsTrackDeveloper(trackID: $trackID)
    challenge(challengeID: $challengeID) {
      id
    }
  }
`;

/**
 * __useGetCreateChallengeNoteConfigQuery__
 *
 * To run a query within a React component, call `useGetCreateChallengeNoteConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateChallengeNoteConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateChallengeNoteConfigQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      challengeID: // value for 'challengeID'
 *   },
 * });
 */
export function useGetCreateChallengeNoteConfigQuery(
  baseOptions: Apollo.QueryHookOptions<GetCreateChallengeNoteConfigQuery, GetCreateChallengeNoteConfigQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCreateChallengeNoteConfigQuery, GetCreateChallengeNoteConfigQueryVariables>(
    GetCreateChallengeNoteConfigDocument,
    options,
  );
}
export function useGetCreateChallengeNoteConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCreateChallengeNoteConfigQuery,
    GetCreateChallengeNoteConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCreateChallengeNoteConfigQuery, GetCreateChallengeNoteConfigQueryVariables>(
    GetCreateChallengeNoteConfigDocument,
    options,
  );
}
export type GetCreateChallengeNoteConfigQueryHookResult = ReturnType<typeof useGetCreateChallengeNoteConfigQuery>;
export type GetCreateChallengeNoteConfigLazyQueryHookResult = ReturnType<
  typeof useGetCreateChallengeNoteConfigLazyQuery
>;
export type GetCreateChallengeNoteConfigQueryResult = Apollo.QueryResult<
  GetCreateChallengeNoteConfigQuery,
  GetCreateChallengeNoteConfigQueryVariables
>;
export const CreateChallengeNotePageCreateChallengeNoteDocument = gql`
  mutation createChallengeNotePageCreateChallengeNote($note: ChallengeNoteInput!) {
    createChallengeNote(note: $note) {
      id
      index
      ...ChallengeNoteFormNote
    }
  }
  ${ChallengeNoteFormNoteFragmentDoc}
`;
export type CreateChallengeNotePageCreateChallengeNoteMutationFn = Apollo.MutationFunction<
  CreateChallengeNotePageCreateChallengeNoteMutation,
  CreateChallengeNotePageCreateChallengeNoteMutationVariables
>;

/**
 * __useCreateChallengeNotePageCreateChallengeNoteMutation__
 *
 * To run a mutation, you first call `useCreateChallengeNotePageCreateChallengeNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChallengeNotePageCreateChallengeNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChallengeNotePageCreateChallengeNoteMutation, { data, loading, error }] = useCreateChallengeNotePageCreateChallengeNoteMutation({
 *   variables: {
 *      note: // value for 'note'
 *   },
 * });
 */
export function useCreateChallengeNotePageCreateChallengeNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateChallengeNotePageCreateChallengeNoteMutation,
    CreateChallengeNotePageCreateChallengeNoteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateChallengeNotePageCreateChallengeNoteMutation,
    CreateChallengeNotePageCreateChallengeNoteMutationVariables
  >(CreateChallengeNotePageCreateChallengeNoteDocument, options);
}
export type CreateChallengeNotePageCreateChallengeNoteMutationHookResult = ReturnType<
  typeof useCreateChallengeNotePageCreateChallengeNoteMutation
>;
export type CreateChallengeNotePageCreateChallengeNoteMutationResult =
  Apollo.MutationResult<CreateChallengeNotePageCreateChallengeNoteMutation>;
export type CreateChallengeNotePageCreateChallengeNoteMutationOptions = Apollo.BaseMutationOptions<
  CreateChallengeNotePageCreateChallengeNoteMutation,
  CreateChallengeNotePageCreateChallengeNoteMutationVariables
>;
export const GetCreateChallengeTabPageConfigDocument = gql`
  query getCreateChallengeTabPageConfig($trackID: String!, $challengeID: String!, $teamSlug: String!) {
    userIsTrackDeveloper(trackID: $trackID)
    challenge(challengeID: $challengeID) {
      id
    }
    track(trackID: $trackID) {
      sandboxConfig {
        resources {
          containers {
            id
            name
          }
          virtualmachines {
            id
            name
          }
          virtualbrowsers {
            id
            name
          }
        }
      }
    }
    trackConfig(trackID: $trackID) {
      id
      containers {
        id
        name
        image
      }
      virtualmachines {
        id
        name
      }
      virtualbrowsers {
        id
        name
      }
    }
    team(teamSlug: $teamSlug) {
      id
      features {
        saas
      }
    }
  }
`;

/**
 * __useGetCreateChallengeTabPageConfigQuery__
 *
 * To run a query within a React component, call `useGetCreateChallengeTabPageConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateChallengeTabPageConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateChallengeTabPageConfigQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      challengeID: // value for 'challengeID'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useGetCreateChallengeTabPageConfigQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCreateChallengeTabPageConfigQuery,
    GetCreateChallengeTabPageConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCreateChallengeTabPageConfigQuery, GetCreateChallengeTabPageConfigQueryVariables>(
    GetCreateChallengeTabPageConfigDocument,
    options,
  );
}
export function useGetCreateChallengeTabPageConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCreateChallengeTabPageConfigQuery,
    GetCreateChallengeTabPageConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCreateChallengeTabPageConfigQuery, GetCreateChallengeTabPageConfigQueryVariables>(
    GetCreateChallengeTabPageConfigDocument,
    options,
  );
}
export type GetCreateChallengeTabPageConfigQueryHookResult = ReturnType<typeof useGetCreateChallengeTabPageConfigQuery>;
export type GetCreateChallengeTabPageConfigLazyQueryHookResult = ReturnType<
  typeof useGetCreateChallengeTabPageConfigLazyQuery
>;
export type GetCreateChallengeTabPageConfigQueryResult = Apollo.QueryResult<
  GetCreateChallengeTabPageConfigQuery,
  GetCreateChallengeTabPageConfigQueryVariables
>;
export const CreateChallengeTabPageCreateChallengeTabDocument = gql`
  mutation createChallengeTabPageCreateChallengeTab($tab: ChallengeTabInput!) {
    createChallengeTab(tab: $tab) {
      id
      index
      target
      ...ChallengeTabFormTab
    }
  }
  ${ChallengeTabFormTabFragmentDoc}
`;
export type CreateChallengeTabPageCreateChallengeTabMutationFn = Apollo.MutationFunction<
  CreateChallengeTabPageCreateChallengeTabMutation,
  CreateChallengeTabPageCreateChallengeTabMutationVariables
>;

/**
 * __useCreateChallengeTabPageCreateChallengeTabMutation__
 *
 * To run a mutation, you first call `useCreateChallengeTabPageCreateChallengeTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChallengeTabPageCreateChallengeTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChallengeTabPageCreateChallengeTabMutation, { data, loading, error }] = useCreateChallengeTabPageCreateChallengeTabMutation({
 *   variables: {
 *      tab: // value for 'tab'
 *   },
 * });
 */
export function useCreateChallengeTabPageCreateChallengeTabMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateChallengeTabPageCreateChallengeTabMutation,
    CreateChallengeTabPageCreateChallengeTabMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateChallengeTabPageCreateChallengeTabMutation,
    CreateChallengeTabPageCreateChallengeTabMutationVariables
  >(CreateChallengeTabPageCreateChallengeTabDocument, options);
}
export type CreateChallengeTabPageCreateChallengeTabMutationHookResult = ReturnType<
  typeof useCreateChallengeTabPageCreateChallengeTabMutation
>;
export type CreateChallengeTabPageCreateChallengeTabMutationResult =
  Apollo.MutationResult<CreateChallengeTabPageCreateChallengeTabMutation>;
export type CreateChallengeTabPageCreateChallengeTabMutationOptions = Apollo.BaseMutationOptions<
  CreateChallengeTabPageCreateChallengeTabMutation,
  CreateChallengeTabPageCreateChallengeTabMutationVariables
>;
export const GetCreateChallengePageConfigDocument = gql`
  query getCreateChallengePageConfig($trackID: String!) {
    userIsTrackDeveloper(trackID: $trackID)
  }
`;

/**
 * __useGetCreateChallengePageConfigQuery__
 *
 * To run a query within a React component, call `useGetCreateChallengePageConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateChallengePageConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateChallengePageConfigQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useGetCreateChallengePageConfigQuery(
  baseOptions: Apollo.QueryHookOptions<GetCreateChallengePageConfigQuery, GetCreateChallengePageConfigQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCreateChallengePageConfigQuery, GetCreateChallengePageConfigQueryVariables>(
    GetCreateChallengePageConfigDocument,
    options,
  );
}
export function useGetCreateChallengePageConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCreateChallengePageConfigQuery,
    GetCreateChallengePageConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCreateChallengePageConfigQuery, GetCreateChallengePageConfigQueryVariables>(
    GetCreateChallengePageConfigDocument,
    options,
  );
}
export type GetCreateChallengePageConfigQueryHookResult = ReturnType<typeof useGetCreateChallengePageConfigQuery>;
export type GetCreateChallengePageConfigLazyQueryHookResult = ReturnType<
  typeof useGetCreateChallengePageConfigLazyQuery
>;
export type GetCreateChallengePageConfigQueryResult = Apollo.QueryResult<
  GetCreateChallengePageConfigQuery,
  GetCreateChallengePageConfigQueryVariables
>;
export const CreateChallengePageCreateChallengeDocument = gql`
  mutation createChallengePageCreateChallenge($challenge: ChallengeInput!) {
    createChallenge(challenge: $challenge) {
      id
      title
      slug
      permalink
    }
  }
`;
export type CreateChallengePageCreateChallengeMutationFn = Apollo.MutationFunction<
  CreateChallengePageCreateChallengeMutation,
  CreateChallengePageCreateChallengeMutationVariables
>;

/**
 * __useCreateChallengePageCreateChallengeMutation__
 *
 * To run a mutation, you first call `useCreateChallengePageCreateChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChallengePageCreateChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChallengePageCreateChallengeMutation, { data, loading, error }] = useCreateChallengePageCreateChallengeMutation({
 *   variables: {
 *      challenge: // value for 'challenge'
 *   },
 * });
 */
export function useCreateChallengePageCreateChallengeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateChallengePageCreateChallengeMutation,
    CreateChallengePageCreateChallengeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateChallengePageCreateChallengeMutation,
    CreateChallengePageCreateChallengeMutationVariables
  >(CreateChallengePageCreateChallengeDocument, options);
}
export type CreateChallengePageCreateChallengeMutationHookResult = ReturnType<
  typeof useCreateChallengePageCreateChallengeMutation
>;
export type CreateChallengePageCreateChallengeMutationResult =
  Apollo.MutationResult<CreateChallengePageCreateChallengeMutation>;
export type CreateChallengePageCreateChallengeMutationOptions = Apollo.BaseMutationOptions<
  CreateChallengePageCreateChallengeMutation,
  CreateChallengePageCreateChallengeMutationVariables
>;
export const ChallengeDocument = gql`
  query Challenge($challengeID: String!) {
    challenge(challengeID: $challengeID) {
      answers
      assignment
      slug
      solution
      teaser
      timelimit
      title
      type
    }
  }
`;

/**
 * __useChallengeQuery__
 *
 * To run a query within a React component, call `useChallengeQuery` and pass it any options that fit your needs.
 * When your component renders, `useChallengeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChallengeQuery({
 *   variables: {
 *      challengeID: // value for 'challengeID'
 *   },
 * });
 */
export function useChallengeQuery(baseOptions: Apollo.QueryHookOptions<ChallengeQuery, ChallengeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ChallengeQuery, ChallengeQueryVariables>(ChallengeDocument, options);
}
export function useChallengeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ChallengeQuery, ChallengeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ChallengeQuery, ChallengeQueryVariables>(ChallengeDocument, options);
}
export type ChallengeQueryHookResult = ReturnType<typeof useChallengeQuery>;
export type ChallengeLazyQueryHookResult = ReturnType<typeof useChallengeLazyQuery>;
export type ChallengeQueryResult = Apollo.QueryResult<ChallengeQuery, ChallengeQueryVariables>;
export const GetCreateTrackWizardPageConfigDocument = gql`
  query getCreateTrackWizardPageConfig($teamSlug: String!, $filter: SandboxConfigVersionsFilterInput!) {
    team(teamSlug: $teamSlug) {
      id
      features {
        containers
        virtual_machines
        saas
        gcp_projects
        aws_accounts
        azure_subscriptions
        custom_machine_type
        shared_hotstart_pools
      }
    }
    teamSecrets(teamSlug: $teamSlug) {
      name
      description
    }
    trackConfigPresets {
      ...CreateTrackSandboxPresets
    }
    sandboxConfigVersions(teamSlug: $teamSlug, filter: $filter) {
      ...ManageNewTrackSandboxConfigVersion
    }
  }
  ${CreateTrackSandboxPresetsFragmentDoc}
  ${ManageNewTrackSandboxConfigVersionFragmentDoc}
`;

/**
 * __useGetCreateTrackWizardPageConfigQuery__
 *
 * To run a query within a React component, call `useGetCreateTrackWizardPageConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateTrackWizardPageConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateTrackWizardPageConfigQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCreateTrackWizardPageConfigQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCreateTrackWizardPageConfigQuery,
    GetCreateTrackWizardPageConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCreateTrackWizardPageConfigQuery, GetCreateTrackWizardPageConfigQueryVariables>(
    GetCreateTrackWizardPageConfigDocument,
    options,
  );
}
export function useGetCreateTrackWizardPageConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCreateTrackWizardPageConfigQuery,
    GetCreateTrackWizardPageConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCreateTrackWizardPageConfigQuery, GetCreateTrackWizardPageConfigQueryVariables>(
    GetCreateTrackWizardPageConfigDocument,
    options,
  );
}
export type GetCreateTrackWizardPageConfigQueryHookResult = ReturnType<typeof useGetCreateTrackWizardPageConfigQuery>;
export type GetCreateTrackWizardPageConfigLazyQueryHookResult = ReturnType<
  typeof useGetCreateTrackWizardPageConfigLazyQuery
>;
export type GetCreateTrackWizardPageConfigQueryResult = Apollo.QueryResult<
  GetCreateTrackWizardPageConfigQuery,
  GetCreateTrackWizardPageConfigQueryVariables
>;
export const GetTrackForWizardDocument = gql`
  query GetTrackForWizard($teamSlug: String!, $trackSlug: String!) {
    track(teamSlug: $teamSlug, trackSlug: $trackSlug) {
      id
      permalink
      slug
      title
    }
  }
`;

/**
 * __useGetTrackForWizardQuery__
 *
 * To run a query within a React component, call `useGetTrackForWizardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrackForWizardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrackForWizardQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      trackSlug: // value for 'trackSlug'
 *   },
 * });
 */
export function useGetTrackForWizardQuery(
  baseOptions: Apollo.QueryHookOptions<GetTrackForWizardQuery, GetTrackForWizardQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTrackForWizardQuery, GetTrackForWizardQueryVariables>(GetTrackForWizardDocument, options);
}
export function useGetTrackForWizardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTrackForWizardQuery, GetTrackForWizardQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTrackForWizardQuery, GetTrackForWizardQueryVariables>(
    GetTrackForWizardDocument,
    options,
  );
}
export type GetTrackForWizardQueryHookResult = ReturnType<typeof useGetTrackForWizardQuery>;
export type GetTrackForWizardLazyQueryHookResult = ReturnType<typeof useGetTrackForWizardLazyQuery>;
export type GetTrackForWizardQueryResult = Apollo.QueryResult<GetTrackForWizardQuery, GetTrackForWizardQueryVariables>;
export const WizardCreateChallengeDocument = gql`
  mutation wizardCreateChallenge($challenge: ChallengeInput!) {
    createChallenge(challenge: $challenge) {
      id
    }
  }
`;
export type WizardCreateChallengeMutationFn = Apollo.MutationFunction<
  WizardCreateChallengeMutation,
  WizardCreateChallengeMutationVariables
>;

/**
 * __useWizardCreateChallengeMutation__
 *
 * To run a mutation, you first call `useWizardCreateChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWizardCreateChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wizardCreateChallengeMutation, { data, loading, error }] = useWizardCreateChallengeMutation({
 *   variables: {
 *      challenge: // value for 'challenge'
 *   },
 * });
 */
export function useWizardCreateChallengeMutation(
  baseOptions?: Apollo.MutationHookOptions<WizardCreateChallengeMutation, WizardCreateChallengeMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<WizardCreateChallengeMutation, WizardCreateChallengeMutationVariables>(
    WizardCreateChallengeDocument,
    options,
  );
}
export type WizardCreateChallengeMutationHookResult = ReturnType<typeof useWizardCreateChallengeMutation>;
export type WizardCreateChallengeMutationResult = Apollo.MutationResult<WizardCreateChallengeMutation>;
export type WizardCreateChallengeMutationOptions = Apollo.BaseMutationOptions<
  WizardCreateChallengeMutation,
  WizardCreateChallengeMutationVariables
>;
export const WizardUpdateChallengeDocument = gql`
  mutation wizardUpdateChallenge($challenge: ChallengeInput!) {
    updateChallenge(challenge: $challenge) {
      id
    }
  }
`;
export type WizardUpdateChallengeMutationFn = Apollo.MutationFunction<
  WizardUpdateChallengeMutation,
  WizardUpdateChallengeMutationVariables
>;

/**
 * __useWizardUpdateChallengeMutation__
 *
 * To run a mutation, you first call `useWizardUpdateChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWizardUpdateChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wizardUpdateChallengeMutation, { data, loading, error }] = useWizardUpdateChallengeMutation({
 *   variables: {
 *      challenge: // value for 'challenge'
 *   },
 * });
 */
export function useWizardUpdateChallengeMutation(
  baseOptions?: Apollo.MutationHookOptions<WizardUpdateChallengeMutation, WizardUpdateChallengeMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<WizardUpdateChallengeMutation, WizardUpdateChallengeMutationVariables>(
    WizardUpdateChallengeDocument,
    options,
  );
}
export type WizardUpdateChallengeMutationHookResult = ReturnType<typeof useWizardUpdateChallengeMutation>;
export type WizardUpdateChallengeMutationResult = Apollo.MutationResult<WizardUpdateChallengeMutation>;
export type WizardUpdateChallengeMutationOptions = Apollo.BaseMutationOptions<
  WizardUpdateChallengeMutation,
  WizardUpdateChallengeMutationVariables
>;
export const WizardUpdateSandboxDocument = gql`
  mutation wizardUpdateSandbox($configID: String!, $config: SandboxConfigInput!) {
    updateSandboxConfig(configID: $configID, config: $config) {
      id
    }
  }
`;
export type WizardUpdateSandboxMutationFn = Apollo.MutationFunction<
  WizardUpdateSandboxMutation,
  WizardUpdateSandboxMutationVariables
>;

/**
 * __useWizardUpdateSandboxMutation__
 *
 * To run a mutation, you first call `useWizardUpdateSandboxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWizardUpdateSandboxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wizardUpdateSandboxMutation, { data, loading, error }] = useWizardUpdateSandboxMutation({
 *   variables: {
 *      configID: // value for 'configID'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useWizardUpdateSandboxMutation(
  baseOptions?: Apollo.MutationHookOptions<WizardUpdateSandboxMutation, WizardUpdateSandboxMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<WizardUpdateSandboxMutation, WizardUpdateSandboxMutationVariables>(
    WizardUpdateSandboxDocument,
    options,
  );
}
export type WizardUpdateSandboxMutationHookResult = ReturnType<typeof useWizardUpdateSandboxMutation>;
export type WizardUpdateSandboxMutationResult = Apollo.MutationResult<WizardUpdateSandboxMutation>;
export type WizardUpdateSandboxMutationOptions = Apollo.BaseMutationOptions<
  WizardUpdateSandboxMutation,
  WizardUpdateSandboxMutationVariables
>;
export const WizardSetTrackSandboxConfigVersionDocument = gql`
  mutation wizardSetTrackSandboxConfigVersion($trackID: String!, $configVersionID: String) {
    setTrackSandboxConfigVersion(trackID: $trackID, configVersionID: $configVersionID)
  }
`;
export type WizardSetTrackSandboxConfigVersionMutationFn = Apollo.MutationFunction<
  WizardSetTrackSandboxConfigVersionMutation,
  WizardSetTrackSandboxConfigVersionMutationVariables
>;

/**
 * __useWizardSetTrackSandboxConfigVersionMutation__
 *
 * To run a mutation, you first call `useWizardSetTrackSandboxConfigVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWizardSetTrackSandboxConfigVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wizardSetTrackSandboxConfigVersionMutation, { data, loading, error }] = useWizardSetTrackSandboxConfigVersionMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      configVersionID: // value for 'configVersionID'
 *   },
 * });
 */
export function useWizardSetTrackSandboxConfigVersionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    WizardSetTrackSandboxConfigVersionMutation,
    WizardSetTrackSandboxConfigVersionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    WizardSetTrackSandboxConfigVersionMutation,
    WizardSetTrackSandboxConfigVersionMutationVariables
  >(WizardSetTrackSandboxConfigVersionDocument, options);
}
export type WizardSetTrackSandboxConfigVersionMutationHookResult = ReturnType<
  typeof useWizardSetTrackSandboxConfigVersionMutation
>;
export type WizardSetTrackSandboxConfigVersionMutationResult =
  Apollo.MutationResult<WizardSetTrackSandboxConfigVersionMutation>;
export type WizardSetTrackSandboxConfigVersionMutationOptions = Apollo.BaseMutationOptions<
  WizardSetTrackSandboxConfigVersionMutation,
  WizardSetTrackSandboxConfigVersionMutationVariables
>;
export const WizardCreateChallengeNoteDocument = gql`
  mutation wizardCreateChallengeNote($note: ChallengeNoteInput!) {
    createChallengeNote(note: $note) {
      id
    }
  }
`;
export type WizardCreateChallengeNoteMutationFn = Apollo.MutationFunction<
  WizardCreateChallengeNoteMutation,
  WizardCreateChallengeNoteMutationVariables
>;

/**
 * __useWizardCreateChallengeNoteMutation__
 *
 * To run a mutation, you first call `useWizardCreateChallengeNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWizardCreateChallengeNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wizardCreateChallengeNoteMutation, { data, loading, error }] = useWizardCreateChallengeNoteMutation({
 *   variables: {
 *      note: // value for 'note'
 *   },
 * });
 */
export function useWizardCreateChallengeNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    WizardCreateChallengeNoteMutation,
    WizardCreateChallengeNoteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<WizardCreateChallengeNoteMutation, WizardCreateChallengeNoteMutationVariables>(
    WizardCreateChallengeNoteDocument,
    options,
  );
}
export type WizardCreateChallengeNoteMutationHookResult = ReturnType<typeof useWizardCreateChallengeNoteMutation>;
export type WizardCreateChallengeNoteMutationResult = Apollo.MutationResult<WizardCreateChallengeNoteMutation>;
export type WizardCreateChallengeNoteMutationOptions = Apollo.BaseMutationOptions<
  WizardCreateChallengeNoteMutation,
  WizardCreateChallengeNoteMutationVariables
>;
export const WizardUpdateChallengeNoteDocument = gql`
  mutation wizardUpdateChallengeNote($note: ChallengeNoteInput!) {
    updateChallengeNote(note: $note) {
      id
    }
  }
`;
export type WizardUpdateChallengeNoteMutationFn = Apollo.MutationFunction<
  WizardUpdateChallengeNoteMutation,
  WizardUpdateChallengeNoteMutationVariables
>;

/**
 * __useWizardUpdateChallengeNoteMutation__
 *
 * To run a mutation, you first call `useWizardUpdateChallengeNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWizardUpdateChallengeNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wizardUpdateChallengeNoteMutation, { data, loading, error }] = useWizardUpdateChallengeNoteMutation({
 *   variables: {
 *      note: // value for 'note'
 *   },
 * });
 */
export function useWizardUpdateChallengeNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    WizardUpdateChallengeNoteMutation,
    WizardUpdateChallengeNoteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<WizardUpdateChallengeNoteMutation, WizardUpdateChallengeNoteMutationVariables>(
    WizardUpdateChallengeNoteDocument,
    options,
  );
}
export type WizardUpdateChallengeNoteMutationHookResult = ReturnType<typeof useWizardUpdateChallengeNoteMutation>;
export type WizardUpdateChallengeNoteMutationResult = Apollo.MutationResult<WizardUpdateChallengeNoteMutation>;
export type WizardUpdateChallengeNoteMutationOptions = Apollo.BaseMutationOptions<
  WizardUpdateChallengeNoteMutation,
  WizardUpdateChallengeNoteMutationVariables
>;
export const WizardCreateChallengeTabDocument = gql`
  mutation wizardCreateChallengeTab($tab: ChallengeTabInput!) {
    createChallengeTab(tab: $tab) {
      id
    }
  }
`;
export type WizardCreateChallengeTabMutationFn = Apollo.MutationFunction<
  WizardCreateChallengeTabMutation,
  WizardCreateChallengeTabMutationVariables
>;

/**
 * __useWizardCreateChallengeTabMutation__
 *
 * To run a mutation, you first call `useWizardCreateChallengeTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWizardCreateChallengeTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wizardCreateChallengeTabMutation, { data, loading, error }] = useWizardCreateChallengeTabMutation({
 *   variables: {
 *      tab: // value for 'tab'
 *   },
 * });
 */
export function useWizardCreateChallengeTabMutation(
  baseOptions?: Apollo.MutationHookOptions<WizardCreateChallengeTabMutation, WizardCreateChallengeTabMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<WizardCreateChallengeTabMutation, WizardCreateChallengeTabMutationVariables>(
    WizardCreateChallengeTabDocument,
    options,
  );
}
export type WizardCreateChallengeTabMutationHookResult = ReturnType<typeof useWizardCreateChallengeTabMutation>;
export type WizardCreateChallengeTabMutationResult = Apollo.MutationResult<WizardCreateChallengeTabMutation>;
export type WizardCreateChallengeTabMutationOptions = Apollo.BaseMutationOptions<
  WizardCreateChallengeTabMutation,
  WizardCreateChallengeTabMutationVariables
>;
export const WizardUpdateChallengeTabDocument = gql`
  mutation wizardUpdateChallengeTab($tab: ChallengeTabInput!) {
    updateChallengeTab(tab: $tab) {
      id
    }
  }
`;
export type WizardUpdateChallengeTabMutationFn = Apollo.MutationFunction<
  WizardUpdateChallengeTabMutation,
  WizardUpdateChallengeTabMutationVariables
>;

/**
 * __useWizardUpdateChallengeTabMutation__
 *
 * To run a mutation, you first call `useWizardUpdateChallengeTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWizardUpdateChallengeTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wizardUpdateChallengeTabMutation, { data, loading, error }] = useWizardUpdateChallengeTabMutation({
 *   variables: {
 *      tab: // value for 'tab'
 *   },
 * });
 */
export function useWizardUpdateChallengeTabMutation(
  baseOptions?: Apollo.MutationHookOptions<WizardUpdateChallengeTabMutation, WizardUpdateChallengeTabMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<WizardUpdateChallengeTabMutation, WizardUpdateChallengeTabMutationVariables>(
    WizardUpdateChallengeTabDocument,
    options,
  );
}
export type WizardUpdateChallengeTabMutationHookResult = ReturnType<typeof useWizardUpdateChallengeTabMutation>;
export type WizardUpdateChallengeTabMutationResult = Apollo.MutationResult<WizardUpdateChallengeTabMutation>;
export type WizardUpdateChallengeTabMutationOptions = Apollo.BaseMutationOptions<
  WizardUpdateChallengeTabMutation,
  WizardUpdateChallengeTabMutationVariables
>;
export const WizardUpdateTrackDocument = gql`
  mutation wizardUpdateTrack($track: TrackInput!) {
    updateTrack(track: $track) {
      id
      permalink
      slug
      title
    }
  }
`;
export type WizardUpdateTrackMutationFn = Apollo.MutationFunction<
  WizardUpdateTrackMutation,
  WizardUpdateTrackMutationVariables
>;

/**
 * __useWizardUpdateTrackMutation__
 *
 * To run a mutation, you first call `useWizardUpdateTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWizardUpdateTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wizardUpdateTrackMutation, { data, loading, error }] = useWizardUpdateTrackMutation({
 *   variables: {
 *      track: // value for 'track'
 *   },
 * });
 */
export function useWizardUpdateTrackMutation(
  baseOptions?: Apollo.MutationHookOptions<WizardUpdateTrackMutation, WizardUpdateTrackMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<WizardUpdateTrackMutation, WizardUpdateTrackMutationVariables>(
    WizardUpdateTrackDocument,
    options,
  );
}
export type WizardUpdateTrackMutationHookResult = ReturnType<typeof useWizardUpdateTrackMutation>;
export type WizardUpdateTrackMutationResult = Apollo.MutationResult<WizardUpdateTrackMutation>;
export type WizardUpdateTrackMutationOptions = Apollo.BaseMutationOptions<
  WizardUpdateTrackMutation,
  WizardUpdateTrackMutationVariables
>;
export const GetEmbedConfigurationDocument = gql`
  query getEmbedConfiguration($trackID: String!, $teamSlug: String!) {
    track(trackID: $trackID) {
      embed_token
    }
    team(teamSlug: $teamSlug) {
      lti_credentials {
        consumer_name
        consumer_key
      }
    }
  }
`;

/**
 * __useGetEmbedConfigurationQuery__
 *
 * To run a query within a React component, call `useGetEmbedConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmbedConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmbedConfigurationQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useGetEmbedConfigurationQuery(
  baseOptions: Apollo.QueryHookOptions<GetEmbedConfigurationQuery, GetEmbedConfigurationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEmbedConfigurationQuery, GetEmbedConfigurationQueryVariables>(
    GetEmbedConfigurationDocument,
    options,
  );
}
export function useGetEmbedConfigurationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetEmbedConfigurationQuery, GetEmbedConfigurationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEmbedConfigurationQuery, GetEmbedConfigurationQueryVariables>(
    GetEmbedConfigurationDocument,
    options,
  );
}
export type GetEmbedConfigurationQueryHookResult = ReturnType<typeof useGetEmbedConfigurationQuery>;
export type GetEmbedConfigurationLazyQueryHookResult = ReturnType<typeof useGetEmbedConfigurationLazyQuery>;
export type GetEmbedConfigurationQueryResult = Apollo.QueryResult<
  GetEmbedConfigurationQuery,
  GetEmbedConfigurationQueryVariables
>;
export const GetHotStartPoolDetailsConfigDocument = gql`
  query GetHotStartPoolDetailsConfig($id: String!, $teamSlug: String!) {
    team(teamSlug: $teamSlug) {
      features {
        shared_hotstart_pools
        global_sandboxes
      }
    }
    hotStartPool(id: $id, organizationSlug: $teamSlug) {
      id
      size
      created
      name
      auto_refill
      starts_at
      ends_at
      status
      type
      region
      created_by {
        profile {
          display_name
        }
      }
      tracks {
        claimed
        available
        creating
        node {
          id
          title
        }
      }
      configs {
        claimed
        available
        creating
        node {
          id
          name
        }
      }
    }
  }
`;

/**
 * __useGetHotStartPoolDetailsConfigQuery__
 *
 * To run a query within a React component, call `useGetHotStartPoolDetailsConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHotStartPoolDetailsConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHotStartPoolDetailsConfigQuery({
 *   variables: {
 *      id: // value for 'id'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useGetHotStartPoolDetailsConfigQuery(
  baseOptions: Apollo.QueryHookOptions<GetHotStartPoolDetailsConfigQuery, GetHotStartPoolDetailsConfigQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetHotStartPoolDetailsConfigQuery, GetHotStartPoolDetailsConfigQueryVariables>(
    GetHotStartPoolDetailsConfigDocument,
    options,
  );
}
export function useGetHotStartPoolDetailsConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetHotStartPoolDetailsConfigQuery,
    GetHotStartPoolDetailsConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetHotStartPoolDetailsConfigQuery, GetHotStartPoolDetailsConfigQueryVariables>(
    GetHotStartPoolDetailsConfigDocument,
    options,
  );
}
export type GetHotStartPoolDetailsConfigQueryHookResult = ReturnType<typeof useGetHotStartPoolDetailsConfigQuery>;
export type GetHotStartPoolDetailsConfigLazyQueryHookResult = ReturnType<
  typeof useGetHotStartPoolDetailsConfigLazyQuery
>;
export type GetHotStartPoolDetailsConfigQueryResult = Apollo.QueryResult<
  GetHotStartPoolDetailsConfigQuery,
  GetHotStartPoolDetailsConfigQueryVariables
>;
export const GetHotStartPageConfigDocument = gql`
  query getHotStartPageConfig($teamSlug: String!) {
    team(teamSlug: $teamSlug) {
      features {
        shared_hotstart_pools
      }
    }
    hotStartPools(organizationSlug: $teamSlug) {
      edges {
        node {
          ...HotStartPagePool
        }
      }
    }
  }
  ${HotStartPagePoolFragmentDoc}
`;

/**
 * __useGetHotStartPageConfigQuery__
 *
 * To run a query within a React component, call `useGetHotStartPageConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHotStartPageConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHotStartPageConfigQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useGetHotStartPageConfigQuery(
  baseOptions: Apollo.QueryHookOptions<GetHotStartPageConfigQuery, GetHotStartPageConfigQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetHotStartPageConfigQuery, GetHotStartPageConfigQueryVariables>(
    GetHotStartPageConfigDocument,
    options,
  );
}
export function useGetHotStartPageConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetHotStartPageConfigQuery, GetHotStartPageConfigQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetHotStartPageConfigQuery, GetHotStartPageConfigQueryVariables>(
    GetHotStartPageConfigDocument,
    options,
  );
}
export type GetHotStartPageConfigQueryHookResult = ReturnType<typeof useGetHotStartPageConfigQuery>;
export type GetHotStartPageConfigLazyQueryHookResult = ReturnType<typeof useGetHotStartPageConfigLazyQuery>;
export type GetHotStartPageConfigQueryResult = Apollo.QueryResult<
  GetHotStartPageConfigQuery,
  GetHotStartPageConfigQueryVariables
>;
export const HotStartPageDeleteHotStartPoolDocument = gql`
  mutation hotStartPageDeleteHotStartPool($poolID: ID!) {
    deleteHotStartPool(poolID: $poolID)
  }
`;
export type HotStartPageDeleteHotStartPoolMutationFn = Apollo.MutationFunction<
  HotStartPageDeleteHotStartPoolMutation,
  HotStartPageDeleteHotStartPoolMutationVariables
>;

/**
 * __useHotStartPageDeleteHotStartPoolMutation__
 *
 * To run a mutation, you first call `useHotStartPageDeleteHotStartPoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHotStartPageDeleteHotStartPoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hotStartPageDeleteHotStartPoolMutation, { data, loading, error }] = useHotStartPageDeleteHotStartPoolMutation({
 *   variables: {
 *      poolID: // value for 'poolID'
 *   },
 * });
 */
export function useHotStartPageDeleteHotStartPoolMutation(
  baseOptions?: Apollo.MutationHookOptions<
    HotStartPageDeleteHotStartPoolMutation,
    HotStartPageDeleteHotStartPoolMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<HotStartPageDeleteHotStartPoolMutation, HotStartPageDeleteHotStartPoolMutationVariables>(
    HotStartPageDeleteHotStartPoolDocument,
    options,
  );
}
export type HotStartPageDeleteHotStartPoolMutationHookResult = ReturnType<
  typeof useHotStartPageDeleteHotStartPoolMutation
>;
export type HotStartPageDeleteHotStartPoolMutationResult =
  Apollo.MutationResult<HotStartPageDeleteHotStartPoolMutation>;
export type HotStartPageDeleteHotStartPoolMutationOptions = Apollo.BaseMutationOptions<
  HotStartPageDeleteHotStartPoolMutation,
  HotStartPageDeleteHotStartPoolMutationVariables
>;
export const GetManageCloudAccountPageConfigDocument = gql`
  query getManageCloudAccountPageConfig($teamSlug: String!, $trackID: String!) {
    userIsTrackDeveloper(trackID: $trackID)
    team(teamSlug: $teamSlug) {
      id
      features {
        aws_accounts
        azure_subscriptions
        gcp_projects
      }
    }
    trackConfig(trackID: $trackID) {
      id
      ...ManageTrackHostResources
      ...ManageTrackCloudAccsResources
      secrets {
        ...SandboxConfigSecret
      }
    }
    trackScripts(trackID: $trackID) {
      id
      host
      action
      contents
    }
  }
  ${ManageTrackHostResourcesFragmentDoc}
  ${ManageTrackCloudAccsResourcesFragmentDoc}
  ${SandboxConfigSecretFragmentDoc}
`;

/**
 * __useGetManageCloudAccountPageConfigQuery__
 *
 * To run a query within a React component, call `useGetManageCloudAccountPageConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManageCloudAccountPageConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManageCloudAccountPageConfigQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useGetManageCloudAccountPageConfigQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetManageCloudAccountPageConfigQuery,
    GetManageCloudAccountPageConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetManageCloudAccountPageConfigQuery, GetManageCloudAccountPageConfigQueryVariables>(
    GetManageCloudAccountPageConfigDocument,
    options,
  );
}
export function useGetManageCloudAccountPageConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetManageCloudAccountPageConfigQuery,
    GetManageCloudAccountPageConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetManageCloudAccountPageConfigQuery, GetManageCloudAccountPageConfigQueryVariables>(
    GetManageCloudAccountPageConfigDocument,
    options,
  );
}
export type GetManageCloudAccountPageConfigQueryHookResult = ReturnType<typeof useGetManageCloudAccountPageConfigQuery>;
export type GetManageCloudAccountPageConfigLazyQueryHookResult = ReturnType<
  typeof useGetManageCloudAccountPageConfigLazyQuery
>;
export type GetManageCloudAccountPageConfigQueryResult = Apollo.QueryResult<
  GetManageCloudAccountPageConfigQuery,
  GetManageCloudAccountPageConfigQueryVariables
>;
export const UpdateCloudAccountsDocument = gql`
  mutation updateCloudAccounts($configID: String!, $config: SandboxConfigInput!) {
    updateSandboxConfig(configID: $configID, config: $config) {
      id
    }
  }
`;
export type UpdateCloudAccountsMutationFn = Apollo.MutationFunction<
  UpdateCloudAccountsMutation,
  UpdateCloudAccountsMutationVariables
>;

/**
 * __useUpdateCloudAccountsMutation__
 *
 * To run a mutation, you first call `useUpdateCloudAccountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCloudAccountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCloudAccountsMutation, { data, loading, error }] = useUpdateCloudAccountsMutation({
 *   variables: {
 *      configID: // value for 'configID'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useUpdateCloudAccountsMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateCloudAccountsMutation, UpdateCloudAccountsMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateCloudAccountsMutation, UpdateCloudAccountsMutationVariables>(
    UpdateCloudAccountsDocument,
    options,
  );
}
export type UpdateCloudAccountsMutationHookResult = ReturnType<typeof useUpdateCloudAccountsMutation>;
export type UpdateCloudAccountsMutationResult = Apollo.MutationResult<UpdateCloudAccountsMutation>;
export type UpdateCloudAccountsMutationOptions = Apollo.BaseMutationOptions<
  UpdateCloudAccountsMutation,
  UpdateCloudAccountsMutationVariables
>;
export const GetManageHostPageConfigDocument = gql`
  query getManageHostPageConfig($teamSlug: String!, $trackID: String!) {
    userIsTrackDeveloper(trackID: $trackID)
    team(teamSlug: $teamSlug) {
      id
      features {
        containers
        virtual_machines
        saas
        custom_machine_type
      }
    }
    trackConfigPresets {
      ...CreateTrackSandboxPresets
    }
    trackConfig(trackID: $trackID) {
      id
      ...ManageTrackHostResources
      ...ManageTrackCloudAccsResources
      secrets {
        ...SandboxConfigSecret
      }
    }
    trackScripts(trackID: $trackID) {
      id
      host
      action
      contents
    }
  }
  ${CreateTrackSandboxPresetsFragmentDoc}
  ${ManageTrackHostResourcesFragmentDoc}
  ${ManageTrackCloudAccsResourcesFragmentDoc}
  ${SandboxConfigSecretFragmentDoc}
`;

/**
 * __useGetManageHostPageConfigQuery__
 *
 * To run a query within a React component, call `useGetManageHostPageConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManageHostPageConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManageHostPageConfigQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useGetManageHostPageConfigQuery(
  baseOptions: Apollo.QueryHookOptions<GetManageHostPageConfigQuery, GetManageHostPageConfigQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetManageHostPageConfigQuery, GetManageHostPageConfigQueryVariables>(
    GetManageHostPageConfigDocument,
    options,
  );
}
export function useGetManageHostPageConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetManageHostPageConfigQuery, GetManageHostPageConfigQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetManageHostPageConfigQuery, GetManageHostPageConfigQueryVariables>(
    GetManageHostPageConfigDocument,
    options,
  );
}
export type GetManageHostPageConfigQueryHookResult = ReturnType<typeof useGetManageHostPageConfigQuery>;
export type GetManageHostPageConfigLazyQueryHookResult = ReturnType<typeof useGetManageHostPageConfigLazyQuery>;
export type GetManageHostPageConfigQueryResult = Apollo.QueryResult<
  GetManageHostPageConfigQuery,
  GetManageHostPageConfigQueryVariables
>;
export const UpdateHostsDocument = gql`
  mutation updateHosts($configID: String!, $config: SandboxConfigInput!) {
    updateSandboxConfig(configID: $configID, config: $config) {
      id
    }
  }
`;
export type UpdateHostsMutationFn = Apollo.MutationFunction<UpdateHostsMutation, UpdateHostsMutationVariables>;

/**
 * __useUpdateHostsMutation__
 *
 * To run a mutation, you first call `useUpdateHostsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHostsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHostsMutation, { data, loading, error }] = useUpdateHostsMutation({
 *   variables: {
 *      configID: // value for 'configID'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useUpdateHostsMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateHostsMutation, UpdateHostsMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateHostsMutation, UpdateHostsMutationVariables>(UpdateHostsDocument, options);
}
export type UpdateHostsMutationHookResult = ReturnType<typeof useUpdateHostsMutation>;
export type UpdateHostsMutationResult = Apollo.MutationResult<UpdateHostsMutation>;
export type UpdateHostsMutationOptions = Apollo.BaseMutationOptions<UpdateHostsMutation, UpdateHostsMutationVariables>;
export const ManageHostPageRenameHostDocument = gql`
  mutation manageHostPageRenameHost($configID: String!, $hostName: String!, $newName: String!) {
    renameSandboxConfigHost(configID: $configID, hostName: $hostName, newName: $newName) {
      id
    }
  }
`;
export type ManageHostPageRenameHostMutationFn = Apollo.MutationFunction<
  ManageHostPageRenameHostMutation,
  ManageHostPageRenameHostMutationVariables
>;

/**
 * __useManageHostPageRenameHostMutation__
 *
 * To run a mutation, you first call `useManageHostPageRenameHostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageHostPageRenameHostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageHostPageRenameHostMutation, { data, loading, error }] = useManageHostPageRenameHostMutation({
 *   variables: {
 *      configID: // value for 'configID'
 *      hostName: // value for 'hostName'
 *      newName: // value for 'newName'
 *   },
 * });
 */
export function useManageHostPageRenameHostMutation(
  baseOptions?: Apollo.MutationHookOptions<ManageHostPageRenameHostMutation, ManageHostPageRenameHostMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ManageHostPageRenameHostMutation, ManageHostPageRenameHostMutationVariables>(
    ManageHostPageRenameHostDocument,
    options,
  );
}
export type ManageHostPageRenameHostMutationHookResult = ReturnType<typeof useManageHostPageRenameHostMutation>;
export type ManageHostPageRenameHostMutationResult = Apollo.MutationResult<ManageHostPageRenameHostMutation>;
export type ManageHostPageRenameHostMutationOptions = Apollo.BaseMutationOptions<
  ManageHostPageRenameHostMutation,
  ManageHostPageRenameHostMutationVariables
>;
export const GetManageHotStartPageConfigDocument = gql`
  query getManageHotStartPageConfig($teamSlug: String!, $filter: SandboxConfigVersionsFilterInput!) {
    team(teamSlug: $teamSlug) {
      features {
        max_hot_start_pool_size_always_on
        max_hot_start_pool_size_scheduled
        shared_hotstart_pools
        global_sandboxes
      }
    }
    tracks(teamSlug: $teamSlug) {
      ...HotStartFormTrack
    }
    sandboxConfigVersions(teamSlug: $teamSlug, filter: $filter) {
      ...HotStartSandboxPreset
    }
  }
  ${HotStartFormTrackFragmentDoc}
  ${HotStartSandboxPresetFragmentDoc}
`;

/**
 * __useGetManageHotStartPageConfigQuery__
 *
 * To run a query within a React component, call `useGetManageHotStartPageConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManageHotStartPageConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManageHotStartPageConfigQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetManageHotStartPageConfigQuery(
  baseOptions: Apollo.QueryHookOptions<GetManageHotStartPageConfigQuery, GetManageHotStartPageConfigQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetManageHotStartPageConfigQuery, GetManageHotStartPageConfigQueryVariables>(
    GetManageHotStartPageConfigDocument,
    options,
  );
}
export function useGetManageHotStartPageConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetManageHotStartPageConfigQuery,
    GetManageHotStartPageConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetManageHotStartPageConfigQuery, GetManageHotStartPageConfigQueryVariables>(
    GetManageHotStartPageConfigDocument,
    options,
  );
}
export type GetManageHotStartPageConfigQueryHookResult = ReturnType<typeof useGetManageHotStartPageConfigQuery>;
export type GetManageHotStartPageConfigLazyQueryHookResult = ReturnType<typeof useGetManageHotStartPageConfigLazyQuery>;
export type GetManageHotStartPageConfigQueryResult = Apollo.QueryResult<
  GetManageHotStartPageConfigQuery,
  GetManageHotStartPageConfigQueryVariables
>;
export const CreateHotStartPoolDocument = gql`
  mutation CreateHotStartPool($input: HotStartPoolInput!) {
    createHotStartPool(pool: $input) {
      id
    }
  }
`;
export type CreateHotStartPoolMutationFn = Apollo.MutationFunction<
  CreateHotStartPoolMutation,
  CreateHotStartPoolMutationVariables
>;

/**
 * __useCreateHotStartPoolMutation__
 *
 * To run a mutation, you first call `useCreateHotStartPoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHotStartPoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHotStartPoolMutation, { data, loading, error }] = useCreateHotStartPoolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateHotStartPoolMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateHotStartPoolMutation, CreateHotStartPoolMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateHotStartPoolMutation, CreateHotStartPoolMutationVariables>(
    CreateHotStartPoolDocument,
    options,
  );
}
export type CreateHotStartPoolMutationHookResult = ReturnType<typeof useCreateHotStartPoolMutation>;
export type CreateHotStartPoolMutationResult = Apollo.MutationResult<CreateHotStartPoolMutation>;
export type CreateHotStartPoolMutationOptions = Apollo.BaseMutationOptions<
  CreateHotStartPoolMutation,
  CreateHotStartPoolMutationVariables
>;
export const UpdateHotStartPoolDocument = gql`
  mutation UpdateHotStartPool($poolID: ID!, $input: HotStartPoolInput!) {
    updateHotStartPool(id: $poolID, pool: $input) {
      id
    }
  }
`;
export type UpdateHotStartPoolMutationFn = Apollo.MutationFunction<
  UpdateHotStartPoolMutation,
  UpdateHotStartPoolMutationVariables
>;

/**
 * __useUpdateHotStartPoolMutation__
 *
 * To run a mutation, you first call `useUpdateHotStartPoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHotStartPoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHotStartPoolMutation, { data, loading, error }] = useUpdateHotStartPoolMutation({
 *   variables: {
 *      poolID: // value for 'poolID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateHotStartPoolMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateHotStartPoolMutation, UpdateHotStartPoolMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateHotStartPoolMutation, UpdateHotStartPoolMutationVariables>(
    UpdateHotStartPoolDocument,
    options,
  );
}
export type UpdateHotStartPoolMutationHookResult = ReturnType<typeof useUpdateHotStartPoolMutation>;
export type UpdateHotStartPoolMutationResult = Apollo.MutationResult<UpdateHotStartPoolMutation>;
export type UpdateHotStartPoolMutationOptions = Apollo.BaseMutationOptions<
  UpdateHotStartPoolMutation,
  UpdateHotStartPoolMutationVariables
>;
export const GetHotStartPoolToDuplicateDocument = gql`
  query GetHotStartPoolToDuplicate($poolID: String!, $teamSlug: String!) {
    hotStartPool(id: $poolID, organizationSlug: $teamSlug) {
      ...HotStartPoolExistingPool
    }
  }
  ${HotStartPoolExistingPoolFragmentDoc}
`;

/**
 * __useGetHotStartPoolToDuplicateQuery__
 *
 * To run a query within a React component, call `useGetHotStartPoolToDuplicateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHotStartPoolToDuplicateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHotStartPoolToDuplicateQuery({
 *   variables: {
 *      poolID: // value for 'poolID'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useGetHotStartPoolToDuplicateQuery(
  baseOptions: Apollo.QueryHookOptions<GetHotStartPoolToDuplicateQuery, GetHotStartPoolToDuplicateQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetHotStartPoolToDuplicateQuery, GetHotStartPoolToDuplicateQueryVariables>(
    GetHotStartPoolToDuplicateDocument,
    options,
  );
}
export function useGetHotStartPoolToDuplicateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetHotStartPoolToDuplicateQuery, GetHotStartPoolToDuplicateQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetHotStartPoolToDuplicateQuery, GetHotStartPoolToDuplicateQueryVariables>(
    GetHotStartPoolToDuplicateDocument,
    options,
  );
}
export type GetHotStartPoolToDuplicateQueryHookResult = ReturnType<typeof useGetHotStartPoolToDuplicateQuery>;
export type GetHotStartPoolToDuplicateLazyQueryHookResult = ReturnType<typeof useGetHotStartPoolToDuplicateLazyQuery>;
export type GetHotStartPoolToDuplicateQueryResult = Apollo.QueryResult<
  GetHotStartPoolToDuplicateQuery,
  GetHotStartPoolToDuplicateQueryVariables
>;
export const GetHotStartInviteDocument = gql`
  query GetHotStartInvite($inviteID: String!) {
    trackInvite(inviteID: $inviteID) {
      ...HotStartInvite
    }
  }
  ${HotStartInviteFragmentDoc}
`;

/**
 * __useGetHotStartInviteQuery__
 *
 * To run a query within a React component, call `useGetHotStartInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHotStartInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHotStartInviteQuery({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *   },
 * });
 */
export function useGetHotStartInviteQuery(
  baseOptions: Apollo.QueryHookOptions<GetHotStartInviteQuery, GetHotStartInviteQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetHotStartInviteQuery, GetHotStartInviteQueryVariables>(GetHotStartInviteDocument, options);
}
export function useGetHotStartInviteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetHotStartInviteQuery, GetHotStartInviteQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetHotStartInviteQuery, GetHotStartInviteQueryVariables>(
    GetHotStartInviteDocument,
    options,
  );
}
export type GetHotStartInviteQueryHookResult = ReturnType<typeof useGetHotStartInviteQuery>;
export type GetHotStartInviteLazyQueryHookResult = ReturnType<typeof useGetHotStartInviteLazyQuery>;
export type GetHotStartInviteQueryResult = Apollo.QueryResult<GetHotStartInviteQuery, GetHotStartInviteQueryVariables>;
export const GetHotStartPoolExistingPoolDocument = gql`
  query GetHotStartPoolExistingPool($teamSlug: String!, $poolID: String!) {
    hotStartPool(id: $poolID, organizationSlug: $teamSlug) {
      ...HotStartPoolExistingPool
    }
  }
  ${HotStartPoolExistingPoolFragmentDoc}
`;

/**
 * __useGetHotStartPoolExistingPoolQuery__
 *
 * To run a query within a React component, call `useGetHotStartPoolExistingPoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHotStartPoolExistingPoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHotStartPoolExistingPoolQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      poolID: // value for 'poolID'
 *   },
 * });
 */
export function useGetHotStartPoolExistingPoolQuery(
  baseOptions: Apollo.QueryHookOptions<GetHotStartPoolExistingPoolQuery, GetHotStartPoolExistingPoolQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetHotStartPoolExistingPoolQuery, GetHotStartPoolExistingPoolQueryVariables>(
    GetHotStartPoolExistingPoolDocument,
    options,
  );
}
export function useGetHotStartPoolExistingPoolLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetHotStartPoolExistingPoolQuery,
    GetHotStartPoolExistingPoolQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetHotStartPoolExistingPoolQuery, GetHotStartPoolExistingPoolQueryVariables>(
    GetHotStartPoolExistingPoolDocument,
    options,
  );
}
export type GetHotStartPoolExistingPoolQueryHookResult = ReturnType<typeof useGetHotStartPoolExistingPoolQuery>;
export type GetHotStartPoolExistingPoolLazyQueryHookResult = ReturnType<typeof useGetHotStartPoolExistingPoolLazyQuery>;
export type GetHotStartPoolExistingPoolQueryResult = Apollo.QueryResult<
  GetHotStartPoolExistingPoolQuery,
  GetHotStartPoolExistingPoolQueryVariables
>;
export const GetManageSandboxPresetConfigDocument = gql`
  query getManageSandboxPresetConfig($teamSlug: String!) {
    userInTeam(teamSlug: $teamSlug)
    team(teamSlug: $teamSlug) {
      id
      features {
        containers
        virtual_machines
        saas
        custom_machine_type
        aws_accounts
        azure_subscriptions
        gcp_projects
        shared_hotstart_pools
      }
    }
    trackConfigPresets {
      ...CreateTrackSandboxPresets
    }
    teamSecrets(teamSlug: $teamSlug) {
      name
      description
    }
  }
  ${CreateTrackSandboxPresetsFragmentDoc}
`;

/**
 * __useGetManageSandboxPresetConfigQuery__
 *
 * To run a query within a React component, call `useGetManageSandboxPresetConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManageSandboxPresetConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManageSandboxPresetConfigQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useGetManageSandboxPresetConfigQuery(
  baseOptions: Apollo.QueryHookOptions<GetManageSandboxPresetConfigQuery, GetManageSandboxPresetConfigQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetManageSandboxPresetConfigQuery, GetManageSandboxPresetConfigQueryVariables>(
    GetManageSandboxPresetConfigDocument,
    options,
  );
}
export function useGetManageSandboxPresetConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetManageSandboxPresetConfigQuery,
    GetManageSandboxPresetConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetManageSandboxPresetConfigQuery, GetManageSandboxPresetConfigQueryVariables>(
    GetManageSandboxPresetConfigDocument,
    options,
  );
}
export type GetManageSandboxPresetConfigQueryHookResult = ReturnType<typeof useGetManageSandboxPresetConfigQuery>;
export type GetManageSandboxPresetConfigLazyQueryHookResult = ReturnType<
  typeof useGetManageSandboxPresetConfigLazyQuery
>;
export type GetManageSandboxPresetConfigQueryResult = Apollo.QueryResult<
  GetManageSandboxPresetConfigQuery,
  GetManageSandboxPresetConfigQueryVariables
>;
export const ManageSandboxPresetCreatePresetDocument = gql`
  mutation manageSandboxPresetCreatePreset(
    $teamID: String!
    $teamSlug: String!
    $name: String!
    $slug: String!
    $config: SandboxConfigInput!
  ) {
    createSandboxConfig(teamID: $teamID, teamSlug: $teamSlug, name: $name, slug: $slug, config: $config) {
      id
      config {
        id
      }
    }
  }
`;
export type ManageSandboxPresetCreatePresetMutationFn = Apollo.MutationFunction<
  ManageSandboxPresetCreatePresetMutation,
  ManageSandboxPresetCreatePresetMutationVariables
>;

/**
 * __useManageSandboxPresetCreatePresetMutation__
 *
 * To run a mutation, you first call `useManageSandboxPresetCreatePresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageSandboxPresetCreatePresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageSandboxPresetCreatePresetMutation, { data, loading, error }] = useManageSandboxPresetCreatePresetMutation({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      teamSlug: // value for 'teamSlug'
 *      name: // value for 'name'
 *      slug: // value for 'slug'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useManageSandboxPresetCreatePresetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ManageSandboxPresetCreatePresetMutation,
    ManageSandboxPresetCreatePresetMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ManageSandboxPresetCreatePresetMutation, ManageSandboxPresetCreatePresetMutationVariables>(
    ManageSandboxPresetCreatePresetDocument,
    options,
  );
}
export type ManageSandboxPresetCreatePresetMutationHookResult = ReturnType<
  typeof useManageSandboxPresetCreatePresetMutation
>;
export type ManageSandboxPresetCreatePresetMutationResult =
  Apollo.MutationResult<ManageSandboxPresetCreatePresetMutation>;
export type ManageSandboxPresetCreatePresetMutationOptions = Apollo.BaseMutationOptions<
  ManageSandboxPresetCreatePresetMutation,
  ManageSandboxPresetCreatePresetMutationVariables
>;
export const ManageSandboxPresetUpdatePresetDocument = gql`
  mutation manageSandboxPresetUpdatePreset($configID: String!, $config: SandboxConfigInput!) {
    updateSandboxConfig(configID: $configID, config: $config) {
      id
      config {
        id
      }
    }
  }
`;
export type ManageSandboxPresetUpdatePresetMutationFn = Apollo.MutationFunction<
  ManageSandboxPresetUpdatePresetMutation,
  ManageSandboxPresetUpdatePresetMutationVariables
>;

/**
 * __useManageSandboxPresetUpdatePresetMutation__
 *
 * To run a mutation, you first call `useManageSandboxPresetUpdatePresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageSandboxPresetUpdatePresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageSandboxPresetUpdatePresetMutation, { data, loading, error }] = useManageSandboxPresetUpdatePresetMutation({
 *   variables: {
 *      configID: // value for 'configID'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useManageSandboxPresetUpdatePresetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ManageSandboxPresetUpdatePresetMutation,
    ManageSandboxPresetUpdatePresetMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ManageSandboxPresetUpdatePresetMutation, ManageSandboxPresetUpdatePresetMutationVariables>(
    ManageSandboxPresetUpdatePresetDocument,
    options,
  );
}
export type ManageSandboxPresetUpdatePresetMutationHookResult = ReturnType<
  typeof useManageSandboxPresetUpdatePresetMutation
>;
export type ManageSandboxPresetUpdatePresetMutationResult =
  Apollo.MutationResult<ManageSandboxPresetUpdatePresetMutation>;
export type ManageSandboxPresetUpdatePresetMutationOptions = Apollo.BaseMutationOptions<
  ManageSandboxPresetUpdatePresetMutation,
  ManageSandboxPresetUpdatePresetMutationVariables
>;
export const ManageSandboxPresetPublishConfigDocument = gql`
  mutation manageSandboxPresetPublishConfig($configID: String!, $changeLogEntry: String!) {
    publishSandboxConfig(configID: $configID, changeLogEntry: $changeLogEntry) {
      id
    }
  }
`;
export type ManageSandboxPresetPublishConfigMutationFn = Apollo.MutationFunction<
  ManageSandboxPresetPublishConfigMutation,
  ManageSandboxPresetPublishConfigMutationVariables
>;

/**
 * __useManageSandboxPresetPublishConfigMutation__
 *
 * To run a mutation, you first call `useManageSandboxPresetPublishConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageSandboxPresetPublishConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageSandboxPresetPublishConfigMutation, { data, loading, error }] = useManageSandboxPresetPublishConfigMutation({
 *   variables: {
 *      configID: // value for 'configID'
 *      changeLogEntry: // value for 'changeLogEntry'
 *   },
 * });
 */
export function useManageSandboxPresetPublishConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ManageSandboxPresetPublishConfigMutation,
    ManageSandboxPresetPublishConfigMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ManageSandboxPresetPublishConfigMutation,
    ManageSandboxPresetPublishConfigMutationVariables
  >(ManageSandboxPresetPublishConfigDocument, options);
}
export type ManageSandboxPresetPublishConfigMutationHookResult = ReturnType<
  typeof useManageSandboxPresetPublishConfigMutation
>;
export type ManageSandboxPresetPublishConfigMutationResult =
  Apollo.MutationResult<ManageSandboxPresetPublishConfigMutation>;
export type ManageSandboxPresetPublishConfigMutationOptions = Apollo.BaseMutationOptions<
  ManageSandboxPresetPublishConfigMutation,
  ManageSandboxPresetPublishConfigMutationVariables
>;
export const ManageSandboxPresetRenameSandboxDocument = gql`
  mutation manageSandboxPresetRenameSandbox($configID: String!, $name: String!) {
    renameSandboxConfig(configID: $configID, name: $name) {
      id
    }
  }
`;
export type ManageSandboxPresetRenameSandboxMutationFn = Apollo.MutationFunction<
  ManageSandboxPresetRenameSandboxMutation,
  ManageSandboxPresetRenameSandboxMutationVariables
>;

/**
 * __useManageSandboxPresetRenameSandboxMutation__
 *
 * To run a mutation, you first call `useManageSandboxPresetRenameSandboxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageSandboxPresetRenameSandboxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageSandboxPresetRenameSandboxMutation, { data, loading, error }] = useManageSandboxPresetRenameSandboxMutation({
 *   variables: {
 *      configID: // value for 'configID'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useManageSandboxPresetRenameSandboxMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ManageSandboxPresetRenameSandboxMutation,
    ManageSandboxPresetRenameSandboxMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ManageSandboxPresetRenameSandboxMutation,
    ManageSandboxPresetRenameSandboxMutationVariables
  >(ManageSandboxPresetRenameSandboxDocument, options);
}
export type ManageSandboxPresetRenameSandboxMutationHookResult = ReturnType<
  typeof useManageSandboxPresetRenameSandboxMutation
>;
export type ManageSandboxPresetRenameSandboxMutationResult =
  Apollo.MutationResult<ManageSandboxPresetRenameSandboxMutation>;
export type ManageSandboxPresetRenameSandboxMutationOptions = Apollo.BaseMutationOptions<
  ManageSandboxPresetRenameSandboxMutation,
  ManageSandboxPresetRenameSandboxMutationVariables
>;
export const GetManageSandboxPresetVersionDocument = gql`
  query getManageSandboxPresetVersion($teamSlug: String!, $filter: SandboxConfigVersionsFilterInput!) {
    sandboxConfigVersions(teamSlug: $teamSlug, filter: $filter) {
      ...ManageSandboxPresetVersion
    }
  }
  ${ManageSandboxPresetVersionFragmentDoc}
`;

/**
 * __useGetManageSandboxPresetVersionQuery__
 *
 * To run a query within a React component, call `useGetManageSandboxPresetVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManageSandboxPresetVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManageSandboxPresetVersionQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetManageSandboxPresetVersionQuery(
  baseOptions: Apollo.QueryHookOptions<GetManageSandboxPresetVersionQuery, GetManageSandboxPresetVersionQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetManageSandboxPresetVersionQuery, GetManageSandboxPresetVersionQueryVariables>(
    GetManageSandboxPresetVersionDocument,
    options,
  );
}
export function useGetManageSandboxPresetVersionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetManageSandboxPresetVersionQuery,
    GetManageSandboxPresetVersionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetManageSandboxPresetVersionQuery, GetManageSandboxPresetVersionQueryVariables>(
    GetManageSandboxPresetVersionDocument,
    options,
  );
}
export type GetManageSandboxPresetVersionQueryHookResult = ReturnType<typeof useGetManageSandboxPresetVersionQuery>;
export type GetManageSandboxPresetVersionLazyQueryHookResult = ReturnType<
  typeof useGetManageSandboxPresetVersionLazyQuery
>;
export type GetManageSandboxPresetVersionQueryResult = Apollo.QueryResult<
  GetManageSandboxPresetVersionQuery,
  GetManageSandboxPresetVersionQueryVariables
>;
export const GetManageSandboxPresetTrackDocument = gql`
  query getManageSandboxPresetTrack($trackID: String!) {
    trackConfig(trackID: $trackID) {
      ...ManageTrackHostResources
      ...ManageTrackCloudAccsResources
      secrets {
        ...SandboxConfigSecret
      }
    }
    trackScripts(trackID: $trackID) {
      host
      action
      contents
    }
  }
  ${ManageTrackHostResourcesFragmentDoc}
  ${ManageTrackCloudAccsResourcesFragmentDoc}
  ${SandboxConfigSecretFragmentDoc}
`;

/**
 * __useGetManageSandboxPresetTrackQuery__
 *
 * To run a query within a React component, call `useGetManageSandboxPresetTrackQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManageSandboxPresetTrackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManageSandboxPresetTrackQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useGetManageSandboxPresetTrackQuery(
  baseOptions: Apollo.QueryHookOptions<GetManageSandboxPresetTrackQuery, GetManageSandboxPresetTrackQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetManageSandboxPresetTrackQuery, GetManageSandboxPresetTrackQueryVariables>(
    GetManageSandboxPresetTrackDocument,
    options,
  );
}
export function useGetManageSandboxPresetTrackLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetManageSandboxPresetTrackQuery,
    GetManageSandboxPresetTrackQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetManageSandboxPresetTrackQuery, GetManageSandboxPresetTrackQueryVariables>(
    GetManageSandboxPresetTrackDocument,
    options,
  );
}
export type GetManageSandboxPresetTrackQueryHookResult = ReturnType<typeof useGetManageSandboxPresetTrackQuery>;
export type GetManageSandboxPresetTrackLazyQueryHookResult = ReturnType<typeof useGetManageSandboxPresetTrackLazyQuery>;
export type GetManageSandboxPresetTrackQueryResult = Apollo.QueryResult<
  GetManageSandboxPresetTrackQuery,
  GetManageSandboxPresetTrackQueryVariables
>;
export const PlayActivityReportPageDocument = gql`
  query PlayActivityReportPage($playReportInput: PlayReportInput!, $teamSlug: String!) {
    playReports(input: $playReportInput) {
      items {
        ...PlayActivityReportsTable
        ...PlayActivityDrawerPlayReportItem
      }
      totalItems
    }
  }
  ${PlayActivityReportsTableFragmentDoc}
  ${PlayActivityDrawerPlayReportItemFragmentDoc}
`;

/**
 * __usePlayActivityReportPageQuery__
 *
 * To run a query within a React component, call `usePlayActivityReportPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayActivityReportPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayActivityReportPageQuery({
 *   variables: {
 *      playReportInput: // value for 'playReportInput'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function usePlayActivityReportPageQuery(
  baseOptions: Apollo.QueryHookOptions<PlayActivityReportPageQuery, PlayActivityReportPageQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PlayActivityReportPageQuery, PlayActivityReportPageQueryVariables>(
    PlayActivityReportPageDocument,
    options,
  );
}
export function usePlayActivityReportPageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PlayActivityReportPageQuery, PlayActivityReportPageQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PlayActivityReportPageQuery, PlayActivityReportPageQueryVariables>(
    PlayActivityReportPageDocument,
    options,
  );
}
export type PlayActivityReportPageQueryHookResult = ReturnType<typeof usePlayActivityReportPageQuery>;
export type PlayActivityReportPageLazyQueryHookResult = ReturnType<typeof usePlayActivityReportPageLazyQuery>;
export type PlayActivityReportPageQueryResult = Apollo.QueryResult<
  PlayActivityReportPageQuery,
  PlayActivityReportPageQueryVariables
>;
export const PlayActivityReportPageTracksDocument = gql`
  query PlayActivityReportPageTracks($teamSlug: String!) {
    tracks(teamSlug: $teamSlug) {
      ...TrackFilterTrack
    }
  }
  ${TrackFilterTrackFragmentDoc}
`;

/**
 * __usePlayActivityReportPageTracksQuery__
 *
 * To run a query within a React component, call `usePlayActivityReportPageTracksQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayActivityReportPageTracksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayActivityReportPageTracksQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function usePlayActivityReportPageTracksQuery(
  baseOptions: Apollo.QueryHookOptions<PlayActivityReportPageTracksQuery, PlayActivityReportPageTracksQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PlayActivityReportPageTracksQuery, PlayActivityReportPageTracksQueryVariables>(
    PlayActivityReportPageTracksDocument,
    options,
  );
}
export function usePlayActivityReportPageTracksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PlayActivityReportPageTracksQuery,
    PlayActivityReportPageTracksQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PlayActivityReportPageTracksQuery, PlayActivityReportPageTracksQueryVariables>(
    PlayActivityReportPageTracksDocument,
    options,
  );
}
export type PlayActivityReportPageTracksQueryHookResult = ReturnType<typeof usePlayActivityReportPageTracksQuery>;
export type PlayActivityReportPageTracksLazyQueryHookResult = ReturnType<
  typeof usePlayActivityReportPageTracksLazyQuery
>;
export type PlayActivityReportPageTracksQueryResult = Apollo.QueryResult<
  PlayActivityReportPageTracksQuery,
  PlayActivityReportPageTracksQueryVariables
>;
export const GetPreviewSandboxPresetPageConfigDocument = gql`
  query getPreviewSandboxPresetPageConfig($teamSlug: String!, $filter: SandboxConfigVersionsFilterInput!) {
    userInTeam(teamSlug: $teamSlug)
    team(teamSlug: $teamSlug) {
      id
      features {
        containers
        virtual_machines
        saas
        custom_machine_type
        aws_accounts
        azure_subscriptions
        gcp_projects
        shared_hotstart_pools
      }
    }
    sandboxConfigVersions(teamSlug: $teamSlug, filter: $filter) {
      ...PreviewSandboxPresetVersion
    }
  }
  ${PreviewSandboxPresetVersionFragmentDoc}
`;

/**
 * __useGetPreviewSandboxPresetPageConfigQuery__
 *
 * To run a query within a React component, call `useGetPreviewSandboxPresetPageConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviewSandboxPresetPageConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviewSandboxPresetPageConfigQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPreviewSandboxPresetPageConfigQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPreviewSandboxPresetPageConfigQuery,
    GetPreviewSandboxPresetPageConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPreviewSandboxPresetPageConfigQuery, GetPreviewSandboxPresetPageConfigQueryVariables>(
    GetPreviewSandboxPresetPageConfigDocument,
    options,
  );
}
export function useGetPreviewSandboxPresetPageConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPreviewSandboxPresetPageConfigQuery,
    GetPreviewSandboxPresetPageConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPreviewSandboxPresetPageConfigQuery, GetPreviewSandboxPresetPageConfigQueryVariables>(
    GetPreviewSandboxPresetPageConfigDocument,
    options,
  );
}
export type GetPreviewSandboxPresetPageConfigQueryHookResult = ReturnType<
  typeof useGetPreviewSandboxPresetPageConfigQuery
>;
export type GetPreviewSandboxPresetPageConfigLazyQueryHookResult = ReturnType<
  typeof useGetPreviewSandboxPresetPageConfigLazyQuery
>;
export type GetPreviewSandboxPresetPageConfigQueryResult = Apollo.QueryResult<
  GetPreviewSandboxPresetPageConfigQuery,
  GetPreviewSandboxPresetPageConfigQueryVariables
>;
export const PreviewSandboxPresetDeleteSandboxConfigDocument = gql`
  mutation previewSandboxPresetDeleteSandboxConfig($configVersionID: String!) {
    deleteSandboxConfig(configVersionID: $configVersionID)
  }
`;
export type PreviewSandboxPresetDeleteSandboxConfigMutationFn = Apollo.MutationFunction<
  PreviewSandboxPresetDeleteSandboxConfigMutation,
  PreviewSandboxPresetDeleteSandboxConfigMutationVariables
>;

/**
 * __usePreviewSandboxPresetDeleteSandboxConfigMutation__
 *
 * To run a mutation, you first call `usePreviewSandboxPresetDeleteSandboxConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreviewSandboxPresetDeleteSandboxConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [previewSandboxPresetDeleteSandboxConfigMutation, { data, loading, error }] = usePreviewSandboxPresetDeleteSandboxConfigMutation({
 *   variables: {
 *      configVersionID: // value for 'configVersionID'
 *   },
 * });
 */
export function usePreviewSandboxPresetDeleteSandboxConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PreviewSandboxPresetDeleteSandboxConfigMutation,
    PreviewSandboxPresetDeleteSandboxConfigMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PreviewSandboxPresetDeleteSandboxConfigMutation,
    PreviewSandboxPresetDeleteSandboxConfigMutationVariables
  >(PreviewSandboxPresetDeleteSandboxConfigDocument, options);
}
export type PreviewSandboxPresetDeleteSandboxConfigMutationHookResult = ReturnType<
  typeof usePreviewSandboxPresetDeleteSandboxConfigMutation
>;
export type PreviewSandboxPresetDeleteSandboxConfigMutationResult =
  Apollo.MutationResult<PreviewSandboxPresetDeleteSandboxConfigMutation>;
export type PreviewSandboxPresetDeleteSandboxConfigMutationOptions = Apollo.BaseMutationOptions<
  PreviewSandboxPresetDeleteSandboxConfigMutation,
  PreviewSandboxPresetDeleteSandboxConfigMutationVariables
>;
export const GetSandboxConfigDocument = gql`
  query getSandboxConfig($trackID: String!, $teamSlug: String!, $filter: SandboxConfigVersionsFilterInput!) {
    userIsTrackDeveloper(trackID: $trackID)
    userInTeam(teamSlug: $teamSlug)
    team(teamSlug: $teamSlug) {
      id
      features {
        containers
        virtual_machines
        gcp_projects
        aws_accounts
        azure_subscriptions
        saas
        shared_hotstart_pools
      }
    }
    track(trackID: $trackID) {
      sandboxConfig {
        ...ManageTrackSandboxConfigVersion
      }
    }
    trackConfig(trackID: $trackID) {
      id
      containers {
        ...ContainerFormContainer
      }
      virtualmachines {
        ...VirtualMachineFormVirtualMachine
      }
      virtualbrowsers {
        ...VirtualBrowserFormVirtualBrowser
      }
      gcp_projects {
        ...GoogleCloudFormGcpProject
      }
      aws_accounts {
        ...AwsAccountFormAwsAccount
      }
      azure_subscriptions {
        ...AzureSubscriptionFormAzureSubscription
      }
      secrets {
        ...SandboxConfigSecret
      }
    }
    teamSecrets(teamSlug: $teamSlug) {
      name
      description
    }
    sandboxConfigVersions(teamSlug: $teamSlug, filter: $filter) {
      ...ManageTrackSandboxConfigVersion
    }
    trackScripts(trackID: $trackID) {
      ...TrackScriptData
    }
  }
  ${ManageTrackSandboxConfigVersionFragmentDoc}
  ${ContainerFormContainerFragmentDoc}
  ${VirtualMachineFormVirtualMachineFragmentDoc}
  ${VirtualBrowserFormVirtualBrowserFragmentDoc}
  ${GoogleCloudFormGcpProjectFragmentDoc}
  ${AwsAccountFormAwsAccountFragmentDoc}
  ${AzureSubscriptionFormAzureSubscriptionFragmentDoc}
  ${SandboxConfigSecretFragmentDoc}
  ${TrackScriptDataFragmentDoc}
`;

/**
 * __useGetSandboxConfigQuery__
 *
 * To run a query within a React component, call `useGetSandboxConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSandboxConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSandboxConfigQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      teamSlug: // value for 'teamSlug'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetSandboxConfigQuery(
  baseOptions: Apollo.QueryHookOptions<GetSandboxConfigQuery, GetSandboxConfigQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSandboxConfigQuery, GetSandboxConfigQueryVariables>(GetSandboxConfigDocument, options);
}
export function useGetSandboxConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSandboxConfigQuery, GetSandboxConfigQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSandboxConfigQuery, GetSandboxConfigQueryVariables>(GetSandboxConfigDocument, options);
}
export type GetSandboxConfigQueryHookResult = ReturnType<typeof useGetSandboxConfigQuery>;
export type GetSandboxConfigLazyQueryHookResult = ReturnType<typeof useGetSandboxConfigLazyQuery>;
export type GetSandboxConfigQueryResult = Apollo.QueryResult<GetSandboxConfigQuery, GetSandboxConfigQueryVariables>;
export const GetSandboxPagePresetResourcesDocument = gql`
  query getSandboxPagePresetResources($configVersionID: String!) {
    sandboxConfigVersion(configVersionID: $configVersionID) {
      resources {
        ...ManageHostResources
        ...ManageCloudAccsResources
        secrets {
          ...SandboxConfigSecret
        }
      }
      scripts {
        action
        contents
        host
      }
    }
  }
  ${ManageHostResourcesFragmentDoc}
  ${ManageCloudAccsResourcesFragmentDoc}
  ${SandboxConfigSecretFragmentDoc}
`;

/**
 * __useGetSandboxPagePresetResourcesQuery__
 *
 * To run a query within a React component, call `useGetSandboxPagePresetResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSandboxPagePresetResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSandboxPagePresetResourcesQuery({
 *   variables: {
 *      configVersionID: // value for 'configVersionID'
 *   },
 * });
 */
export function useGetSandboxPagePresetResourcesQuery(
  baseOptions: Apollo.QueryHookOptions<GetSandboxPagePresetResourcesQuery, GetSandboxPagePresetResourcesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSandboxPagePresetResourcesQuery, GetSandboxPagePresetResourcesQueryVariables>(
    GetSandboxPagePresetResourcesDocument,
    options,
  );
}
export function useGetSandboxPagePresetResourcesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSandboxPagePresetResourcesQuery,
    GetSandboxPagePresetResourcesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSandboxPagePresetResourcesQuery, GetSandboxPagePresetResourcesQueryVariables>(
    GetSandboxPagePresetResourcesDocument,
    options,
  );
}
export type GetSandboxPagePresetResourcesQueryHookResult = ReturnType<typeof useGetSandboxPagePresetResourcesQuery>;
export type GetSandboxPagePresetResourcesLazyQueryHookResult = ReturnType<
  typeof useGetSandboxPagePresetResourcesLazyQuery
>;
export type GetSandboxPagePresetResourcesQueryResult = Apollo.QueryResult<
  GetSandboxPagePresetResourcesQuery,
  GetSandboxPagePresetResourcesQueryVariables
>;
export const SandboxConfigPageDeleteHostDocument = gql`
  mutation sandboxConfigPageDeleteHost($configID: String!, $hostName: String!) {
    deleteSandboxConfigHost(configID: $configID, hostName: $hostName) {
      id
    }
  }
`;
export type SandboxConfigPageDeleteHostMutationFn = Apollo.MutationFunction<
  SandboxConfigPageDeleteHostMutation,
  SandboxConfigPageDeleteHostMutationVariables
>;

/**
 * __useSandboxConfigPageDeleteHostMutation__
 *
 * To run a mutation, you first call `useSandboxConfigPageDeleteHostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSandboxConfigPageDeleteHostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sandboxConfigPageDeleteHostMutation, { data, loading, error }] = useSandboxConfigPageDeleteHostMutation({
 *   variables: {
 *      configID: // value for 'configID'
 *      hostName: // value for 'hostName'
 *   },
 * });
 */
export function useSandboxConfigPageDeleteHostMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SandboxConfigPageDeleteHostMutation,
    SandboxConfigPageDeleteHostMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SandboxConfigPageDeleteHostMutation, SandboxConfigPageDeleteHostMutationVariables>(
    SandboxConfigPageDeleteHostDocument,
    options,
  );
}
export type SandboxConfigPageDeleteHostMutationHookResult = ReturnType<typeof useSandboxConfigPageDeleteHostMutation>;
export type SandboxConfigPageDeleteHostMutationResult = Apollo.MutationResult<SandboxConfigPageDeleteHostMutation>;
export type SandboxConfigPageDeleteHostMutationOptions = Apollo.BaseMutationOptions<
  SandboxConfigPageDeleteHostMutation,
  SandboxConfigPageDeleteHostMutationVariables
>;
export const SandboxConfigPageRenameHostDocument = gql`
  mutation sandboxConfigPageRenameHost($configID: String!, $hostName: String!, $newName: String!) {
    renameSandboxConfigHost(configID: $configID, hostName: $hostName, newName: $newName) {
      id
    }
  }
`;
export type SandboxConfigPageRenameHostMutationFn = Apollo.MutationFunction<
  SandboxConfigPageRenameHostMutation,
  SandboxConfigPageRenameHostMutationVariables
>;

/**
 * __useSandboxConfigPageRenameHostMutation__
 *
 * To run a mutation, you first call `useSandboxConfigPageRenameHostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSandboxConfigPageRenameHostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sandboxConfigPageRenameHostMutation, { data, loading, error }] = useSandboxConfigPageRenameHostMutation({
 *   variables: {
 *      configID: // value for 'configID'
 *      hostName: // value for 'hostName'
 *      newName: // value for 'newName'
 *   },
 * });
 */
export function useSandboxConfigPageRenameHostMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SandboxConfigPageRenameHostMutation,
    SandboxConfigPageRenameHostMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SandboxConfigPageRenameHostMutation, SandboxConfigPageRenameHostMutationVariables>(
    SandboxConfigPageRenameHostDocument,
    options,
  );
}
export type SandboxConfigPageRenameHostMutationHookResult = ReturnType<typeof useSandboxConfigPageRenameHostMutation>;
export type SandboxConfigPageRenameHostMutationResult = Apollo.MutationResult<SandboxConfigPageRenameHostMutation>;
export type SandboxConfigPageRenameHostMutationOptions = Apollo.BaseMutationOptions<
  SandboxConfigPageRenameHostMutation,
  SandboxConfigPageRenameHostMutationVariables
>;
export const SandboxConfigPageSetPresetDocument = gql`
  mutation sandboxConfigPageSetPreset($trackID: String!, $configVersionID: String) {
    setTrackSandboxConfigVersion(trackID: $trackID, configVersionID: $configVersionID)
  }
`;
export type SandboxConfigPageSetPresetMutationFn = Apollo.MutationFunction<
  SandboxConfigPageSetPresetMutation,
  SandboxConfigPageSetPresetMutationVariables
>;

/**
 * __useSandboxConfigPageSetPresetMutation__
 *
 * To run a mutation, you first call `useSandboxConfigPageSetPresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSandboxConfigPageSetPresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sandboxConfigPageSetPresetMutation, { data, loading, error }] = useSandboxConfigPageSetPresetMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      configVersionID: // value for 'configVersionID'
 *   },
 * });
 */
export function useSandboxConfigPageSetPresetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SandboxConfigPageSetPresetMutation,
    SandboxConfigPageSetPresetMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SandboxConfigPageSetPresetMutation, SandboxConfigPageSetPresetMutationVariables>(
    SandboxConfigPageSetPresetDocument,
    options,
  );
}
export type SandboxConfigPageSetPresetMutationHookResult = ReturnType<typeof useSandboxConfigPageSetPresetMutation>;
export type SandboxConfigPageSetPresetMutationResult = Apollo.MutationResult<SandboxConfigPageSetPresetMutation>;
export type SandboxConfigPageSetPresetMutationOptions = Apollo.BaseMutationOptions<
  SandboxConfigPageSetPresetMutation,
  SandboxConfigPageSetPresetMutationVariables
>;
export const SandboxConfigPageUpdateSandboxConfigDocument = gql`
  mutation sandboxConfigPageUpdateSandboxConfig($configID: String!, $config: SandboxConfigInput!) {
    updateSandboxConfig(configID: $configID, config: $config) {
      id
    }
  }
`;
export type SandboxConfigPageUpdateSandboxConfigMutationFn = Apollo.MutationFunction<
  SandboxConfigPageUpdateSandboxConfigMutation,
  SandboxConfigPageUpdateSandboxConfigMutationVariables
>;

/**
 * __useSandboxConfigPageUpdateSandboxConfigMutation__
 *
 * To run a mutation, you first call `useSandboxConfigPageUpdateSandboxConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSandboxConfigPageUpdateSandboxConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sandboxConfigPageUpdateSandboxConfigMutation, { data, loading, error }] = useSandboxConfigPageUpdateSandboxConfigMutation({
 *   variables: {
 *      configID: // value for 'configID'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useSandboxConfigPageUpdateSandboxConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SandboxConfigPageUpdateSandboxConfigMutation,
    SandboxConfigPageUpdateSandboxConfigMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SandboxConfigPageUpdateSandboxConfigMutation,
    SandboxConfigPageUpdateSandboxConfigMutationVariables
  >(SandboxConfigPageUpdateSandboxConfigDocument, options);
}
export type SandboxConfigPageUpdateSandboxConfigMutationHookResult = ReturnType<
  typeof useSandboxConfigPageUpdateSandboxConfigMutation
>;
export type SandboxConfigPageUpdateSandboxConfigMutationResult =
  Apollo.MutationResult<SandboxConfigPageUpdateSandboxConfigMutation>;
export type SandboxConfigPageUpdateSandboxConfigMutationOptions = Apollo.BaseMutationOptions<
  SandboxConfigPageUpdateSandboxConfigMutation,
  SandboxConfigPageUpdateSandboxConfigMutationVariables
>;
export const SandboxConfigPageSaveTrackScriptDocument = gql`
  mutation sandboxConfigPageSaveTrackScript($script: TrackScriptInput!, $base64Encoded: Boolean!) {
    saveTrackScript(script: $script, base64Encoded: $base64Encoded) {
      ...TrackScriptData
    }
  }
  ${TrackScriptDataFragmentDoc}
`;
export type SandboxConfigPageSaveTrackScriptMutationFn = Apollo.MutationFunction<
  SandboxConfigPageSaveTrackScriptMutation,
  SandboxConfigPageSaveTrackScriptMutationVariables
>;

/**
 * __useSandboxConfigPageSaveTrackScriptMutation__
 *
 * To run a mutation, you first call `useSandboxConfigPageSaveTrackScriptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSandboxConfigPageSaveTrackScriptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sandboxConfigPageSaveTrackScriptMutation, { data, loading, error }] = useSandboxConfigPageSaveTrackScriptMutation({
 *   variables: {
 *      script: // value for 'script'
 *      base64Encoded: // value for 'base64Encoded'
 *   },
 * });
 */
export function useSandboxConfigPageSaveTrackScriptMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SandboxConfigPageSaveTrackScriptMutation,
    SandboxConfigPageSaveTrackScriptMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SandboxConfigPageSaveTrackScriptMutation,
    SandboxConfigPageSaveTrackScriptMutationVariables
  >(SandboxConfigPageSaveTrackScriptDocument, options);
}
export type SandboxConfigPageSaveTrackScriptMutationHookResult = ReturnType<
  typeof useSandboxConfigPageSaveTrackScriptMutation
>;
export type SandboxConfigPageSaveTrackScriptMutationResult =
  Apollo.MutationResult<SandboxConfigPageSaveTrackScriptMutation>;
export type SandboxConfigPageSaveTrackScriptMutationOptions = Apollo.BaseMutationOptions<
  SandboxConfigPageSaveTrackScriptMutation,
  SandboxConfigPageSaveTrackScriptMutationVariables
>;
export const GetSandboxPresetsListPageConfigDocument = gql`
  query getSandboxPresetsListPageConfig($teamSlug: String!, $filter: SandboxConfigVersionsFilterInput!) {
    team(teamSlug: $teamSlug) {
      id
      features {
        shared_hotstart_pools
      }
    }
    sandboxConfigVersions(teamSlug: $teamSlug, filter: $filter) {
      ...SandboxPresetListCard
    }
  }
  ${SandboxPresetListCardFragmentDoc}
`;

/**
 * __useGetSandboxPresetsListPageConfigQuery__
 *
 * To run a query within a React component, call `useGetSandboxPresetsListPageConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSandboxPresetsListPageConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSandboxPresetsListPageConfigQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetSandboxPresetsListPageConfigQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSandboxPresetsListPageConfigQuery,
    GetSandboxPresetsListPageConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSandboxPresetsListPageConfigQuery, GetSandboxPresetsListPageConfigQueryVariables>(
    GetSandboxPresetsListPageConfigDocument,
    options,
  );
}
export function useGetSandboxPresetsListPageConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSandboxPresetsListPageConfigQuery,
    GetSandboxPresetsListPageConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSandboxPresetsListPageConfigQuery, GetSandboxPresetsListPageConfigQueryVariables>(
    GetSandboxPresetsListPageConfigDocument,
    options,
  );
}
export type GetSandboxPresetsListPageConfigQueryHookResult = ReturnType<typeof useGetSandboxPresetsListPageConfigQuery>;
export type GetSandboxPresetsListPageConfigLazyQueryHookResult = ReturnType<
  typeof useGetSandboxPresetsListPageConfigLazyQuery
>;
export type GetSandboxPresetsListPageConfigQueryResult = Apollo.QueryResult<
  GetSandboxPresetsListPageConfigQuery,
  GetSandboxPresetsListPageConfigQueryVariables
>;
export const SandboxPresetsListPagePublishConfigDocument = gql`
  mutation sandboxPresetsListPagePublishConfig($configID: String!, $changeLogEntry: String!) {
    publishSandboxConfig(configID: $configID, changeLogEntry: $changeLogEntry) {
      id
    }
  }
`;
export type SandboxPresetsListPagePublishConfigMutationFn = Apollo.MutationFunction<
  SandboxPresetsListPagePublishConfigMutation,
  SandboxPresetsListPagePublishConfigMutationVariables
>;

/**
 * __useSandboxPresetsListPagePublishConfigMutation__
 *
 * To run a mutation, you first call `useSandboxPresetsListPagePublishConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSandboxPresetsListPagePublishConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sandboxPresetsListPagePublishConfigMutation, { data, loading, error }] = useSandboxPresetsListPagePublishConfigMutation({
 *   variables: {
 *      configID: // value for 'configID'
 *      changeLogEntry: // value for 'changeLogEntry'
 *   },
 * });
 */
export function useSandboxPresetsListPagePublishConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SandboxPresetsListPagePublishConfigMutation,
    SandboxPresetsListPagePublishConfigMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SandboxPresetsListPagePublishConfigMutation,
    SandboxPresetsListPagePublishConfigMutationVariables
  >(SandboxPresetsListPagePublishConfigDocument, options);
}
export type SandboxPresetsListPagePublishConfigMutationHookResult = ReturnType<
  typeof useSandboxPresetsListPagePublishConfigMutation
>;
export type SandboxPresetsListPagePublishConfigMutationResult =
  Apollo.MutationResult<SandboxPresetsListPagePublishConfigMutation>;
export type SandboxPresetsListPagePublishConfigMutationOptions = Apollo.BaseMutationOptions<
  SandboxPresetsListPagePublishConfigMutation,
  SandboxPresetsListPagePublishConfigMutationVariables
>;
export const SandboxPresetsListDeleteSandboxConfigDocument = gql`
  mutation sandboxPresetsListDeleteSandboxConfig($configVersionID: String!) {
    deleteSandboxConfig(configVersionID: $configVersionID)
  }
`;
export type SandboxPresetsListDeleteSandboxConfigMutationFn = Apollo.MutationFunction<
  SandboxPresetsListDeleteSandboxConfigMutation,
  SandboxPresetsListDeleteSandboxConfigMutationVariables
>;

/**
 * __useSandboxPresetsListDeleteSandboxConfigMutation__
 *
 * To run a mutation, you first call `useSandboxPresetsListDeleteSandboxConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSandboxPresetsListDeleteSandboxConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sandboxPresetsListDeleteSandboxConfigMutation, { data, loading, error }] = useSandboxPresetsListDeleteSandboxConfigMutation({
 *   variables: {
 *      configVersionID: // value for 'configVersionID'
 *   },
 * });
 */
export function useSandboxPresetsListDeleteSandboxConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SandboxPresetsListDeleteSandboxConfigMutation,
    SandboxPresetsListDeleteSandboxConfigMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SandboxPresetsListDeleteSandboxConfigMutation,
    SandboxPresetsListDeleteSandboxConfigMutationVariables
  >(SandboxPresetsListDeleteSandboxConfigDocument, options);
}
export type SandboxPresetsListDeleteSandboxConfigMutationHookResult = ReturnType<
  typeof useSandboxPresetsListDeleteSandboxConfigMutation
>;
export type SandboxPresetsListDeleteSandboxConfigMutationResult =
  Apollo.MutationResult<SandboxPresetsListDeleteSandboxConfigMutation>;
export type SandboxPresetsListDeleteSandboxConfigMutationOptions = Apollo.BaseMutationOptions<
  SandboxPresetsListDeleteSandboxConfigMutation,
  SandboxPresetsListDeleteSandboxConfigMutationVariables
>;
export const SandboxesFormDataDocument = gql`
  query sandboxesFormData($teamSlug: String!) {
    tracks(teamSlug: $teamSlug) {
      id
      title
    }
    trackInvites(teamSlug: $teamSlug) {
      id
      title
      publicTitle
    }
    hotStartPools(organizationSlug: $teamSlug) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

/**
 * __useSandboxesFormDataQuery__
 *
 * To run a query within a React component, call `useSandboxesFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSandboxesFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSandboxesFormDataQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useSandboxesFormDataQuery(
  baseOptions: Apollo.QueryHookOptions<SandboxesFormDataQuery, SandboxesFormDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SandboxesFormDataQuery, SandboxesFormDataQueryVariables>(SandboxesFormDataDocument, options);
}
export function useSandboxesFormDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SandboxesFormDataQuery, SandboxesFormDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SandboxesFormDataQuery, SandboxesFormDataQueryVariables>(
    SandboxesFormDataDocument,
    options,
  );
}
export type SandboxesFormDataQueryHookResult = ReturnType<typeof useSandboxesFormDataQuery>;
export type SandboxesFormDataLazyQueryHookResult = ReturnType<typeof useSandboxesFormDataLazyQuery>;
export type SandboxesFormDataQueryResult = Apollo.QueryResult<SandboxesFormDataQuery, SandboxesFormDataQueryVariables>;
export const SandboxesDocument = gql`
  query sandboxes($teamSlug: String!, $filter: SandboxFilterInput!, $paging: Pagination!, $ordering: Ordering!) {
    sandboxes(teamSlug: $teamSlug, filter: $filter, paging: $paging, ordering: $ordering) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
      edges {
        node {
          hot_start_pool {
            id
            name
          }
          created
          ttl
          state
          id
          invite {
            id
            title
            publicTitle
          }
          track {
            id
            slug
            title
          }
          user {
            id
            profile {
              display_name
            }
          }
        }
      }
    }
  }
`;

/**
 * __useSandboxesQuery__
 *
 * To run a query within a React component, call `useSandboxesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSandboxesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSandboxesQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      ordering: // value for 'ordering'
 *   },
 * });
 */
export function useSandboxesQuery(baseOptions: Apollo.QueryHookOptions<SandboxesQuery, SandboxesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SandboxesQuery, SandboxesQueryVariables>(SandboxesDocument, options);
}
export function useSandboxesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SandboxesQuery, SandboxesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SandboxesQuery, SandboxesQueryVariables>(SandboxesDocument, options);
}
export type SandboxesQueryHookResult = ReturnType<typeof useSandboxesQuery>;
export type SandboxesLazyQueryHookResult = ReturnType<typeof useSandboxesLazyQuery>;
export type SandboxesQueryResult = Apollo.QueryResult<SandboxesQuery, SandboxesQueryVariables>;
export const UpdateSandboxTtlDocument = gql`
  mutation updateSandboxTTL($sandboxID: String!, $until: Time!) {
    updateSandboxTTL(sandboxID: $sandboxID, until: $until) {
      id
    }
  }
`;
export type UpdateSandboxTtlMutationFn = Apollo.MutationFunction<
  UpdateSandboxTtlMutation,
  UpdateSandboxTtlMutationVariables
>;

/**
 * __useUpdateSandboxTtlMutation__
 *
 * To run a mutation, you first call `useUpdateSandboxTtlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSandboxTtlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSandboxTtlMutation, { data, loading, error }] = useUpdateSandboxTtlMutation({
 *   variables: {
 *      sandboxID: // value for 'sandboxID'
 *      until: // value for 'until'
 *   },
 * });
 */
export function useUpdateSandboxTtlMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateSandboxTtlMutation, UpdateSandboxTtlMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateSandboxTtlMutation, UpdateSandboxTtlMutationVariables>(
    UpdateSandboxTtlDocument,
    options,
  );
}
export type UpdateSandboxTtlMutationHookResult = ReturnType<typeof useUpdateSandboxTtlMutation>;
export type UpdateSandboxTtlMutationResult = Apollo.MutationResult<UpdateSandboxTtlMutation>;
export type UpdateSandboxTtlMutationOptions = Apollo.BaseMutationOptions<
  UpdateSandboxTtlMutation,
  UpdateSandboxTtlMutationVariables
>;
export const StopSandboxDocument = gql`
  mutation stopSandbox($sandboxID: String!) {
    stopSandbox(sandboxID: $sandboxID) {
      id
    }
  }
`;
export type StopSandboxMutationFn = Apollo.MutationFunction<StopSandboxMutation, StopSandboxMutationVariables>;

/**
 * __useStopSandboxMutation__
 *
 * To run a mutation, you first call `useStopSandboxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopSandboxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopSandboxMutation, { data, loading, error }] = useStopSandboxMutation({
 *   variables: {
 *      sandboxID: // value for 'sandboxID'
 *   },
 * });
 */
export function useStopSandboxMutation(
  baseOptions?: Apollo.MutationHookOptions<StopSandboxMutation, StopSandboxMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<StopSandboxMutation, StopSandboxMutationVariables>(StopSandboxDocument, options);
}
export type StopSandboxMutationHookResult = ReturnType<typeof useStopSandboxMutation>;
export type StopSandboxMutationResult = Apollo.MutationResult<StopSandboxMutation>;
export type StopSandboxMutationOptions = Apollo.BaseMutationOptions<StopSandboxMutation, StopSandboxMutationVariables>;
export const TeamPageDocument = gql`
  query teamPage($teamSlug: String!) {
    organization(organizationSlug: $teamSlug) {
      id
      name
      logo
      title
      subtitle
      slug
      primary_link_text
      primary_link_url
      secondary_link_text
      secondary_link_url
      theme {
        foreground_color
        foreground_image
        background_color
        background_image
        primary_foreground_color
        primary_background_color
        secondary_foreground_color
        secondary_background_color
      }
    }
    tracks(teamSlug: $teamSlug) {
      developers {
        id
        profile {
          avatar
          display_name
        }
      }
      icon
      id
      last_update
      createdAt
      permalink
      slug
      teaser
      tags
      title
      description
      maintenance
      updated_by {
        id
        profile {
          avatar
          display_name
        }
      }
    }
  }
`;

/**
 * __useTeamPageQuery__
 *
 * To run a query within a React component, call `useTeamPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamPageQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useTeamPageQuery(baseOptions: Apollo.QueryHookOptions<TeamPageQuery, TeamPageQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TeamPageQuery, TeamPageQueryVariables>(TeamPageDocument, options);
}
export function useTeamPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamPageQuery, TeamPageQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TeamPageQuery, TeamPageQueryVariables>(TeamPageDocument, options);
}
export type TeamPageQueryHookResult = ReturnType<typeof useTeamPageQuery>;
export type TeamPageLazyQueryHookResult = ReturnType<typeof useTeamPageLazyQuery>;
export type TeamPageQueryResult = Apollo.QueryResult<TeamPageQuery, TeamPageQueryVariables>;
export const DeleteTrackDocument = gql`
  mutation deleteTrack($trackID: String!) {
    deleteTrack(trackID: $trackID)
  }
`;
export type DeleteTrackMutationFn = Apollo.MutationFunction<DeleteTrackMutation, DeleteTrackMutationVariables>;

/**
 * __useDeleteTrackMutation__
 *
 * To run a mutation, you first call `useDeleteTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTrackMutation, { data, loading, error }] = useDeleteTrackMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useDeleteTrackMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteTrackMutation, DeleteTrackMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteTrackMutation, DeleteTrackMutationVariables>(DeleteTrackDocument, options);
}
export type DeleteTrackMutationHookResult = ReturnType<typeof useDeleteTrackMutation>;
export type DeleteTrackMutationResult = Apollo.MutationResult<DeleteTrackMutation>;
export type DeleteTrackMutationOptions = Apollo.BaseMutationOptions<DeleteTrackMutation, DeleteTrackMutationVariables>;
export const GetTemplateTracksDocument = gql`
  query GetTemplateTracks($teamSlug: String!) {
    tracks(teamSlug: $teamSlug) {
      id
      version
      slug
      icon
      title
      teaser
      description
      level
      tags
      owner
      idle_timeout
      timelimit
      status
      developers {
        profile {
          email
        }
      }
      private
      published
      maintenance
      show_timer
      skipping_enabled
      challenges {
        id
        type
        slug
        title
        teaser
        notes {
          type
          contents
          url
        }
        difficulty
        assignment
        timelimit
        tabs {
          cmd
          type
          title
          hostname
          path
          port
          url
          new_window
        }
        scripts {
          host
          action
          contents
        }
        answers
        solution
      }
      config {
        version
        containers {
          name
          image
          entrypoint
          cmd
          shell
          ports
          environment {
            key
            value
          }
          memory
        }
        virtualmachines {
          name
          image
          machine_type
          allow_external_ingress
          shell
          environment {
            key
            value
          }
          memory
          cpus
        }
        gcp_projects {
          name
          services
        }
        aws_accounts {
          name
          iam_policy
          managed_policies
          scp_policy
        }
        azure_subscriptions {
          name
          user_only
          roles
        }
      }
      scripts {
        id
        action
        contents
        host
      }
    }
  }
`;

/**
 * __useGetTemplateTracksQuery__
 *
 * To run a query within a React component, call `useGetTemplateTracksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplateTracksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemplateTracksQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useGetTemplateTracksQuery(
  baseOptions: Apollo.QueryHookOptions<GetTemplateTracksQuery, GetTemplateTracksQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTemplateTracksQuery, GetTemplateTracksQueryVariables>(GetTemplateTracksDocument, options);
}
export function useGetTemplateTracksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTemplateTracksQuery, GetTemplateTracksQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTemplateTracksQuery, GetTemplateTracksQueryVariables>(
    GetTemplateTracksDocument,
    options,
  );
}
export type GetTemplateTracksQueryHookResult = ReturnType<typeof useGetTemplateTracksQuery>;
export type GetTemplateTracksLazyQueryHookResult = ReturnType<typeof useGetTemplateTracksLazyQuery>;
export type GetTemplateTracksQueryResult = Apollo.QueryResult<GetTemplateTracksQuery, GetTemplateTracksQueryVariables>;
export const TrackDashboardDocument = gql`
  query TrackDashboard($trackSlug: String!, $teamSlug: String!) {
    statistics(trackSlug: $trackSlug, teamSlug: $teamSlug) {
      track {
        ...DashboardStatistics
      }
    }
    track(trackSlug: $trackSlug, teamSlug: $teamSlug) {
      ...DashboardTrack
    }
  }
  ${DashboardStatisticsFragmentDoc}
  ${DashboardTrackFragmentDoc}
`;

/**
 * __useTrackDashboardQuery__
 *
 * To run a query within a React component, call `useTrackDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackDashboardQuery({
 *   variables: {
 *      trackSlug: // value for 'trackSlug'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useTrackDashboardQuery(
  baseOptions: Apollo.QueryHookOptions<TrackDashboardQuery, TrackDashboardQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TrackDashboardQuery, TrackDashboardQueryVariables>(TrackDashboardDocument, options);
}
export function useTrackDashboardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TrackDashboardQuery, TrackDashboardQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TrackDashboardQuery, TrackDashboardQueryVariables>(TrackDashboardDocument, options);
}
export type TrackDashboardQueryHookResult = ReturnType<typeof useTrackDashboardQuery>;
export type TrackDashboardLazyQueryHookResult = ReturnType<typeof useTrackDashboardLazyQuery>;
export type TrackDashboardQueryResult = Apollo.QueryResult<TrackDashboardQuery, TrackDashboardQueryVariables>;
export const ActivityReportPageDocument = gql`
  query ActivityReportPage($teamSlug: String!, $inviteID: String!) {
    trackInvite(inviteID: $inviteID) {
      id
      type
      allowAnonymous
      allowedEmailAddressesOnly
      title
      publicTitle
      claims {
        id
        claimedAt
        playLimit
        playTTL
        user {
          id
          profile {
            display_name
            email
          }
          details(teamSlug: $teamSlug) {
            firstName
            lastName
            email
            ...UserDetailsCollectedTableDetails
          }
        }
      }
      ...DownloadTrackInviteCsvTrackInvite
    }
  }
  ${UserDetailsCollectedTableDetailsFragmentDoc}
  ${DownloadTrackInviteCsvTrackInviteFragmentDoc}
`;

/**
 * __useActivityReportPageQuery__
 *
 * To run a query within a React component, call `useActivityReportPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityReportPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityReportPageQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      inviteID: // value for 'inviteID'
 *   },
 * });
 */
export function useActivityReportPageQuery(
  baseOptions: Apollo.QueryHookOptions<ActivityReportPageQuery, ActivityReportPageQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ActivityReportPageQuery, ActivityReportPageQueryVariables>(
    ActivityReportPageDocument,
    options,
  );
}
export function useActivityReportPageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ActivityReportPageQuery, ActivityReportPageQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ActivityReportPageQuery, ActivityReportPageQueryVariables>(
    ActivityReportPageDocument,
    options,
  );
}
export type ActivityReportPageQueryHookResult = ReturnType<typeof useActivityReportPageQuery>;
export type ActivityReportPageLazyQueryHookResult = ReturnType<typeof useActivityReportPageLazyQuery>;
export type ActivityReportPageQueryResult = Apollo.QueryResult<
  ActivityReportPageQuery,
  ActivityReportPageQueryVariables
>;
export const CreateInvitePageDocument = gql`
  query CreateInvitePage($teamSlug: String!) {
    tracks(teamSlug: $teamSlug) {
      ...InviteFormTrack
    }
    team(teamSlug: $teamSlug) {
      ...InviteFormTeam
    }
  }
  ${InviteFormTrackFragmentDoc}
  ${InviteFormTeamFragmentDoc}
`;

/**
 * __useCreateInvitePageQuery__
 *
 * To run a query within a React component, call `useCreateInvitePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateInvitePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateInvitePageQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useCreateInvitePageQuery(
  baseOptions: Apollo.QueryHookOptions<CreateInvitePageQuery, CreateInvitePageQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CreateInvitePageQuery, CreateInvitePageQueryVariables>(CreateInvitePageDocument, options);
}
export function useCreateInvitePageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CreateInvitePageQuery, CreateInvitePageQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CreateInvitePageQuery, CreateInvitePageQueryVariables>(CreateInvitePageDocument, options);
}
export type CreateInvitePageQueryHookResult = ReturnType<typeof useCreateInvitePageQuery>;
export type CreateInvitePageLazyQueryHookResult = ReturnType<typeof useCreateInvitePageLazyQuery>;
export type CreateInvitePageQueryResult = Apollo.QueryResult<CreateInvitePageQuery, CreateInvitePageQueryVariables>;
export const CreateInviteCreateTrackInviteDocument = gql`
  mutation CreateInviteCreateTrackInvite($invite: TrackInviteInput!) {
    createTrackInvite(invite: $invite) {
      id
    }
  }
`;
export type CreateInviteCreateTrackInviteMutationFn = Apollo.MutationFunction<
  CreateInviteCreateTrackInviteMutation,
  CreateInviteCreateTrackInviteMutationVariables
>;

/**
 * __useCreateInviteCreateTrackInviteMutation__
 *
 * To run a mutation, you first call `useCreateInviteCreateTrackInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInviteCreateTrackInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInviteCreateTrackInviteMutation, { data, loading, error }] = useCreateInviteCreateTrackInviteMutation({
 *   variables: {
 *      invite: // value for 'invite'
 *   },
 * });
 */
export function useCreateInviteCreateTrackInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateInviteCreateTrackInviteMutation,
    CreateInviteCreateTrackInviteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateInviteCreateTrackInviteMutation, CreateInviteCreateTrackInviteMutationVariables>(
    CreateInviteCreateTrackInviteDocument,
    options,
  );
}
export type CreateInviteCreateTrackInviteMutationHookResult = ReturnType<
  typeof useCreateInviteCreateTrackInviteMutation
>;
export type CreateInviteCreateTrackInviteMutationResult = Apollo.MutationResult<CreateInviteCreateTrackInviteMutation>;
export type CreateInviteCreateTrackInviteMutationOptions = Apollo.BaseMutationOptions<
  CreateInviteCreateTrackInviteMutation,
  CreateInviteCreateTrackInviteMutationVariables
>;
export const DuplicateInvitePageDocument = gql`
  query DuplicateInvitePage($inviteID: String!, $teamSlug: String!) {
    trackInvite(inviteID: $inviteID) {
      ...InviteFormTrackInvite
    }
    tracks(teamSlug: $teamSlug) {
      ...InviteFormTrack
    }
    team(teamSlug: $teamSlug) {
      ...InviteFormTeam
    }
  }
  ${InviteFormTrackInviteFragmentDoc}
  ${InviteFormTrackFragmentDoc}
  ${InviteFormTeamFragmentDoc}
`;

/**
 * __useDuplicateInvitePageQuery__
 *
 * To run a query within a React component, call `useDuplicateInvitePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDuplicateInvitePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDuplicateInvitePageQuery({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useDuplicateInvitePageQuery(
  baseOptions: Apollo.QueryHookOptions<DuplicateInvitePageQuery, DuplicateInvitePageQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DuplicateInvitePageQuery, DuplicateInvitePageQueryVariables>(
    DuplicateInvitePageDocument,
    options,
  );
}
export function useDuplicateInvitePageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DuplicateInvitePageQuery, DuplicateInvitePageQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DuplicateInvitePageQuery, DuplicateInvitePageQueryVariables>(
    DuplicateInvitePageDocument,
    options,
  );
}
export type DuplicateInvitePageQueryHookResult = ReturnType<typeof useDuplicateInvitePageQuery>;
export type DuplicateInvitePageLazyQueryHookResult = ReturnType<typeof useDuplicateInvitePageLazyQuery>;
export type DuplicateInvitePageQueryResult = Apollo.QueryResult<
  DuplicateInvitePageQuery,
  DuplicateInvitePageQueryVariables
>;
export const DuplicateInviteCreateTrackInviteDocument = gql`
  mutation DuplicateInviteCreateTrackInvite($invite: TrackInviteInput!) {
    createTrackInvite(invite: $invite) {
      id
    }
  }
`;
export type DuplicateInviteCreateTrackInviteMutationFn = Apollo.MutationFunction<
  DuplicateInviteCreateTrackInviteMutation,
  DuplicateInviteCreateTrackInviteMutationVariables
>;

/**
 * __useDuplicateInviteCreateTrackInviteMutation__
 *
 * To run a mutation, you first call `useDuplicateInviteCreateTrackInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateInviteCreateTrackInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateInviteCreateTrackInviteMutation, { data, loading, error }] = useDuplicateInviteCreateTrackInviteMutation({
 *   variables: {
 *      invite: // value for 'invite'
 *   },
 * });
 */
export function useDuplicateInviteCreateTrackInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DuplicateInviteCreateTrackInviteMutation,
    DuplicateInviteCreateTrackInviteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DuplicateInviteCreateTrackInviteMutation,
    DuplicateInviteCreateTrackInviteMutationVariables
  >(DuplicateInviteCreateTrackInviteDocument, options);
}
export type DuplicateInviteCreateTrackInviteMutationHookResult = ReturnType<
  typeof useDuplicateInviteCreateTrackInviteMutation
>;
export type DuplicateInviteCreateTrackInviteMutationResult =
  Apollo.MutationResult<DuplicateInviteCreateTrackInviteMutation>;
export type DuplicateInviteCreateTrackInviteMutationOptions = Apollo.BaseMutationOptions<
  DuplicateInviteCreateTrackInviteMutation,
  DuplicateInviteCreateTrackInviteMutationVariables
>;
export const EditInvitePageDocument = gql`
  query EditInvitePage($inviteID: String!, $teamSlug: String!) {
    trackInvite(inviteID: $inviteID) {
      ...InviteFormTrackInvite
    }
    tracks(teamSlug: $teamSlug) {
      ...InviteFormTrack
    }
    team(teamSlug: $teamSlug) {
      ...InviteFormTeam
    }
  }
  ${InviteFormTrackInviteFragmentDoc}
  ${InviteFormTrackFragmentDoc}
  ${InviteFormTeamFragmentDoc}
`;

/**
 * __useEditInvitePageQuery__
 *
 * To run a query within a React component, call `useEditInvitePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditInvitePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditInvitePageQuery({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useEditInvitePageQuery(
  baseOptions: Apollo.QueryHookOptions<EditInvitePageQuery, EditInvitePageQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EditInvitePageQuery, EditInvitePageQueryVariables>(EditInvitePageDocument, options);
}
export function useEditInvitePageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<EditInvitePageQuery, EditInvitePageQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<EditInvitePageQuery, EditInvitePageQueryVariables>(EditInvitePageDocument, options);
}
export type EditInvitePageQueryHookResult = ReturnType<typeof useEditInvitePageQuery>;
export type EditInvitePageLazyQueryHookResult = ReturnType<typeof useEditInvitePageLazyQuery>;
export type EditInvitePageQueryResult = Apollo.QueryResult<EditInvitePageQuery, EditInvitePageQueryVariables>;
export const EditInviteUpdateTrackInviteDocument = gql`
  mutation EditInviteUpdateTrackInvite($invite: TrackInviteInput!) {
    updateTrackInvite(invite: $invite) {
      id
    }
  }
`;
export type EditInviteUpdateTrackInviteMutationFn = Apollo.MutationFunction<
  EditInviteUpdateTrackInviteMutation,
  EditInviteUpdateTrackInviteMutationVariables
>;

/**
 * __useEditInviteUpdateTrackInviteMutation__
 *
 * To run a mutation, you first call `useEditInviteUpdateTrackInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditInviteUpdateTrackInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editInviteUpdateTrackInviteMutation, { data, loading, error }] = useEditInviteUpdateTrackInviteMutation({
 *   variables: {
 *      invite: // value for 'invite'
 *   },
 * });
 */
export function useEditInviteUpdateTrackInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditInviteUpdateTrackInviteMutation,
    EditInviteUpdateTrackInviteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<EditInviteUpdateTrackInviteMutation, EditInviteUpdateTrackInviteMutationVariables>(
    EditInviteUpdateTrackInviteDocument,
    options,
  );
}
export type EditInviteUpdateTrackInviteMutationHookResult = ReturnType<typeof useEditInviteUpdateTrackInviteMutation>;
export type EditInviteUpdateTrackInviteMutationResult = Apollo.MutationResult<EditInviteUpdateTrackInviteMutation>;
export type EditInviteUpdateTrackInviteMutationOptions = Apollo.BaseMutationOptions<
  EditInviteUpdateTrackInviteMutation,
  EditInviteUpdateTrackInviteMutationVariables
>;
export const ViewInvitePageDocument = gql`
  query ViewInvitePage($inviteID: String!) {
    trackInvite(inviteID: $inviteID) {
      ...TrackInviteDetailsTrackInvite
    }
  }
  ${TrackInviteDetailsTrackInviteFragmentDoc}
`;

/**
 * __useViewInvitePageQuery__
 *
 * To run a query within a React component, call `useViewInvitePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewInvitePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewInvitePageQuery({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *   },
 * });
 */
export function useViewInvitePageQuery(
  baseOptions: Apollo.QueryHookOptions<ViewInvitePageQuery, ViewInvitePageQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ViewInvitePageQuery, ViewInvitePageQueryVariables>(ViewInvitePageDocument, options);
}
export function useViewInvitePageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ViewInvitePageQuery, ViewInvitePageQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ViewInvitePageQuery, ViewInvitePageQueryVariables>(ViewInvitePageDocument, options);
}
export type ViewInvitePageQueryHookResult = ReturnType<typeof useViewInvitePageQuery>;
export type ViewInvitePageLazyQueryHookResult = ReturnType<typeof useViewInvitePageLazyQuery>;
export type ViewInvitePageQueryResult = Apollo.QueryResult<ViewInvitePageQuery, ViewInvitePageQueryVariables>;
export const GetTrackLimitsPageConfigDocument = gql`
  query getTrackLimitsPageConfig($teamSlug: String!) {
    team(teamSlug: $teamSlug) {
      id
    }
    tracks(teamSlug: $teamSlug) {
      ...TrackLimitsTableTrack
    }
    trackPlayLimits(teamSlug: $teamSlug) {
      ...TrackLimitsTableTrackLimits
    }
  }
  ${TrackLimitsTableTrackFragmentDoc}
  ${TrackLimitsTableTrackLimitsFragmentDoc}
`;

/**
 * __useGetTrackLimitsPageConfigQuery__
 *
 * To run a query within a React component, call `useGetTrackLimitsPageConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrackLimitsPageConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrackLimitsPageConfigQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useGetTrackLimitsPageConfigQuery(
  baseOptions: Apollo.QueryHookOptions<GetTrackLimitsPageConfigQuery, GetTrackLimitsPageConfigQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTrackLimitsPageConfigQuery, GetTrackLimitsPageConfigQueryVariables>(
    GetTrackLimitsPageConfigDocument,
    options,
  );
}
export function useGetTrackLimitsPageConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTrackLimitsPageConfigQuery, GetTrackLimitsPageConfigQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTrackLimitsPageConfigQuery, GetTrackLimitsPageConfigQueryVariables>(
    GetTrackLimitsPageConfigDocument,
    options,
  );
}
export type GetTrackLimitsPageConfigQueryHookResult = ReturnType<typeof useGetTrackLimitsPageConfigQuery>;
export type GetTrackLimitsPageConfigLazyQueryHookResult = ReturnType<typeof useGetTrackLimitsPageConfigLazyQuery>;
export type GetTrackLimitsPageConfigQueryResult = Apollo.QueryResult<
  GetTrackLimitsPageConfigQuery,
  GetTrackLimitsPageConfigQueryVariables
>;
export const LimitsPageSaveLimitsDocument = gql`
  mutation limitsPageSaveLimits($trackID: String, $teamSlug: String!, $trackPlayLimits: TrackPlayLimitInput!) {
    saveTrackPlayLimits(trackID: $trackID, teamSlug: $teamSlug, trackPlayLimits: $trackPlayLimits) {
      ...TrackLimitsTableTrackLimits
    }
  }
  ${TrackLimitsTableTrackLimitsFragmentDoc}
`;
export type LimitsPageSaveLimitsMutationFn = Apollo.MutationFunction<
  LimitsPageSaveLimitsMutation,
  LimitsPageSaveLimitsMutationVariables
>;

/**
 * __useLimitsPageSaveLimitsMutation__
 *
 * To run a mutation, you first call `useLimitsPageSaveLimitsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLimitsPageSaveLimitsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [limitsPageSaveLimitsMutation, { data, loading, error }] = useLimitsPageSaveLimitsMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      teamSlug: // value for 'teamSlug'
 *      trackPlayLimits: // value for 'trackPlayLimits'
 *   },
 * });
 */
export function useLimitsPageSaveLimitsMutation(
  baseOptions?: Apollo.MutationHookOptions<LimitsPageSaveLimitsMutation, LimitsPageSaveLimitsMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LimitsPageSaveLimitsMutation, LimitsPageSaveLimitsMutationVariables>(
    LimitsPageSaveLimitsDocument,
    options,
  );
}
export type LimitsPageSaveLimitsMutationHookResult = ReturnType<typeof useLimitsPageSaveLimitsMutation>;
export type LimitsPageSaveLimitsMutationResult = Apollo.MutationResult<LimitsPageSaveLimitsMutation>;
export type LimitsPageSaveLimitsMutationOptions = Apollo.BaseMutationOptions<
  LimitsPageSaveLimitsMutation,
  LimitsPageSaveLimitsMutationVariables
>;
export const GetUpdateChallengeNotePageConfigDocument = gql`
  query getUpdateChallengeNotePageConfig($trackID: String!, $challengeID: String!, $noteID: String!) {
    userIsTrackDeveloper(trackID: $trackID)
    challenge(challengeID: $challengeID) {
      id
    }
    note(noteID: $noteID) {
      id
      index
      ...ChallengeNoteFormNote
    }
  }
  ${ChallengeNoteFormNoteFragmentDoc}
`;

/**
 * __useGetUpdateChallengeNotePageConfigQuery__
 *
 * To run a query within a React component, call `useGetUpdateChallengeNotePageConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpdateChallengeNotePageConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpdateChallengeNotePageConfigQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      challengeID: // value for 'challengeID'
 *      noteID: // value for 'noteID'
 *   },
 * });
 */
export function useGetUpdateChallengeNotePageConfigQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUpdateChallengeNotePageConfigQuery,
    GetUpdateChallengeNotePageConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUpdateChallengeNotePageConfigQuery, GetUpdateChallengeNotePageConfigQueryVariables>(
    GetUpdateChallengeNotePageConfigDocument,
    options,
  );
}
export function useGetUpdateChallengeNotePageConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUpdateChallengeNotePageConfigQuery,
    GetUpdateChallengeNotePageConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUpdateChallengeNotePageConfigQuery, GetUpdateChallengeNotePageConfigQueryVariables>(
    GetUpdateChallengeNotePageConfigDocument,
    options,
  );
}
export type GetUpdateChallengeNotePageConfigQueryHookResult = ReturnType<
  typeof useGetUpdateChallengeNotePageConfigQuery
>;
export type GetUpdateChallengeNotePageConfigLazyQueryHookResult = ReturnType<
  typeof useGetUpdateChallengeNotePageConfigLazyQuery
>;
export type GetUpdateChallengeNotePageConfigQueryResult = Apollo.QueryResult<
  GetUpdateChallengeNotePageConfigQuery,
  GetUpdateChallengeNotePageConfigQueryVariables
>;
export const UpdateChallengeNotePageUpdateChallengeNoteDocument = gql`
  mutation updateChallengeNotePageUpdateChallengeNote($note: ChallengeNoteInput!) {
    updateChallengeNote(note: $note) {
      id
      index
      ...ChallengeNoteFormNote
    }
  }
  ${ChallengeNoteFormNoteFragmentDoc}
`;
export type UpdateChallengeNotePageUpdateChallengeNoteMutationFn = Apollo.MutationFunction<
  UpdateChallengeNotePageUpdateChallengeNoteMutation,
  UpdateChallengeNotePageUpdateChallengeNoteMutationVariables
>;

/**
 * __useUpdateChallengeNotePageUpdateChallengeNoteMutation__
 *
 * To run a mutation, you first call `useUpdateChallengeNotePageUpdateChallengeNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChallengeNotePageUpdateChallengeNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChallengeNotePageUpdateChallengeNoteMutation, { data, loading, error }] = useUpdateChallengeNotePageUpdateChallengeNoteMutation({
 *   variables: {
 *      note: // value for 'note'
 *   },
 * });
 */
export function useUpdateChallengeNotePageUpdateChallengeNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateChallengeNotePageUpdateChallengeNoteMutation,
    UpdateChallengeNotePageUpdateChallengeNoteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateChallengeNotePageUpdateChallengeNoteMutation,
    UpdateChallengeNotePageUpdateChallengeNoteMutationVariables
  >(UpdateChallengeNotePageUpdateChallengeNoteDocument, options);
}
export type UpdateChallengeNotePageUpdateChallengeNoteMutationHookResult = ReturnType<
  typeof useUpdateChallengeNotePageUpdateChallengeNoteMutation
>;
export type UpdateChallengeNotePageUpdateChallengeNoteMutationResult =
  Apollo.MutationResult<UpdateChallengeNotePageUpdateChallengeNoteMutation>;
export type UpdateChallengeNotePageUpdateChallengeNoteMutationOptions = Apollo.BaseMutationOptions<
  UpdateChallengeNotePageUpdateChallengeNoteMutation,
  UpdateChallengeNotePageUpdateChallengeNoteMutationVariables
>;
export const GetUpdateChallengeTabPageConfigDocument = gql`
  query getUpdateChallengeTabPageConfig($trackID: String!, $challengeID: String!, $tabID: String!, $teamSlug: String!) {
    userIsTrackDeveloper(trackID: $trackID)
    challenge(challengeID: $challengeID) {
      id
    }
    tab(tabID: $tabID) {
      ...UpdateChallengeTabChallengeTab
    }
    track(trackID: $trackID) {
      sandboxConfig {
        resources {
          containers {
            id
            name
          }
          virtualmachines {
            id
            name
          }
          virtualbrowsers {
            id
            name
          }
        }
      }
    }
    trackConfig(trackID: $trackID) {
      id
      containers {
        id
        name
        image
      }
      virtualmachines {
        id
        name
      }
      virtualbrowsers {
        id
        name
      }
    }
    team(teamSlug: $teamSlug) {
      id
      features {
        saas
      }
    }
  }
  ${UpdateChallengeTabChallengeTabFragmentDoc}
`;

/**
 * __useGetUpdateChallengeTabPageConfigQuery__
 *
 * To run a query within a React component, call `useGetUpdateChallengeTabPageConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpdateChallengeTabPageConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpdateChallengeTabPageConfigQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      challengeID: // value for 'challengeID'
 *      tabID: // value for 'tabID'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useGetUpdateChallengeTabPageConfigQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUpdateChallengeTabPageConfigQuery,
    GetUpdateChallengeTabPageConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUpdateChallengeTabPageConfigQuery, GetUpdateChallengeTabPageConfigQueryVariables>(
    GetUpdateChallengeTabPageConfigDocument,
    options,
  );
}
export function useGetUpdateChallengeTabPageConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUpdateChallengeTabPageConfigQuery,
    GetUpdateChallengeTabPageConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUpdateChallengeTabPageConfigQuery, GetUpdateChallengeTabPageConfigQueryVariables>(
    GetUpdateChallengeTabPageConfigDocument,
    options,
  );
}
export type GetUpdateChallengeTabPageConfigQueryHookResult = ReturnType<typeof useGetUpdateChallengeTabPageConfigQuery>;
export type GetUpdateChallengeTabPageConfigLazyQueryHookResult = ReturnType<
  typeof useGetUpdateChallengeTabPageConfigLazyQuery
>;
export type GetUpdateChallengeTabPageConfigQueryResult = Apollo.QueryResult<
  GetUpdateChallengeTabPageConfigQuery,
  GetUpdateChallengeTabPageConfigQueryVariables
>;
export const UpdateChallengeTabPageUpdateChallengeTabDocument = gql`
  mutation updateChallengeTabPageUpdateChallengeTab($tab: ChallengeTabInput!) {
    updateChallengeTab(tab: $tab) {
      ...UpdateChallengeTabChallengeTab
    }
  }
  ${UpdateChallengeTabChallengeTabFragmentDoc}
`;
export type UpdateChallengeTabPageUpdateChallengeTabMutationFn = Apollo.MutationFunction<
  UpdateChallengeTabPageUpdateChallengeTabMutation,
  UpdateChallengeTabPageUpdateChallengeTabMutationVariables
>;

/**
 * __useUpdateChallengeTabPageUpdateChallengeTabMutation__
 *
 * To run a mutation, you first call `useUpdateChallengeTabPageUpdateChallengeTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChallengeTabPageUpdateChallengeTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChallengeTabPageUpdateChallengeTabMutation, { data, loading, error }] = useUpdateChallengeTabPageUpdateChallengeTabMutation({
 *   variables: {
 *      tab: // value for 'tab'
 *   },
 * });
 */
export function useUpdateChallengeTabPageUpdateChallengeTabMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateChallengeTabPageUpdateChallengeTabMutation,
    UpdateChallengeTabPageUpdateChallengeTabMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateChallengeTabPageUpdateChallengeTabMutation,
    UpdateChallengeTabPageUpdateChallengeTabMutationVariables
  >(UpdateChallengeTabPageUpdateChallengeTabDocument, options);
}
export type UpdateChallengeTabPageUpdateChallengeTabMutationHookResult = ReturnType<
  typeof useUpdateChallengeTabPageUpdateChallengeTabMutation
>;
export type UpdateChallengeTabPageUpdateChallengeTabMutationResult =
  Apollo.MutationResult<UpdateChallengeTabPageUpdateChallengeTabMutation>;
export type UpdateChallengeTabPageUpdateChallengeTabMutationOptions = Apollo.BaseMutationOptions<
  UpdateChallengeTabPageUpdateChallengeTabMutation,
  UpdateChallengeTabPageUpdateChallengeTabMutationVariables
>;
export const GetUpdateChallengePageConfigDocument = gql`
  query getUpdateChallengePageConfig($trackID: String!, $challengeID: String!) {
    userIsTrackDeveloper(trackID: $trackID)
    track(trackID: $trackID) {
      lab_config {
        position
        width
        overlay
        extendTTL
      }
    }
    challenge(challengeID: $challengeID) {
      ...UpdateChallengePageChallenge
    }
  }
  ${UpdateChallengePageChallengeFragmentDoc}
`;

/**
 * __useGetUpdateChallengePageConfigQuery__
 *
 * To run a query within a React component, call `useGetUpdateChallengePageConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpdateChallengePageConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpdateChallengePageConfigQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      challengeID: // value for 'challengeID'
 *   },
 * });
 */
export function useGetUpdateChallengePageConfigQuery(
  baseOptions: Apollo.QueryHookOptions<GetUpdateChallengePageConfigQuery, GetUpdateChallengePageConfigQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUpdateChallengePageConfigQuery, GetUpdateChallengePageConfigQueryVariables>(
    GetUpdateChallengePageConfigDocument,
    options,
  );
}
export function useGetUpdateChallengePageConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUpdateChallengePageConfigQuery,
    GetUpdateChallengePageConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUpdateChallengePageConfigQuery, GetUpdateChallengePageConfigQueryVariables>(
    GetUpdateChallengePageConfigDocument,
    options,
  );
}
export type GetUpdateChallengePageConfigQueryHookResult = ReturnType<typeof useGetUpdateChallengePageConfigQuery>;
export type GetUpdateChallengePageConfigLazyQueryHookResult = ReturnType<
  typeof useGetUpdateChallengePageConfigLazyQuery
>;
export type GetUpdateChallengePageConfigQueryResult = Apollo.QueryResult<
  GetUpdateChallengePageConfigQuery,
  GetUpdateChallengePageConfigQueryVariables
>;
export const UpdateChallengePageUpdateChallengeDocument = gql`
  mutation updateChallengePageUpdateChallenge($challenge: ChallengeInput!) {
    updateChallenge(challenge: $challenge) {
      ...UpdateChallengePageChallenge
    }
  }
  ${UpdateChallengePageChallengeFragmentDoc}
`;
export type UpdateChallengePageUpdateChallengeMutationFn = Apollo.MutationFunction<
  UpdateChallengePageUpdateChallengeMutation,
  UpdateChallengePageUpdateChallengeMutationVariables
>;

/**
 * __useUpdateChallengePageUpdateChallengeMutation__
 *
 * To run a mutation, you first call `useUpdateChallengePageUpdateChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChallengePageUpdateChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChallengePageUpdateChallengeMutation, { data, loading, error }] = useUpdateChallengePageUpdateChallengeMutation({
 *   variables: {
 *      challenge: // value for 'challenge'
 *   },
 * });
 */
export function useUpdateChallengePageUpdateChallengeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateChallengePageUpdateChallengeMutation,
    UpdateChallengePageUpdateChallengeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateChallengePageUpdateChallengeMutation,
    UpdateChallengePageUpdateChallengeMutationVariables
  >(UpdateChallengePageUpdateChallengeDocument, options);
}
export type UpdateChallengePageUpdateChallengeMutationHookResult = ReturnType<
  typeof useUpdateChallengePageUpdateChallengeMutation
>;
export type UpdateChallengePageUpdateChallengeMutationResult =
  Apollo.MutationResult<UpdateChallengePageUpdateChallengeMutation>;
export type UpdateChallengePageUpdateChallengeMutationOptions = Apollo.BaseMutationOptions<
  UpdateChallengePageUpdateChallengeMutation,
  UpdateChallengePageUpdateChallengeMutationVariables
>;
export const UpdateChallengePageDeleteChallengeDocument = gql`
  mutation updateChallengePageDeleteChallenge($challengeID: String!) {
    deleteChallenge(challengeID: $challengeID)
  }
`;
export type UpdateChallengePageDeleteChallengeMutationFn = Apollo.MutationFunction<
  UpdateChallengePageDeleteChallengeMutation,
  UpdateChallengePageDeleteChallengeMutationVariables
>;

/**
 * __useUpdateChallengePageDeleteChallengeMutation__
 *
 * To run a mutation, you first call `useUpdateChallengePageDeleteChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChallengePageDeleteChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChallengePageDeleteChallengeMutation, { data, loading, error }] = useUpdateChallengePageDeleteChallengeMutation({
 *   variables: {
 *      challengeID: // value for 'challengeID'
 *   },
 * });
 */
export function useUpdateChallengePageDeleteChallengeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateChallengePageDeleteChallengeMutation,
    UpdateChallengePageDeleteChallengeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateChallengePageDeleteChallengeMutation,
    UpdateChallengePageDeleteChallengeMutationVariables
  >(UpdateChallengePageDeleteChallengeDocument, options);
}
export type UpdateChallengePageDeleteChallengeMutationHookResult = ReturnType<
  typeof useUpdateChallengePageDeleteChallengeMutation
>;
export type UpdateChallengePageDeleteChallengeMutationResult =
  Apollo.MutationResult<UpdateChallengePageDeleteChallengeMutation>;
export type UpdateChallengePageDeleteChallengeMutationOptions = Apollo.BaseMutationOptions<
  UpdateChallengePageDeleteChallengeMutation,
  UpdateChallengePageDeleteChallengeMutationVariables
>;
export const GetUpdateScriptsPageQueryDocument = gql`
  query getUpdateScriptsPageQuery($trackSlug: String!, $teamSlug: String!) {
    userIsTrackDeveloper(trackSlug: $trackSlug, organizationSlug: $teamSlug)
    track(trackSlug: $trackSlug, organizationSlug: $teamSlug) {
      ...UpdateTrackScripts
    }
  }
  ${UpdateTrackScriptsFragmentDoc}
`;

/**
 * __useGetUpdateScriptsPageQueryQuery__
 *
 * To run a query within a React component, call `useGetUpdateScriptsPageQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpdateScriptsPageQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpdateScriptsPageQueryQuery({
 *   variables: {
 *      trackSlug: // value for 'trackSlug'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useGetUpdateScriptsPageQueryQuery(
  baseOptions: Apollo.QueryHookOptions<GetUpdateScriptsPageQueryQuery, GetUpdateScriptsPageQueryQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUpdateScriptsPageQueryQuery, GetUpdateScriptsPageQueryQueryVariables>(
    GetUpdateScriptsPageQueryDocument,
    options,
  );
}
export function useGetUpdateScriptsPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUpdateScriptsPageQueryQuery, GetUpdateScriptsPageQueryQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUpdateScriptsPageQueryQuery, GetUpdateScriptsPageQueryQueryVariables>(
    GetUpdateScriptsPageQueryDocument,
    options,
  );
}
export type GetUpdateScriptsPageQueryQueryHookResult = ReturnType<typeof useGetUpdateScriptsPageQueryQuery>;
export type GetUpdateScriptsPageQueryLazyQueryHookResult = ReturnType<typeof useGetUpdateScriptsPageQueryLazyQuery>;
export type GetUpdateScriptsPageQueryQueryResult = Apollo.QueryResult<
  GetUpdateScriptsPageQueryQuery,
  GetUpdateScriptsPageQueryQueryVariables
>;
export const GetUpdateScriptsTrackConfigQueryDocument = gql`
  query getUpdateScriptsTrackConfigQuery($trackID: String!) {
    trackConfig(trackID: $trackID) {
      id
      containers {
        id
        name
      }
      virtualmachines {
        id
        name
      }
      virtualbrowsers {
        id
        name
      }
    }
  }
`;

/**
 * __useGetUpdateScriptsTrackConfigQueryQuery__
 *
 * To run a query within a React component, call `useGetUpdateScriptsTrackConfigQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpdateScriptsTrackConfigQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpdateScriptsTrackConfigQueryQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useGetUpdateScriptsTrackConfigQueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUpdateScriptsTrackConfigQueryQuery,
    GetUpdateScriptsTrackConfigQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUpdateScriptsTrackConfigQueryQuery, GetUpdateScriptsTrackConfigQueryQueryVariables>(
    GetUpdateScriptsTrackConfigQueryDocument,
    options,
  );
}
export function useGetUpdateScriptsTrackConfigQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUpdateScriptsTrackConfigQueryQuery,
    GetUpdateScriptsTrackConfigQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUpdateScriptsTrackConfigQueryQuery, GetUpdateScriptsTrackConfigQueryQueryVariables>(
    GetUpdateScriptsTrackConfigQueryDocument,
    options,
  );
}
export type GetUpdateScriptsTrackConfigQueryQueryHookResult = ReturnType<
  typeof useGetUpdateScriptsTrackConfigQueryQuery
>;
export type GetUpdateScriptsTrackConfigQueryLazyQueryHookResult = ReturnType<
  typeof useGetUpdateScriptsTrackConfigQueryLazyQuery
>;
export type GetUpdateScriptsTrackConfigQueryQueryResult = Apollo.QueryResult<
  GetUpdateScriptsTrackConfigQueryQuery,
  GetUpdateScriptsTrackConfigQueryQueryVariables
>;
export const UpdateTrackScriptDocument = gql`
  mutation updateTrackScript($script: TrackScriptInput!, $base64Encoded: Boolean!) {
    saveTrackScript(script: $script, base64Encoded: $base64Encoded) {
      ...UpdateTrackScriptResult
    }
  }
  ${UpdateTrackScriptResultFragmentDoc}
`;
export type UpdateTrackScriptMutationFn = Apollo.MutationFunction<
  UpdateTrackScriptMutation,
  UpdateTrackScriptMutationVariables
>;

/**
 * __useUpdateTrackScriptMutation__
 *
 * To run a mutation, you first call `useUpdateTrackScriptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrackScriptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrackScriptMutation, { data, loading, error }] = useUpdateTrackScriptMutation({
 *   variables: {
 *      script: // value for 'script'
 *      base64Encoded: // value for 'base64Encoded'
 *   },
 * });
 */
export function useUpdateTrackScriptMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateTrackScriptMutation, UpdateTrackScriptMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateTrackScriptMutation, UpdateTrackScriptMutationVariables>(
    UpdateTrackScriptDocument,
    options,
  );
}
export type UpdateTrackScriptMutationHookResult = ReturnType<typeof useUpdateTrackScriptMutation>;
export type UpdateTrackScriptMutationResult = Apollo.MutationResult<UpdateTrackScriptMutation>;
export type UpdateTrackScriptMutationOptions = Apollo.BaseMutationOptions<
  UpdateTrackScriptMutation,
  UpdateTrackScriptMutationVariables
>;
export const UpdateChallengeScriptDocument = gql`
  mutation updateChallengeScript($script: ChallengeScriptInput!, $base64Encoded: Boolean!) {
    saveChallengeScript(script: $script, base64Encoded: $base64Encoded) {
      ...UpdateChallengeScriptResult
    }
  }
  ${UpdateChallengeScriptResultFragmentDoc}
`;
export type UpdateChallengeScriptMutationFn = Apollo.MutationFunction<
  UpdateChallengeScriptMutation,
  UpdateChallengeScriptMutationVariables
>;

/**
 * __useUpdateChallengeScriptMutation__
 *
 * To run a mutation, you first call `useUpdateChallengeScriptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChallengeScriptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChallengeScriptMutation, { data, loading, error }] = useUpdateChallengeScriptMutation({
 *   variables: {
 *      script: // value for 'script'
 *      base64Encoded: // value for 'base64Encoded'
 *   },
 * });
 */
export function useUpdateChallengeScriptMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateChallengeScriptMutation, UpdateChallengeScriptMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateChallengeScriptMutation, UpdateChallengeScriptMutationVariables>(
    UpdateChallengeScriptDocument,
    options,
  );
}
export type UpdateChallengeScriptMutationHookResult = ReturnType<typeof useUpdateChallengeScriptMutation>;
export type UpdateChallengeScriptMutationResult = Apollo.MutationResult<UpdateChallengeScriptMutation>;
export type UpdateChallengeScriptMutationOptions = Apollo.BaseMutationOptions<
  UpdateChallengeScriptMutation,
  UpdateChallengeScriptMutationVariables
>;
export const DeleteChallengeScriptDocument = gql`
  mutation deleteChallengeScript($challengeScriptID: String!) {
    deleteChallengeScript(challengeScriptID: $challengeScriptID)
  }
`;
export type DeleteChallengeScriptMutationFn = Apollo.MutationFunction<
  DeleteChallengeScriptMutation,
  DeleteChallengeScriptMutationVariables
>;

/**
 * __useDeleteChallengeScriptMutation__
 *
 * To run a mutation, you first call `useDeleteChallengeScriptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChallengeScriptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChallengeScriptMutation, { data, loading, error }] = useDeleteChallengeScriptMutation({
 *   variables: {
 *      challengeScriptID: // value for 'challengeScriptID'
 *   },
 * });
 */
export function useDeleteChallengeScriptMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteChallengeScriptMutation, DeleteChallengeScriptMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteChallengeScriptMutation, DeleteChallengeScriptMutationVariables>(
    DeleteChallengeScriptDocument,
    options,
  );
}
export type DeleteChallengeScriptMutationHookResult = ReturnType<typeof useDeleteChallengeScriptMutation>;
export type DeleteChallengeScriptMutationResult = Apollo.MutationResult<DeleteChallengeScriptMutation>;
export type DeleteChallengeScriptMutationOptions = Apollo.BaseMutationOptions<
  DeleteChallengeScriptMutation,
  DeleteChallengeScriptMutationVariables
>;
export const UpdateTrackPageUpdateTrackDocument = gql`
  mutation updateTrackPageUpdateTrack($track: TrackInput!) {
    updateTrack(track: $track) {
      id
      slug
    }
  }
`;
export type UpdateTrackPageUpdateTrackMutationFn = Apollo.MutationFunction<
  UpdateTrackPageUpdateTrackMutation,
  UpdateTrackPageUpdateTrackMutationVariables
>;

/**
 * __useUpdateTrackPageUpdateTrackMutation__
 *
 * To run a mutation, you first call `useUpdateTrackPageUpdateTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrackPageUpdateTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrackPageUpdateTrackMutation, { data, loading, error }] = useUpdateTrackPageUpdateTrackMutation({
 *   variables: {
 *      track: // value for 'track'
 *   },
 * });
 */
export function useUpdateTrackPageUpdateTrackMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTrackPageUpdateTrackMutation,
    UpdateTrackPageUpdateTrackMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateTrackPageUpdateTrackMutation, UpdateTrackPageUpdateTrackMutationVariables>(
    UpdateTrackPageUpdateTrackDocument,
    options,
  );
}
export type UpdateTrackPageUpdateTrackMutationHookResult = ReturnType<typeof useUpdateTrackPageUpdateTrackMutation>;
export type UpdateTrackPageUpdateTrackMutationResult = Apollo.MutationResult<UpdateTrackPageUpdateTrackMutation>;
export type UpdateTrackPageUpdateTrackMutationOptions = Apollo.BaseMutationOptions<
  UpdateTrackPageUpdateTrackMutation,
  UpdateTrackPageUpdateTrackMutationVariables
>;
export const TrackReviewsDocument = gql`
  query trackReviews($trackID: String!) {
    trackReviews(trackID: $trackID) {
      nodes {
        id
        score
        created_at
        content
      }
    }
    statistics(trackID: $trackID, start: "1970-01-01T00:00:00+00:00", end: "2970-01-01T00:00:00+00:00") {
      track {
        happiness {
          score
          count
        }
      }
    }
  }
`;

/**
 * __useTrackReviewsQuery__
 *
 * To run a query within a React component, call `useTrackReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackReviewsQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useTrackReviewsQuery(
  baseOptions: Apollo.QueryHookOptions<TrackReviewsQuery, TrackReviewsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TrackReviewsQuery, TrackReviewsQueryVariables>(TrackReviewsDocument, options);
}
export function useTrackReviewsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TrackReviewsQuery, TrackReviewsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TrackReviewsQuery, TrackReviewsQueryVariables>(TrackReviewsDocument, options);
}
export type TrackReviewsQueryHookResult = ReturnType<typeof useTrackReviewsQuery>;
export type TrackReviewsLazyQueryHookResult = ReturnType<typeof useTrackReviewsLazyQuery>;
export type TrackReviewsQueryResult = Apollo.QueryResult<TrackReviewsQuery, TrackReviewsQueryVariables>;
export const CheckChallengeDocument = gql`
  mutation CheckChallenge($challengeID: String!, $inviteID: String, $userID: String) {
    checkChallenge(challengeID: $challengeID, inviteID: $inviteID, userID: $userID) {
      id
      status
      attempts {
        timestamp
        message
      }
      unlocks {
        id
        permalink
      }
    }
  }
`;
export type CheckChallengeMutationFn = Apollo.MutationFunction<CheckChallengeMutation, CheckChallengeMutationVariables>;

/**
 * __useCheckChallengeMutation__
 *
 * To run a mutation, you first call `useCheckChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkChallengeMutation, { data, loading, error }] = useCheckChallengeMutation({
 *   variables: {
 *      challengeID: // value for 'challengeID'
 *      inviteID: // value for 'inviteID'
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useCheckChallengeMutation(
  baseOptions?: Apollo.MutationHookOptions<CheckChallengeMutation, CheckChallengeMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CheckChallengeMutation, CheckChallengeMutationVariables>(CheckChallengeDocument, options);
}
export type CheckChallengeMutationHookResult = ReturnType<typeof useCheckChallengeMutation>;
export type CheckChallengeMutationResult = Apollo.MutationResult<CheckChallengeMutation>;
export type CheckChallengeMutationOptions = Apollo.BaseMutationOptions<
  CheckChallengeMutation,
  CheckChallengeMutationVariables
>;
export const CheckQuizDocument = gql`
  mutation CheckQuiz($challengeID: String!, $userID: String, $inviteID: String, $solution: [Int!]!) {
    checkQuiz(challengeID: $challengeID, userID: $userID, inviteID: $inviteID, solution: $solution) {
      id
      status
      attempts {
        timestamp
        message
      }
      unlocks {
        id
        permalink
      }
    }
  }
`;
export type CheckQuizMutationFn = Apollo.MutationFunction<CheckQuizMutation, CheckQuizMutationVariables>;

/**
 * __useCheckQuizMutation__
 *
 * To run a mutation, you first call `useCheckQuizMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckQuizMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkQuizMutation, { data, loading, error }] = useCheckQuizMutation({
 *   variables: {
 *      challengeID: // value for 'challengeID'
 *      userID: // value for 'userID'
 *      inviteID: // value for 'inviteID'
 *      solution: // value for 'solution'
 *   },
 * });
 */
export function useCheckQuizMutation(
  baseOptions?: Apollo.MutationHookOptions<CheckQuizMutation, CheckQuizMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CheckQuizMutation, CheckQuizMutationVariables>(CheckQuizDocument, options);
}
export type CheckQuizMutationHookResult = ReturnType<typeof useCheckQuizMutation>;
export type CheckQuizMutationResult = Apollo.MutationResult<CheckQuizMutation>;
export type CheckQuizMutationOptions = Apollo.BaseMutationOptions<CheckQuizMutation, CheckQuizMutationVariables>;
export const LearnEnvironmentKeepAliveDocument = gql`
  mutation LearnEnvironmentKeepAlive($trackId: ID!) {
    keepAlive(trackID: $trackId)
  }
`;
export type LearnEnvironmentKeepAliveMutationFn = Apollo.MutationFunction<
  LearnEnvironmentKeepAliveMutation,
  LearnEnvironmentKeepAliveMutationVariables
>;

/**
 * __useLearnEnvironmentKeepAliveMutation__
 *
 * To run a mutation, you first call `useLearnEnvironmentKeepAliveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLearnEnvironmentKeepAliveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [learnEnvironmentKeepAliveMutation, { data, loading, error }] = useLearnEnvironmentKeepAliveMutation({
 *   variables: {
 *      trackId: // value for 'trackId'
 *   },
 * });
 */
export function useLearnEnvironmentKeepAliveMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LearnEnvironmentKeepAliveMutation,
    LearnEnvironmentKeepAliveMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LearnEnvironmentKeepAliveMutation, LearnEnvironmentKeepAliveMutationVariables>(
    LearnEnvironmentKeepAliveDocument,
    options,
  );
}
export type LearnEnvironmentKeepAliveMutationHookResult = ReturnType<typeof useLearnEnvironmentKeepAliveMutation>;
export type LearnEnvironmentKeepAliveMutationResult = Apollo.MutationResult<LearnEnvironmentKeepAliveMutation>;
export type LearnEnvironmentKeepAliveMutationOptions = Apollo.BaseMutationOptions<
  LearnEnvironmentKeepAliveMutation,
  LearnEnvironmentKeepAliveMutationVariables
>;
export const LearnEnvironmentLegacyDocument = gql`
  query LearnEnvironmentLegacy(
    $trackSlug: String!
    $challengeSlug: String!
    $teamSlug: String!
    $userID: String
    $inviteID: String
  ) {
    team(teamSlug: $teamSlug) {
      id
      slug
      name
      features {
        track_reviews
        service_tab_focus_overlay
        members_skip_to_challenge
        use_new_terminal
      }
    }
    track(trackSlug: $trackSlug, teamSlug: $teamSlug, userID: $userID) {
      id
      title
      permalink
      slug
      status
      started
      creating
      created
      failed
      stopped
      completed
      cleaned
      show_timer
      ttl
      idle_timeout
      challenges {
        id
        status
        index
        permalink
        ...ProgressChallenge
      }
      participant {
        id
      }
      ...ProgressTrack
      ...ExpiredScreenTrack
    }
    userInTeam(teamSlug: $teamSlug)
    challenge(
      trackSlug: $trackSlug
      teamSlug: $teamSlug
      challengeSlug: $challengeSlug
      userID: $userID
      inviteID: $inviteID
      parseAssignmentVariables: true
    ) {
      id
      type
      index
      teaser
      permalink
      title
      slug
      status
      assignment
      answers
      can_check
      failed
      notes {
        id
        type
        contents
        url
      }
      attempts {
        timestamp
        message
      }
      ...WorkspaceChallenge
    }
    ...IsSkippingEnabledQuery
  }
  ${ProgressChallengeFragmentDoc}
  ${ProgressTrackFragmentDoc}
  ${ExpiredScreenTrackFragmentDoc}
  ${WorkspaceChallengeFragmentDoc}
  ${IsSkippingEnabledQueryFragmentDoc}
`;

/**
 * __useLearnEnvironmentLegacyQuery__
 *
 * To run a query within a React component, call `useLearnEnvironmentLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearnEnvironmentLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearnEnvironmentLegacyQuery({
 *   variables: {
 *      trackSlug: // value for 'trackSlug'
 *      challengeSlug: // value for 'challengeSlug'
 *      teamSlug: // value for 'teamSlug'
 *      userID: // value for 'userID'
 *      inviteID: // value for 'inviteID'
 *   },
 * });
 */
export function useLearnEnvironmentLegacyQuery(
  baseOptions: Apollo.QueryHookOptions<LearnEnvironmentLegacyQuery, LearnEnvironmentLegacyQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LearnEnvironmentLegacyQuery, LearnEnvironmentLegacyQueryVariables>(
    LearnEnvironmentLegacyDocument,
    options,
  );
}
export function useLearnEnvironmentLegacyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<LearnEnvironmentLegacyQuery, LearnEnvironmentLegacyQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LearnEnvironmentLegacyQuery, LearnEnvironmentLegacyQueryVariables>(
    LearnEnvironmentLegacyDocument,
    options,
  );
}
export type LearnEnvironmentLegacyQueryHookResult = ReturnType<typeof useLearnEnvironmentLegacyQuery>;
export type LearnEnvironmentLegacyLazyQueryHookResult = ReturnType<typeof useLearnEnvironmentLegacyLazyQuery>;
export type LearnEnvironmentLegacyQueryResult = Apollo.QueryResult<
  LearnEnvironmentLegacyQuery,
  LearnEnvironmentLegacyQueryVariables
>;
export const LearnEnvironmentStopTrackDocument = gql`
  mutation LearnEnvironmentStopTrack($trackID: String!) {
    stopTrack(trackID: $trackID) {
      id
    }
  }
`;
export type LearnEnvironmentStopTrackMutationFn = Apollo.MutationFunction<
  LearnEnvironmentStopTrackMutation,
  LearnEnvironmentStopTrackMutationVariables
>;

/**
 * __useLearnEnvironmentStopTrackMutation__
 *
 * To run a mutation, you first call `useLearnEnvironmentStopTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLearnEnvironmentStopTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [learnEnvironmentStopTrackMutation, { data, loading, error }] = useLearnEnvironmentStopTrackMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useLearnEnvironmentStopTrackMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LearnEnvironmentStopTrackMutation,
    LearnEnvironmentStopTrackMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LearnEnvironmentStopTrackMutation, LearnEnvironmentStopTrackMutationVariables>(
    LearnEnvironmentStopTrackDocument,
    options,
  );
}
export type LearnEnvironmentStopTrackMutationHookResult = ReturnType<typeof useLearnEnvironmentStopTrackMutation>;
export type LearnEnvironmentStopTrackMutationResult = Apollo.MutationResult<LearnEnvironmentStopTrackMutation>;
export type LearnEnvironmentStopTrackMutationOptions = Apollo.BaseMutationOptions<
  LearnEnvironmentStopTrackMutation,
  LearnEnvironmentStopTrackMutationVariables
>;
export const LearnEnvironmentInviteDocument = gql`
  query learnEnvironmentInvite($inviteID: String!) {
    trackInvite(inviteID: $inviteID) {
      id
      canClaim
      enableLearnerSharing
      allowAnonymous
      allowedEmailAddresses
    }
  }
`;

/**
 * __useLearnEnvironmentInviteQuery__
 *
 * To run a query within a React component, call `useLearnEnvironmentInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearnEnvironmentInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearnEnvironmentInviteQuery({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *   },
 * });
 */
export function useLearnEnvironmentInviteQuery(
  baseOptions: Apollo.QueryHookOptions<LearnEnvironmentInviteQuery, LearnEnvironmentInviteQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LearnEnvironmentInviteQuery, LearnEnvironmentInviteQueryVariables>(
    LearnEnvironmentInviteDocument,
    options,
  );
}
export function useLearnEnvironmentInviteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<LearnEnvironmentInviteQuery, LearnEnvironmentInviteQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LearnEnvironmentInviteQuery, LearnEnvironmentInviteQueryVariables>(
    LearnEnvironmentInviteDocument,
    options,
  );
}
export type LearnEnvironmentInviteQueryHookResult = ReturnType<typeof useLearnEnvironmentInviteQuery>;
export type LearnEnvironmentInviteLazyQueryHookResult = ReturnType<typeof useLearnEnvironmentInviteLazyQuery>;
export type LearnEnvironmentInviteQueryResult = Apollo.QueryResult<
  LearnEnvironmentInviteQuery,
  LearnEnvironmentInviteQueryVariables
>;
export const RecapLegacyDocument = gql`
  query RecapLegacy($trackSlug: String!, $teamSlug: String!) {
    track(trackSlug: $trackSlug, teamSlug: $teamSlug) {
      id
      title
      permalink
      ...ProgressTrack
      challenges {
        permalink
        ...ProgressChallenge
      }
      participant {
        id
      }
    }
    ...IsSkippingEnabledQuery
  }
  ${ProgressTrackFragmentDoc}
  ${ProgressChallengeFragmentDoc}
  ${IsSkippingEnabledQueryFragmentDoc}
`;

/**
 * __useRecapLegacyQuery__
 *
 * To run a query within a React component, call `useRecapLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecapLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecapLegacyQuery({
 *   variables: {
 *      trackSlug: // value for 'trackSlug'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useRecapLegacyQuery(baseOptions: Apollo.QueryHookOptions<RecapLegacyQuery, RecapLegacyQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RecapLegacyQuery, RecapLegacyQueryVariables>(RecapLegacyDocument, options);
}
export function useRecapLegacyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<RecapLegacyQuery, RecapLegacyQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RecapLegacyQuery, RecapLegacyQueryVariables>(RecapLegacyDocument, options);
}
export type RecapLegacyQueryHookResult = ReturnType<typeof useRecapLegacyQuery>;
export type RecapLegacyLazyQueryHookResult = ReturnType<typeof useRecapLegacyLazyQuery>;
export type RecapLegacyQueryResult = Apollo.QueryResult<RecapLegacyQuery, RecapLegacyQueryVariables>;
export const RecapTrackInviteDocument = gql`
  query recapTrackInvite($inviteID: String!) {
    trackInvite(inviteID: $inviteID) {
      id
      canClaim
      enableLearnerSharing
      allowAnonymous
      allowedEmailAddresses
    }
  }
`;

/**
 * __useRecapTrackInviteQuery__
 *
 * To run a query within a React component, call `useRecapTrackInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecapTrackInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecapTrackInviteQuery({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *   },
 * });
 */
export function useRecapTrackInviteQuery(
  baseOptions: Apollo.QueryHookOptions<RecapTrackInviteQuery, RecapTrackInviteQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RecapTrackInviteQuery, RecapTrackInviteQueryVariables>(RecapTrackInviteDocument, options);
}
export function useRecapTrackInviteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<RecapTrackInviteQuery, RecapTrackInviteQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RecapTrackInviteQuery, RecapTrackInviteQueryVariables>(RecapTrackInviteDocument, options);
}
export type RecapTrackInviteQueryHookResult = ReturnType<typeof useRecapTrackInviteQuery>;
export type RecapTrackInviteLazyQueryHookResult = ReturnType<typeof useRecapTrackInviteLazyQuery>;
export type RecapTrackInviteQueryResult = Apollo.QueryResult<RecapTrackInviteQuery, RecapTrackInviteQueryVariables>;
export const StopTrackDocument = gql`
  mutation StopTrack($trackID: String!) {
    stopTrack(trackID: $trackID) {
      id
      status
      challenges {
        id
        slug
        title
        teaser
        status
      }
    }
  }
`;
export type StopTrackMutationFn = Apollo.MutationFunction<StopTrackMutation, StopTrackMutationVariables>;

/**
 * __useStopTrackMutation__
 *
 * To run a mutation, you first call `useStopTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopTrackMutation, { data, loading, error }] = useStopTrackMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useStopTrackMutation(
  baseOptions?: Apollo.MutationHookOptions<StopTrackMutation, StopTrackMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<StopTrackMutation, StopTrackMutationVariables>(StopTrackDocument, options);
}
export type StopTrackMutationHookResult = ReturnType<typeof useStopTrackMutation>;
export type StopTrackMutationResult = Apollo.MutationResult<StopTrackMutation>;
export type StopTrackMutationOptions = Apollo.BaseMutationOptions<StopTrackMutation, StopTrackMutationVariables>;
export const UpdateTrackReviewDocument = gql`
  mutation UpdateTrackReview($id: String!, $content: String!) {
    updateTrackReview(id: $id, content: $content) {
      id
    }
  }
`;
export type UpdateTrackReviewMutationFn = Apollo.MutationFunction<
  UpdateTrackReviewMutation,
  UpdateTrackReviewMutationVariables
>;

/**
 * __useUpdateTrackReviewMutation__
 *
 * To run a mutation, you first call `useUpdateTrackReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrackReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrackReviewMutation, { data, loading, error }] = useUpdateTrackReviewMutation({
 *   variables: {
 *      id: // value for 'id'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useUpdateTrackReviewMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateTrackReviewMutation, UpdateTrackReviewMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateTrackReviewMutation, UpdateTrackReviewMutationVariables>(
    UpdateTrackReviewDocument,
    options,
  );
}
export type UpdateTrackReviewMutationHookResult = ReturnType<typeof useUpdateTrackReviewMutation>;
export type UpdateTrackReviewMutationResult = Apollo.MutationResult<UpdateTrackReviewMutation>;
export type UpdateTrackReviewMutationOptions = Apollo.BaseMutationOptions<
  UpdateTrackReviewMutation,
  UpdateTrackReviewMutationVariables
>;
export const TrackReviewSaveRatingDocument = gql`
  mutation TrackReviewSaveRating($trackID: String!, $participantID: String!, $score: Int!) {
    createTrackReview(trackID: $trackID, participantID: $participantID, score: $score) {
      id
    }
  }
`;
export type TrackReviewSaveRatingMutationFn = Apollo.MutationFunction<
  TrackReviewSaveRatingMutation,
  TrackReviewSaveRatingMutationVariables
>;

/**
 * __useTrackReviewSaveRatingMutation__
 *
 * To run a mutation, you first call `useTrackReviewSaveRatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackReviewSaveRatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackReviewSaveRatingMutation, { data, loading, error }] = useTrackReviewSaveRatingMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      participantID: // value for 'participantID'
 *      score: // value for 'score'
 *   },
 * });
 */
export function useTrackReviewSaveRatingMutation(
  baseOptions?: Apollo.MutationHookOptions<TrackReviewSaveRatingMutation, TrackReviewSaveRatingMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TrackReviewSaveRatingMutation, TrackReviewSaveRatingMutationVariables>(
    TrackReviewSaveRatingDocument,
    options,
  );
}
export type TrackReviewSaveRatingMutationHookResult = ReturnType<typeof useTrackReviewSaveRatingMutation>;
export type TrackReviewSaveRatingMutationResult = Apollo.MutationResult<TrackReviewSaveRatingMutation>;
export type TrackReviewSaveRatingMutationOptions = Apollo.BaseMutationOptions<
  TrackReviewSaveRatingMutation,
  TrackReviewSaveRatingMutationVariables
>;
export const TrackReviewRatingGetTrackDocument = gql`
  query TrackReviewRatingGetTrack($trackID: String!, $teamSlug: String!) {
    track(trackID: $trackID, teamSlug: $teamSlug) {
      id
      slug
      participant {
        id
      }
    }
  }
`;

/**
 * __useTrackReviewRatingGetTrackQuery__
 *
 * To run a query within a React component, call `useTrackReviewRatingGetTrackQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackReviewRatingGetTrackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackReviewRatingGetTrackQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useTrackReviewRatingGetTrackQuery(
  baseOptions: Apollo.QueryHookOptions<TrackReviewRatingGetTrackQuery, TrackReviewRatingGetTrackQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TrackReviewRatingGetTrackQuery, TrackReviewRatingGetTrackQueryVariables>(
    TrackReviewRatingGetTrackDocument,
    options,
  );
}
export function useTrackReviewRatingGetTrackLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TrackReviewRatingGetTrackQuery, TrackReviewRatingGetTrackQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TrackReviewRatingGetTrackQuery, TrackReviewRatingGetTrackQueryVariables>(
    TrackReviewRatingGetTrackDocument,
    options,
  );
}
export type TrackReviewRatingGetTrackQueryHookResult = ReturnType<typeof useTrackReviewRatingGetTrackQuery>;
export type TrackReviewRatingGetTrackLazyQueryHookResult = ReturnType<typeof useTrackReviewRatingGetTrackLazyQuery>;
export type TrackReviewRatingGetTrackQueryResult = Apollo.QueryResult<
  TrackReviewRatingGetTrackQuery,
  TrackReviewRatingGetTrackQueryVariables
>;
export const TrackAndChallengeStatusDocument = gql`
  query TrackAndChallengeStatus($trackID: String!, $challengeID: String!, $userID: String, $inviteID: String) {
    track(trackID: $trackID, userID: $userID, inviteID: $inviteID) {
      id
      status
      creating
    }
    challenge(challengeID: $challengeID, userID: $userID, inviteID: $inviteID) {
      id
      status
      failMessage
    }
  }
`;

/**
 * __useTrackAndChallengeStatusQuery__
 *
 * To run a query within a React component, call `useTrackAndChallengeStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackAndChallengeStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackAndChallengeStatusQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      challengeID: // value for 'challengeID'
 *      userID: // value for 'userID'
 *      inviteID: // value for 'inviteID'
 *   },
 * });
 */
export function useTrackAndChallengeStatusQuery(
  baseOptions: Apollo.QueryHookOptions<TrackAndChallengeStatusQuery, TrackAndChallengeStatusQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TrackAndChallengeStatusQuery, TrackAndChallengeStatusQueryVariables>(
    TrackAndChallengeStatusDocument,
    options,
  );
}
export function useTrackAndChallengeStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TrackAndChallengeStatusQuery, TrackAndChallengeStatusQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TrackAndChallengeStatusQuery, TrackAndChallengeStatusQueryVariables>(
    TrackAndChallengeStatusDocument,
    options,
  );
}
export type TrackAndChallengeStatusQueryHookResult = ReturnType<typeof useTrackAndChallengeStatusQuery>;
export type TrackAndChallengeStatusLazyQueryHookResult = ReturnType<typeof useTrackAndChallengeStatusLazyQuery>;
export type TrackAndChallengeStatusQueryResult = Apollo.QueryResult<
  TrackAndChallengeStatusQuery,
  TrackAndChallengeStatusQueryVariables
>;
export const SetupChallengeDocument = gql`
  mutation SetupChallenge($challengeID: String!) {
    setupChallenge(challengeID: $challengeID) {
      id
    }
  }
`;
export type SetupChallengeMutationFn = Apollo.MutationFunction<SetupChallengeMutation, SetupChallengeMutationVariables>;

/**
 * __useSetupChallengeMutation__
 *
 * To run a mutation, you first call `useSetupChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupChallengeMutation, { data, loading, error }] = useSetupChallengeMutation({
 *   variables: {
 *      challengeID: // value for 'challengeID'
 *   },
 * });
 */
export function useSetupChallengeMutation(
  baseOptions?: Apollo.MutationHookOptions<SetupChallengeMutation, SetupChallengeMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetupChallengeMutation, SetupChallengeMutationVariables>(SetupChallengeDocument, options);
}
export type SetupChallengeMutationHookResult = ReturnType<typeof useSetupChallengeMutation>;
export type SetupChallengeMutationResult = Apollo.MutationResult<SetupChallengeMutation>;
export type SetupChallengeMutationOptions = Apollo.BaseMutationOptions<
  SetupChallengeMutation,
  SetupChallengeMutationVariables
>;
export const CompletionGetTrackDocument = gql`
  query CompletionGetTrack($trackSlug: String!, $teamSlug: String!) {
    track(trackSlug: $trackSlug, teamSlug: $teamSlug) {
      id
      title
      permalink
      challenges {
        permalink
      }
      participant {
        id
      }
    }
  }
`;

/**
 * __useCompletionGetTrackQuery__
 *
 * To run a query within a React component, call `useCompletionGetTrackQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompletionGetTrackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompletionGetTrackQuery({
 *   variables: {
 *      trackSlug: // value for 'trackSlug'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useCompletionGetTrackQuery(
  baseOptions: Apollo.QueryHookOptions<CompletionGetTrackQuery, CompletionGetTrackQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CompletionGetTrackQuery, CompletionGetTrackQueryVariables>(
    CompletionGetTrackDocument,
    options,
  );
}
export function useCompletionGetTrackLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CompletionGetTrackQuery, CompletionGetTrackQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CompletionGetTrackQuery, CompletionGetTrackQueryVariables>(
    CompletionGetTrackDocument,
    options,
  );
}
export type CompletionGetTrackQueryHookResult = ReturnType<typeof useCompletionGetTrackQuery>;
export type CompletionGetTrackLazyQueryHookResult = ReturnType<typeof useCompletionGetTrackLazyQuery>;
export type CompletionGetTrackQueryResult = Apollo.QueryResult<
  CompletionGetTrackQuery,
  CompletionGetTrackQueryVariables
>;
export const CompletionScreenUpdateTrackReviewDocument = gql`
  mutation CompletionScreenUpdateTrackReview($id: String!, $content: String!) {
    updateTrackReview(id: $id, content: $content) {
      id
    }
  }
`;
export type CompletionScreenUpdateTrackReviewMutationFn = Apollo.MutationFunction<
  CompletionScreenUpdateTrackReviewMutation,
  CompletionScreenUpdateTrackReviewMutationVariables
>;

/**
 * __useCompletionScreenUpdateTrackReviewMutation__
 *
 * To run a mutation, you first call `useCompletionScreenUpdateTrackReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompletionScreenUpdateTrackReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completionScreenUpdateTrackReviewMutation, { data, loading, error }] = useCompletionScreenUpdateTrackReviewMutation({
 *   variables: {
 *      id: // value for 'id'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useCompletionScreenUpdateTrackReviewMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompletionScreenUpdateTrackReviewMutation,
    CompletionScreenUpdateTrackReviewMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CompletionScreenUpdateTrackReviewMutation,
    CompletionScreenUpdateTrackReviewMutationVariables
  >(CompletionScreenUpdateTrackReviewDocument, options);
}
export type CompletionScreenUpdateTrackReviewMutationHookResult = ReturnType<
  typeof useCompletionScreenUpdateTrackReviewMutation
>;
export type CompletionScreenUpdateTrackReviewMutationResult =
  Apollo.MutationResult<CompletionScreenUpdateTrackReviewMutation>;
export type CompletionScreenUpdateTrackReviewMutationOptions = Apollo.BaseMutationOptions<
  CompletionScreenUpdateTrackReviewMutation,
  CompletionScreenUpdateTrackReviewMutationVariables
>;
export const CompletionScreenSaveRatingDocument = gql`
  mutation CompletionScreenSaveRating($trackID: String!, $participantID: String!, $score: Int!) {
    createTrackReview(trackID: $trackID, participantID: $participantID, score: $score) {
      id
    }
  }
`;
export type CompletionScreenSaveRatingMutationFn = Apollo.MutationFunction<
  CompletionScreenSaveRatingMutation,
  CompletionScreenSaveRatingMutationVariables
>;

/**
 * __useCompletionScreenSaveRatingMutation__
 *
 * To run a mutation, you first call `useCompletionScreenSaveRatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompletionScreenSaveRatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completionScreenSaveRatingMutation, { data, loading, error }] = useCompletionScreenSaveRatingMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      participantID: // value for 'participantID'
 *      score: // value for 'score'
 *   },
 * });
 */
export function useCompletionScreenSaveRatingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompletionScreenSaveRatingMutation,
    CompletionScreenSaveRatingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CompletionScreenSaveRatingMutation, CompletionScreenSaveRatingMutationVariables>(
    CompletionScreenSaveRatingDocument,
    options,
  );
}
export type CompletionScreenSaveRatingMutationHookResult = ReturnType<typeof useCompletionScreenSaveRatingMutation>;
export type CompletionScreenSaveRatingMutationResult = Apollo.MutationResult<CompletionScreenSaveRatingMutation>;
export type CompletionScreenSaveRatingMutationOptions = Apollo.BaseMutationOptions<
  CompletionScreenSaveRatingMutation,
  CompletionScreenSaveRatingMutationVariables
>;
export const CompletionStopTrackDocument = gql`
  mutation CompletionStopTrack($trackID: String!) {
    stopTrack(trackID: $trackID) {
      id
      status
      challenges {
        id
        slug
        title
        teaser
        status
      }
    }
  }
`;
export type CompletionStopTrackMutationFn = Apollo.MutationFunction<
  CompletionStopTrackMutation,
  CompletionStopTrackMutationVariables
>;

/**
 * __useCompletionStopTrackMutation__
 *
 * To run a mutation, you first call `useCompletionStopTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompletionStopTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completionStopTrackMutation, { data, loading, error }] = useCompletionStopTrackMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useCompletionStopTrackMutation(
  baseOptions?: Apollo.MutationHookOptions<CompletionStopTrackMutation, CompletionStopTrackMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CompletionStopTrackMutation, CompletionStopTrackMutationVariables>(
    CompletionStopTrackDocument,
    options,
  );
}
export type CompletionStopTrackMutationHookResult = ReturnType<typeof useCompletionStopTrackMutation>;
export type CompletionStopTrackMutationResult = Apollo.MutationResult<CompletionStopTrackMutation>;
export type CompletionStopTrackMutationOptions = Apollo.BaseMutationOptions<
  CompletionStopTrackMutation,
  CompletionStopTrackMutationVariables
>;
export const LearnEnvironmentDocument = gql`
  query LearnEnvironment(
    $trackSlug: String!
    $challengeSlug: String!
    $teamSlug: String!
    $userID: String
    $inviteID: String
  ) {
    team(teamSlug: $teamSlug) {
      id
      slug
      name
      features {
        track_reviews
        service_tab_focus_overlay
        members_skip_to_challenge
        use_new_terminal
      }
    }
    track(trackSlug: $trackSlug, teamSlug: $teamSlug, userID: $userID) {
      id
      title
      permalink
      slug
      status
      started
      creating
      created
      failed
      stopped
      completed
      cleaned
      show_timer
      ttl
      idle_timeout
      challenges {
        id
        status
        index
        permalink
        ...ProgressChallenge
      }
      participant {
        id
        ttlExtendedByUser
      }
      lab_config {
        overlay
        position
        width
        extendTTL
      }
      ...ProgressTrack
      ...ExpiredScreenTrack
    }
    userInTeam(teamSlug: $teamSlug)
    challenge(
      trackSlug: $trackSlug
      teamSlug: $teamSlug
      challengeSlug: $challengeSlug
      userID: $userID
      inviteID: $inviteID
      parseAssignmentVariables: true
    ) {
      id
      type
      index
      teaser
      permalink
      title
      slug
      status
      assignment
      answers
      can_check
      failed
      notes {
        id
        type
        contents
        url
      }
      attempts {
        timestamp
        message
      }
      ...WorkspaceChallenge
    }
    ...IsSkippingEnabledQuery
  }
  ${ProgressChallengeFragmentDoc}
  ${ProgressTrackFragmentDoc}
  ${ExpiredScreenTrackFragmentDoc}
  ${WorkspaceChallengeFragmentDoc}
  ${IsSkippingEnabledQueryFragmentDoc}
`;

/**
 * __useLearnEnvironmentQuery__
 *
 * To run a query within a React component, call `useLearnEnvironmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearnEnvironmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearnEnvironmentQuery({
 *   variables: {
 *      trackSlug: // value for 'trackSlug'
 *      challengeSlug: // value for 'challengeSlug'
 *      teamSlug: // value for 'teamSlug'
 *      userID: // value for 'userID'
 *      inviteID: // value for 'inviteID'
 *   },
 * });
 */
export function useLearnEnvironmentQuery(
  baseOptions: Apollo.QueryHookOptions<LearnEnvironmentQuery, LearnEnvironmentQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LearnEnvironmentQuery, LearnEnvironmentQueryVariables>(LearnEnvironmentDocument, options);
}
export function useLearnEnvironmentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<LearnEnvironmentQuery, LearnEnvironmentQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LearnEnvironmentQuery, LearnEnvironmentQueryVariables>(LearnEnvironmentDocument, options);
}
export type LearnEnvironmentQueryHookResult = ReturnType<typeof useLearnEnvironmentQuery>;
export type LearnEnvironmentLazyQueryHookResult = ReturnType<typeof useLearnEnvironmentLazyQuery>;
export type LearnEnvironmentQueryResult = Apollo.QueryResult<LearnEnvironmentQuery, LearnEnvironmentQueryVariables>;
export const ExtendSandboxTtlDocument = gql`
  mutation extendSandboxTTL($sandboxID: String!, $until: Time!) {
    updateSandboxTTL(sandboxID: $sandboxID, until: $until) {
      id
      track {
        id
        ttl
        participant {
          id
          ttlExtendedByUser
        }
      }
    }
  }
`;
export type ExtendSandboxTtlMutationFn = Apollo.MutationFunction<
  ExtendSandboxTtlMutation,
  ExtendSandboxTtlMutationVariables
>;

/**
 * __useExtendSandboxTtlMutation__
 *
 * To run a mutation, you first call `useExtendSandboxTtlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExtendSandboxTtlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [extendSandboxTtlMutation, { data, loading, error }] = useExtendSandboxTtlMutation({
 *   variables: {
 *      sandboxID: // value for 'sandboxID'
 *      until: // value for 'until'
 *   },
 * });
 */
export function useExtendSandboxTtlMutation(
  baseOptions?: Apollo.MutationHookOptions<ExtendSandboxTtlMutation, ExtendSandboxTtlMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ExtendSandboxTtlMutation, ExtendSandboxTtlMutationVariables>(
    ExtendSandboxTtlDocument,
    options,
  );
}
export type ExtendSandboxTtlMutationHookResult = ReturnType<typeof useExtendSandboxTtlMutation>;
export type ExtendSandboxTtlMutationResult = Apollo.MutationResult<ExtendSandboxTtlMutation>;
export type ExtendSandboxTtlMutationOptions = Apollo.BaseMutationOptions<
  ExtendSandboxTtlMutation,
  ExtendSandboxTtlMutationVariables
>;
export const NotesContainerStartTrackDocument = gql`
  mutation NotesContainerStartTrack(
    $trackID: String!
    $inviteID: String
    $mode: Mode
    $customParameters: [CustomParametersInput!]
    $forceStart: Boolean
    $region: String
  ) {
    startTrack(
      trackID: $trackID
      inviteID: $inviteID
      recaptchaToken: ""
      mode: $mode
      customParameters: $customParameters
      force: $forceStart
      region: $region
    ) {
      id
      status
      permalink
      challenges {
        id
        slug
        status
      }
    }
  }
`;
export type NotesContainerStartTrackMutationFn = Apollo.MutationFunction<
  NotesContainerStartTrackMutation,
  NotesContainerStartTrackMutationVariables
>;

/**
 * __useNotesContainerStartTrackMutation__
 *
 * To run a mutation, you first call `useNotesContainerStartTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotesContainerStartTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notesContainerStartTrackMutation, { data, loading, error }] = useNotesContainerStartTrackMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      inviteID: // value for 'inviteID'
 *      mode: // value for 'mode'
 *      customParameters: // value for 'customParameters'
 *      forceStart: // value for 'forceStart'
 *      region: // value for 'region'
 *   },
 * });
 */
export function useNotesContainerStartTrackMutation(
  baseOptions?: Apollo.MutationHookOptions<NotesContainerStartTrackMutation, NotesContainerStartTrackMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<NotesContainerStartTrackMutation, NotesContainerStartTrackMutationVariables>(
    NotesContainerStartTrackDocument,
    options,
  );
}
export type NotesContainerStartTrackMutationHookResult = ReturnType<typeof useNotesContainerStartTrackMutation>;
export type NotesContainerStartTrackMutationResult = Apollo.MutationResult<NotesContainerStartTrackMutation>;
export type NotesContainerStartTrackMutationOptions = Apollo.BaseMutationOptions<
  NotesContainerStartTrackMutation,
  NotesContainerStartTrackMutationVariables
>;
export const NotesContainerStartChallengeDocument = gql`
  mutation NotesContainerStartChallenge($challengeID: String!) {
    startChallenge(challengeID: $challengeID) {
      id
      status
      assignment
      tabs {
        type
        title
        target
      }
    }
  }
`;
export type NotesContainerStartChallengeMutationFn = Apollo.MutationFunction<
  NotesContainerStartChallengeMutation,
  NotesContainerStartChallengeMutationVariables
>;

/**
 * __useNotesContainerStartChallengeMutation__
 *
 * To run a mutation, you first call `useNotesContainerStartChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotesContainerStartChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notesContainerStartChallengeMutation, { data, loading, error }] = useNotesContainerStartChallengeMutation({
 *   variables: {
 *      challengeID: // value for 'challengeID'
 *   },
 * });
 */
export function useNotesContainerStartChallengeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    NotesContainerStartChallengeMutation,
    NotesContainerStartChallengeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<NotesContainerStartChallengeMutation, NotesContainerStartChallengeMutationVariables>(
    NotesContainerStartChallengeDocument,
    options,
  );
}
export type NotesContainerStartChallengeMutationHookResult = ReturnType<typeof useNotesContainerStartChallengeMutation>;
export type NotesContainerStartChallengeMutationResult = Apollo.MutationResult<NotesContainerStartChallengeMutation>;
export type NotesContainerStartChallengeMutationOptions = Apollo.BaseMutationOptions<
  NotesContainerStartChallengeMutation,
  NotesContainerStartChallengeMutationVariables
>;
export const NotesContainerDocument = gql`
  query notesContainer(
    $trackSlug: String
    $challengeSlug: String!
    $teamSlug: String!
    $inviteID: String
    $userID: String
  ) {
    track(trackSlug: $trackSlug, teamSlug: $teamSlug, userID: $userID, inviteID: $inviteID) {
      id
      permalink
      slug
      status
      creating
      completed
      median_starttime
      owner
      participant {
        id
      }
      challenges {
        id
        title
        status
        permalink
        ...ProgressChallenge
      }
    }
    challenge(
      trackSlug: $trackSlug
      teamSlug: $teamSlug
      challengeSlug: $challengeSlug
      userID: $userID
      inviteID: $inviteID
    ) {
      id
      index
      title
      permalink
      slug
      status
      teaser
      type
      failed
      notes {
        id
        type
        contents
        url
      }
    }
    ...IsSkippingEnabledQuery
  }
  ${ProgressChallengeFragmentDoc}
  ${IsSkippingEnabledQueryFragmentDoc}
`;

/**
 * __useNotesContainerQuery__
 *
 * To run a query within a React component, call `useNotesContainerQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotesContainerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotesContainerQuery({
 *   variables: {
 *      trackSlug: // value for 'trackSlug'
 *      challengeSlug: // value for 'challengeSlug'
 *      teamSlug: // value for 'teamSlug'
 *      inviteID: // value for 'inviteID'
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useNotesContainerQuery(
  baseOptions: Apollo.QueryHookOptions<NotesContainerQuery, NotesContainerQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<NotesContainerQuery, NotesContainerQueryVariables>(NotesContainerDocument, options);
}
export function useNotesContainerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<NotesContainerQuery, NotesContainerQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<NotesContainerQuery, NotesContainerQueryVariables>(NotesContainerDocument, options);
}
export type NotesContainerQueryHookResult = ReturnType<typeof useNotesContainerQuery>;
export type NotesContainerLazyQueryHookResult = ReturnType<typeof useNotesContainerLazyQuery>;
export type NotesContainerQueryResult = Apollo.QueryResult<NotesContainerQuery, NotesContainerQueryVariables>;
export const NotesContainerInviteDocument = gql`
  query notesContainerInvite($inviteID: String!) {
    trackInvite(inviteID: $inviteID) {
      id
      canClaim
      enableLearnerSharing
      allowAnonymous
      allowedEmailAddresses
    }
  }
`;

/**
 * __useNotesContainerInviteQuery__
 *
 * To run a query within a React component, call `useNotesContainerInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotesContainerInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotesContainerInviteQuery({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *   },
 * });
 */
export function useNotesContainerInviteQuery(
  baseOptions: Apollo.QueryHookOptions<NotesContainerInviteQuery, NotesContainerInviteQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<NotesContainerInviteQuery, NotesContainerInviteQueryVariables>(
    NotesContainerInviteDocument,
    options,
  );
}
export function useNotesContainerInviteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<NotesContainerInviteQuery, NotesContainerInviteQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<NotesContainerInviteQuery, NotesContainerInviteQueryVariables>(
    NotesContainerInviteDocument,
    options,
  );
}
export type NotesContainerInviteQueryHookResult = ReturnType<typeof useNotesContainerInviteQuery>;
export type NotesContainerInviteLazyQueryHookResult = ReturnType<typeof useNotesContainerInviteLazyQuery>;
export type NotesContainerInviteQueryResult = Apollo.QueryResult<
  NotesContainerInviteQuery,
  NotesContainerInviteQueryVariables
>;
export const RecapDocument = gql`
  query Recap($trackSlug: String!, $teamSlug: String!) {
    track(trackSlug: $trackSlug, teamSlug: $teamSlug) {
      id
      title
      permalink
      ...ProgressTrack
      challenges {
        permalink
        ...ProgressChallenge
      }
      participant {
        id
      }
      lab_config {
        overlay
        position
        width
      }
    }
    ...IsSkippingEnabledQuery
  }
  ${ProgressTrackFragmentDoc}
  ${ProgressChallengeFragmentDoc}
  ${IsSkippingEnabledQueryFragmentDoc}
`;

/**
 * __useRecapQuery__
 *
 * To run a query within a React component, call `useRecapQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecapQuery({
 *   variables: {
 *      trackSlug: // value for 'trackSlug'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useRecapQuery(baseOptions: Apollo.QueryHookOptions<RecapQuery, RecapQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RecapQuery, RecapQueryVariables>(RecapDocument, options);
}
export function useRecapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecapQuery, RecapQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RecapQuery, RecapQueryVariables>(RecapDocument, options);
}
export type RecapQueryHookResult = ReturnType<typeof useRecapQuery>;
export type RecapLazyQueryHookResult = ReturnType<typeof useRecapLazyQuery>;
export type RecapQueryResult = Apollo.QueryResult<RecapQuery, RecapQueryVariables>;
export const SplashScreenDocument = gql`
  query SplashScreen($teamSlug: String!, $trackSlug: String!) {
    track(teamSlug: $teamSlug, trackSlug: $trackSlug) {
      id
      title
      teaser
      status
      challenges {
        status
        slug
        started
        permalink
        completed
        title
      }
      participant {
        id
      }
    }
    ...IsSkippingEnabledQuery
  }
  ${IsSkippingEnabledQueryFragmentDoc}
`;

/**
 * __useSplashScreenQuery__
 *
 * To run a query within a React component, call `useSplashScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useSplashScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSplashScreenQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      trackSlug: // value for 'trackSlug'
 *   },
 * });
 */
export function useSplashScreenQuery(
  baseOptions: Apollo.QueryHookOptions<SplashScreenQuery, SplashScreenQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SplashScreenQuery, SplashScreenQueryVariables>(SplashScreenDocument, options);
}
export function useSplashScreenLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SplashScreenQuery, SplashScreenQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SplashScreenQuery, SplashScreenQueryVariables>(SplashScreenDocument, options);
}
export type SplashScreenQueryHookResult = ReturnType<typeof useSplashScreenQuery>;
export type SplashScreenLazyQueryHookResult = ReturnType<typeof useSplashScreenLazyQuery>;
export type SplashScreenQueryResult = Apollo.QueryResult<SplashScreenQuery, SplashScreenQueryVariables>;
export const ChallengeStatusDocument = gql`
  query ChallengeStatus($challengeID: String!, $userID: String, $inviteID: String) {
    challenge(challengeID: $challengeID, userID: $userID, inviteID: $inviteID) {
      status
      failed
      failMessage
    }
  }
`;

/**
 * __useChallengeStatusQuery__
 *
 * To run a query within a React component, call `useChallengeStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useChallengeStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChallengeStatusQuery({
 *   variables: {
 *      challengeID: // value for 'challengeID'
 *      userID: // value for 'userID'
 *      inviteID: // value for 'inviteID'
 *   },
 * });
 */
export function useChallengeStatusQuery(
  baseOptions: Apollo.QueryHookOptions<ChallengeStatusQuery, ChallengeStatusQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ChallengeStatusQuery, ChallengeStatusQueryVariables>(ChallengeStatusDocument, options);
}
export function useChallengeStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ChallengeStatusQuery, ChallengeStatusQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ChallengeStatusQuery, ChallengeStatusQueryVariables>(ChallengeStatusDocument, options);
}
export type ChallengeStatusQueryHookResult = ReturnType<typeof useChallengeStatusQuery>;
export type ChallengeStatusLazyQueryHookResult = ReturnType<typeof useChallengeStatusLazyQuery>;
export type ChallengeStatusQueryResult = Apollo.QueryResult<ChallengeStatusQuery, ChallengeStatusQueryVariables>;
